/*
	SCOUT helper functions
*/

var $ = jQuery.noConflict();

// allow to update urls
scout.config(['$locationProvider', function ($locationProvider) {
	$locationProvider.html5Mode({ enabled: true, requireBase: false, rewriteLinks: false });
}]);

htmlEscape = function (str = '') {
	return String(str)
		.replace(/&/g, "&amp;")
		.replace(/'/g, "&#39;")
		.replace(/"/g, "&#34;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;");
};

htmlUnescape = function (str = '') {
	return String(str)
		.replace(/&#39;/g, "'")
		.replace(/&#34;/g, '"')
		.replace(/&lt;/g, "<")
		.replace(/&gt;/g, ">")
		.replace(/&amp;/g, "&");
};

stripTagsAndUnescapeHTML = function (html = '') {
	let tmp = document.createElement('DIV');
	tmp.innerHTML = html;
	return tmp.textContent || tmp.innerText || ""; // Returns unescaped HTML
};

removeElementsFromHTML = function (html, excludeTags = ['BR']) {
	let tmp = document.createElement("DIV");
	tmp.innerHTML = html;
	for (let node of tmp.childNodes) {
		if (node.nodeType != 3 && (!node.tagName || !excludeTags.includes(node.tagName))) {
			tmp.removeChild(node);
		}
	}
	return tmp.innerHTML || "";
};

toTitleCase = function (str) {
	return str.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
}

getUrlVars = function () {
	var vars = {};
	var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
		vars[key] = value;
	});
	return vars;
};

addZero = function (i) {
	if (i < 10) {
		i = "0" + i;
	}
	return i;
};

getUserAgentInfo = function () {
	let getBrowser = function () {
		var ua = navigator.userAgent, tem,
			M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
		if (/trident/i.test(M[1])) {
			tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
			return 'IE ' + (tem[1] || '');
		}
		if (M[1] === 'Chrome') {
			tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
			if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
		}
		M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
		if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
		return M.join(' ');
	};

	var OSName = "Unknown OS";
	if (navigator.appVersion.indexOf("Win") != -1) OSName = "Windows";
	if (navigator.appVersion.indexOf("Mac") != -1) OSName = "MacOS";
	if (navigator.appVersion.indexOf("X11") != -1) OSName = "UNIX";
	if (navigator.appVersion.indexOf("Linux") != -1) OSName = "Linux";

	return 'Browser: ' + getBrowser() + ', OS: ' + OSName;
};

focusFirstModalInput = function () {
	window.setTimeout(function () {
		var firstInput = document.querySelector('.mpg-modal input[type="text"]');
		if (firstInput) firstInput.focus();
	}, 0);
};

focusModalInput = function (number = 1) {
	window.setTimeout(function () {
		var inputs = document.querySelectorAll('.mpg-modal input');
		for (let i = 0; i < inputs.length; i++) {
			if (i + 1 == number) inputs[i].focus();
		}
	}, 0);
};

bodyScrollbarChangeNotAllowed = false;
disableBodyScrollbar = function () {
	if (bodyScrollbarChangeNotAllowed) return false;
	let isScrollbarVisible = document.body.scrollHeight > document.body.clientHeight;
	let scrollTop = document.documentElement.scrollTop;
	if (isScrollbarVisible) {
		document.body.style.overflowY = 'scroll';
		document.body.style.top = -scrollTop + 'px';
	}
	document.body.style.minHeight = (scrollTop + window.innerHeight) + 'px';
	document.body.style.width = '100%';
	document.body.style.position = 'fixed';
};

enableBodyScrollbar = function () {
	if (bodyScrollbarChangeNotAllowed) return false;
	let scrollTop = -parseInt(document.body.style.top);
	document.body.style.top = '';
	document.body.style.position = '';
	document.body.style.width = '';
	document.body.style.overflowY = '';
	document.body.style.minHeight = '';
	if (scrollTop) window.scrollTo(0, scrollTop);
};

// allow to delay view updates until specific element properties are available
waitForView = async function (checkFunction = () => true, maxRetries = 30, waitMs = 100) {
	let retries = maxRetries;
	while (!checkFunction() && retries > 0) {
		retries--;
		await new Promise((r) => {
			setTimeout(() => r(), waitMs);
		});
	}
	if (retries == 0) console.log('Timeout reached in waitForView()');
};

base64ImageToFile = function (imageDataB64, type = 'image/jpeg', fileName = 'image.jpg') {
	// Decode the Base64 string to binary
	const byteString = atob(imageDataB64);

	// Create a Uint8Array to hold the binary data
	const arrayBuffer = new Uint8Array(byteString.length);
	for (let i = 0; i < byteString.length; i++) {
		arrayBuffer[i] = byteString.charCodeAt(i);
	}

	const blob = new Blob([arrayBuffer], { type: type });
	return new File([blob], fileName, { type: type });
};

base64ImageToSizeLimitedFile = async function (imageDataB64, maxKiB = 50, defaultQuality = 80) {
	// Draw image on canvas
	const canvas = await new Promise((resolve, reject) => {
		const img = new Image();
		img.onload = async function () {
			const canvas = document.createElement('canvas');
			canvas.width = img.width;
			canvas.height = img.height;
			canvas.getContext('2d').drawImage(img, 0, 0);
			resolve(canvas);
		};
		img.onerror = function (err) {
			reject(err);
		};
		img.src = `data:image/jpeg;base64,${ imageDataB64 }`;
	});

	// Limit file size
	const maxFileSize = 1024 * maxKiB;
	let imgFile = null;
	for (let quality = defaultQuality; quality > 0 && (!imgFile || imgFile.size > maxFileSize); quality -= 5) {
		await new Promise(function (resolve) {
			canvas.toBlob(function (blob) {
				imgFile = new File([blob], 'image.jpg');
				resolve();
			}, 'image/jpeg', quality / 100);
		});
	}
	return imgFile;
};

// With this controller we can ensure that users can insert only single-line plain-text into an input or
// contenteditable element. Optionally, we can use parameters to loosen the restrictions.
simpleTextInput = function (selector, mode = 'single') {
	let elem = document.querySelector(selector);

	// Clean text input
	let cleanupTextInput = function (e) {
		if (['insertText', 'insertFromPaste', 'insertFromDrop', 'insertLineBreak'].includes(e.inputType)) {
			e.stopPropagation();
			e.preventDefault();
			let text = null;
			if (e.data) text = e.data;
			else if (e.dataTransfer) text = e.dataTransfer.getData('text/plain');
			else if (e.inputType == 'insertLineBreak') text = '\n';

			if (text) {
				let selection = document.getSelection();
				switch (mode) {
					// Remove unbreakable spaces, tabs, redundant spaces and line breaks
					case 'single':
						text = text.replace(/(\u00a0|\r|\n|\t)/g, ' ').replace(/\s\s+/g, ' ');
						break;

					// Remove unbreakable spaces, tabs, redundant spaces
					case 'multi':
						text = text.replace(/(\u00a0|\r|\t)/g, ' ').replace(/[^\S\r\n][^\S\r\n]+/g, ' ');
						break;
				}

				let selectionStart, selectionEnd, prevValue;
				if (this.isContentEditable) {
					selectionStart = selection.anchorOffset;
					selectionEnd = selection.focusOffset;
					prevValue = selection.anchorNode.nodeValue || '';
				} else {
					selectionStart = this.selectionStart;
					selectionEnd = this.selectionEnd;
					prevValue = this.value || '';
				}
				let firstPart = prevValue ? prevValue.substr(0, selectionStart) : '';
				let lastPart = prevValue ? prevValue.substr(selectionEnd, prevValue.length - selectionEnd) : '';

				// Allow only 1 empty line within the inserted text (users can still add more than 1 empty line)
				text = text.replace(/\n[^\S\r\n]*/g, '\n');
				text = text.replace(/(\n){3,}/g, '\n\n');

				// Prevent insertion of double spaces
				if (text.search(/^[^\S\r\n]/) > -1 && selectionStart > 0
					&& prevValue.substr(selectionStart - 1, 1).search(/^[^\S\r\n]$/) > -1) {
					text = text.replace(/^[^\S\r\n]+/, '');
				}
				if (text.search(/[^\S\r\n]$/) > -1 && selectionEnd < prevValue.length
					&& prevValue.substr(selectionEnd, 1).search(/^[^\S\r\n]$/) > -1) {
					text = text.replace(/[^\S\r\n]+$/, '');
				}

				document.execCommand('insertText', false, text);
			}
		}
	};

	// Forbid line breaks - needed for contenteditable elements
	let preventLinebreak = function (e) {
		if (e.code === 'Enter') e.preventDefault();
	};
	let preventFirefoxInsertingLinebreak = function () {
		if (elem.innerHTML === '<br>') elem.innerHTML = '';
	};

	// Register listeners
	if (elem.deregisterSimpleTextInput) {
		console.log('Cannot register SimpleTextInput ' + selector + '. The input is already registered.');
	} else {
		// Allow to deregister element
		elem.deregisterSimpleTextInput = function () {
			elem.removeEventListener('beforeinput', cleanupTextInput);
			if (mode == 'single') {
				elem.removeEventListener('keydown', preventLinebreak);
				elem.removeEventListener('input', preventFirefoxInsertingLinebreak);
			}
			delete elem.deregisterSimpleTextInput;
		};

		elem.addEventListener('beforeinput', cleanupTextInput);
		if (mode == 'single') {
			elem.addEventListener('keydown', preventLinebreak);
			elem.addEventListener('input', preventFirefoxInsertingLinebreak);
		}
	}
};

function getProjectThumbnailGenerationPrompt (projectTitle) {
	return 'Generate a realistic, high-quality visual representation of the emerging '
		+ 'technology or topic "' + projectTitle.replaceAll('"', "'") + '" from a scientific or '
		+ 'technological viewpoint. The image should convey the essence of the topic without any '
		+ 'text, icons, or additional descriptions, focusing solely on visual elements that make '
		+ 'the concept self-explanatory.';
}

// For debugging
function dbLogToSql (log) {
	const quote = (value) => {
		if (value === null || value === undefined) return 'NULL';
		if (typeof value === 'number' || typeof value === 'boolean') {
			return String(value);
		}

		const str =
			typeof value === 'object'
				? JSON.stringify(value, null, 2)
				: String(value);

		const escaped = str
			.replace(/\\/g, '\\\\')
			.replace(/'/g, "''")
			.replace(/\n/g, '\n  ');

		return `E'${ escaped }'`;
	};

	return log
		.map(({ schema, function: fn, params = {} }) => {
			const values = Array.isArray(params)
				? params
				: [
					params._query || {},
					params._output_filter || {},
					params._options || {}
				];

			const args = values
				.map(value => `  ${ quote(value) }`)
				.join(",\n");

			return `SELECT *
			        FROM "${ schema }".${ fn }(${ args });`;
		})
		.join('\n\n');
}

// Drag & Drop -------------------------------------------------------------

var ngDragEventDirectives = {};
angular.forEach(
	'drag dragend dragenter dragexit dragleave dragover dragstart drop'.split(' '),
	function (eventName) {
		var directiveName = 'ng' + eventName.charAt(0).toUpperCase() + eventName.slice(1);

		ngDragEventDirectives[directiveName] = ['$parse', '$rootScope', function ($parse, $rootScope) {
			return {
				restrict: 'A',
				compile: function ($element, attr) {
					var fn = $parse(attr[directiveName], null, true);

					return function ngDragEventHandler (scope, element) {
						element.on(eventName, function (event) {
							fn(scope, { $event: event });
							scope.$applyAsync();
						});
					};
				}
			};
		}];
	}
);
scout.directive(ngDragEventDirectives);

// Name handling -------------------------------------------------------------

getShortUserName = function (fullName) {
	let parts = fullName.split(/\s+/g);
	let firstPart = parts[0];
	let shortName = firstPart[0];
	if (parts.length > 1) {
		let lastPart = parts[parts.length - 1];
		shortName += lastPart[0];
	}
	return shortName;
};

// query-related functions ---------------------------------------------------------------
// more in scout.query-ng.js

// function to create an empty scout query object
function ScoutQuery () {
	this.format_version = '1.6.0';
	this.data = {
		/*
			SEMANTIC SEARCH (deprecated)
			If used, ADVANCED SEARCH is limited to "organizations".
		*/
		//semantic: '', // since 1.5.0

		/*
			ADVANCED SEARCH
			Each field contains a nested array of search terms in the format [[x1,x2,...], [y1,y2,...], ...]
			which represents the Boolean query (x1 OR x2 OR ...) AND (y1 OR y2 OR ...) AND ...
		*/

		// Topic names
		topics: [],
		not_topics: [], // since 1.2.0 // AND NOT (...)

		// Organization names
		organizations: [],
		not_organizations: [] // since 1.2.0 // AND NOT (...)
	};
};

function getDefaultQuery () {
	return initQueryBuilderFormat(new ScoutQuery());
};

cleanQueryTerm = function (term = '', allowVerbatimSearch = false) {
	term = term.replace(/[\(\)«»]/g, ' ').replace(/\s\s+/g, ' ').trim();
	if (allowVerbatimSearch) {
		let isVerbatimSearch = false;
		if (term.length > 2 && term.startsWith('"') && term.endsWith('"')) {
			isVerbatimSearch = true;
			term = term.substr(1, term.length - 2);
		}
		term = term.replace(/"/g, ' ').trim();
		if (term && isVerbatimSearch) term = '"' + term + '"';
	} else {
		term = term.replace(/"/g, ' ');
	}
	return term.replace(/\s\s+/g, ' ').trim();
};

// ensure that every query-builder section is initialized
initQueryBuilderFormat = function (query) {
	if (query.data.topics.length == 0) query.data.topics.push([]);
	if (query.data.organizations.length == 0) query.data.organizations.push([]);
	return query;
};

// init root scope functions & variables -------------------------------------------------------------

angularRootScope = {};
initRootScope = function ($rootScope, $sce, $window) {
	angularRootScope = $rootScope;

	$rootScope.MPG = MPG;

	$rootScope.mixpanel = {
		// This is a workaround. "$rootScope.mixpanel = mixpanel" doesn't work deterministically.
		track: (...args) => mixpanel.track(...args)
	};

	$rootScope.getScopes = function () {
		var scopes = [];

		function visit (scope) {
			scopes.push(scope);
		}

		function traverse (scope) {
			visit(scope);
			if (scope.$$nextSibling)
				traverse(scope.$$nextSibling);
			if (scope.$$childHead)
				traverse(scope.$$childHead);
		}

		traverse($rootScope);
		return scopes;
	};

	$rootScope.toDate = (input) => {
		return new Date(input);
	};

	$rootScope.sortProjects = function (projects, sortPinnedFolders = false, parentId = null) {
		var rootProjects = projects.filter(function (a) {
			return a.parent_id == parentId;
		});
		var childProjects = projects.filter(function (a) {
			return a.parent_id != parentId;
		});
		rootProjects.sort(function (a, b) {
			if (a.id?.startsWith('unassigned_folder') || !a.id) return -999999999;
			if (b.id?.startsWith('unassigned_folder') || !b.id) return 999999999;
			if (sortPinnedFolders) {
				if (a.is_pinned_to_portfolio && !b.is_pinned_to_portfolio) return -999999998;
				if (!a.is_pinned_to_portfolio && b.is_pinned_to_portfolio) return 999999998;
			}
			return datetimeToDate(b.moved || b.created).getTime() - datetimeToDate(a.moved || a.created).getTime();
		});
		childProjects.sort(function (a, b) {
			return datetimeToDate(a.rearranged).getTime() - datetimeToDate(b.rearranged).getTime();
		});
		return rootProjects.concat(childProjects);
	};

	$rootScope.filterArray = function (arr, field, value, not = false) {
		if (not) return arr.filter(x => x[field] != value);
		else return arr.filter(x => x[field] == value);
	};

	// used for iframes in projects
	$rootScope.postMessageToChildWindows = function (message) {
		if (!MPG.IS_PROJECT_IFRAME) {
			let iframes = document.getElementsByClassName('proj-iframe');
			for (let i = 0; i < iframes.length; i++) {
				iframes[i].contentWindow.postMessage(message, MPG.SCOUT_BASE_URL);
			}
		}
	};
	$rootScope.postMessageToParentWindows = function (message) {
		if (MPG.IS_PROJECT_IFRAME) parent.postMessage(message, MPG.SCOUT_BASE_URL);
	};

	$rootScope.trustAsHtml = function (html) {
		return $sce.trustAsHtml(html);
	};

	$rootScope.focus = function (selector) {
		document.querySelector(selector)?.focus();
	};

	$rootScope.getErrorDetails = function (errorMessage, source) {
		if (source == 'saveProject') {
			switch (errorMessage) {
				case 'Error 504':
					return {
						message: 'The server is taking too long to respond. Please try again.',
						remark: 'If the error persists, please refine your query, and save again. '
							+ 'This type of error is usually caused by a too broad query.'
					};
				case 'Error 421':
					return {
						message: 'The IP address of the service endpoint has changed. Please wait 5 minutes and try again.',
						remark: 'Usually, you see this error because your browser (or your operating system) has not yet '
							+ 'updated its DNS cache. If the request still doesn\'t work after 5 minutes, '
							+ 'please restart your browser.'
					};
				default:
					return {
						message: errorMessage,
						remark: 'Please try again. If the error persists, please contact the support.'
					};
			}
		}
		return {
			message: errorMessage,
			remark: 'Please try again. If the error persists, please contact the support.'
		};
	};

	$rootScope.timeout = function (callback, ms = 0) {
		setTimeout(callback, ms);
	};

	$rootScope.Math = Math;
	$rootScope.log = console.log;

	$rootScope.isBookmarkActionAvailable = (wk) => {
		let moduleScope = angular.element('#' + wk.id).scope();
		if (moduleScope.project && moduleScope.project.readonly &&
			(!MPG.IS_LOGGED_IN || wk.mode == 'library' || !MPG.HAS_BASIC_SCOUT)) return false;
		if (wk.include_method === 'standalone') return false;
		return true;
	};

	// a simple screenshot function (not as advanced as the function that is used in panels)
	$rootScope.isExportingScreenshot = false;
	$rootScope.downloadScreenshot = function (target, fileName = 'export', wrapper = null, stateHandler = function () {
	}, scale = 2) {
		if ($rootScope.isExportingScreenshot) return;

		// get elements
		if (typeof target != 'object') target = document.querySelector(target);
		if (!target || typeof target != 'object') return alert('Export not possible (error 1). Please contact the support.');
		if (wrapper && typeof wrapper != 'object') wrapper = document.querySelector(wrapper);

		$rootScope.isExportingScreenshot = true;
		stateHandler(true);
		if (wrapper) wrapper.classList.add('isExportMode');
		setTimeout(function () {
			html2canvas(target, {
				// http://html2canvas.hertzen.com/configuration/
				scale: scale
			}).then(function (canvas) {
				canvas.toBlob(function (blob) {
					if (wrapper) wrapper.classList.remove('isExportMode');
					stateHandler(false);
					$rootScope.isExportingScreenshot = false;
					saveAs(blob, fileName + '.png');
				});
			}).catch(function (err) {
				if (wrapper) wrapper.classList.remove('isExportMode');
				$rootScope.isExportingScreenshot = false;
				stateHandler(false);
				alert('Export not possible (error 2). Please contact the support.');
				console.log(err);
			});
		});
	};

	// global events ------------------------------------------------------------------------

	angular.element($window).bind('resize', function () {
		$rootScope.$emit('resize');
	});

	// URL helper -------------------------------------------------------------------------

	$rootScope.cleanUrl = function (url, httpsOnly) {
		if (url.startsWith(MPG.SCOUT_BASE_URL)) return url;
		if (httpsOnly && url.substr(0, 7) == 'http://') url = 'https://' + url.substr(7, url.length - 7);
		if (url.substr(0, 7) == 'http://' || url.substr(0, 8) == 'https://') return url;
		else return 'https://' + url;
	};

	// type = image | file
	$rootScope.getProjectFileUrl = function (filename, type, projectId) {
		return MPG.SCOUT_BASE_URL + '/userdata/?context=project&id='
			+ projectId + '&' + type + '=' + encodeURIComponent(filename);
	};

	// type = image
	$rootScope.getLogoUrl = function (filename, type, id, isGroup = true) {
		let context = isGroup ? 'group' : 'user'
		return MPG.SCOUT_BASE_URL + '/userdata/?context=' + context + '&id='
			+ id + '&' + type + '=' + encodeURIComponent(filename);
	};

	// formatters ----------------------------------------------------------------------------

	// must be >= 0
	$rootScope.bigNumberFormatter = function (number, advanced = true) {
		if (number == Infinity) return '∞';
		if (typeof number == 'undefined' || number === null || isNaN(number) || number < 0) return '';
		let string = '' + Math.round(number);

		if (!advanced) return string.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

		let length = 0;
		let extension = '';
		if (string.length > 12) {
			length = 12;
			extension = 'Tn';
		} else if (string.length > 9) {
			length = 9;
			extension = 'Bn';
		} else if (string.length > 6) {
			length = 6;
			extension = 'M';
		} else if (string.length > 3) {
			length = 3;
			extension = 'k';
		} else if (string.length == 1) return '' + Math.round(number * 10) / 10;
		else return string;

		// if the resulting number has only a single digit, we add a decimal digit
		let roundFactor = 1;
		if (string.length == length + 1) roundFactor = 10;

		return Math.round(number * roundFactor / Math.pow(10, length)) / roundFactor + extension;
	};

	$rootScope.tagsFormatter = function (tags, label = '', defaultString = '') {
		// array input (allows color customization)
		let hasData = false;
		for (let item of tags) if (item.data.length) hasData = true;
		if (!hasData) var html = defaultString;
		else {
			var html = htmlEscape(label) + (label ? '&nbsp;&nbsp;' : '');
			for (let item of tags) {
				for (let term of item.data) {
					if (typeof term === 'object') {
						const { name, url } = term;
						html += '<a class="m-table-tag-link ' + (item.class || 'm-table-tag') + '" ' +
							(item.color ? ('style="background-color:' + item.color + ';"') : '') +
							' onclick="event.stopPropagation();" href="' + htmlEscape(url) + '"' +
							' title="' + htmlEscape(item.title || '') + '">' + htmlEscape(name) + '</a>';
					} else {
						html += '<div class="' + (item.class || 'm-table-tag') + '" ' +
							(item.color ? ('style="background-color:' + item.color + ';"') : '') +
							' title="' + htmlEscape(item.title || '') + '">' + htmlEscape(term) + '</div>';
					}
				}
			}
		}
		return html;
	};

	$rootScope.mapHypeValue = function (value) {
		if (typeof value == 'undefined' || value === null) return undefined;
		else if (value > 2.58) return 1;
		else if (value > 1.96 && value <= 2.58) return 0.5;
		else if (value > -1.96 && value < 1.96) return 0;
		else if (value > -2.58 && value <= -1.96) return -0.5;
		else return -1;
	};

	$rootScope.limitString = function (str, softLimit = 166) {
		if (!str || str.length <= softLimit) return str;

		// Trim the string to the maximum length plus the length of the next word
		const nextSpaceIndex = str.indexOf(' ', softLimit);
		if (nextSpaceIndex !== -1) {
			return str.substr(0, nextSpaceIndex) + '…'; // Add ellipsis
		} else {
			return str; // String is one word and it exceeds the word limit, return it as it is.
		}
	};

	// query-related functions ---------------------------------------------------------------
	// more in scout.query-ng.js

	/**
	 * Build the Search String
	 *
	 * @param options:
	 * 		{
	 * 			return_types: optional list of types (e.g. ['organizations']) to return a partial search string
	 * 			no_not: if true, the "not_..." types will not be added
	 * 			...
	 * 		}
	 * @returns {string}
	 */
	$rootScope.getSearchString = function (options = false) {
		let listPrefix = '';
		let query;
		let returnTypes;
		let noNot;
		let addTypeName;
		if (options) {
			if ('query' in options) query = JSON.parse(JSON.stringify(options.query.data));
			if ('return_types' in options) returnTypes = options.return_types;
			if ('no_not' in options && options.no_not === true) noNot = true;

			// List prefixes
			if ('add_type_name' in options && options.add_type_name === true) addTypeName = true;
			if ('listPrefix' in options) listPrefix = options.listPrefix;
		}

		// Optionally remove NOT entities
		if (noNot) {
			Object.keys(query).forEach(function (type) {
				if (type.substr(0, 4) === 'not_') {
					delete query[type];
				}
			});
		}

		// Select return type by removing the other types
		if (returnTypes) {
			Object.keys(query).forEach(function (type) {
				// Add not_... types
				let notReturnTypes = returnTypes.map(function (t) {
					return 'not_' + t;
				});
				if (!returnTypes.includes(type) && !notReturnTypes.includes(type)) delete query[type];
			});
		}

		// Clean tags
		let cleanTerm = function (str) {
			return str.toLowerCase();
		};
		Object.keys(query).forEach(function (type) {
			if (Array.isArray(query[type])) {
				query[type].forEach(function (list) {
					list.forEach(function (term, idx, obj) {
						obj[idx] = cleanTerm(term);
					});
				});
			} else {
				query[type] = cleanTerm(query[type]);
			}
		});

		// Remove duplicates
		Object.keys(query).forEach(function (type) {
			if (Array.isArray(query[type])) {
				query[type].forEach(function (list, idx, obj) {
					let uniqueTerms = [];
					for (let el of list) {
						if (!uniqueTerms.includes(el)) uniqueTerms.push(el);
					}
					obj[idx] = uniqueTerms;
				});
			}
		});

		// Remove empty strings
		Object.keys(query).forEach(function (type) {
			if (Array.isArray(query[type])) {
				query[type] = query[type].map(function (list) {
					return list.filter((x) => x.length > 0);
				});
			}
		});

		// Remove empty lists
		Object.keys(query).forEach(function (type) {
			if (Array.isArray(query[type])) {
				query[type] = query[type].filter(function (list) {
					return list.length !== 0;
				});
			}
		});

		// Remove empty entities
		Object.keys(query).forEach(function (type) {
			if (Array.isArray(query[type]) && query[type].length === 0 || !query[type]) delete query[type];
		});

		// Build query
		let entities = [];
		let groupL = '(';
		let groupR = ')';
		let phraseL = '«';
		let phraseR = '»';
		let isSemanticSearch = false;
		Object.keys(query).forEach(function (type) {
			let lists = [];
			if (addTypeName) listPrefix = type.substr(0, type.length - 1).replace('not_', '') + ':';
			if (Array.isArray(query[type])) {
				query[type].forEach(function (list) {
					let terms = [];
					list.forEach(function (term) {
						terms.push(term.startsWith('"') ? term : phraseL + term + phraseR);
					});
					if (type.startsWith('not_')) {
						// Add AND NOT lists
						lists.push('NOT ' + listPrefix + groupL + terms.join(' OR ') + groupR);
					} else {
						// Add AND lists
						lists.push(listPrefix + groupL + terms.join(' OR ') + groupR);
					}
				});
				entities.push(lists.join(' AND '));
			} else if (query[type]) {
				// Semantic search is a single phrase
				entities.push(groupL + query[type] + groupR); // Omit listPrefix
				isSemanticSearch = true;
			}
		});

		// Return simple semantic searches without brackets
		if (entities.length === 1 && isSemanticSearch) {
			return entities[0].substring(1, 2).toUpperCase() + entities[0].substring(2, entities[0].length - 1);
		} else {
			return entities.join(' AND ');
		}
	};

	$rootScope.isQueryDataExclusive = function (query, AllowedDataKeys) {
		// checks if the query data has only the allowedDataKeys i.e: 'topics'
		if (!Array.isArray(AllowedDataKeys)) AllowedDataKeys = [AllowedDataKeys];

		const data = query.data;

		return Object.keys(data).every(key => {
			const val = data[key];

			const isAllowed = AllowedDataKeys.includes(key);
			const isEmpty = key === 'semantic'
				? val === ""
				: Array.isArray(val) && (val.length === 0 || val.every(i => Array.isArray(i) ? i.length === 0 : false));

			return isAllowed ? !isEmpty : isEmpty;
		});
	}
	// global bookmark functions -------------------------------------------------------------

	// Stores selected bookmarks until you save them
	$rootScope.selectedBookmarks = {}; // { <moduleName>: [...] }

	// Stores selected project bookmarks (library mode) until action
	$rootScope.selectedProjectBookmarks = {}; // { <moduleName>: [...] }

	$rootScope.importBookmarks = function (bookmarks) {
		if (!bookmarks) return [];
		for (let moduleName of Object.keys(bookmarks)) {
			for (let bookmarkKey of Object.keys(bookmarks[moduleName])) {
				var bookmark = bookmarks[moduleName][bookmarkKey];
				// adapt timezone
				bookmark._meta.created = universalToLocalDatetime(bookmark._meta.created);
				let meta = bookmark._meta;
				bookmark = scoutBackendApi.cleanBookmark(bookmark);
				bookmark._meta = meta;
			}
		}
		return bookmarks;
	};

	// return an object with bookmark-related information that can be added to data rows
	$rootScope.getBookmarkMeta = function (bookmark_id, responseItem, settings = {}) {
		let _meta = responseItem._meta || {};
		let module_name = settings['targetModule'];
		let isLibrary = false;
		if (settings.wk) {
			if (!module_name) module_name = settings.wk.bookmark_module_name
				? settings.wk.bookmark_module_name : settings.wk.module_name;
			if (settings.wk.mode == 'library') isLibrary = true;
		}

		// get meta information from stored bookmarks
		if (isLibrary && $rootScope.bookmarks
			&& $rootScope.bookmarks[module_name] && $rootScope.bookmarks[module_name][bookmark_id]) {
			_meta = Object.assign(_meta, $rootScope.bookmarks[module_name][bookmark_id]._meta);
		}

		// check if item is a selected bookmark
		let selected = false;
		let bookmarks = isLibrary ? $rootScope.selectedProjectBookmarks : $rootScope.selectedBookmarks;
		if (bookmarks[module_name]) {
			for (let item of bookmarks[module_name]) {
				if (bookmark_id == item._meta.id) selected = true;
				// handle grouped patents
				if (item.relatedItems) {
					for (let relatedItem of item.relatedItems) {
						if (relatedItem._meta.id == _meta.id) selected = true;
					}
				}
				if (_meta.relatedItems) {
					for (let relatedItem of _meta.relatedItems) {
						if (relatedItem._meta.id == item._meta.id) selected = true;
					}
				}
			}
		}


		let infos = {
			id: bookmark_id,
			module_name: module_name
		};
		if (selected) infos.selected = true;

		// the item that will be sent via sendDataToIframeParent to external applications (when all API routes are wrapped in the DB's "external layer")
		if (typeof responseItem != 'undefined') infos.origItem = angular.copy(responseItem);
		// items that will be excluded from the Panel API bookmarking
		if (settings.exportBlacklist) infos.exportBlacklist = settings.exportBlacklist;
		if (typeof settings['saveBookmarkContent'] != 'undefined') infos.saveBookmarkContent = settings['saveBookmarkContent'];
		return Object.assign(_meta, infos);
	};

	// Returns all items that are loaded on the page
	$rootScope.getAllPotentialBookmarks = function () {
		let dataLists = [];
		let scopes = $rootScope.getScopes();
		for (let scope of scopes) {
			// get items from tables
			if (scope.componentName == 'module' && scope.wk && scope.mode != 'library' && scope.wk.data
				&& Array.isArray(scope.wk.data) && scope.wk.data[0] && scope.wk.data[0]._meta
				&& !dataLists.includes(scope.wk.data)) {
				dataLists.push(scope.wk.data);
			}

			// Get items via 'bookmarkAction' component
			if (scope.$ctrl && scope.$ctrl.componentName && scope.$ctrl.componentName == 'bookmarkAction'
				&& scope.$ctrl.row) {
				/*
					Check for ref_items. Reference items may occur also as bookmarked items on the current page,
					so we need to find them as reference bookmarks instead of bookmarked items.
				*/
				const isRowInDataLists = dataLists?.some(dataList => Array.isArray(dataList)
					&& dataList?.some(
						item => item._meta.id === scope.$ctrl.row._meta.id
							&& (!scope.$ctrl.row._meta.ref_item || item._meta.ref_item)
					)
				);
				if (!isRowInDataLists) {
					dataLists.push(scope.$ctrl.row);
				}
			}
		}
		return [].concat.apply([], dataLists);
	};

	// returns all bookmarks for the current project
	$rootScope.getProjectBookmarks = function (moduleName) {
		let bookmarks = [];

		if ($rootScope.bookmarks && $rootScope.bookmarks[moduleName]) {
			for (let bookmark of Object.values($rootScope.bookmarks[moduleName])) {
				bookmarks.push(bookmark);
			}
		}
		return bookmarks;
	};

	$rootScope.selectBookmark = function (item, mode) {
		$rootScope.$broadcast('selectBookmark', item, mode);
		if (MPG.IS_PROJECT_IFRAME) $rootScope.postMessageToParentWindows({
			action: 'Mapegy_SelectBookmark', data: item, mode: mode
		});
		else $rootScope.postMessageToChildWindows({ action: 'Mapegy_SelectBookmark', data: item, mode: mode });
	};

	$rootScope.unselectBookmark = function (item, mode) {
		$rootScope.$broadcast('unselectBookmark', item, mode);
		if (MPG.IS_PROJECT_IFRAME) $rootScope.postMessageToParentWindows({
			action: 'Mapegy_UnselectBookmark', data: item, mode: mode
		});
		else $rootScope.postMessageToChildWindows({ action: 'Mapegy_UnselectBookmark', data: item, mode: mode });
	};

	$rootScope.setSelectedBookmarksLoading = function () {
		$rootScope.$broadcast('setSelectedBookmarksLoading');
		if (MPG.IS_PROJECT_IFRAME) $rootScope.postMessageToParentWindows({ action: 'Mapegy_SetSelectedBookmarksLoading' });
		else $rootScope.postMessageToChildWindows({ action: 'Mapegy_SetSelectedBookmarksLoading' });
	};

	$rootScope.resetSelectedBookmarks = function (bookmarkableItem = false, bookmarkedItem = false) {
		$rootScope.$broadcast('resetSelectedBookmarks', bookmarkableItem, bookmarkedItem);
		if (MPG.IS_PROJECT_IFRAME) $rootScope.postMessageToParentWindows({
			action: 'Mapegy_ResetSelectedBookmarks', bookmarkableItem, bookmarkedItem
		});
		else $rootScope.postMessageToChildWindows({
			action: 'Mapegy_ResetSelectedBookmarks', bookmarkableItem, bookmarkedItem
		});
	};

	$rootScope.broadcastUpdatedBookmarks
		= function (bookmarks = $rootScope.bookmarks, bookmarksUpdateTriggerId, deletedBookmarks = []) {
		let data = {
			bookmarks: bookmarks, bookmarksUpdateTriggerId: bookmarksUpdateTriggerId
			, deletedBookmarks: deletedBookmarks
		};
		$rootScope.$broadcast('broadcastUpdatedBookmarks', data);
		if (MPG.IS_PROJECT_IFRAME) $rootScope.postMessageToParentWindows(
			{ action: 'Mapegy_BroadcastUpdatedBookmarks', data: data });
		else $rootScope.postMessageToChildWindows(
			{ action: 'Mapegy_BroadcastUpdatedBookmarks', data: data });
	};

	$rootScope.countSelectedBookmarks = function () {
		let counter = 0;
		for (let list of Object.values($rootScope.selectedBookmarks)) {
			counter += list.length;
		}
		return counter;
	};

	$rootScope.countSelectedProjectBookmarks = function () {
		let counter = 0;
		for (let list of Object.values($rootScope.selectedProjectBookmarks)) {
			counter += list.length;
		}
		return counter;
	};

	$rootScope.areAllSelectedBookmarksBookmarked = function () {
		for (const [listKey, items] of Object.entries($rootScope.selectedBookmarks)) {
			for (const item of items) {
				if (!$rootScope.bookmarks[item._meta.module_name]?.[item._meta.id]) return false;
			}
		}
		return true;
	}

	$rootScope.copySelectedProjectBookmarks = function () {
		$rootScope.saveSelectedBookmarks(true);
	};

	$rootScope.moveSelectedProjectBookmarks = function () {
		$rootScope.saveSelectedBookmarks(false, true);
	};

	$rootScope.saveSelectedBookmarks = function (copy = false, move = false) {
		let updatedPages = [];
		let selectedItems = (move || copy) ? $rootScope.selectedProjectBookmarks
			: $rootScope.selectedBookmarks;
		let sessionLastBookmarkTarget = JSON.parse(localStorage.getItem('last-bookmark-target') || null);
		let offerLastBookmark = sessionLastBookmarkTarget
			&& (!$rootScope.project || (sessionLastBookmarkTarget.id !== $rootScope.project.id));
		if ('undefined' in selectedItems) throw new Error('Bookmark type is undefined');

		$rootScope.selectProjectsDialog = {
			dialogName: 'Add Bookmarks',
			show: true,
			caption: copy ? 'Copy Bookmark' + ($rootScope.countSelectedProjectBookmarks() > 1 ? 's' : '')
				: move ? 'Move Bookmark' + ($rootScope.countSelectedProjectBookmarks() > 1 ? 's' : '')
					: 'Add Bookmark' + ($rootScope.countSelectedBookmarks() > 1 ? 's' : ''),
			multiselect: true,
			disabledProjectIds: (copy || move) ? [MPG.PROJECT_ID] : [],
			iconClass: 'fa-solid fa-star',
			/*
			Will return a project that only has an id property (focusedProjectId)
			// Don't offer current page if moving or copying the project
			*/
			offerCurrentPage: (copy || move) ? false : (
				typeof MPG.PROJECT_ID != 'undefined' && MPG.PAGE_TYPE !== 'Library Project Page' ? true : false
			),
			offerLastBookmarkTarget: offerLastBookmark,
			lastBookmarkTarget: offerLastBookmark ? sessionLastBookmarkTarget : null,
			offerSourcePage: MPG.PAGE_TYPE === 'Alerts Overview',
			focusedProjectId: typeof MPG.PROJECT_ID != 'undefined' ? MPG.PROJECT_ID : null,
			focusedProject: $rootScope.project,
			showGroupFolders: true,
			rightButtonLabel: 'Save',
			hideNewProjectOption: true,
			rightButtonCallback: function () {
				$rootScope.showMessage('Updating project(s)...', 'pending', null);
				$rootScope.setSelectedBookmarksLoading();

				// Prepare tasks
				let tasks = [];
				let selectedProjects = []; // for determining last bookmark target project
				for (let listKey of Object.keys(selectedItems)) {
					for (let item of selectedItems[listKey]) {
						// prepare request
						let task = {
							id: item._meta.id,
							module_name: listKey,
							add_projects: []
						};

						// If set, we'll not only store the ID but also the content
						if ((typeof item._meta.saveBookmarkContent != 'undefined'
							&& item._meta.saveBookmarkContent)) {
							task.bookmark_json = scoutBackendApi.cleanBookmark(item);
						}
						if ($rootScope.selectProjectsDialog.offerSourcePage) {
							let sourceProjectId = item._meta.project_id;
							let sourceProjectTitle = item._meta.project_name;

							task.add_projects.push(sourceProjectId);

							if (!updatedPages.some(p => p.id === sourceProjectId)) {
								updatedPages.push({ id: sourceProjectId, title: sourceProjectTitle });
							}

							if (!selectedProjects.some(p => p.id === sourceProjectId)) {
								selectedProjects.push({ id: sourceProjectId, title: sourceProjectTitle });
							}
						} else {
							angular.forEach($rootScope.selectProjectsDialog.projects, function (project) {
								if (project.selected) task.add_projects.push(project.id);
							});
						}
						tasks.push(task);
					}
				}

				// Prepare feedback
				angular.forEach($rootScope.selectProjectsDialog.projects, function (project) {
					if (project.selected) {
						let projectData = {
							id: project.id,
							title: project.title
						};
						if (!$rootScope.project || project.id !== $rootScope.project.id) {
							updatedPages.push(projectData);
						}
						selectedProjects.push(projectData);
					}
				});
				let options = { tasks: tasks };
				let lastBookmarkTarget = (selectedProjects[selectedProjects.length - 1]);
				let hasProjectNewBookmarks = $rootScope.project
					&& tasks.some(x => x.add_projects.includes($rootScope.project.id));
				// In projects, return the updated bookmark dataset if bookmarks of the project were changed.
				if (hasProjectNewBookmarks) {
					options.response = { project_id: $rootScope.project.id };
				}

				// Perform action
				scoutBackendApi.editBookmarks(options, function (response) {
					if (response.status === 'success') {
						$rootScope.showMessage('Project(s) updated.', 'success');
						localStorage.setItem('last-bookmark-target', JSON.stringify(lastBookmarkTarget));

						// Apply changes that affect the current project page
						if (options.response) {
							// update bookmarks of current page
							$rootScope.bookmarks = $rootScope.importBookmarks(response.data);
							// refresh other panels
							$rootScope.broadcastUpdatedBookmarks();
						}

						// Send a generic event that allows bookmark sources to apply custom state updates
						$rootScope.$broadcast('bookmarksSaved', selectedItems);

						if (!move) {
							if (copy) {
								$rootScope.resetSelectedBookmarks(false, true);
							} else {
								$rootScope.resetSelectedBookmarks(true);
							}
						}
						showFeedback();
					} else {
						$rootScope.showMessage('Project(s) could not be updated.', 'error');
					}
				});
			}
		};

		function showFeedback () {
			// create links html
			let html = [];
			for (let newPage of updatedPages) {
				let link = MPG.SCOUT_BASE_URL + '/projects/' + newPage.id;
				html.push('<li><a href="' + link + '">' + htmlEscape(newPage.title) + '</a></li>');
			}
			html = '<ul class="app-list">' + html.join('<br>') + '</ul>';

			// if moveSelectedProjectBookmarks() save in the new project then delete from current project.
			if (move) $rootScope.deleteBookmarks(true);

			if (updatedPages.length) {
				$rootScope.confirmDialog = {
					show: true,
					iconClass: 'fa-solid fa-info-circle',
					caption: 'Info',
					rightButtonLabel: 'Close',
					content: '<div style="margin-bottom: 16px">Bookmarks were'
						+ (copy ? ' copied ' : move ? ' moved ' : ' added ') + 'to:</div>' + html,
					closeRight: true
				};
			}
		}
	};

	$rootScope.deleteBookmarks = function (move = false, selectedBookmarks = false) {
		/*
			If selectedBookmarks is true, all items in $rootScope.selectedBookmarks
			are already bookmarked in the current project.
			Calling this function will remove those corresponding bookmarks from the current page.
		*/
		let countBookmarks = selectedBookmarks
			? $rootScope.countSelectedBookmarks()
			: $rootScope.countSelectedProjectBookmarks();
		let selected = selectedBookmarks ? $rootScope.selectedBookmarks : $rootScope.selectedProjectBookmarks;
		$rootScope.confirmDialog = {
			show: move ? false : true,
			iconClass: 'fa-solid fa-trash',
			caption: 'Delete Bookmark' + (countBookmarks > 1 ? 's' : ''),
			content: "Delete bookmark" + (countBookmarks > 1 ? "s" : "") + "?",
			rightButtonLabel: 'Delete',

			rightButtonCallback: function () {
				if (selectedBookmarks) $rootScope.setSelectedBookmarksLoading();
				let tasks = [];
				for (let listKey of Object.keys(selected)) {
					for (let item of selected[listKey]) {
						// prepare request
						let task = {
							id: item._meta.id,
							module_name: listKey,
							remove_projects: [MPG.PROJECT_ID]
						};
						if (!selectedBookmarks) item.loading = true;
						tasks.push(task);
					}
				}

				if (move === false) {
					$rootScope.showMessage(
						'Deleting bookmark'
						+ (countBookmarks > 1 ? 's' : '')
						+ '...', 'pending', null
					);
				}

				scoutBackendApi.editBookmarks({ tasks: tasks }, function (response) {
					if (response.status === 'success') {
						if (move === false) {
							$rootScope.showMessage('Bookmark'
								+ (countBookmarks > 1 ? 's ' : ' ') + 'deleted.', 'success');
						}
						// update bookmarks
						let deletedBookmarks = [];

						for (let listKey of Object.keys(selected)) {
							for (let item of selected[listKey]) {
								if (selectedBookmarks) {
									/*
										updatePanelData deletes an item from the tab data by checking _meta.created and
										_meta.id to ensure that only the bookmarked item is removed, without affecting
										the corresponding bookmarkable item. _meta.created is only available in
										$rootScope.bookmarks, $rootScope.selectedProjectBookmarks
									*/
									let bookmark = angular.copy(item);
									bookmark._meta.created = $rootScope.bookmarks[listKey][item._meta.id]._meta.created;
									deletedBookmarks.push(bookmark);
								} else {
									deletedBookmarks.push(item);
								}
								delete $rootScope.bookmarks[listKey][item._meta.id];
								if (!Object.keys($rootScope.bookmarks[listKey]).length) {
									delete $rootScope.bookmarks[listKey];
								}
							}
						}

						// refresh other panels
						let bookmarksUpdateTriggerId = new Date().getTime();
						$rootScope.broadcastUpdatedBookmarks($rootScope.bookmarks
							, bookmarksUpdateTriggerId, deletedBookmarks);
						if (selectedBookmarks) $rootScope.resetSelectedBookmarks(true);
						else selected = $rootScope.selectedProjectBookmarks = {};

					} else {
						$rootScope.showMessage('Bookmark'
							+ (countBookmarks > 1 ? 's' : '')
							+ ' could not be deleted.', 'error');
					}
				});
			},

			leftButtonCallback: function () {
				for (let listKey of Object.keys(selected)) {
					for (let item of selected[listKey]) {
						item.loading = false;
					}
				}
			}
		};

		// For moveSelectedProject(), We use saveSelectedbookmarks() then deleteBookmarks()
		if (move) $rootScope.confirmDialog.rightButtonCallback();

	};

	$rootScope.showZeroBookmarksMessage = function (scope) {
		var wk = scope.wk;
		scope.endProgress(wk);
		wk.data = [];
		wk.zero = true;
		wk.zero_title = "No bookmarks added yet.";
		wk.zero_msg = "";
		scope.$emit('dataLoaded', wk);
		wk.updateView();
	};

	// listen to messages from child and parent windows
	window.addEventListener("message", function (e) {
		if (e.origin == window.origin && e.data) {
			switch (e.data.action) {
				case 'Mapegy_SelectBookmark':
					if (MPG.IS_PROJECT_IFRAME) {
						$rootScope.$broadcast('selectBookmark', e.data.data, e.data.mode);
					} else {
						$rootScope.selectBookmark(e.data.data, e.data.mode);
					}
					break;
				case 'Mapegy_UnselectBookmark':
					if (MPG.IS_PROJECT_IFRAME) {
						$rootScope.$broadcast('unselectBookmark', e.data.data, e.data.mode);
					} else {
						$rootScope.unselectBookmark(e.data.data, e.data.mode);
					}
					break;
				case 'Mapegy_SetSelectedBookmarksLoading':
					if (MPG.IS_PROJECT_IFRAME) {
						$rootScope.$broadcast('setSelectedBookmarksLoading');
					} else {
						$rootScope.setSelectedBookmarksLoading();
					}
					break;
				case 'Mapegy_ResetSelectedBookmarks':
					if (MPG.IS_PROJECT_IFRAME) {
						$rootScope.$broadcast('resetSelectedBookmarks', e.data.bookmarkableItem, e.data.bookmarkedItem);
					} else {
						$rootScope.resetSelectedBookmarks(e.data.bookmarkableItem, e.data.bookmarkedItem);
					}
					break;
				case 'Mapegy_BroadcastUpdatedBookmarks':
					if (MPG.IS_PROJECT_IFRAME) {
						$rootScope.$broadcast('broadcastUpdatedBookmarks', e.data.data);
					} else {
						$rootScope.broadcastUpdatedBookmarks(e.data.data.bookmarks,
							e.data.data.bookmarksUpdateTriggerId);
					}
					break;
				case 'Mapegy_IframeReady':
					$rootScope.postMessageToChildWindows({
						action: 'Mapegy_InitSelectedBookmarks',
						data: {
							projectBookmarks: $rootScope.selectedProjectBookmarks
							, bookmarkable: $rootScope.selectedBookmarks
						}
						, mode: e.data.mode
					});
					break;
				case 'Mapegy_InitSelectedBookmarks':
					if (e.data.data.projectBookmarks) {
						for (let listKey of Object.keys(e.data.data.projectBookmarks)) {
							for (let item of e.data.data.projectBookmarks[listKey]) {
								// selectedProjectbookmarks is for library projects so we set mode equal to true
								$rootScope.$broadcast('selectBookmark', item, true);
							}
						}
					}
					if (e.data.data.bookmarkable) {
						for (let listKey of Object.keys(e.data.data.bookmarkable)) {
							for (let item of e.data.data.bookmarkable[listKey]) {
								$rootScope.$broadcast('selectBookmark', item, e.data.mode);
							}
						}
					}
					break;
			}
			$rootScope.$applyAsync();
		}
	});

	angular.element(document).ready(function () {
		$rootScope.postMessageToParentWindows({ action: 'Mapegy_IframeReady' });
	});

	$rootScope.$on('selectBookmark', function (evt, bookmark, libraryMode = false) {
		// update bookmarking summary
		let moduleName = bookmark._meta.module_name;
		if (libraryMode) {
			if (!$rootScope.selectedProjectBookmarks[moduleName]) $rootScope.selectedProjectBookmarks[moduleName] = [];

			// Checking for duplicates while loading a new panel and selecting a bookmark in it
			const containsElement = $rootScope.selectedProjectBookmarks[moduleName].some(
				item => item._meta.id === bookmark._meta.id
			);
			if (!containsElement) $rootScope.selectedProjectBookmarks[moduleName].push(bookmark);
		} else {
			if (!$rootScope.selectedBookmarks[moduleName]) $rootScope.selectedBookmarks[moduleName] = [];

			// Checking for duplicates while loading a new panel and selecting a bookmark in it
			const containsElement = $rootScope.selectedBookmarks[moduleName].some(
				item => item._meta.id === bookmark._meta.id
			);
			if (!containsElement) $rootScope.selectedBookmarks[moduleName].push(bookmark);
		}

		// update items
		for (let item of $rootScope.getAllPotentialBookmarks()) {
			if ((item._meta.created === bookmark._meta.created) || (!item._meta.created && !bookmark._meta.created)) {
				if (item._meta.id == bookmark._meta.id && item._meta.module_name == bookmark._meta.module_name) {
					item._meta.selected = true;
				}
				// handle grouped patents
				if (item._meta.relatedItems) {
					for (let relatedItem of item._meta.relatedItems) {
						if (relatedItem._meta.id == bookmark._meta.id
							&& relatedItem._meta.module_name == bookmark._meta.module_name) {
							item._meta.selected = true;
						}
					}
				}
				if (bookmark._meta.relatedItems) {
					for (let relatedItem of bookmark._meta.relatedItems) {
						if (relatedItem._meta.id == item._meta.id
							&& relatedItem._meta.module_name == item._meta.module_name) {
							item._meta.selected = true;
						}
					}
				}
			}
		}
	});

	$rootScope.$on('unselectBookmark', function (evt, bookmark, libraryMode = false) {
		// update bookmarking summary
		let moduleName = bookmark._meta.module_name;
		let bookmarks = (libraryMode)
			? $rootScope.selectedProjectBookmarks
			: $rootScope.selectedBookmarks;
		bookmarks[moduleName] = bookmarks[moduleName].filter(function (x) {
			if (x._meta.relatedItems) {
				for (let relatedItem of x._meta.relatedItems) {
					if (relatedItem._meta.id == bookmark._meta.id) return false;
				}
			}
			if (bookmark._meta.relatedItems) {
				for (let relatedItem of bookmark._meta.relatedItems) {
					if (relatedItem._meta.id == x._meta.id) return false;
				}
			}
			return x._meta.id != bookmark._meta.id;
		});

		// update items
		for (let item of $rootScope.getAllPotentialBookmarks()) {
			if ((item._meta.created === bookmark._meta.created) || (!item._meta.created && !bookmark._meta.created)) {
				if (item._meta.id == bookmark._meta.id && item._meta.module_name == bookmark._meta.module_name) {
					item._meta.selected = false;
				}
				// handle grouped patents
				if (item._meta.relatedItems) {
					for (let relatedItem of item._meta.relatedItems) {
						if (relatedItem._meta.id == bookmark._meta.id
							&& relatedItem._meta.module_name == bookmark._meta.module_name) {
							item._meta.selected = false;
						}
					}
				}
				if (bookmark._meta.relatedItems) {
					for (let relatedItem of bookmark._meta.relatedItems) {
						if (relatedItem._meta.id == item._meta.id
							&& relatedItem._meta.module_name == item._meta.module_name) {
							item._meta.selected = false;
						}
					}
				}
			}
		}
	});

	$rootScope.$on('setSelectedBookmarksLoading', function (evt) {
		// update items
		for (let item of $rootScope.getAllPotentialBookmarks()) {
			if (item._meta.selected) {
				item._meta.loading = true;
			}
		}
	});

	$rootScope.$on('resetSelectedBookmarks', function (evt, bookmarkable = false, bookmarked = false) {
		/*
			resetSelectedbookmarks() => reset all bookmarks, resetSelectedBookmarks(true) => reset selectedBookmarks,
			resetSelectedBookmarks(false, true) => reset selectedProjectBookmarks,
		*/
		let bookmarkedArray = $rootScope.selectedProjectBookmarks;
		let bookmarkableArray = $rootScope.selectedBookmarks;
		$rootScope.selectedProjectBookmarks = (!bookmarkable) ? {} : $rootScope.selectedProjectBookmarks;
		$rootScope.selectedBookmarks = (!bookmarked) ? {} : $rootScope.selectedBookmarks;
		$rootScope.$applyAsync;

		// update items
		const resetSelected = (item) => {
			if (item._meta.selected) {
				item._meta.selected = false;
				item._meta.loading = false;
			}
			// Patent events uses references section component and they are not bookmarks
			if (item.refsData && !item.refsData[0]?.patent_event) {
				for (let refItem of item.refsData) {
					resetSelected(refItem);
				}
			}
		};
		if (!bookmarkable && !bookmarked) {
			for (let item of $rootScope.getAllPotentialBookmarks()) {
				resetSelected(item);
			}
		} else if (bookmarkable) {
			for (let item of $rootScope.getAllPotentialBookmarks()) {
				let module = item._meta.module_name;
				if (bookmarkableArray[module]?.some(bookmark => bookmark._meta.id === item._meta.id
					&& !bookmark._meta.created && !item._meta.created)) {
					resetSelected(item);
				}
			}
		} else if (bookmarked) {
			for (let item of $rootScope.getAllPotentialBookmarks()) {
				let module = item._meta.module_name
				if (bookmarkedArray[module]?.some(bookmark => bookmark._meta.id === item._meta.id
					&& bookmark._meta.created === item._meta.created)) {
					resetSelected(item);
				}
			}
		}
	});

	$rootScope.$on('broadcastUpdatedBookmarks', function (evt, data) {
		$rootScope.bookmarks = data.bookmarks;
		$rootScope.$broadcast('updatePanelData', {
			bookmarksOnly: true,
			bookmarksUpdateTriggerId: data.bookmarksUpdateTriggerId,
			deletedBookmarks: data.deletedBookmarks
		});
		$rootScope.$applyAsync();
	});

	// check if a project has bookmarks that aren't visible on the page
	$rootScope.hasProjectInvisibleBookmarks = function (moduleName = null) {
		// get library modules of the page
		let elements = $rootScope.project.tmpElements || $rootScope.project.elements || [];
		elements = elements.filter(x => x.type == 'PANEL' && x.mode == 'library').map(x => x.module_name);

		// check bookmarks
		if (!$rootScope.bookmarks) return false;
		if (moduleName) {
			if ($rootScope.bookmarks[moduleName] && Object.keys($rootScope.bookmarks[moduleName]).length > 0
				&& !elements.includes(moduleName)) {
				return true;
			}
		} else {
			for (let key of Object.keys($rootScope.bookmarks)) {
				if ($rootScope.bookmarks[key] && Object.keys($rootScope.bookmarks[key]).length > 0
					&& !elements.includes(key)) {
					return true;
				}
			}
		}
		return false;
	};

	// bookmarking by 3rd-party tool
	$rootScope.sendDataToIframeParent = function (row, itemCode = 'TableRow') {
		// external communication with panel iframes
		var message = {
			action: 'Mapegy_Send' + itemCode,
			source: row._meta.module_name,
			// when all API routes are wrapped in the DB's "external layer", use: row._meta.origItem
			data: scoutBackendApi.cleanBookmark(row)
		};
		if (row._meta.context) message.context = row._meta.context;
		$rootScope.showMessage('Data transmitted.', 'success');
		row.sentToCustomer = true;
		parent.postMessage(message, '*');
	};

	// confirm unload if we have selected bookmarks
	$window.addEventListener('beforeunload', function (e) {
		if ($rootScope.suppressUnloadWarning) return;
		if (Object.keys($rootScope.selectedBookmarks).some(key => $rootScope.selectedBookmarks[key].length > 0)
			|| Object.keys($rootScope.selectedProjectBookmarks).some(
				key => $rootScope.selectedProjectBookmarks[key].length > 0
			) || $rootScope.selectedLibraryProjects?.length > 0) {
			e.returnValue = true;
			e.preventDefault();
		}
	});

	// Centralized project actions -----------------------------------------------------

	$rootScope.resetSelectedLibraryProjects = function () {
		($rootScope.selectedLibraryProjects).forEach(item => {
			item.selected = false;
		});
		$rootScope.selectedLibraryProjects = [];
	}
	$rootScope.copyProjectStructure = function (disableProjectIds = [], confirmLabel = null) {
		return new Promise((resolve) => {
			let selTemplate;
			$rootScope.selectProjectsDialog = {
				show: true,
				iconClass: 'fa-solid fa-object-group',
				caption: 'Copy Existing Project Structure',
				content: 'Select which project structure (pages, panels) you want to replicate.',
				modalClass: 'mark-childs-of-selection',
				rightButtonLabel: confirmLabel || 'Save',
				hideNewProjectOption: true,
				showGroupFolders: true,
				disabledProjectIds: disableProjectIds,

				rightButtonCallback: function () {
					// custom template
					selTemplate = $rootScope.selectProjectsDialog.projects;
					selTemplate.template_type = 'MY_TEMPLATE';
					resolve(selTemplate);
				}
			};

			$rootScope.$applyAsync();
		});
	};

	$rootScope.moveProject = function (options) {
		let row = options.row;
		let newFolder = options.newFolder || null;
		let newOwner = options.newOwner || null;
		let preselectID = null;
		if (newOwner && newFolder) return options.cancel();

		if (newFolder && !newFolder.id) {
			preselectID = 'unassigned_folder' + (newFolder.owner_id !== MPG.USER_ID ? '_' + newFolder.owner_id : '');
		}
		if (newOwner) {
			preselectID = 'unassigned_folder' + (newOwner.id !== MPG.USER_ID ? '_' + newOwner.id : '');
		}
		$rootScope.selectProjectsDialog = {
			show: true,
			iconClass: 'fa-solid fa-sitemap',
			caption: 'Move Project',
			rightButtonLabel: 'Move',
			preselect: (newFolder || newOwner) ? (newFolder?.id || preselectID) : null,
			hideNewProjectOption: true,
			filterByOwner: (row.foreign && MPG.USER_ROLE !== 'Admin') ? row.owner_id : false,
			customFoldersTitle: row.foreign ? row.owner : false,
			dialogSubtype: 'SELECT_FOLDER',
			alwaysShowUnassignedProjects: true,
			dropdownFolders: true,
			disabledProjectIds: [row.id],
			inheritPageDisabledState: true,
			leftButtonCallback: () => options.cancel(),
			rightButtonCallback: function () {

				let newParent = options.onAfterFolderSelected($rootScope.selectProjectsDialog.projects);
				// Only continue if the parent changed.
				if (
					(newParent.id === row.parent_id && newParent.owner_id === row.owner_id) || newParent.id === row.id
				) {
					return options.cancel();
				}

				function moveProject () {
					$rootScope.showMessage('Moving ' + (row.item_type == 'FOLDER' ? 'folder' : 'project')
						+ '...', 'pending', null);

					let params = {
						id: row.id,
						parent_id: newParent.id,
						response: { newProjectMeta: true }
					};
					if (!newParent.id && newParent.owner_id && newParent.owner_id !== row.owner_id) {
						let parameters = {
							id: row.id,
							method: 'Move',
							response: { newProjectMeta: true }
						};
						scoutBackendApi.changeProjectOwner(parameters, newParent.owner_id, async function (response) {
							let message = response.message;
							if (row.item_type == 'FOLDER') message = message.replace(/project/g, 'folder');
							$rootScope.showMessage(message, response.status);
							options.updateView(response, row, newParent);
						});
					} else {
						scoutBackendApi.updateProject(params, function (response) {
							let message = response.message;
							if (row.item_type == 'FOLDER') message = message.replace(/project/g, 'folder');
							$rootScope.showMessage(message, response.status);
							options.updateView(response, row, newParent);
						});
					}
				}

				if (MPG.USER_ROLE !== 'Admin' && newParent.foreign && !row.foreign) {
					// Verify
					$rootScope.confirmDialog = {
						show: true,
						iconClass: 'fa-solid fa-user-group',
						caption: 'Confirm Owner Change',
						content: "<b>New Owner:</b> <b style='color: var(--mpg-color-main2)'>" + newParent.owner + "</b>"
							+ "<br> <small>After transfer, only Admins can change the owner.</small>",
						rightButtonLabel: 'Move',
						leftButtonCallback: () => options.cancel(),
						rightButtonCallback: () => moveProject()
					};
				} else {
					// Just move
					moveProject();
				}
			}
		};
	};

	$rootScope.copyProject = function (item, callback) {
		$rootScope.showMessage('Copying project...', 'pending', null);

		let options = {
			template_type: 'MY_TEMPLATE',
			template_clone: true,
			template_id: item.id,
			title: 'Copy of ' + (item.title || MPG.DEFAULT_PROJECT_NAME),
			description: item.description,
			response: { newProjectMeta: true }
		};
		if (item.parent_id) options.parent_id = item.parent_id;

		scoutBackendApi.addProject(options, {
			log_content_type: 'SOURCE_CONTENT'
		}, function (response) {
			$rootScope.showMessage(response.message, response.status);
			callback(response);
		});
	};

	$rootScope.toggleAlerts = function (row, callback) {
		let intervalChoices = {
			1: {
				label: 'Daily',
				alert_days: 1,
				default_result_limit: 40
			},
			7: {
				label: 'Weekly',
				alert_days: 7,
				default_result_limit: 100
			}
		};

		let dataTypes = [
			{
				key: 'news',
				label: 'News'
			},
			{
				key: 'research',
				label: 'Research'
			},
			{
				key: 'patents',
				label: 'Patents'
			},
			{
				key: 'startups',
				label: 'Startups'
			}
		];

		let getField = (key) => $rootScope.confirmDialog.fields.find((x) => x.key == key);

		$rootScope.confirmDialog = {
			show: true,
			iconClass: 'fa-solid fa-bell',
			caption: 'Alerts',
			content: 'You can be notified via email about new articles, patents, scientific publications, '
				+ 'startups, corresponding to your search query.',
			rightButtonLabel: 'OK',
			fields: [
				{
					type: 'checkbox',
					key: 'is_active',
					label: 'Activate Alerts',
					value: !!row.alert_days,
					onChange: () => {
						if (getField('is_active').value) {
							// Set default values
							dataTypes.forEach((x) => getField(x.key).value = true);
							getField('interval').value = intervalChoices[7];
							getField('limit').value = null;
						}
					}
				},
				...dataTypes.map((x) => {
					return {
						type: 'checkbox',
						indent: true,
						key: x.key,
						label: x.label,
						value: row.alert_types ? row.alert_types.includes(x.key) : true,
						condition: () => getField('is_active').value,
						onChange: () => {
							if (dataTypes.every((y) => !getField(y.key).value)) {
								// All alert types unselected => deactivate alert
								getField('is_active').value = false;
							}
						}
					}
				}),
				{
					type: 'select',
					key: 'interval',
					label: 'Notification Interval',
					choices: Object.values(intervalChoices),
					choicesLabelKey: 'label',
					value: intervalChoices[row.alert_days || 7],
					mandatory: true,
					style: { 'margin-top': '1em' },
					condition: () => getField('is_active').value
				},
				{
					type: 'number',
					key: 'limit',
					label: 'Max. Results per Alert',
					value: row.alert_max_results || null,
					min: 1,
					max: 500,
					allowMissingNumber: true,
					placeholder: () => getField('interval').value.default_result_limit,
					hint: 'We will store the latest 10,000 results from all your alerts. Please be aware '
						+ 'that a larger number of results per alert also means that results will disappear'
						+ ' earlier from your alerts overview page. Click to open your alerts overview '
						+ 'page.',
					hintLink: '/alerts',
					condition: () => getField('is_active').value
				}
			],

			leftButtonCallback: () => callback(),
			rightButtonCallback: function () {
				// Get alert interval
				const alertInterval = getField('is_active').value
					? getField('interval').value.alert_days : 0;

				// Get alert types
				let alertTypes = null; // "all"
				if (getField('is_active').value
					&& dataTypes.filter((x) => !getField(x.key).value).length) {
					alertTypes = dataTypes.filter((x) => getField(x.key).value).map((x) => x.key);
				}

				// Get alert result limit
				let resultLimit = getField('limit').value ? getField('limit').value : null;
				if (!getField('is_active').value) resultLimit = null;

				// Check if something changed
				if ((row.alert_days || 0) != alertInterval
					|| JSON.stringify(row.alert_types || null) != JSON.stringify(alertTypes)
					|| (row.alert_max_results || null) != resultLimit) {
					$rootScope.showMessage('Updating alert settings...', 'pending', null);

					let params = {
						id: row.id, // project ID
						alert_days: alertInterval,
						alert_types: alertTypes,
						alert_max_results: resultLimit,
						response: { newProjectMeta: true }
					};

					scoutBackendApi.updateProjectAlert(params, function (response) {
						$rootScope.showMessage(response.message, response.status);
						callback(response);
					});

					let alertDays = $rootScope.confirmDialog.fields[0].value.alert_days;
					let interaction = alertDays === 1 ? 'Daily Alert Activated'
						: alertDays === 7 ? 'Weekly Alert Activated'
							: 'Alert Deactivated';
					mixpanel.track('Project Interaction', { interaction_name: interaction });

				} else {
					callback();
				}
			}
		};
	};

	// Change owner to a group
	$rootScope.moveFolder = function (config) {
		const rows = config.folders?.length ? config.folders : [config.project];
		let row = rows[0];
		let preselectedOwner = config.preselect || null;

		// Load list of Scout users
		let groups = angular.copy(config.groups)
			.filter(function (x) {
				return x.id != row.owner_id;
			}).map(function (item) {
				item.label = item.full_name;
				item.role = 'Group';
				return item;
			});

		if (MPG.USER_ROLE == 'Admin' && row.foreign && config.user) {
			let userContact = angular.copy(config.user);
			userContact.label = userContact.full_name;
			groups.unshift(userContact);
		}

		const fields = [];
		if (rows.length > 1) {
			fields.push({
				type: 'output',
				label: 'Folders',
				noStyle: true,
				output: () => $rootScope.tagsFormatter([{
					data: rows.map(folder => folder.title),
					color: 'var(--mpg-color-dark-grey)',
					class: 'm-table-tag move-folders-dialog-folder'
				}])
			});
		}
		fields.push({
			type: 'select',
			label: 'New Owner',
			choices: groups,
			choicesLabelKey: 'label',
			value: preselectedOwner ? groups.find(x => x.id === preselectedOwner) : groups[0],
			mandatory: true
		});

		$rootScope.confirmDialog = {
			show: true,
			iconClass: 'fa-solid fa-sitemap',
			caption: rows.length > 1 ? 'Move Folders' : 'Move Folder',
			rightButtonLabel: 'Move',
			fields,

			leftButtonCallback: () => config.callback(),
			rightButtonCallback: function () {
				let newOwner = $rootScope.confirmDialog.fields.find(field => field.type === 'select').value;

				function moveFolder () {
					$rootScope.showMessage('Moving folder' + (rows.length > 1 ? 's' : '') + '...', 'pending', null);

					const results = [];
					for (const folder of rows) {
						scoutBackendApi.changeProjectOwner({
							id: folder.id,
							response: { newProjectMeta: true }
						}, newOwner.id, function (response) {
							results.push({ folder, response });
							if (results.length !== rows.length) return;

							const failedCount = results.filter(result => result.response.status !== 'success').length;
							let combinedResponse = results[0].response;
							if (rows.length > 1) {
								combinedResponse = {
									status: failedCount ? 'error' : 'success',
									message: failedCount
										? (rows.length - failedCount) + ' of ' + rows.length + ' folders were moved. '
										+ failedCount + ' failed.'
										: 'Folders were moved to the new owner.'
								};
							} else {
								combinedResponse.message = combinedResponse.message.replace(/project/g, 'folder');
							}
							$rootScope.showMessage(combinedResponse.message, combinedResponse.status);
							config.callback(combinedResponse, newOwner, results);
						});
					}
				}

				if (MPG.USER_ROLE !== 'Admin' && rows.some(folder => !folder.foreign)) {
					// Verify
					$rootScope.confirmDialog = {
						show: true,
						iconClass: 'fa-solid fa-user-group',
						caption: 'Confirm Owner Change',
						content: "<b>New Owner:</b> <b style='color: var(--mpg-color-main2)'>" + newOwner.label + "</b>"
							+ "<br> <small>After transfer, only Admins can change the owner.</small>",
						rightButtonLabel: 'Move',
						leftButtonCallback: () => config.callback(),
						rightButtonCallback: () => moveFolder()
					};
				} else {
					// Just move
					moveFolder();
				}

			}
		};
	};

	$rootScope.deleteProject = function (row, projectsCount = null, callback) {
		$rootScope.confirmDialog = {
			show: true,
			iconClass: 'fa-solid fa-trash',
			caption: 'Delete Project',
			content: "Delete <b style='color:var(--mpg-color-main)'>"
				+ htmlEscape(row.title || MPG.DEFAULT_PROJECT_NAME) + "</b> ?",
			remark: row.item_type == 'FOLDER' && projectsCount && projectsCount > 0
				? '<span style="color:var(--mpg-color-alert2)">The folder contains '
				+ projectsCount + ' project' + (projectsCount > 1 ? 's' : '')
				+ ' that will be deleted as well!</span>'
				: '',
			rightButtonLabel: 'Delete',

			leftButtonCallback: () => callback(),
			rightButtonCallback: function () {
				$rootScope.showMessage(
					'Deleting ' + (row.item_type == 'FOLDER' ? 'folder' : 'project') + '...', 'pending', null
				);

				scoutBackendApi.removeProject({
					id: row.id
				}, function (response) {
					let message = response.message;
					if (row.item_type == 'FOLDER') message = message.replace(/project/g, 'folder');
					$rootScope.showMessage(message, response.status);
					callback(response);
				});
			}
		};
	};

	// Transform the content of projects of a folder based on an existing template - only available for MAPEGY team.
	$rootScope.transformProjects = function (config) {
		let folder = config.folder;

		async function processProjects (template) {
			let projects = config.projects;
			let cancelled = false;

			$rootScope.confirmDialog = {
				show: true,
				iconClass: 'fa-solid fa-reflect-horizontal',
				caption: 'Transforming Projects…',
				rightButtonLabel: 'Cancel',
				content: '0 / ' + projects.length,
				closeRight: true,
				leftButtonCallback: function () {
					cancelled = true;
				},
				rightButtonCallback: function () {
					cancelled = true;
				}
			};
			$rootScope.$applyAsync();

			const updateStatus = (text) => {
				$rootScope.confirmDialog.content = text;
				$rootScope.$applyAsync();
			};
			const showError = (text) => {
				$rootScope.confirmDialog.content =
					'<span style="color:var(--mpg-color-alert)">' + htmlEscape(text) + '</span>';
				$rootScope.$applyAsync();
			};

			for (let [idx, project] of projects.entries()) {
				if (cancelled) break;

				updateStatus((idx + 1) + ' / ' + projects.length +
					'<span style="color:#aaa; margin-left:10px">Transforming project…</span>'
				);

				await new Promise((resolve) => {
					scoutBackendApi.transformProject(
						{ project_id: project, template_id: template },
						function (response) {
							if (response.status !== 'success') {
								cancelled = true;
								showError('Failed to transform projects');
								$rootScope.showMessage('Project(s) could not be transformed.', 'error');
							}
							resolve();
						}
					);
				});
			}

			if (!cancelled) {
				$rootScope.confirmDialog.show = false;
				$rootScope.showMessage('Project(s) transformed.', 'success');
			}
		};
		$rootScope.copyProjectStructure([folder.id], 'Use as template')
			.then(template => {
				$rootScope.$applyAsync();
				// Verify
				$rootScope.confirmDialog = {
					show: true,
					iconClass: 'fa-solid fa-reflect-horizontal',
					caption: 'Transform Projects',
					content: "Transform all projects from the <b style='color:var(--mpg-color-main)'>"
						+ htmlEscape(folder.title) + "</b> folder?"
						+ "<br> <small> Content elements and subpages from these projects will be irreversibly deleted!"
						+ "</small>",
					fields: [
						{
							type: 'checkbox',
							label: 'Yes, I confirm.',
							mandatory: true
						}
					],
					rightButtonLabel: 'Transform',
					rightButtonCallback: () => processProjects(template.id)
				};

			}).catch(error => {
			$rootScope.showMessage('Project(s) could not be transformed.', 'error');
			console.log(error);
		});
	};

	// Change owner to a SCOUT user by contact id - only available for MAPEGY group
	$rootScope.handOverProject = function (row, callback) {
		let itemType = row.item_type == 'FOLDER' ? 'folder' : 'project';

		let groups = [];
		let users = [];

		// Prepare options
		var options = [];
		options.push({
			title: 'Group',
			choices: groups,
			choicesLabelKey: 'label',
			value: null
		});
		options.push({
			title: 'User',
			choices: users,
			choicesLabelKey: 'label',
			value: null
		});

		$rootScope.confirmDialog = {
			show: true,
			loading: true,
			iconClass: 'fa-solid fa-people-carry',
			caption: 'Hand Over / Deliver',
			content: 'You\'re about to hand over the ' + itemType
				+ ' <b style="color:var(--mpg-color-main)">'
				+ htmlEscape(row.title || MPG.DEFAULT_PROJECT_NAME)
				+ '</b> to another SCOUT user.',
			remark: 'In case the new owner is a group, the ' + itemType
				+ ' will be shared automatically with the group\'s members.',
			rightButtonLabel: 'Apply',
			fields: [
				{
					type: 'radio',
					choices: ['Copy', 'Move'],
					value: 'Copy',
					label: 'Method',
					mandatory: true
				},
				{
					type: 'radio',
					label: 'New owner:',
					choices: options,
					choicesLabelKey: 'title',
					value: options[0],
					mandatory: true
				}
			],

			leftButtonCallback: () => callback(),
			rightButtonCallback: function () {
				let selectedUser = $rootScope.confirmDialog.fields[1].value.value;

				$rootScope.showMessage($rootScope.confirmDialog.fields[0].value == 'Copy' ? 'Copying'
					: 'Moving' + ' ' + (row.item_type == 'FOLDER' ? 'folder' : 'project')
					+ '...', 'pending', null);

				let params = {
					id: row.id,
					method: $rootScope.confirmDialog.fields[0].value,
					response: { newProjectMeta: true }
				};

				scoutBackendApi.changeProjectOwner(params, selectedUser.id, async function (response) {
					let message = response.message;
					if (row.item_type == 'FOLDER') message = message.replace(/project/g, 'folder');
					$rootScope.showMessage(message, response.status);
					callback(response, params, selectedUser.id);
				});
			}
		};

		// Load list of scout users
		scoutBackendApi.getScoutUsers(function (response) {
			if (response.status == 'success') {
				for (let item of response.data) {
					item.label = item.full_name + (item.email ? ', ' + item.email : '')
						+ ' (ID ' + item.id + ')';
					if (item.role == 'Group') groups.push(item);
					else users.push(item);
				}
				groups = groups.sort((a, b) => ('' + a.label).localeCompare(b.label));
				users = users.sort((a, b) => ('' + a.label).localeCompare(b.label));
				$rootScope.confirmDialog.loading = false;
				$rootScope.$applyAsync();
			}
		});
	};

	// Centralized Scout analysis actions --------------------------------------------------

	const ANALYSIS_KEY_MAPPING = {
		NEWS: {
			NEWS: 'NEWS__TOP_CATEGORIES',
			NEWS_THREAT: 'NEWS__THREAT_DETECTION',
			NEWS_SENTIMENTS: 'NEWS__SENTIMENT_ANALYSIS',
			APPLICATION_AREAS: 'NEWS__APPLICATION_AREAS',
			MATERIALS_IDENTIFICATION: 'NEWS__MATERIALS_IDENTIFICATION',
			PUBLICATIONS_EMERGING_TECHNOLOGIES: 'NEWS__EMERGING_TECHNOLOGIES',
			PUBLICATIONS_HIGH_TRL: 'NEWS__HIGH_TRL_TECHNOLOGIES',
			NEWS_LEGAL: 'NEWS__LEGAL_UPDATES',
			NEWS_MA: 'NEWS__M&A_UPDATES',
			NEWS_STARTUPS: 'NEWS__STARTUP_UPDATES',
			NEWS_PRODUCT: 'NEWS__PRODUCT_INNOVATIONS',
			NEWS_SIGNAL: 'NEWS__INNOVATION_TRENDS',
			NEWS_FUNDING: 'NEWS__R&D_GRANTS_FUNDING',
			NEWS_REPORT: 'NEWS__STRATEGIC_REPORTS',
		},
		RESEARCH: {
			RESEARCH: 'RESEARCH__TOP_CATEGORIES',
			PUBLICATIONS_EMERGING_TECHNOLOGIES: 'RESEARCH__EMERGING_TECHNOLOGIES',
			PUBLICATIONS_HIGH_TRL: 'RESEARCH__HIGH_TRL_TECHNOLOGIES',
			APPLICATION_AREAS: 'RESEARCH__APPLICATION_AREAS',
			MATERIALS_IDENTIFICATION: 'RESEARCH__MATERIALS_IDENTIFICATION',
		},
		PATENTS: {
			PATENTS: 'PATENTS__TOP_CATEGORIES',
			APPLICATION_AREAS: 'PATENTS__APPLICATION_AREAS',
			MATERIALS_IDENTIFICATION: 'PATENTS__MATERIALS_IDENTIFICATION',
			PUBLICATIONS_EMERGING_TECHNOLOGIES: 'PATENTS__EMERGING_TECHNOLOGIES',
			PUBLICATIONS_HIGH_TRL: 'PATENTS__HIGH_TRL_TECHNOLOGIES',
		},
		PROJECTS: {
			PUBLICATIONS_EMERGING_TECHNOLOGIES: 'PROJECTS__EMERGING_TECHNOLOGIES',
			PUBLICATIONS_HIGH_TRL: 'PROJECTS__HIGH_TRL_TECHNOLOGIES',
			APPLICATION_AREAS: 'PROJECTS__APPLICATION_AREAS',
		},
		COMPANIES: {
			COMPANIES: 'COMPANIES__TOP_ORGANIZATIONS',
			PEERS_AND_PARTNERS_CLASSIFICATION: 'COMPANIES__CLASSIFICATION',
			PEERS_AND_PARTNERS_SUPPLIERS: 'COMPANIES__SUPPLIERS',
		},
		STARTUPS: {
			STARTUPS: 'STARTUPS__TOP_ORGANIZATIONS',
			PEERS_AND_PARTNERS_CLASSIFICATION: 'STARTUPS__CLASSIFICATION',
			PEERS_AND_PARTNERS_SUPPLIERS: 'STARTUPS__SUPPLIERS',
		},
		PUBLIC_INSTITUTIONS: {
			PUBLIC_INSTITUTIONS: 'PUBLIC_INSTITUTIONS__TOP_ORGANIZATIONS',
		}
	};

	const NEWS_FILTERS = {
		'PRODUCT': {
			serverSideFilter: 'NEWS__PRODUCT',
			configuration: { items: [{ id: 'PRODUCT', title: 'PRODUCT' }] }
		},
		'SIGNAL': { serverSideFilter: 'NEWS__SIGNAL', configuration: { items: [{ id: 'SIGNAL', title: 'SIGNAL' }] } },
		'STARTUP': {
			serverSideFilter: 'NEWS__STARTUP',
			configuration: { items: [{ id: 'STARTUP', title: 'STARTUP' }] }
		},
		'M&A': { serverSideFilter: 'NEWS__M&A', configuration: { items: [{ id: 'M&A', title: 'M&A' }] } },
		'LEGAL': { serverSideFilter: 'NEWS__LEGAL', configuration: { items: [{ id: 'LEGAL', title: 'LEGAL' }] } },
		'FUNDING': {
			serverSideFilter: 'NEWS__FUNDING',
			configuration: { items: [{ id: 'FUNDING', title: 'FUNDING' }] }
		},
		'REPORT': { serverSideFilter: 'NEWS__REPORT', configuration: { items: [{ id: 'REPORT', title: 'REPORT' }] } },
	};


	$rootScope.getAnalysisUseCases = function (currentModule, queryName, query) {
		const PUBLICATION_MODULES = ['NEWS', 'PATENTS', 'RESEARCH', 'PROJECTS'];
		const ORGANIZATION_MODULES = ['COMPANIES', 'STARTUPS', 'PUBLIC_INSTITUTIONS'];
		const TOP_INNOVATION_MODULES = ['PATENTS', 'RESEARCH', 'NEWS'];
		const ALL_MODULES = [...PUBLICATION_MODULES, ...ORGANIZATION_MODULES];

		const MODULE_NAMES = {
			NEWS: 'News',
			PATENTS: 'Patents',
			RESEARCH: 'Research',
			PROJECTS: 'Projects',
			COMPANIES: 'Companies',
			STARTUPS: 'Startups',
			PUBLIC_INSTITUTIONS: 'Public Institutions'
		};
		const isGeneralAnalysis = !currentModule;
		const activeModules = isGeneralAnalysis
			? ALL_MODULES
			: [currentModule.AI_summary_type];

		const queryText = '<b>' + (queryName || 'query') + '</b>';
		const useCases = [];

		activeModules.forEach(modType => {
			const modName = isGeneralAnalysis ? MODULE_NAMES[modType] : currentModule.name;
			const filterText = isGeneralAnalysis ? '' : '<br><br>Generated using your currently applied filters.';
			const isPublication = PUBLICATION_MODULES.includes(modType);
			const isOrganization = ORGANIZATION_MODULES.includes(modType);
			const isTopInnovation = TOP_INNOVATION_MODULES.includes(modType);
			const isNews = modType === 'NEWS';

			const addUseCase = (label, description, type, condition, filterOptions = null) => {
				if (!condition) return;

				const mappedType = isGeneralAnalysis
					? (ANALYSIS_KEY_MAPPING[modType]?.[type] ?? type)
					: type;

				useCases.push({
					group: modName,
					label,
					description,
					useCaseSummaryType: mappedType,
					filterOptions,
					categoryType: isOrganization ? 'organization' : 'topic'
				});
			};

			// --- Publications ---

			addUseCase(
				'Top 5 SCOUT categories',
				'Summary of the top 5 categories, highlighting key focus areas related to your query '
				+ queryText + ', based on results from the ' + modName + ' panel. ' + filterText,
				modType,
				isTopInnovation
			);

			addUseCase(
				'Technology and concept identification',
				'Summary of key emerging technologies identified from the ' + modName + ' panel results for your '
				+ queryText + '. ' + filterText,
				'PUBLICATIONS_EMERGING_TECHNOLOGIES',
				isPublication
			);

			addUseCase(
				'High-TRL technologies',
				'Summary of technologies with TRL (Technology Readiness Level) identified from the '
				+ modName + ' panel results for your query ' + queryText + '. ' + filterText,
				'PUBLICATIONS_HIGH_TRL',
				isPublication
			);

			addUseCase(
				'Product innovations',
				'Summary of product-related innovations across industries related to your query ' + queryText
				+ ' based on results from the News panel. '
				+ (isGeneralAnalysis
						? ''
						: '<br><br>The GENRE - PRODUCT filter is applied. '
						+ 'This filter retrieves news on product launches, and breakthrough solutions.'
				),
				'NEWS_PRODUCT',
				isNews,
				NEWS_FILTERS.PRODUCT
			);

			addUseCase(
				'Innovation trends',
				'Summary of emerging innovation trends and notable technological advancements related to your query '
				+ queryText + ' based on results from the News panel. '
				+ (isGeneralAnalysis
						? ''
						: '<br><br>The GENRE - SIGNAL filter is applied. '
						+ 'This filter retrieves news on forward-looking developments and R&D directions.'
				),
				'NEWS_SIGNAL',
				isNews,
				NEWS_FILTERS.SIGNAL
			);

			addUseCase(
				'Application identification',
				'Summary of key applications related to your query ' + queryText
				+ ' based on results from the ' + modName + ' panel. ' + filterText,
				'APPLICATION_AREAS',
				isPublication
			);

			addUseCase(
				'Material identification',
				'Summary of key materials related to your query ' + queryText
				+ ' based on results from the ' + modName + ' panel. ' + filterText,
				'MATERIALS_IDENTIFICATION',
				isTopInnovation
			);

			addUseCase(
				'Startup identification',
				'Summary of startup activities, new business launches, and early-stage investor movements related '
				+ 'to your query ' + queryText + ' based on results from the News panel. '
				+ (isGeneralAnalysis
						? ''
						: '<br><br>The GENRE - STARTUPS filter is applied. '
						+ 'This filter retrieves news on new tech companies, venture capital funding, '
						+ 'accelerators and incubators.'
				),
				'NEWS_STARTUPS',
				isNews,
				NEWS_FILTERS.STARTUP
			);

			addUseCase(
				'Mergers & acquisitions',
				'Summary of reported mergers, acquisitions, and major investment activities related to your query '
				+ queryText + ' based on results from the News panel. '
				+ (isGeneralAnalysis
						? ''
						: '<br><br>The GENRE - M&A filter is applied. '
						+ 'This filter retrieves news on business relations, partnerships, and mergers '
						+ 'and acquisitions.'
				),
				'NEWS_MA',
				isNews,
				NEWS_FILTERS['M&A']
			);

			addUseCase(
				'Legal updates',
				'Summary of key regulatory changes and legal developments related to your query '
				+ queryText + ' based on results from the News panel. '
				+ (isGeneralAnalysis
						? ''
						: '<br><br>The GENRE – LEGAL filter is applied. '
						+ 'This filter retrieves legal news on legislations, regulatory changes, '
						+ 'government policies, and intellectual property issues.'
				),
				'NEWS_LEGAL',
				isNews,
				NEWS_FILTERS.LEGAL
			);

			addUseCase(
				'Threat identification',
				'Summary of the key threats related to your query '
				+ queryText + ' based on results from the News panel. ' + filterText,
				'NEWS_THREAT',
				isNews
			);

			addUseCase(
				'Sentiment analysis',
				'Sentiment analysis of news articles revealing public and media perception to your query '
				+ queryText + '. ' + filterText,
				'NEWS_SENTIMENTS',
				isNews
			);

			addUseCase(
				'R&D grants and fundings',
				'Summary of key grants, funding programs, and financial initiatives supporting R&D efforts related '
				+ 'to your query ' + queryText + ', based on result from the News panel. '
				+ (isGeneralAnalysis
						? ''
						: '<br><br>The GENRE - FUNDING filter is applied. '
						+ 'This filter retrieves news on relevant subsidies, '
						+ 'awards, and public or private investments.'
				),
				'NEWS_FUNDING',
				isNews,
				NEWS_FILTERS.FUNDING
			);

			addUseCase(
				'Strategic reports',
				'Summary of key insights, trends, and strategic findings from expert reports related to your query '
				+ queryText + ', based on results from the News panel. '
				+ (isGeneralAnalysis
						? ''
						: '<br><br>The GENRE - REPORT filter is applied. '
						+ 'This filter retrieves market research reports providing in-depth analysis '
						+ 'of a specific industry or market landscape, '
						+ 'including assessments of competitive dynamics, trend forecasts, and opportunities.'
				),
				'NEWS_REPORT',
				isNews,
				NEWS_FILTERS.REPORT
			);

			// --- Organizations ---

			const orgLabel = modType === 'PUBLIC_INSTITUTIONS' ? 'Leading public institutions'
				: modType === 'STARTUPS' ? 'Leading startups'
					: 'Leading organizations';

			addUseCase(
				orgLabel,
				'Summary of leading organizations and their relevance to your search. '
				+ 'Focuses on key players contributing to or influencing your query '
				+ queryText + '. ' + filterText,
				modType,
				isOrganization
			);

			const effectiveModType = currentModule?.AI_summary_type || modType;
			const isCompanyOrStartup = ['COMPANIES', 'STARTUPS'].includes(effectiveModType);

			addUseCase(
				'Value chain exploration',
				'Classification of organizations by their relationship to your query ' + queryText
				+ ': supplier, manufacturer, vendor, or innovator. ' + filterText,
				'PEERS_AND_PARTNERS_CLASSIFICATION',
				isCompanyOrStartup
				&& ($rootScope.isQueryDataExclusive(query, ['topics'])
					|| $rootScope.isQueryDataExclusive(query, ['semantic']))
			);

			addUseCase(
				'Suppliers & competitors',
				'Classification of organizations by their relationship to your query ' + queryText
				+ ': supplier, competitor, or affiliated brand/subsidiary. ' + filterText,
				'PEERS_AND_PARTNERS_SUPPLIERS',
				isCompanyOrStartup && $rootScope.isQueryDataExclusive(query, ['organizations'])
			);
		});

		return useCases;
	};

	$rootScope.generateAnalysisHtml = function (flatResults, useCaseDescription) {
		let html = `<p class="analysis-usecase-description">${ useCaseDescription }</p>
			<div class="analysis-container">`;

		html += flatResults.map((category, categoryIdx) => `
			${ category?.category_style === 'big' ? `
				<div class="analysis-category analysis-category-big">
					<h2 style="margin: 10px 0">
						 <span style="display:none;">SPACER</span>${
			category.category ? htmlEscape(category.category) : `` }
					</h2>
					${ category.summary ? `
						<p style="margin:0; line-height:1.2em; font-size:16px;">
							${ htmlEscape(category.summary) }
						</p>
					` : `` }
				</div>
			` : `` }
			${ !category?.category_style ? `
				<p class="analysis-category">
					 <span style="display:none;">SPACER</span><b>${ category.category
			? htmlEscape(category.category)
			: ``
		}${ category.category && category.summary ? `:` : `` }</b>${
			category.summary ? ` ${ htmlEscape(category.summary) }` : `` }
				</p>
			` : `` }
			${ Array.isArray(category.notes) ? category.notes.map(note =>
			// This exceeds the line limit to avoid line breaks in copied plain text
			`<p class="analysis-category-note">
					<span class="analysis-category-note-value">
						<i style="font-style:normal;">
							<b style="font-weight:normal;">${ htmlEscape(note.key) }</b></i></span><i style="padding: 2px 0"> - ${ htmlEscape(note.value) }</i>
				</p>`
		).join('') : '' }

			${ category?.related_items ? `
				<ul class="analysis-category-articles">
					${ category.related_items.map((article, articleIdx) => `
						<li style="margin-bottom:3px; line-height:1.3em;
							display:flex; align-items:flex-start;
							${ article.remark ? `padding-bottom:8px;` : `` }">
							${ article.panelItem?._meta ? `
								<span class="m-checkbox analysis-bookmark-checkbox
								${ article.panelItem._meta.selected
			? 'checked'
			: ''
		}"
								data-category-idx="${ categoryIdx }"
								data-article-idx="${ articleIdx }"
								onclick="angular.element(this).scope().$root.confirmDialog.toggleAnalysisBookmark(this, event)">
								<div></div>
								</span>
							` : `` }
							<span style="flex:1;">
							${ article.link ? `
								<a href="${ htmlEscape(article.link) }"
								target="_blank" onclick="event.stopPropagation();">
								<span style="text-decoration:none;"
									class="m-link-default">
								${ article.remark
			? `<b class=
										"analysis-reference-link-with-remark">`
			: `` }
								${ htmlEscape(article.title) }${ article.remark
			? `</b>`
			: ``
		}</span></a>${ article.remark ?
			// This exceeds the line limit to avoid line breaks
			`<span style="padding-left:4px"><i
								style="font-size:9px"
								class="fa-solid fa-external-link-alt"></i></span><span>: ${ htmlEscape(article.remark) }</span>` : `` }
								${ !article.remark
			? ` <span style="padding-left:2px"><i
										style="font-size:9px"
										class="fa-solid fa-external-link-alt"></i>
										</span>`
			: ``
		}
							` : `
								<span>${ article.remark
			? `<b
										style="color:var(--mpg-color-dark-grey);">`
			: ``
		}${ htmlEscape(article.title) }${ article.remark
			? `</b>` : `` }</span>${ article.remark
			? `: ${ htmlEscape(article.remark) }`
			: ``
		}
							` }
							</span>
						</li>
					`).join('') }
				</ul>
			` : `` }
		`).join('');
		html += `</div>`;
		return html;
	};

	// Centralized preset actions --------------------------------------------------

	$rootScope.getDefaultPresets = function (includePatentOffices = true) {
		let presetsMap = Object.fromEntries(defaultPresetsKeys.map(k => [k, []]));
		let sources = includePatentOffices ? [countries, regionalPatentOffices] : [countries];
		sources.forEach(group =>
			Object.entries(group).forEach(([code, data]) =>
				data.presets?.forEach(preset => {
					if (presetsMap[preset]) presetsMap[preset].push(code);
				})
			)
		);

		// Sort presetsMap by keys alphabetically before returning
		return Object.fromEntries(Object.entries(presetsMap).sort(([a], [b]) => a.localeCompare(b)));
	}

	$rootScope.getPresetTooltip = function (presetCodes, addHeadline = false) {
		let countries = presetCodes
			.map(code => getCountryOrPatentOfficeByCode(code)?.name || code)
			.sort((a, b) => a.localeCompare(b))
			.join(', ');
		return addHeadline ? `<b>Default Preset</b> <br>${ countries }` : countries;
	}

	/* Import functions -------------------------------------------------------------
		- used to prepare API data for panels
		- used to prepare 3rd-party items for bookmarking
	*/

	$rootScope.getRequiredFieldsForApiDataImport = function (type, additionalFields = []) {
		let fields = [];
		if (Array.isArray(type)) {
			for (let t of type) fields = Array.from(new Set([...fields, ...$rootScope.importApiDataItem(t)]));
		} else {
			fields = $rootScope.importApiDataItem(type);
		}

		return Array.from(new Set([...fields, ...additionalFields]));
	};

	// if responseItem is set, the data will be mapped to the frontend format
	// if responseItem is not set, the list of required 'include' fields will be returned
	$rootScope.importApiDataItem = function (type, responseItem, wk) {
		let bookmarkSettings = {};
		if (wk) bookmarkSettings.wk = wk;
		else bookmarkSettings.targetModule = type;

		try {
			switch (type) {
				case 'web':
				case 'podcasts':
					if (!responseItem) return ['doc_id', 'score_relevance', 'title', 'abstract', 'web_links', 'web_links_broken'];
					else {
						var bookmark_id = responseItem.doc_id;
						var saveBookmarkContent = false;
						if (!bookmark_id) {
							// bing news don't have an ID because they are retrieved on-the-fly from a 3rd party
							bookmark_id = responseItem.web_links.homepage;
							saveBookmarkContent = true;
						}

						// highlighting can be disabled in shared-projects
						if (!wk.highlight_keywords) {
							if (responseItem.title) responseItem.title = htmlEscape(responseItem.title);
							if (responseItem.abstract) responseItem.abstract = htmlEscape(responseItem.abstract);
						}

						var entry = {
							score_relevance: responseItem.score_relevance, // will be reset for bookmarks if saveBookmarkContent==true
							title: stripTagsAndUnescapeHTML(responseItem.title),
							title_html: responseItem.title, // won't be bookmarked if saveBookmarkContent==true
							description: stripTagsAndUnescapeHTML(responseItem.abstract),
							description_html: responseItem.abstract, // won't be bookmarked if saveBookmarkContent==true
							url: responseItem.web_links.homepage,
							url_broken: responseItem.web_links_broken.homepage,
							source: null
						};
						try {
							entry.source = new URL($rootScope.cleanUrl(entry.url)).hostname;
						} catch (e) {
						}
						entry._meta = $rootScope.getBookmarkMeta(bookmark_id, responseItem,
							Object.assign(bookmarkSettings, { saveBookmarkContent: saveBookmarkContent }));
						return entry;
					}
				case 'signals':
				case 'forecasts':
				case 'news':
					if (!responseItem) {
						let fields = ['doc_id', 'score_relevance', 'title', 'abstract', 'news_meta', 'organization_names',
							'expert_names', 'doc_sub_type', 'doc_timestamp', 'web_links', 'web_links_broken',
							'inserted_timestamp', 'topics'];
						if (type == 'forecasts') fields.push('forecast_meta');
						return fields;
					} else {
						var bookmark_id = responseItem.doc_id;
						var saveBookmarkContent = false;
						if (!bookmark_id) {
							// bing news don't have an ID because they are retrieved on-the-fly from a 3rd party
							bookmark_id = responseItem.web_links.homepage;
							saveBookmarkContent = true;
						}

						// highlighting can be disabled in shared-projects
						if (!wk.highlight_keywords) {
							if (responseItem.title) responseItem.title = htmlEscape(responseItem.title);
							if (responseItem.abstract) responseItem.abstract = htmlEscape(responseItem.abstract);
						}

						var entry = {
							/*
								Due to the need for content-based bookmarking,
								keep these fields consistent with cronjob.alerts.js of the cronjobs application!
							*/
							score_relevance: responseItem.score_relevance,
							title: stripTagsAndUnescapeHTML(responseItem.title),
							title_html: responseItem.title, // won't be bookmarked if saveBookmarkContent==true
							description: stripTagsAndUnescapeHTML(responseItem.abstract),
							description_html: responseItem.abstract, // won't be bookmarked if saveBookmarkContent==true
							source: responseItem.news_meta.source,
							published: responseItem.doc_timestamp ? responseItem.doc_timestamp.substr(0, 10) : null,
							published_timestamp: responseItem.doc_timestamp ? (new Date(responseItem.doc_timestamp.replace(' UTC', 'Z').replace(' ', 'T')).getTime()) : null,
							mentions: [].concat(responseItem.organization_names).concat(responseItem.expert_names),
							tags: responseItem.news_meta.source_tags,
							genres: responseItem.doc_sub_type.filter(x => ['STARTUP', 'SIGNAL', 'FUNDING', 'LEGAL', 'M&A', 'REPORT', 'PRODUCT'].includes(x)),
							sector: responseItem.topics.SECTOR ? responseItem.topics.SECTOR.map((x) => x.term)[0] : null,
							url: responseItem.web_links.homepage,
							url_broken: responseItem.web_links_broken.homepage,
							inserted_timestamp: new Date(responseItem.inserted_timestamp.replace(' UTC', 'Z').replace(' ', 'T')).getTime()
						};
						if (type == 'forecasts') entry.predict_year = responseItem.forecast_meta.predict_year;
						entry._meta = $rootScope.getBookmarkMeta(bookmark_id, responseItem,
							Object.assign(bookmarkSettings, { saveBookmarkContent: saveBookmarkContent }));
						return entry;
					}
				case 'research':
					if (!responseItem) return ['doc_id', 'score_relevance', 'title', 'science_meta', 'topics',
						'doc_sub_type', 'doc_timestamp', 'web_links', 'web_links_broken', 'inserted_timestamp'];
					else {
						var bookmark_id = responseItem.doc_id;

						// highlighting can be disabled in shared-projects
						if (!wk.highlight_keywords) {
							if (responseItem.title) responseItem.title = htmlEscape(responseItem.title);
						}

						var entry = {
							score_relevance: responseItem.score_relevance,
							title: stripTagsAndUnescapeHTML(responseItem.title),
							title_html: responseItem.title,
							authors: (responseItem.science_meta.authors || []).map(function (x) {
								if (x.name) return x.name;
								else if (x.family && x.given) return x.family + ', ' + x.given;
								else if (x.family) return x.family;
								else if (x.given) return x.given;
								else {
									console.log('ERROR: Unknown format in crossref_authors');
									console.log(x);
									return '-';
								}
							}),
							published_timestamp: responseItem.doc_timestamp ? (new Date(responseItem.doc_timestamp.replace(' UTC', 'Z').replace(' ', 'T')).getTime()) : null,
							publisher: responseItem.science_meta.publisher || null,
							series: responseItem.science_meta.series || null,
							source_type: responseItem.doc_sub_type.filter((x) => ['BOOK', 'ARTICLE'].includes(x))[0] || null,
							scientific_fields: responseItem.topics.SCIENCE.map((x) => x.term),
							sector: responseItem.topics.SECTOR ? responseItem.topics.SECTOR.map((x) => x.term)[0] : null,
							url: responseItem.web_links.homepage,
							url_broken: responseItem.web_links_broken.homepage,
							inserted_timestamp: new Date(responseItem.inserted_timestamp.replace(' UTC', 'Z').replace(' ', 'T')).getTime(),
							_meta: $rootScope.getBookmarkMeta(bookmark_id, responseItem, bookmarkSettings)
						};
						return entry;
					}
				case 'patents':
					if (!responseItem) return ['doc_id', 'score_relevance', 'title', 'patent_meta', 'topics',
						'doc_timestamp', 'abstract', 'web_links', 'web_links_broken', 'inserted_timestamp'];
					else {
						var bookmark_id = responseItem.doc_id;

						// highlighting can be disabled in shared-projects
						if (!wk.highlight_keywords) {
							if (responseItem.title) responseItem.title = htmlEscape(responseItem.title);
							if (responseItem.abstract) responseItem.abstract = htmlEscape(responseItem.abstract);
						}

						var entry = {
							score_relevance: responseItem.score_relevance,
							title: stripTagsAndUnescapeHTML(responseItem.title),
							title_html: responseItem.title,
							description: responseItem.abstract
								? stripTagsAndUnescapeHTML(responseItem.abstract) : null,
							description_html: responseItem.abstract || null,
							inventors: responseItem.patent_meta.inventors
								? responseItem.patent_meta.inventors.map(x => x.person_name) : [],
							applicants: responseItem.patent_meta.applicants
								? responseItem.patent_meta.applicants.map(x => x.person_name) : [],
							patent_office: responseItem.patent_meta.patent_office,
							granted: ['true', 'false'].includes(responseItem.patent_meta.granted)
								? responseItem.patent_meta.granted : null,
							filing_year: responseItem.doc_timestamp
								? (parseInt(responseItem.doc_timestamp.substr(0, 4)) || null) : null,
							filing_date: responseItem.doc_timestamp
								? responseItem.doc_timestamp.substr(0, 10) : null,
							filing_timestamp: responseItem.doc_timestamp
								? (new Date(responseItem.doc_timestamp.replace(' UTC', 'Z').replace(' ', 'T')).getTime())
								: null,
							technological_areas: responseItem.topics.TECHNOLOGY
								? responseItem.topics.TECHNOLOGY.map((x) => x.term) : [],
							sector: responseItem.topics.SECTOR
								? responseItem.topics.SECTOR.map((x) => x.term)[0] : null,
							url: responseItem.web_links.homepage,
							url_broken: responseItem.web_links_broken.homepage,
							family_id: responseItem.patent_meta.docdb_family_id,
							patent_number: responseItem.patent_meta.publn_nr,
							inserted_timestamp: new Date(responseItem.inserted_timestamp.replace(' UTC', 'Z')
								.replace(' ', 'T')).getTime(),
							_meta: $rootScope.getBookmarkMeta(bookmark_id, responseItem, bookmarkSettings)
						};
					}
					return entry;
			}
		} catch (err) {
			console.log(responseItem);
			console.log(err);
		}
	};

	// color functions
	$rootScope.getThemeColor = function (h = null, s = null, l = null, opacity = 1) {
		if (h === null) h = MPG.COLOR_H;
		if (s === null) s = MPG.COLOR_S;
		if (l === null) l = MPG.COLOR_L;
		return 'hsla(' + h + ',' + s + '%,' + l + '%,' + opacity + ')';
	};

	$rootScope.getGrowthColor = function (growthNumber, isText = false) {
		let factor = (growthNumber || 0) / 100;
		let color, cSat, cLum, opa;
		if (factor >= 0) {
			color = 145;
			cSat = 63;
			cLum = 42;
		} // --mpg-color-attention
		else {
			color = 6;
			cSat = 78;
			cLum = 57;
		} // --mpg-color-alert
		factor = Math.abs(factor);
		let sat = Math.min(1, factor * 2);
		let lum = Math.min(1, factor * 8);
		if (isText) opa = factor * 0.6 + 0.4; // for texts
		else opa = factor * 0.75 + 0.25; // for background
		return $rootScope.getThemeColor(color, sat * cSat, lum * cLum, opa);
	};

	$rootScope.htmlEscape = function (str) {
		return htmlEscape(str);
	};

	$rootScope.getTypeOf = function (elem) {
		return typeof elem;
	};

	// panel related functions
	$rootScope.getWeblinksWithout = function (row, excludeArr = []) {
		let links = {};
		for (let key in row.web_links) {
			let value = row.web_links[key];
			if (value && !excludeArr.includes(key)) links[key] = value;
		}
		return links;
	};

	// deprecated
	$rootScope.getKpiName = function (key) {
		for (let group of AVAILABLE_KPIS) {
			if (key in group.kpis) return group.kpis[key].name;
		}
		return null;
	};

	$rootScope.getKpiMeta = function (key) {
		for (let group of AVAILABLE_KPIS) {
			if (key in group.kpis) return group.kpis[key];
		}
		return null;
	};
};

// Date handling -------------------------------------------------------------

dateToDatetime = function (dateObj, getUniversalTime = false) {
	if (getUniversalTime) {
		return dateObj.getUTCFullYear() + '-' +
			('0' + (dateObj.getUTCMonth() + 1)).slice(-2) + '-' +
			('0' + (dateObj.getUTCDate())).slice(-2) + ' ' +
			dateObj.getUTCHours() + ':' +
			('0' + (dateObj.getUTCMinutes())).slice(-2) + ':' +
			('0' + (dateObj.getUTCSeconds())).slice(-2);
	} else {
		return dateObj.getFullYear() + '-' +
			('0' + (dateObj.getMonth() + 1)).slice(-2) + '-' +
			('0' + (dateObj.getDate())).slice(-2) + ' ' +
			dateObj.getHours() + ':' +
			('0' + (dateObj.getMinutes())).slice(-2) + ':' +
			('0' + (dateObj.getSeconds())).slice(-2);
	}
};

datetimeToDate = function (datetimeString, isUniversalTime = false) {
	if (!datetimeString) return datetimeString;
	// new Date(yyyy-mm-dd) is not supported by Safari - workaround:
	let comps = datetimeString.split(' ');
	let ymd = comps[0].split('-');
	return new Date(ymd[1] + '/' + ymd[2] + '/' + ymd[0] + ' ' + comps[1] + (isUniversalTime ? ' UTC' : ''));
};

universalToLocalDatetime = function (datetimeString) {
	if (datetimeString) {
		return dateToDatetime(datetimeToDate(datetimeString, true));
	} else return datetimeString;
};

getMonthName = function (dateObj) {
	switch (dateObj.getMonth()) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		case 11:
			return 'December';
	}
};

dateToMDY = function (dateObj) {
	return getMonthName(dateObj) + ' ' + dateObj.getDate() + ', ' + dateObj.getFullYear();
};

// HTML inputs of type date translate the inserted date to the local timezone
// Use the below two functions for pre-/post-processing to allow users to select UTC date instead
shiftTimezone = (date) => {
	if (!date) return date;
	return new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
}

unshiftTimezone = (date) => {
	return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
}

// Tooltip-related function -----------------------------------------------

// position tooltip container
var isTooltipActive = false;
var latestTooltipMaxWidth = null;
const tooltipOffsetYUp = 10;
const tooltipOffsetYDown = 25;
const tooltipOffsetX = -20;
const tooltipOffsetXShift = 20;
const tooltipOffsetYStatusBar = 20;

window.addEventListener('mouseup', function (e) {
	var obj = document.getElementById('tooltip-window');
	if (obj) {
		if (isTooltipActive && e.target && e.target.closest) {
			setTimeout(function () {
				let closest = e.target.closest('*[m-tooltip], *[m-tooltip-dummy]');
				if (!closest || closest.getAttribute('m-tooltip-hide') == 'true') {
					hideTooltip();
				}
			});
		}
	}
});

window.addEventListener('mousemove', function (e) {
	var obj = document.getElementById('tooltip-window');
	if (obj) {
		if (isTooltipActive && e.target && e.target.closest) {
			let closest = e.target.closest('*[m-tooltip], *[m-tooltip-dummy]');
			if (!closest || closest.getAttribute('m-tooltip-hide') == 'true') {
				hideTooltip();
				return;
			}
		}

		var x = e.clientX;
		var y = e.clientY;
		var maxWidth = latestTooltipMaxWidth || document.body.clientWidth;
		var availableWidth = Math.max(document.body.clientWidth - maxWidth, 0);
		var availableHeight = document.body.clientHeight;

		// determine the position of the popup while it's visible,
		// keep the position for the fade-out animation when the mouse is moved out
		function getBasicPosition () {
			if (!obj.mpgLastHorizPosition) {
				if (x < document.body.clientWidth / 2) {
					obj.mpgLastHorizPosition = 'left';
				} else {
					obj.mpgLastHorizPosition = 'right';
				}
			}
			if (!obj.mpgLastVertiPosition) {
				if (y < document.body.clientHeight / 2) {
					obj.mpgLastVertiPosition = 'top';
				} else {
					obj.mpgLastVertiPosition = 'bottom';
				}
			}
		}

		getBasicPosition();

		// avoid partially hidden popups on top/bottom
		function optimizePosition () {
			let requiredShift = {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0
			};
			// calculate overlap (negative values) of popup
			if (obj.mpgLastVertiPosition == 'top') requiredShift.bottom = availableHeight - y - tooltipOffsetYStatusBar - tooltipOffsetYDown - obj.offsetHeight;
			else requiredShift.top = y - tooltipOffsetYUp - obj.offsetHeight;

			// keep values only if shift is required
			if (requiredShift.bottom > 0) requiredShift.bottom = 0;
			if (requiredShift.top > 0) requiredShift.top = 0;

			// if shift is required, move popup away from the cursor
			if (requiredShift.bottom < 0 || requiredShift.top < 0) {
				if (obj.mpgLastHorizPosition == 'left') requiredShift.right = tooltipOffsetXShift;
				else requiredShift.left = tooltipOffsetXShift;
			}

			return requiredShift;
		}

		let shift = optimizePosition();

		function positionLeft () {
			obj.style.left = Math.min(x + tooltipOffsetX + shift.right, availableWidth) + 'px';
			obj.style.right = 'unset';
		}

		function positionRight () {
			obj.style.right = Math.min(document.body.clientWidth - x + tooltipOffsetX + shift.left, availableWidth) + 'px';
			obj.style.left = 'unset';
		}

		function positionTop () {
			obj.style.top = Math.min(y + tooltipOffsetYDown + shift.bottom, availableHeight) + 'px';
			obj.style.bottom = 'unset';
		}

		function positionBottom () {
			obj.style.bottom = Math.min(availableHeight - y + tooltipOffsetYUp + shift.top, availableHeight) + 'px';
			obj.style.top = 'unset';
		}

		if (obj.mpgLastHorizPosition == 'left') positionLeft();
		else positionRight();

		if (obj.mpgLastVertiPosition == 'top') positionTop();
		else positionBottom();
	}
});

var showTooltip = function (html, maxWidth, e) {
	// stop mouseover events on touch screens
	if (e && e.type == 'mouseover' && 'ontouchstart' in window) return;

	latestTooltipMaxWidth = maxWidth;
	var obj = document.getElementById('tooltip-window');
	obj.innerHTML = html;

	if (maxWidth) obj.style.maxWidth = maxWidth + 'px';
	else obj.style.maxWidth = 'none';

	// reset positions
	obj.mpgLastHorizPosition = null;
	obj.mpgLastVertiPosition = null;

	window.setTimeout(function () {
		isTooltipActive = true;
		obj.style.opacity = 1;
		obj.style.transform = 'scale(1)';
	}, 0);
};

var hideTooltip = function () {
	isTooltipActive = false;
	window.setTimeout(function () {
		var obj = document.getElementById('tooltip-window');
		obj.style.opacity = 0;
		obj.style.transform = 'scale(0)';
	}, 0);
};

var addTooltip = function (wk, selectorEnd, tooltipHTML, maxWidth = 400) {
	if (!selectorEnd) {
		// wk is an html element
		let element = wk;
		element.onmouseover = function (e) {
			element.isTooltipActive = true;
			showTooltip(tooltipHTML, maxWidth, e);
		};
		element.onmouseout = function () {
			element.isTooltipActive = false;
			hideTooltip();
		};
		if (element.isTooltipActive === true) {
			showTooltip(tooltipHTML, maxWidth);
		}

	} else {
		let id = (wk && wk.id) ? ('#' + wk.id + ' ') : '';
		let selector = id + ' ' + selectorEnd;
		let target = document.querySelectorAll(selector);

		for (let i = 0; i < target.length; i++) {
			target[i].onmouseover = function (e) {
				showTooltip(tooltipHTML, maxWidth, e);
			};
			target[i].onmouseout = function () {
				hideTooltip();
			};
			// allow visibility handling via isTooltipActive
			target[i].setAttribute('m-tooltip-dummy', '1');
		}
	}
};

scout.directive('mTooltip', [function () {
	return {
		restrict: "A",
		scope: {
			mTooltip: "=",
			mTooltipWidth: "@"
		},
		link: function (scope, element, attrs) {
			scope.$watch(function () {
				return scope.mTooltip;
			}, function (now, before) {
				if (before && !now) {
					element[0].onmouseover = function () {
					};
					element[0].onmouseout = function () {
					};
				}
				if (scope.mTooltip) {
					addTooltip(element[0], null, scope.mTooltip, scope.mTooltipWidth || undefined);
				}
			});
		}
	}
}]);

/* Token Handling ------------------------------------------------------------------- */

// store last token promises to avoid concurrent token requests
var TOKEN_PROMISE_CACHE = {
	// <hostname>: <promise>
};

var TOKEN_CACHE = {
	// <hostname>: { access_token: ..., expiration_timestamp: ... }
};

if (typeof MPG.INITIAL_API_TOKEN != 'undefined') TOKEN_CACHE[MPG.MAPEGY_API_ENDPOINT] = MPG.INITIAL_API_TOKEN;

var getTokenFromCache = function (hostname) {
	if (TOKEN_CACHE[hostname]) {
		let token = TOKEN_CACHE[hostname];
		let timestamp = Math.floor(Date.now() / 1000);
		if (timestamp < token.expiration_timestamp - 900) {
			// reuse token
			return token;
		} else {
			// remove token from cache
			delete TOKEN_CACHE[hostname];
			return false;
		}
	}
};

var makeQuerablePromise = function (promise) {
	// Set initial state
	var isPending = true;
	var isRejected = false;
	var isFulfilled = false;

	// Observe the promise, saving the fulfillment in a closure scope.
	var result = promise.then(
		function (v) {
			isFulfilled = true;
			isPending = false;
			return v;
		},
		function (e) {
			isRejected = true;
			isPending = false;
			throw e;
		}
	);

	result.isFulfilled = function () {
		return isFulfilled;
	};
	result.isPending = function () {
		return isPending;
	};
	result.isRejected = function () {
		return isRejected;
	};
	return result;
};

/* Request handling ------------------------------------------------------------------- */

var ajaxRequests = [];

scout.factory('MapegyAPIService', ['$http', '$sce', '$rootScope', '$q', function ($http, $sce, $rootScope, $q) {
	function getToken (project) {
		// Public stat panels don't need a token
		if (typeof MPG.M_REQUEST_TYPE !== 'undefined' && MPG.M_REQUEST_TYPE === 'PUBLIC_STAT_PANEL') {
			return new Promise(function (resolve) {
				resolve();
			});
		}

		let cachedToken = getTokenFromCache(MPG.MAPEGY_API_ENDPOINT);
		if (cachedToken) {
			// Return cached token
			return new Promise(function (resolve, reject) {
				resolve(cachedToken);
			});

		} else if (TOKEN_PROMISE_CACHE[MPG.MAPEGY_API_ENDPOINT] && TOKEN_PROMISE_CACHE[MPG.MAPEGY_API_ENDPOINT].isPending()) {
			// Return cached token promise
			return TOKEN_PROMISE_CACHE[MPG.MAPEGY_API_ENDPOINT];

		} else {
			// Handle expired tokens in Panel API
			if (typeof MPG.M_REQUEST_TYPE !== 'undefined' && MPG.M_REQUEST_TYPE === 'PANEL') {
				document.getElementById('panel-reload-notifier').style.display = 'flex';
				document.body.style.minHeight = '300px';
				IS_PAGE_BLOCKED = true;
				return new Promise(function (resolve, reject) {
					reject('Panel API Token is expired.');
				});
			}

			// Request new token
			let tokenPromise = new Promise(function (resolve, reject) {
				scoutBackendApi.getMapegyApiToken(function (response) {
					if (response.status == 'success') {
						resolve(response.data);
					} else {
						$rootScope.showMessage(response.message, response.status);
						reject(response.message);
					}
				}, project);
			});

			tokenPromise = makeQuerablePromise(tokenPromise);
			TOKEN_PROMISE_CACHE[MPG.MAPEGY_API_ENDPOINT] = tokenPromise;
			return tokenPromise.then(function (token) {
				TOKEN_CACHE[MPG.MAPEGY_API_ENDPOINT] = token;
				return token;
			});
		}
	};

	function prepareRequest (pathname, jsonParams, token) {
		// Add signature for Public Scout API requests
		if (typeof MPG.MPG_QUERY_SIGNATURE != 'undefined') jsonParams.signature = MPG.MPG_QUERY_SIGNATURE;

		// Add ID of Shared Project for Public Scout API requests
		if (typeof MPG.SHARED_PROJECT_ID != 'undefined') jsonParams.mpg_shared_project_id = MPG.SHARED_PROJECT_ID;

		// Allow to disable the API cache and show backend function call parameters
		if ($rootScope.isAPIDebugMode) jsonParams.debug = true; // backend uses "disable_cache" only

		// Allow to use the DB's "staging" schema
		if ($rootScope.isInnoGraphStaging) jsonParams.backend = 'staging';

		// Prepare parameters
		var params = Object.keys(jsonParams).map(
			function (k) {
				return encodeURIComponent(k) + '=' + encodeURIComponent(jsonParams[k])
			}
		).join('&');
		if (params) {
			if (pathname.includes('?')) params = '&' + params;
			else params = '?' + params;
		}

		// Transform GET to POST requests
		let getPath = (pathname + params);
		if (getPath.includes('?')) {
			pathname = getPath.split('?')[0];
			params = getPath.split('?')[1];
		}

		// Add token
		if (token) {
			// Exclude adding token in authorization to prevent duplicate parameter keys for token.
			if (!getPath.toLowerCase().startsWith('auth/')) {
				params += (params ? '&' : '') + 'token=' + token.access_token;
			}
			// Add request type
			if (token.api_type == 'Panel Data API') params += '&m_request_type=PANEL_DATA';
		}

		return {
			pathname: pathname,
			params: params
		};
	}

	function logAPIDebug (apiDebugLog) {
		if (apiDebugLog) {
			try {
				apiDebugLog = decodeURI(apiDebugLog);
				apiDebugLog = JSON.parse(apiDebugLog);
				try {
					apiDebugLog = dbLogToSql(apiDebugLog);
				} catch {
					apiDebugLog = JSON.stringify(apiDebugLog, null, 2);
				}
			} catch {
				// Nothing to do
			}
			console.info(apiDebugLog);
		}
	}

	return {
		callData: function (pathname, jsonParams, panelScope, endProgressAutomatically = true,
			throwErrorAutomatically = true, timeoutSec = 90) {
			let xhr = null;
			let xhrCancelledBeforeStart = false;

			if (IS_PAGE_BLOCKED) {
				throw new Error('User is logged out, unable to perform action.')
			}
			let promise = getToken($rootScope.project).catch(function (err) {
				return new Promise(function (resolve, reject) {
					// handle feedback in panels
					if (panelScope.wk) {
						panelScope.wk.requestCancelled = false;
						if (endProgressAutomatically) panelScope.endProgress(panelScope.wk);
						if (throwErrorAutomatically) {
							panelScope.wk.error = true;
						}
					}
					if (MPG.DEBUG) {
						console.log("ERROR in getToken():");
						console.log(err);
					}

					return reject(err);
				});
			}).then(function (token) {
				return new Promise(function (resolve, reject) {
					let request = prepareRequest(pathname, jsonParams, token);
					pathname = request.pathname;
					let params = request.params;

					// Prepare request
					xhr = (window.XMLHttpRequest) ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
					xhr.open('POST', MPG.MAPEGY_API_ENDPOINT + pathname, true);
					xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
					xhr.timeout = timeoutSec * 1000; // time in milliseconds

					xhr.onabort = function () {
						xhr.cancelled = true;
					};

					xhr.ontimeout = function (e) {
						xhr.timedOut = true;
					};

					// Handle response
					xhr.onloadend = function () {
						var isError = false;
						if (xhr.readyState == 4) {
							try {
								// Try to parse JSON
								var response = JSON.parse(xhr.responseText);
							} catch (err) {
								// Return error message
								isError = true;
								var response = xhr.responseText;
							}

							// Remove finished requests
							ajaxRequests = ajaxRequests.filter(x => x != xhr);

							// Optionally log backend function call parameters (see isAPIDebugMode)
							logAPIDebug(xhr.getResponseHeader('X-Debug'));

							if (xhr.status == 200 && response && !isError) {
								// Success
								if (endProgressAutomatically) panelScope.endProgress(panelScope.wk);
								resolve(response);

							} else {
								if (xhr.cancelled) {
									// Abort
									if (panelScope.wk) panelScope.wk.requestCancelled = true;
								} else {
									// Error

									// Handle feedback in panels
									if (panelScope.wk) {
										panelScope.wk.requestCancelled = false;
										if (endProgressAutomatically) panelScope.endProgress(panelScope.wk);
										if (throwErrorAutomatically) {
											if (xhr.timedOut || xhr.status == 504) panelScope.wk.error = 'timeout';
											else panelScope.wk.error = true;
										}
									}
									if (MPG.DEBUG) {
										console.log("ERROR in callData('" + pathname + "', ...):");
										console.log(response);
									}
								}
								reject(response);
							}
						}
					};
					xhr.identifier = panelScope.wk ? panelScope.wk.id : '';
					ajaxRequests.push(xhr);
					xhr.send((params ? params : ''));
					if (xhrCancelledBeforeStart) xhr.abort();
				});
			});
			promise.abortRequest = function () {
				if (xhr) {
					if (xhr.readyState < 4) xhr.abort();
				} else {
					xhrCancelledBeforeStart = true;
				}
			};
			return promise;
		},

		getToken: function () {
			return getToken();
		},

		streamJson: function (pathname, jsonParams, onData, timeoutSec = 90) {
			let controller = new AbortController();
			let timeout = null;
			let cancelled = false;
			let timedOut = false;

			if (IS_PAGE_BLOCKED) {
				throw new Error('User is logged out, unable to perform action.')
			}
			let promise = getToken($rootScope.project).catch(function (err) {
				if (MPG.DEBUG) {
					console.log("ERROR in getToken():");
					console.log(err);
				}
				return Promise.reject(err);
			}).then(function (token) {
				let request = prepareRequest(pathname, jsonParams, token);
				pathname = request.pathname;
				let params = request.params;

				if (timeoutSec > 0) {
					timeout = setTimeout(function () {
						timedOut = true;
						controller.abort();
					}, timeoutSec * 1000);
				}

				return fetch(MPG.MAPEGY_API_ENDPOINT + pathname, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
						'Accept': 'application/x-ndjson'
					},
					body: (params ? params : ''),
					signal: controller.signal
				});
			}).then(async function (response) {
				// Optionally log backend function call parameters (see isAPIDebugMode)
				logAPIDebug(response.headers.get('X-Debug'));

				if (!response.ok) {
					let responseText = await response.text();
					let errorResponse;

					try {
						errorResponse = JSON.parse(responseText);
					} catch (err) {
						errorResponse = responseText;
					}

					throw errorResponse;
				}

				if (!response.body) {
					throw new Error('Streaming response body is not available.');
				}

				let reader = response.body.getReader();
				let decoder = new TextDecoder();
				let buffer = '';

				while (true) {
					let result = await reader.read();

					if (result.done) break;

					buffer += decoder.decode(result.value, { stream: true });

					let lines = buffer.split('\n');
					buffer = lines.pop();

					for (let line of lines) {
						if (!line.trim()) continue;
						await onData(JSON.parse(line));
					}
				}

				buffer += decoder.decode();

				if (buffer.trim()) {
					await onData(JSON.parse(buffer));
				}
			}).catch(function (err) {
				if (timedOut) return Promise.reject('Request timed out.');
				if (cancelled) return Promise.reject('Request aborted.');

				if (MPG.DEBUG) {
					console.log("ERROR in streamJson('" + pathname + "', ...):");
					console.log(err);
				}

				return Promise.reject(err);
			}).finally(function () {
				if (timeout) clearTimeout(timeout);
			});

			promise.abortRequest = function () {
				promise.aborted = true;
				cancelled = true;
				controller.abort();
			};

			return promise;
		}
	}
}]);

function prepareInnoGraphStats (data) {
	function preparePlayers (item) {
		let country = getCountryOrPatentOfficeByCode(item.country_code);
		item.country = country ? country.name : null;
		item.country_code = country ? country.code : null; // correct codes
		if (item.player_sub_type) {
			item.player_sub_type = item.player_sub_type.map(x => toTitleCase(x));
		}
		return item;
	}

	if (data?.top_companies) data.top_companies = data.top_companies.map(preparePlayers);
	if (data?.latest_startups) data.latest_startups = data.latest_startups.map(preparePlayers);
	if (data?.top_public_inst) data.top_public_inst = data.top_public_inst.map(preparePlayers);
	if (data?.stat_bib?.PATENT) data.stat_bib.PATENT = data.stat_bib.PATENT.map(function (item) {
		let tmp = item.publisher.split(/[\(\)]/);
		item.patent_office = tmp.length >= 2 ? tmp[1] : null;
		return item;
	});
	return data;
}

// Countries -----------------------------------------------------

/*
	See also: countries.js in nodejs-utils repo
*/
var getCountryOrPatentOfficeByCode = function (countryCode) {
	if (!countryCode) return countryCode;
	let country = regionalPatentOffices[countryCode] || countries[countryCode];
	if (typeof country === 'undefined') {
		console.log('WARNING: country code ' + countryCode + ' is unknown.');
	} else {
		country = Object.assign({}, country);
		country.code = countryCode;
	}
	return country;
};

// ISO 3166-1 alpha-2
var countries = {
	"AD": {
		"name": "Andorra",
		"presets": ["Europe"]
	},
	"AE": {
		"name": "United Arab Emirates",
		"presets": ["BRICS", "GCC", "Asia"]
	},
	"AF": {
		"name": "Afghanistan",
		"presets": ["Asia"]
	},
	"AG": {
		"name": "Antigua and Barbuda",
		"presets": ["Americas"]
	},
	"AI": {
		"name": "Anguilla",
		"presets": ["Americas"]
	},
	"AL": {
		"name": "Albania",
		"presets": ["NATO", "Europe"]
	},
	"AM": {
		"name": "Armenia",
		"presets": ["Asia", "Europe"]
	},
	"AO": {
		"name": "Angola",
		"presets": ["Africa"]
	},
	"AQ": {
		"name": "Antarctica",
	},
	"AR": {
		"name": "Argentina",
		"presets": ["Americas"]
	},
	"AS": {
		"name": "American Samoa",
		"presets": ["Oceania"]
	},
	"AT": {
		"name": "Austria",
		"presets": ["EU", "DACH", "Europe"]
	},
	"AU": {
		"name": "Australia",
		"presets": ["APEC", "Oceania"]
	},
	"AW": {
		"name": "Aruba",
		"presets": ["Americas"]
	},
	"AX": {
		"name": "Åland Islands",
		"presets": ["Europe"]
	},
	"AZ": {
		"name": "Azerbaijan",
		"presets": ["Asia", "Europe"]
	},
	"BA": {
		"name": "Bosnia and Herzegovina",
		"presets": ["Europe"]
	},
	"BB": {
		"name": "Barbados",
		"presets": ["Americas"]
	},
	"BD": {
		"name": "Bangladesh",
		"presets": ["Asia"]
	},
	"BE": {
		"name": "Belgium",
		"presets": ["NATO", "EU", "Europe"]
	},
	"BF": {
		"name": "Burkina Faso",
		"presets": ["Africa"]
	},
	"BG": {
		"name": "Bulgaria",
		"presets": ["NATO", "EU", "Europe"]
	},
	"BH": {
		"name": "Bahrain",
		"presets": ["GCC", "Asia"]
	},
	"BI": {
		"name": "Burundi",
		"presets": ["Africa"]
	},
	"BJ": {
		"name": "Benin",
		"presets": ["Africa"]
	},
	"BL": {
		"name": "Saint Barthélemy",
		"presets": ["Americas"]
	},
	"BM": {
		"name": "Bermuda",
		"presets": ["Americas"]
	},
	"BN": {
		"name": "Brunei",
		"presets": ["ASEAN", "Asia", "APEC"]
	},
	"BO": {
		"name": "Bolivia",
		"presets": ["Americas"]
	},
	"BQ": {
		"name": "Bonaire, Sint Eustatius and Saba",
		"presets": ["Americas"]
	},
	"BR": {
		"name": "Brazil",
		"presets": ["BRICS", "Americas"]
	},
	"BS": {
		"name": "Bahamas",
		"presets": ["Americas"]
	},
	"BT": {
		"name": "Bhutan",
		"presets": ["Asia"]
	},
	"BV": {
		"name": "Bouvet Island",
	},
	"BW": {
		"name": "Botswana",
		"presets": ["Africa"]
	},
	"BY": {
		"name": "Belarus",
		"presets": ["Europe"]
	},
	"BZ": {
		"name": "Belize",
		"presets": ["Americas"]
	},
	"CA": {
		"name": "Canada",
		"presets": ["NATO", "APEC", "Americas"]
	},
	"CC": {
		"name": "Cocos (Keeling) Islands",
		"presets": ["Oceania"]
	},
	"CD": {
		"name": "Congo (Kinshasa)",
		"presets": ["Africa"]
	},
	"CF": {
		"name": "Central African Republic",
		"presets": ["Africa"]
	},
	"CG": {
		"name": "Congo (Brazzaville)",
		"presets": ["Africa"]
	},
	"CH": {
		"name": "Switzerland",
		"presets": ["DACH", "Europe"]
	},
	"CI": {
		"name": "Ivory Coast",
		"presets": ["Africa"]
	},
	"CK": {
		"name": "Cook Islands",
		"presets": ["Oceania"]
	},
	"CL": {
		"name": "Chile",
		"presets": ["APEC", "Americas"]
	},
	"CM": {
		"name": "Cameroon",
		"presets": ["Africa"]
	},
	"CN": {
		"name": "China",
		"presets": ["BRICS", "APEC", "Asia"]
	},
	"CO": {
		"name": "Colombia",
		"presets": ["Americas"]
	},
	"CR": {
		"name": "Costa Rica",
		"presets": ["Americas"]
	},
	"CU": {
		"name": "Cuba",
		"presets": ["Americas"]
	},
	"CV": {
		"name": "Cape Verde",
		"presets": ["Africa"]
	},
	"CW": {
		"name": "Curaçao",
		"presets": ["Americas"]
	},
	"CX": {
		"name": "Christmas Island",
		"presets": ["Oceania"]
	},
	"CY": {
		"name": "Cyprus",
		"presets": ["EU", "Europe", "Asia"]
	},
	"CZ": {
		"name": "Czech Republic",
		"presets": ["EU", "NATO", "Europe"]
	},
	"DE": {
		"name": "Germany",
		"presets": ["EU", "DACH", "NATO", "Europe"]
	},
	"DJ": {
		"name": "Djibouti",
		"presets": ["Africa"]
	},
	"DK": {
		"name": "Denmark",
		"presets": ["EU", "NATO", "Europe"]
	},
	"DM": {
		"name": "Dominica",
		"presets": ["Americas"]
	},
	"DO": {
		"name": "Dominican Republic",
		"presets": ["Americas"]
	},
	"DZ": {
		"name": "Algeria",
		"presets": ["Africa"]
	},
	"EC": {
		"name": "Ecuador",
		"presets": ["Americas"]
	},
	"EE": {
		"name": "Estonia",
		"presets": ["EU", "NATO", "Europe"]
	},
	"EG": {
		"name": "Egypt",
		"presets": ["BRICS", "Africa"]
	},
	"EH": {
		"name": "Western Sahara",
		"presets": ["Africa"]
	},
	"ER": {
		"name": "Eritrea",
		"presets": ["Africa"]
	},
	"ES": {
		"name": "Spain",
		"presets": ["EU", "NATO", "Europe"]
	},
	"ET": {
		"name": "Ethiopia",
		"presets": ["BRICS", "Africa"]
	},
	"FI": {
		"name": "Finland",
		"presets": ["EU", "NATO", "Europe"]
	},
	"FJ": {
		"name": "Fiji",
		"presets": ["Oceania"]

	},
	"FK": {
		"name": "Falkland Islands",
		"presets": ["Americas"]
	},
	"FM": {
		"name": "Micronesia",
		"presets": ["Oceania"]
	},
	"FO": {
		"name": "Faroe Islands",
		"presets": ["Europe"]
	},
	"FR": {
		"name": "France",
		"presets": ["EU", "NATO", "Europe"]
	},
	"GA": {
		"name": "Gabon",
		"presets": ["Africa"]
	},
	"GB": {
		"name": "United Kingdom",
		"presets": ["NATO", "Europe"]
	},
	"GD": {
		"name": "Grenada",
		"presets": ["Americas"]
	},
	"GE": {
		"name": "Georgia",
		"presets": ["Asia", "Europe"]
	},
	"GF": {
		"name": "French Guiana",
		"presets": ["Americas"]
	},
	"GG": {
		"name": "Guernsey",
		"presets": ["Europe"]
	},
	"GH": {
		"name": "Ghana",
		"presets": ["Africa"]
	},
	"GI": {
		"name": "Gibraltar",
		"presets": ["Europe"]
	},
	"GL": {
		"name": "Greenland",
		"presets": ["Europe", "Americas"]
	},
	"GM": {
		"name": "Gambia",
		"presets": ["Africa"]
	},
	"GN": {
		"name": "Guinea",
		"presets": ["Africa"]
	},
	"GP": {
		"name": "Guadeloupe",
		"presets": ["Americas"]
	},
	"GQ": {
		"name": "Equatorial Guinea",
		"presets": ["Africa"]
	},
	"GR": {
		"name": "Greece",
		"presets": ["EU", "NATO", "Europe"]
	},
	"GS": {
		"name": "South Georgia and the South Sandwich Islands",
		"presets": ["Americas"]
	},
	"GT": {
		"name": "Guatemala",
		"presets": ["Americas"]
	},
	"GU": {
		"name": "Guam",
		"presets": ["Oceania"]
	},
	"GW": {
		"name": "Guinea-Bissau",
		"presets": ["Africa"]
	},
	"GY": {
		"name": "Guyana",
		"presets": ["Americas"]
	},
	"HK": {
		"name": "Hong Kong",
		"presets": ["APEC", "Asia"]
	},
	"HM": {
		"name": "Heard Island and McDonald Islands",
	},
	"HN": {
		"name": "Honduras",
		"presets": ["Americas"]
	},
	"HR": {
		"name": "Croatia",
		"presets": ["EU", "NATO", "Europe"]
	},
	"HT": {
		"name": "Haiti",
		"presets": ["Americas"]
	},
	"HU": {
		"name": "Hungary",
		"presets": ["EU", "NATO", "Europe"]
	},
	"ID": {
		"name": "Indonesia",
		"presets": ["BRICS", "ASEAN", "APEC", "Asia"]
	},
	"IE": {
		"name": "Ireland",
		"presets": ["EU", "Europe"]
	},
	"IL": {
		"name": "Israel",
		"presets": ["Asia"]
	},
	"IM": {
		"name": "Isle of Man",
		"presets": ["Europe"]
	},
	"IN": {
		"name": "India",
		"presets": ["BRICS", "Asia"]
	},
	"IO": {
		"name": "British Indian Ocean Territory",
		"presets": ["Asia"]
	},
	"IQ": {
		"name": "Iraq",
		"presets": ["Asia"]
	},
	"IR": {
		"name": "Iran",
		"presets": ["BRICS", "Asia"]
	},
	"IS": {
		"name": "Iceland",
		"presets": ["NATO", "Europe"]
	},
	"IT": {
		"name": "Italy",
		"presets": ["EU", "NATO", "Europe"]
	},
	"JE": {
		"name": "Jersey",
		"presets": ["Europe"]
	},
	"JM": {
		"name": "Jamaica",
		"presets": ["Americas"]
	},
	"JO": {
		"name": "Jordan",
		"presets": ["Asia"]
	},
	"JP": {
		"name": "Japan",
		"presets": ["APEC", "Asia"]
	},
	"KE": {
		"name": "Kenya",
		"presets": ["Africa"]
	},
	"KG": {
		"name": "Kyrgyzstan",
		"presets": ["Asia"]
	},
	"KH": {
		"name": "Cambodia",
		"presets": ["ASEAN", "Asia"]
	},
	"KI": {
		"name": "Kiribati",
		"presets": ["Oceania"]
	},
	"KM": {
		"name": "Comoros",
		"presets": ["Africa"]
	},
	"KN": {
		"name": "Saint Kitts and Nevis",
		"presets": ["Americas"]
	},
	"KP": {
		"name": "North Korea",
		"presets": ["Asia"]
	},
	"KR": {
		"name": "South Korea",
		"presets": ["APEC", "Asia"]
	},
	"KW": {
		"name": "Kuwait",
		"presets": ["GCC", "Asia"]
	},
	"KY": {
		"name": "Cayman Islands",
		"presets": ["Americas"]
	},
	"KZ": {
		"name": "Kazakhstan",
		"presets": ["Europe", "Asia"]
	},
	"LA": {
		"name": "Laos",
		"presets": ["ASEAN", "Asia"]
	},
	"LB": {
		"name": "Lebanon",
		"presets": ["Asia"]
	},
	"LC": {
		"name": "Saint Lucia",
		"presets": ["Americas"]
	},
	"LI": {
		"name": "Liechtenstein",
		"presets": ["Europe"]
	},
	"LK": {
		"name": "Sri Lanka",
		"presets": ["Asia"]
	},
	"LR": {
		"name": "Liberia",
		"presets": ["Africa"]
	},
	"LS": {
		"name": "Lesotho",
		"presets": ["Africa"]
	},
	"LT": {
		"name": "Lithuania",
		"presets": ["EU", "NATO", "Europe"]
	},
	"LU": {
		"name": "Luxembourg",
		"presets": ["EU", "NATO", "Europe"]
	},
	"LV": {
		"name": "Latvia",
		"presets": ["EU", "NATO", "Europe"]
	},
	"LY": {
		"name": "Libya",
		"presets": ["Africa"]
	},
	"MA": {
		"name": "Morocco",
		"presets": ["Africa"]
	},
	"MC": {
		"name": "Monaco",
		"presets": ["Europe"]
	},
	"MD": {
		"name": "Moldova",
		"presets": ["Europe"]
	},
	"ME": {
		"name": "Montenegro",
		"presets": ["NATO", "Europe"]
	},
	"MF": {
		"name": "Saint Martin",
		"presets": ["Americas"]
	},
	"MG": {
		"name": "Madagascar",
		"presets": ["Africa"]
	},
	"MH": {
		"name": "Marshall Islands",
		"presets": ["Oceania"]
	},
	"MK": {
		"name": "North Macedonia",
		"presets": ["NATO", "Europe"]
	},
	"ML": {
		"name": "Mali",
		"presets": ["Africa"]
	},
	"MM": {
		"name": "Myanmar",
		"presets": ["Asia", "ASEAN"]
	},
	"MN": {
		"name": "Mongolia",
		"presets": ["Asia"]
	},
	"MO": {
		"name": "Macao",
		"presets": ["Asia"]
	},
	"MP": {
		"name": "Northern Mariana Islands",
		"presets": ["Oceania"]
	},
	"MQ": {
		"name": "Martinique",
		"presets": ["Americas"]
	},
	"MR": {
		"name": "Mauritania",
		"presets": ["Africa"]
	},
	"MS": {
		"name": "Montserrat",
		"presets": ["Americas"]
	},
	"MT": {
		"name": "Malta",
		"presets": ["EU", "Europe"]
	},
	"MU": {
		"name": "Mauritius",
		"presets": ["Africa"]
	},
	"MV": {
		"name": "Maldives",
		"presets": ["Asia"]
	},
	"MW": {
		"name": "Malawi",
		"presets": ["Africa"]
	},
	"MX": {
		"name": "Mexico",
		"presets": ["APEC", "Americas"]
	},
	"MY": {
		"name": "Malaysia",
		"presets": ["ASEAN", "APEC", "Asia"]
	},
	"MZ": {
		"name": "Mozambique",
		"presets": ["Africa"]
	},
	"NA": {
		"name": "Namibia",
		"presets": ["Africa"]
	},
	"NC": {
		"name": "New Caledonia",
		"presets": ["Oceania"]
	},
	"NE": {
		"name": "Niger",
		"presets": ["Africa"]
	},
	"NF": {
		"name": "Norfolk Island",
		"presets": ["Oceania"]
	},
	"NG": {
		"name": "Nigeria",
		"presets": ["Africa"]
	},
	"NI": {
		"name": "Nicaragua",
		"presets": ["Americas"]
	},
	"NL": {
		"name": "Netherlands",
		"presets": ["EU", "NATO", "Europe"]
	},
	"NO": {
		"name": "Norway",
		"presets": ["NATO", "Europe"]
	},
	"NP": {
		"name": "Nepal",
		"presets": ["Asia"]
	},
	"NR": {
		"name": "Nauru",
		"presets": ["Oceania"]
	},
	"NU": {
		"name": "Niue",
		"presets": ["Oceania"]
	},
	"NZ": {
		"name": "New Zealand",
		"presets": ["APEC", "Oceania"]
	},
	"OM": {
		"name": "Oman",
		"presets": ["GCC", "Asia"]
	},
	"PA": {
		"name": "Panama",
		"presets": ["Americas"]
	},
	"PE": {
		"name": "Peru",
		"presets": ["APEC", "Americas"]
	},
	"PF": {
		"name": "French Polynesia",
		"presets": ["Oceania"]
	},
	"PG": {
		"name": "Papua New Guinea",
		"presets": ["APEC", "Oceania"]
	},
	"PH": {
		"name": "Philippines",
		"presets": ["ASEAN", "APEC", "Asia"]
	},
	"PK": {
		"name": "Pakistan",
		"presets": ["Asia"]
	},
	"PL": {
		"name": "Poland",
		"presets": ["EU", "NATO", "Europe"]
	},
	"PM": {
		"name": "Saint Pierre and Miquelon",
		"presets": ["Americas"]
	},
	"PN": {
		"name": "Pitcairn",
		"presets": ["Oceania"]
	},
	"PR": {
		"name": "Puerto Rico",
		"presets": ["Americas"]
	},
	"PS": {
		"name": "Palestine",
		"presets": ["Asia"]
	},
	"PT": {
		"name": "Portugal",
		"presets": ["EU", "NATO", "Europe"]
	},
	"PW": {
		"name": "Palau",
		"presets": ["Oceania"]
	},
	"PY": {
		"name": "Paraguay",
		"presets": ["Americas"]
	},
	"QA": {
		"name": "Qatar",
		"presets": ["GCC", "Asia"]
	},
	"RE": {
		"name": "Réunion",
		"presets": ["Africa"]
	},
	"RO": {
		"name": "Romania",
		"presets": ["EU", "NATO", "Europe"]
	},
	"RS": {
		"name": "Serbia",
		"presets": ["Europe"]
	},
	"RU": {
		"name": "Russia",
		"presets": ["BRICS", "APEC", "Europe", "Asia"]
	},
	"RW": {
		"name": "Rwanda",
		"presets": ["Africa"]
	},
	"SA": {
		"name": "Saudi Arabia",
		"presets": ["GCC", "Asia"]
	},
	"SB": {
		"name": "Solomon Islands",
		"presets": ["Oceania"]
	},
	"SC": {
		"name": "Seychelles",
		"presets": ["Africa"]
	},
	"SD": {
		"name": "Sudan",
		"presets": ["Africa"]
	},
	"SE": {
		"name": "Sweden",
		"presets": ["EU", "Europe", "NATO"]
	},
	"SG": {
		"name": "Singapore",
		"presets": ["ASEAN", "APEC", "Asia"]
	},
	"SH": {
		"name": "Saint Helena, Ascension and Tristan da Cunha",
		"presets": ["Africa"]
	},
	"SI": {
		"name": "Slovenia",
		"presets": ["EU", "NATO", "Europe"]
	},
	"SJ": {
		"name": "Svalbard and Jan Mayen",
		"presets": ["Europe"]
	},
	"SK": {
		"name": "Slovakia",
		"presets": ["EU", "NATO", "Europe"]
	},
	"SL": {
		"name": "Sierra Leone",
		"presets": ["Africa"]
	},
	"SM": {
		"name": "San Marino",
		"presets": ["Europe"]
	},
	"SN": {
		"name": "Senegal",
		"presets": ["Africa"]
	},
	"SO": {
		"name": "Somalia",
		"presets": ["Africa"]
	},
	"SR": {
		"name": "Suriname",
		"presets": ["Americas"]
	},
	"SS": {
		"name": "South Sudan",
		"presets": ["Africa"]
	},
	"ST": {
		"name": "São Tomé and Príncipe",
		"presets": ["Africa"]
	},
	"SV": {
		"name": "El Salvador",
		"presets": ["Americas"]
	},
	"SX": {
		"name": "Sint Maarten",
		"presets": ["Americas"]
	},
	"SY": {
		"name": "Syria",
		"presets": ["Asia"]
	},
	"SZ": {
		"name": "Eswatini",
		"presets": ["Africa"]
	},
	"TC": {
		"name": "Turks and Caicos Islands",
		"presets": ["Americas"]
	},
	"TD": {
		"name": "Chad",
		"presets": ["Africa"]
	},
	"TF": {
		"name": "French Southern Territories",
	},
	"TG": {
		"name": "Togo",
		"presets": ["Africa"]
	},
	"TH": {
		"name": "Thailand",
		"presets": ["ASEAN", "Asia", "APEC"]
	},
	"TJ": {
		"name": "Tajikistan",
		"presets": ["Asia"]
	},
	"TK": {
		"name": "Tokelau",
		"presets": ["Oceania"]
	},
	"TL": {
		"name": "Timor-Leste",
		"presets": ["Asia"]
	},
	"TM": {
		"name": "Turkmenistan",
		"presets": ["Asia"]
	},
	"TN": {
		"name": "Tunisia",
		"presets": ["Africa"]
	},
	"TO": {
		"name": "Tonga",
		"presets": ["Oceania"]
	},
	"TR": {
		"name": "Turkey",
		"presets": ["NATO", "Asia", "Europe"]
	},
	"TT": {
		"name": "Trinidad and Tobago",
		"presets": ["Americas"]
	},
	"TV": {
		"name": "Tuvalu",
		"presets": ["Oceania"]
	},
	"TW": {
		"name": "Taiwan",
		"presets": ["APEC", "Asia"]
	},
	"TZ": {
		"name": "Tanzania",
		"presets": ["Africa"]
	},
	"UA": {
		"name": "Ukraine",
		"presets": ["Europe"]
	},
	"UG": {
		"name": "Uganda",
		"presets": ["Africa"]
	},
	"UM": {
		"name": "United States Minor Outlying Islands",
		"presets": ["Oceania"]
	},
	"US": {
		"name": "United States",
		"presets": ["NATO", "APEC", "Americas"]
	},
	"UY": {
		"name": "Uruguay",
		"presets": ["Americas"]
	},
	"UZ": {
		"name": "Uzbekistan",
		"presets": ["Asia"]
	},
	"VA": {
		"name": "Holy See",
		"presets": ["Europe"]
	},
	"VC": {
		"name": "Saint Vincent and the Grenadines",
		"presets": ["Americas"]
	},
	"VE": {
		"name": "Venezuela",
		"presets": ["Americas"]
	},
	"VG": {
		"name": "Virgin Islands (British)",
		"presets": ["Americas"]
	},
	"VI": {
		"name": "Virgin Islands (U.S.)",
		"presets": ["Americas"]
	},
	"VN": {
		"name": "Vietnam",
		"presets": ["ASEAN", "APEC", "Asia"]
	},
	"VU": {
		"name": "Vanuatu",
		"presets": ["Oceania"]
	},
	"WF": {
		"name": "Wallis and Futuna",
		"presets": ["Oceania"]
	},
	"WS": {
		"name": "Samoa",
		"presets": ["Oceania"]
	},
	"YE": {
		"name": "Yemen",
		"presets": ["Asia"]
	},
	"YT": {
		"name": "Mayotte",
		"presets": ["Africa"]
	},
	"ZA": {
		"name": "South Africa",
		"presets": ["BRICS", "Africa"]
	},
	"ZM": {
		"name": "Zambia",
		"presets": ["Africa"]
	},
	"ZW": {
		"name": "Zimbabwe",
		"presets": ["Africa"]
	}
};

var regionalPatentOffices = {
	"AP": {
		"name": "ARIPO",
		"presets": ["Africa"],
		"type": "patent office"
	},
	"EA": {
		"name": "EAPO",
		"type": "patent office"
	},
	"EM": {
		"name": "EUIPO",
		"presets": ["EU", "Europe"],
		"type": "patent office"
	},
	"EP": {
		"name": "EPO",
		"presets": ["Europe"],
		"type": "patent office"
	},
	"OA": {
		"name": "OAPI",
		"presets": ["Africa"],
		"type": "patent office"
	},
	"WO": {
		"name": "WIPO",
		"type": "patent office"
	},
	"GC": {
		"name": "GCC",
		"presets": ["GCC", "Asia"],
		"type": "patent office"
	}
}

var defaultPresetsKeys = ['EU', 'DACH', 'BRICS', 'ASEAN', 'GCC', 'APEC', 'NATO', 'Europe', 'Americas',
	'Africa', 'Asia', 'Oceania'];

// KPIs ------------------------------------------------------

const defaultKPILogTransformation = (value) => {
	const logScaleFactor = 35;
	return Math.log(logScaleFactor * value + 1) / Math.log(logScaleFactor + 1);
};

// All KPI keys must be unique in a global KPI scope.
const WTA_STATUS = Object.freeze({
	WATCH_MAX: 1 / 3,
	THINK_MAX: 2 / 3,
	VALUE_PRECISION: 6,
	RANGES: Object.freeze({
		WATCH: Object.freeze({ min: 0, max: 0.333333, defaultValue: 0 }),
		THINK: Object.freeze({ min: 0.333334, max: 0.666666, defaultValue: 0.5 }),
		ACT: Object.freeze({ min: 0.666667, max: 1, defaultValue: 1 })
	})
});

const AVAILABLE_KPIS = [
	{
		type: 'USER_CLUSTER',
		name: 'Market',
		kpis: {
			MP: {
				name: 'Market Potential',
				descriptionHTML: 'Estimate of the total demand for a product or service.',
				range: [0, 1],
				unit: '%'
			},
			Cpi: {
				name: 'Compliance',
				descriptionHTML: 'Adherence to regulatory requirements.',
				range: [0, 1],
				unit: '%'
			},
			PI: {
				name: 'Potential Impact',
				descriptionHTML: 'Effect or influence on a product, service, organization, or market.',
				range: [0, 1],
				unit: '%'
			},
			Sus: {
				name: 'Sustainability',
				descriptionHTML: 'Degree to which economic, social and environmental needs are met.',
				range: [0, 1],
				unit: '%'
			},
		}
	},
	{
		type: 'USER_CLUSTER',
		name: 'Customer',
		kpis: {
			Pri: {
				name: 'Privacy',
				descriptionHTML: 'Ability to protect sensitive or personal data.',
				range: [0, 1],
				unit: '%'
			},
			Sec: {
				name: 'Security',
				descriptionHTML: 'Ability to protect information against threats or attacks.',
				range: [0, 1],
				unit: '%'
			},
			Usa: {
				name: 'Usability & Functionality',
				descriptionHTML: 'Ability to serve a specific purpose or solve a problem effectively.',
				range: [0, 1],
				unit: '%'
			},
		}
	},
	{
		type: 'USER_CLUSTER',
		name: 'Subject of Interest',
		kpis: {
			TM: {
				name: 'Technology Readiness',
				descriptionHTML: 'Maturity level. Propensity to embrace and use a new technology.',
				range: [0, 1],
				unit: '%'
			},
			Cpx: {
				name: 'Complexity',
				descriptionHTML: 'Development or implementation difficulty due to number of components, used '
					+ 'technology, and other requirements.',
				range: [0, 1],
				unit: '%'
			},
			TTM: {
				name: 'Time to Market',
				descriptionHTML: 'Amount of time it takes a product or service is available for sale.',
				range: [0, 1],
				unit: '%'
			},
		}
	},
	{
		type: 'USER_CLUSTER',
		name: 'Organization',
		kpis: {
			SF: {
				name: 'Strategic Fit',
				descriptionHTML: 'Degree to which a particular project is suitable to the organization’s strategy.',
				range: [0, 1],
				unit: '%'
			},
			CF: {
				name: 'Culture Fit',
				descriptionHTML: 'Degree to which a particular project is suitable to the core values and culture '
					+ 'of an organization.',
				range: [0, 1],
				unit: '%'
			},
			PF: {
				name: 'Fit to Portfolio',
				descriptionHTML: 'Degree to which a particular project suits the sum of all company projects.',
				range: [0, 1],
				unit: '%'
			},
			TMC: {
				name: 'Top Management Commitment',
				descriptionHTML: 'Involvement of senior management.',
				range: [0, 1],
				unit: '%'
			},
			IKH: {
				name: 'Internal Know-How',
				descriptionHTML: 'Practical or technical knowledge; expertise within the organization.',
				range: [0, 1],
				unit: '%'
			},
			C: {
				name: 'Development Costs',
				descriptionHTML: 'Incurred cost while researching and developing products or services.',
				range: [0, 1],
				unit: '%'
			},
			MC: {
				name: 'Marketing Costs',
				descriptionHTML: 'Cost incurred in selling a product or service.',
				range: [0, 1],
				unit: '%'
			},
			MOR: {
				name: 'Risk to Miss Out',
				descriptionHTML: 'Likelihood of losing an opportunity.',
				range: [0, 1],
				unit: '%'
			},
			R: {
				name: 'Strategic Risk',
				descriptionHTML: 'Probability of impacting the ability to achieve business objectives.',
				range: [0, 1],
				unit: '%'
			},
		}
	},
	{
		type: 'USER',
		kpis: {
			WTA: {
				name: 'Status',
				range: [0, 1],
				unit: '%'
			},
		}
	},
	{
		type: 'AUTOMATED',
		name: 'MAPEGY Indicators',
		kpis: {
			// automated KPIs start with '_'
			_NB_ESTABLISHED_COMPANIES: {
				name: 'Established Companies',
				descriptionHTML: 'Estimate of the total number of companies that show activity in the space, '
					+ 'excluding startups. A high number may indicate a high <b>technological maturity</b>.',
				range: [0, null],
				transformer: defaultKPILogTransformation
			},
			_FUNDING_STARTUP: {
				name: 'Startup Funding',
				descriptionHTML: 'This is an estimate of the total funding received by startups. A high number may '
					+ 'indicate high <b>market potential</b>.',
				range: [0, null],
				unit: 'USD',
				transformer: defaultKPILogTransformation
			},
			_FUNDING_RESEARCH: {
				name: 'Research Funding',
				descriptionHTML: 'Estimate of the total funding that research projects have received in the past or '
					+ 'will receive in the near future. A high number may indicate a high <b>technology push</b>.',
				range: [0, null],
				unit: 'EUR',
				transformer: defaultKPILogTransformation
			},
			_NB_NEWS: {
				name: 'News',
				descriptionHTML: '<b>Number of publications:</b><br>News articles about the queried topic, '
					+ 'organization, or expert. Published in the last 10 years (120 months).',
				range: [0, null],
				transformer: defaultKPILogTransformation
			},
			_NB_SCIENCE: {
				name: 'Research',
				descriptionHTML: '<b>Number of publications:</b><br>Research publications about the queried topic '
					+ 'or authored by experts or members of the queried organization. Published in the last '
					+ '10 years (120 months).',
				range: [0, null],
				transformer: defaultKPILogTransformation
			},
			_NB_PATENT: {
				name: 'Patents',
				descriptionHTML: '<b>Number of publications:</b><br>Patent publications about the queried topic or '
					+ 'filed by the queried organization or expert. Published in the last 10 years (120 months).',
				range: [0, null],
				transformer: defaultKPILogTransformation
			},
			_GROWTH_NEWS: {
				name: 'News Growth',
				descriptionHTML: '<b>Estimated Growth:</b><br>Estimate of news articles published during the past '
					+ '12 months.',
				range: [null, null],
				unit: '%'
			},
			_GROWTH_SCIENCE: {
				name: 'Research Growth',
				descriptionHTML: '<b>Estimated Growth:</b><br>Estimate of research publications published during '
					+ 'the past 12 months.',
				range: [null, null],
				unit: '%'
			},
			_GROWTH_PATENT: {
				name: 'Patents Growth',
				descriptionHTML: '<b>Estimated Growth:</b><br>Estimate of patents filed during the past three years.',
				range: [null, null],
				unit: '%'
			}
		}
	},
	{
		type: 'AUTOMATED_INDIRECT', // needed in Portfolio but not in Radar
		kpis: {
			_RATE_RECENT_NEWS: {
				name: 'Recent News Publication Rate',
				descriptionHTML: 'Publications in the past year.',
				range: [0, null]
			},
			_RATE_RECENT_SCIENCE: {
				name: 'Recent Research Publication Rate',
				descriptionHTML: 'Publications in the past year.',
				range: [0, null]
			},
			_RATE_RECENT_PATENT: {
				name: 'Recent Patent Publication Rate',
				descriptionHTML: 'Publication rate 3 years ago (publications/year).',
				range: [0, null]
			},
			_RATE_PAST_NEWS: {
				name: 'Past News Publication Rate',
				descriptionHTML: 'Publication rate more than 1 year ago (publications/year).',
				range: [0, null]
			},
			_RATE_PAST_SCIENCE: {
				name: 'Past Research Publication Rate',
				descriptionHTML: 'Publication rate more than 1 year ago (publications/year).',
				range: [0, null]
			},
			_RATE_PAST_PATENT: {
				name: 'Past Patent Publication Rate',
				descriptionHTML: 'Publication rate more than 3 years ago (publications/year).',
				range: [0, null]
			}
		}
	}
];
// add keys to KPI meta
for (let group of AVAILABLE_KPIS) {
	for (const [key, value] of Object.entries(group.kpis)) value.key = key;
}

// Use Cases ------------------------------------------------------

const USE_CASES = [
	{
		contextName: 'Topic Only',
		useCases: [
			{
				title: 'Technology Intelligence',
				description: 'Identify and analyze topics and technologies',
				thumbnail: 'technology-intelligence.jpg',
				panels: [
					'topics',
					'trends',
					'visual-explorer',
					'topic-map',
					'market-reports'
				]
			},
			{
				title: 'Competitive Intelligence',
				description: 'Identify and analyze competitors',
				thumbnail: 'competitive-intelligence.jpg',
				panels: [
					'companies',
					'startups'
				]
			},
			{
				title: 'Future/Trend Intelligence',
				description: 'Identify and analyze trends and forecasts',
				thumbnail: 'trend-intelligence.jpg',
				panels: [
					'trends',
					'forecasts',
					'market-reports',
					'investees'
				]
			},
			{
				title: 'Startup Intelligence',
				description: 'Identify and analyze startups',
				thumbnail: 'startup-intelligence.jpg',
				panels: [
					'startups',
					'investees'
				]
			},
			{
				title: 'Partner Intelligence',
				description: 'Identify and analyze potential partners',
				thumbnail: 'partner-intelligence.jpg',
				panels: [
					'companies',
					'startups',
					'public-institutions',
					'organizations-network',
					'organizations-geomap'
				]
			},
			{
				title: 'Patent Intelligence',
				description: 'Analyze patents',
				thumbnail: 'patent-intelligence.jpg',
				panels: [
					'patents',
					'tech-areas',
					'standards'
				]
			},
			{
				title: 'Research Intelligence',
				description: 'Analyze research',
				thumbnail: 'research-intelligence.jpg',
				panels: [
					'research',
					'projects',
					'scientific-fields',
					'public-institutions'
				]
			},
			{
				title: 'News Monitoring',
				description: 'Analyze news',
				thumbnail: 'news-monitoring.jpg',
				panels: [
					'news',
					'web',
					'events',
					'forecasts',
					'market-reports'
				]
			}
		]
	},
	{
		contextName: 'Organization Only',
		useCases: [
			{
				title: 'Partner Intelligence',
				description: 'Identify and analyze partners of the organization',
				thumbnail: 'partner-intelligence.jpg',
				panels: [
					'companies',
					'startups',
					'public-institutions',
					'organizations-network',
					'organizations-geomap'
				]
			},
			{
				title: 'Patent Intelligence',
				description: 'Analyze IP of the organization',
				thumbnail: 'patent-intelligence.jpg',
				panels: [
					'patents',
					'tech-areas',
					'standards'
				]
			},
			{
				title: 'Research Intelligence',
				description: 'Analyze research of the organization',
				thumbnail: 'research-intelligence.jpg',
				panels: [
					'research',
					'projects',
					'scientific-fields'
				]
			},
			{
				title: 'News Monitoring',
				description: 'Analyze news of the organization',
				thumbnail: 'news-monitoring.jpg',
				panels: [
					'news',
					'web',
					'events',
					'forecasts',
					'market-reports'
				]
			},
			{
				title: 'Topic Mapping',
				description: 'Analyze topics and technologies related to the organization',
				thumbnail: 'topic-mapping.jpg',
				panels: [
					'topics',
					'trends',
					'visual-explorer',
					'topic-map'
				]
			}
		]
	},
	{
		contextName: 'Topic + Organization',
		useCases: [
			{
				title: 'Combined Search',
				description: "Analyze an organization's publications within a specific topic",
				thumbnail: 'combined-search.jpg',
				panels: [
					'news',
					'web',
					'patents',
					'research'
				]
			}
		]
	}
];

scout.component('referenceSection', {
	bindings: {
		data: '=',
		wk: '<',
		type: '@'
	},
	controller: function ($scope, $element, $sce, $rootScope) {
		// this identifier is required to get all instances of this component
		this.componentName = 'referenceSection';
		this.hasPatentEvents = function () {
			if (!this.data || this.data === 'error' || !this.data.length) return false;
			for (var i = 0; i < this.data.length; i++) {
				if (this.data[i]?.patent_event) return true;
			}
			return false;
		};
		this.hasType = function (type) {
			if (!this.data || this.data == 'error' || !this.data.length) return false;
			for (var i = 0; i < this.data.length; i++) {
				if (this.data[i]?._meta?.origItem.doc_type == type) return true;
			}
			return false;
		};
		this.getWeblink = function (item) {
			if (item.web_links && item.web_links.homepage) {
				return item.web_links.homepage;
			} else {
				return '#';
			}
		};
		this.getTitle = function (item, trustHighlightShorten = false) {
			let rawTitle = item.title;

			// avoid uppercase titles
			if (rawTitle.length > 5) {
				let uppercaseCount = rawTitle.length - rawTitle.replace(/[A-Z]/g, '').length;
				if (uppercaseCount / rawTitle.length > 0.6) {
					if (trustHighlightShorten) {
						// handle case where string starts with a tag
						let content = item.title_html.split(/<[^>]+>/);
						let tags = Array.from(item.title_html.matchAll(/<[^>]+>/g));
						let idx = 0;
						while (idx < content.length && content[idx].length == 0) idx++;
						let pos = 0;
						for (let i = 0; i < idx; i++) {
							if (tags[i]) pos += tags[i][0].length;
						}
						// uppercase to normal case
						item.title_html = item.title_html.substr(0, pos + 1).toUpperCase() + item.title_html.substr(pos + 1).toLowerCase();
					} else {
						rawTitle = rawTitle.substr(0, 1).toUpperCase() + rawTitle.substr(1).toLowerCase();
					}
				}
			}

			// select title
			let title = '';
			if (typeof item.title_html != 'undefined' && item.title_html != null) {
				title = item.title_html;
			} else {
				title = this.getWeblink(item);
			}

			let limit = 200;
			if (trustHighlightShorten) {
				// limit length
				if (title && rawTitle.length > limit) {
					// limiting must not cut through tags
					let nextTagEnd = -1;
					do {
						limit += nextTagEnd + 1;
						var begin = title.substr(0, limit);
						var end = title.substr(limit);
						var beginOpen = (begin.match(/<[^\/>]+>/g) || []).length;
						var beginClose = (begin.match(/<\/[^>]+>/g) || []).length;
						var endOpen = (end.match(/<[^\/>]+>/g) || []).length;
						var endClose = (end.match(/<\/[^>]+>/g) || []).length;
						nextTagEnd = end.search('>');
					} while ((beginOpen != beginClose || endOpen != endClose) && nextTagEnd != -1)
					title = begin + "…";
				}

				return $rootScope.trustAsHtml(title);
			} else {
				return rawTitle.length > limit ? htmlEscape(rawTitle) : '';
			}
		};
	},
	template: `
		<div style="text-align:center" ng-if="!$ctrl.data">
			<div style="position:relative" style="margin:10px 0px;">
				<i class="fa-solid fa-sync fa-spin fa-2x fa-fw" style="font-size: 1.5em;"></i>
				<div style="font-size:14px; margin-top:12px;">Loading documents</div>
			</div>
		</div>
		<div>
			<i style='color:grey' ng-if="$ctrl.data.length == 0">
				{{$ctrl.wk.module_name == 'patents' ? 'No legal events available' : 'No documents available'}}
			</i>
		</div>
		<div><i style='color:grey' ng-if="$ctrl.data == 'error'">Error: Could not load documents</i></div>
		<div class="references">
			<div class="ref-group" ng-if="$ctrl.hasType('WEB')">
				<h3><i class="fa-solid fa-globe-americas refs-group-icon"></i>Web</h3>
				<table class="ref-inner-table">
					<tr ng-repeat="item in $ctrl.data" ng-if="item._meta.doc_type == 'WEB'">
						<td class="action">
							<bookmark-action row="item" wk="$ctrl.wk" all-data="$ctrl.data"
								ng-if="::$root.isBookmarkActionAvailable($ctrl.wk)"></bookmark-action>
						</td>
						<td>
							<a href="{{$ctrl.getWeblink(item._meta.origItem)}}" title="{{$ctrl.getTitle(item._meta.origItem)}}"
								ng-bind-html="$ctrl.getTitle(item._meta.origItem, true)" target="_blank"></a>
							<span class="external-link"><i class="fa-solid fa-external-link-alt"></i></span>
							<broken-link-marker ng-if="item.web_links_broken.homepage"</broken-link-marker>
						</td>
					</tr>
				</table>
			</div>
			<div class="ref-group" ng-if="$ctrl.hasType('NEWS')">
				<h3><i class="fa-solid fa-rss refs-group-icon"></i>{{ $ctrl.type == 'trend' ? 'Signals' : 'News' }}</h3>
				<table class="ref-inner-table">
					<tr ng-repeat="item in $ctrl.data" ng-if="item._meta.doc_type == 'NEWS'">
						<td class="action">
							<bookmark-action row="item" wk="$ctrl.wk" all-data="$ctrl.data"
								ng-if="::$root.isBookmarkActionAvailable($ctrl.wk)"></bookmark-action>
						</td>
						<td>
							<a href="{{$ctrl.getWeblink(item._meta.origItem)}}" title="{{$ctrl.getTitle(item._meta.origItem)}}"
								ng-bind-html="$ctrl.getTitle(item._meta.origItem, true)" target="_blank"></a>
							<span class="external-link"><i class="fa-solid fa-external-link-alt"></i></span>
							<broken-link-marker ng-if="item.web_links_broken.homepage"</broken-link-marker>
						</td>
					</tr>
				</table>
			</div>
			<div class="ref-group" ng-if="$ctrl.hasType('PATENT')">
				<h3><i class="fa-solid fa-file-alt refs-group-icon"></i>Patents</h3>
				<table class="ref-inner-table">
					<tr ng-repeat="item in $ctrl.data" ng-if="item._meta.doc_type == 'PATENT'">
						<td class="action">
							<bookmark-action row="item" wk="$ctrl.wk" all-data="$ctrl.data"
								ng-if="::$root.isBookmarkActionAvailable($ctrl.wk)"></bookmark-action>
						</td>
						<td>
							<a href="{{$ctrl.getWeblink(item)}}" title="{{$ctrl.getTitle(item)}}" target="_blank"
								ng-bind-html="$ctrl.getTitle(item, true)"></a>
							<span ng-if="item._meta.relatedItems">
								(<a href="{{$ctrl.getWeblink(item)}}" title="{{$ctrl.getTitle(item)}}" target="_blank">{{ item.patent_meta.epodoc_nr || '…' }}</a>,
								<span ng-repeat="i in item._meta.relatedItems track by $index">
									<a href="{{$ctrl.getWeblink(i)}}" title="{{$ctrl.getTitle(i)}}" target="_blank">{{ i.patent_meta.epodoc_nr || '…' }}</a
								><span ng-if="$index < item._meta.relatedItems.length-1">, </span></span>)
							</span>
							<span class="external-link"><i class="fa-solid fa-external-link-alt"></i></span>
							<broken-link-marker ng-if="item.web_links_broken.homepage"</broken-link-marker>
						</td>
					</tr>
				</table>
			</div>
			<div class="ref-group" ng-if="$ctrl.hasType('SCIENCE')">
				<h3><i class="fa-solid fa-graduation-cap refs-group-icon"></i>Research</h3>
				<table class="ref-inner-table">
					<tr ng-repeat="item in $ctrl.data" ng-if="item._meta.doc_type == 'SCIENCE'">
						<td class="action">
							<bookmark-action row="item" wk="$ctrl.wk" all-data="$ctrl.data"
								ng-if="::$root.isBookmarkActionAvailable($ctrl.wk)"></bookmark-action>
						</td>
						<td>
							<a href="{{$ctrl.getWeblink(item)}}" title="{{$ctrl.getTitle(item)}}" target="_blank"
								ng-bind-html="$ctrl.getTitle(item, true)"></a>
							<span class="external-link"><i class="fa-solid fa-external-link-alt"></i></span>
							<broken-link-marker ng-if="item.web_links_broken.homepage"</broken-link-marker>
						</td>
					</tr>
				</table>
			</div>
			<div class="ref-group" ng-if="$ctrl.hasType('STANDARD')">
				<h3><i class="fa-regular fa-file-alt refs-group-icon"></i>Standards</h3>
				<table class="ref-inner-table">
					<tr ng-repeat="item in $ctrl.data" ng-if="item._meta.doc_type == 'STANDARD'">
						<td class="action">
							<bookmark-action row="item" wk="$ctrl.wk" all-data="$ctrl.data"
								ng-if="::$root.isBookmarkActionAvailable($ctrl.wk)"></bookmark-action>
						</td>
						<td>
							<a href="{{$ctrl.getWeblink(item)}}" title="{{$ctrl.getTitle(item)}}" target="_blank"
								ng-bind-html="$ctrl.getTitle(item, true)"></a>
							<span class="external-link"><i class="fa-solid fa-external-link-alt"></i></span>
							<broken-link-marker ng-if="item.web_links_broken.homepage"</broken-link-marker>
						</td>
					</tr>
				</table>
			</div>
			<div class="ref-group" ng-if="$ctrl.hasType('PROJECT_DESCR')">
				<h3><i class="fa-solid fa-project-diagram refs-group-icon"></i>Projects</h3>
				<table class="ref-inner-table">
					<tr ng-repeat="item in $ctrl.data" ng-if="item._meta.doc_type == 'PROJECT_DESCR'">
						<td class="action">
							<bookmark-action row="item" wk="$ctrl.wk" all-data="$ctrl.data"
								ng-if="::$root.isBookmarkActionAvailable($ctrl.wk)"></bookmark-action>
						</td>
						<td>
							<a href="{{$ctrl.getWeblink(item)}}" title="{{$ctrl.getTitle(item)}}" target="_blank"
								ng-bind-html="$ctrl.getTitle(item, true)"></a>
							<span class="external-link"><i class="fa-solid fa-external-link-alt"></i></span>
							<broken-link-marker ng-if="item.web_links_broken.homepage"</broken-link-marker>
						</td>
					</tr>
				</table>
			</div>
			<div class="ref-group" ng-if="$ctrl.hasPatentEvents()">
				<h3><i class="fa-solid fa-calendar refs-group-icon"></i>Legal events</h3>
				<div ng-repeat="item in $ctrl.data" style="align-items:center; margin: 14px 10px 0 10px;">
					<div style="font-size:15px; font-weight:600;">
						{{item.event_code}} | {{item.category_code}}: {{item.category_title}}
					</div>
					<div style="font-size:14px; margin-top:3px;"> {{item.description}} </div>
					<div style="color:var(--mpg-color-text-secondary); font-size:12px; margin-top:3px;">
						{{item.publn_date}}
					</div>
				</div>
			</div>
		</div>
	`
});

maxActionFieldWidth = '38px'; // max-width of below component + 16px, used to define max-width of other fields
scout.component('bookmarkAction', {
	bindings: {
		row: '<',
		type: '<',
		wk: '<',
		allData: '<'
	},
	controller: function ($scope, $element, $sce, $rootScope) {
		// this identifier is required to get all instances of this component
		this.componentName = 'bookmarkAction';
		let self = this;

		this.handleBookmarkCheckbox = function (row, event, mode) {
			if (row && event.shiftKey) {
				if (row._meta.selected) {
					this.unselectRowsInRange(row, mode);
				} else {
					this.selectRowsInRange(row, mode);
				}
			} else {
				this.toggleRowSelection(row, mode);
			}

			event.stopPropagation();
			event.preventDefault();
		};

		this.selectRowsInRange = function (clickedRow, mode) {
			let arr = clickedRow.doc_type
				? this.allData.filter(item => item.doc_type === clickedRow.doc_type) : this.allData;
			let clickedIndex = arr.indexOf(clickedRow);

			// Search for nearest predecessor
			let startIndex = this.findSelectedIndex(arr, clickedIndex, false, false);
			let endIndex = 0;

			// If no selected predecessor found, search for nearest selected successor
			if (startIndex === clickedIndex) {
				endIndex = this.findSelectedIndex(arr, clickedIndex, true, false);

				// No successor or predecessor
				if (endIndex === clickedIndex) {
					$rootScope.selectBookmark(clickedRow, mode);
					return;
				}
			}

			endIndex = (endIndex === 0) ? clickedIndex + 1 : endIndex;
			startIndex = (endIndex === clickedIndex + 1) ? startIndex + 1 : startIndex;

			for (let i = startIndex; i < endIndex; i++) {
				$rootScope.selectBookmark(arr[i], mode);
			}
		};

		this.unselectRowsInRange = function (clickedRow, mode) {
			let arr = clickedRow.doc_type
				? this.allData.filter(item => item.doc_type === clickedRow.doc_type) : this.allData;
			let clickedIndex = arr.indexOf(clickedRow);

			// Furthest predecessor
			let startIndex = this.findSelectedIndex(arr, clickedIndex, false, true);

			// Furthest successor
			let endIndex = this.findSelectedIndex(arr, clickedIndex, true, true);

			// If no neighbours
			if (startIndex === clickedIndex && clickedIndex === endIndex) {
				$rootScope.unselectBookmark(clickedRow, mode);
				return;
			}

			for (let i = startIndex; i <= endIndex; i++) {
				$rootScope.unselectBookmark(arr[i], mode);
			}
		};

		this.findSelectedIndex = function (arr, currentIndex, searchSuccessor, searchFurthest) {
			let step = searchSuccessor ? 1 : -1;
			let limit = searchSuccessor ? arr.length : -1;

			if (searchFurthest) {
				// Unselect, Find the furthest selected predecessor or successor.
				for (let i = currentIndex; (searchSuccessor ? i < limit : i > limit); i += step) {
					if (arr[i] && arr[i]._meta.selected
						&& (arr[i + step] && !arr[i + step]._meta.selected) || !arr[i + step]) {
						return i;
					}
				}
			} else {
				// Select, If the adjacent checkbox is selected return.
				if (arr[currentIndex + step] && arr[currentIndex + step]._meta.selected) {
					return currentIndex;
				}
				// Find the nearest selected predecessor or successor.
				for (let i = currentIndex + step; i !== limit; i += step) {
					if (arr[i] && arr[i]._meta.selected) {
						return i;
					}
				}
			}

			return currentIndex; // No selected predecessor or successor found, return the current index
		};

		this.toggleRowSelection = function (row, mode) {
			if (row._meta.selected) {
				$rootScope.unselectBookmark(row, mode);
			} else {
				$rootScope.selectBookmark(row, mode);
			}
		};

	},
	template: `
		<span style="cursor:pointer"
			ng-style="{
					'pointer-events': $ctrl.row.loading ? 'none' : null,
					'opacity': $ctrl.row.loading ? '0.5' : null
				}">
			<i class="fa-solid fa-file-import m-link" style="font-size:22px"
				title="{{ 'Import this ' + ($ctrl.type == 'TableRow' ? 'table row' : 'item') }}"
				ng-click="$root.sendDataToIframeParent($ctrl.row, $ctrl.type || 'ReferenceItem');
					$event.stopPropagation();"
				ng-style="{
					'visibility': $ctrl.row.sentToCustomer ? 'hidden' : null,
					'pointer-events': $ctrl.row.sentToCustomer ? 'none' : null
				}"
				ng-if="$ctrl.wk.mode == 'customer_iframe'"></i>

			<span title="{{ 'Select one or more items to bookmark to projects.' + (
				$root.bookmarks[$ctrl.row._meta.module_name][$ctrl.row._meta.id]
					? '\r\n\r\nThis item is bookmarked in the current page.'
					: ($ctrl.row._meta.bookmarked_by_me ? '\r\n\r\nYou bookmarked this item.' : '')
				) }}"
					ng-if="$ctrl.wk.mode !== 'customer_iframe'
					&& ($ctrl.wk.mode !== 'library' || ($ctrl.wk.mode === 'library' && $ctrl.row._meta.ref_item))">
				<i class="fa-solid fa-star m-checkbox-bookmarked"
					ng-if="$root.bookmarks[$ctrl.row._meta.module_name][$ctrl.row._meta.id]
						|| $ctrl.row._meta.bookmarked_by_me"
					ng-style="$ctrl.row._meta.selected ? {'color': 'white', 'z-index': 1} : {}"></i>
				<div class="m-checkbox" ng-class="{checked: $ctrl.row._meta.selected}"
					ng-click="$ctrl.handleBookmarkCheckbox($ctrl.row, $event, false)"><div></div></div>
			</span>

			<div class="m-checkbox" ng-class="{checked: $ctrl.row._meta.selected}"
				ng-click="$ctrl.handleBookmarkCheckbox($ctrl.row, $event, true)"
				ng-if="$ctrl.wk.mode == 'library' && !$ctrl.row._meta.ref_item"><div></div></div>
		</span>
	`
});

scout.component('queryBuilder', {
	bindings: {
		settings: '='
	},
	controller: function ($scope, $element, $sce, $window, $timeout, $rootScope, MapegyAPIService) {
		this.componentName = 'queryBuilder';
		let self = this;
		this.isInitialized = false;

		this.defaultSettings = {
			filterButtons: [],
			loading: null,
			hideQuerySummary: false,
			isFilterOpen: true,
			page: null,
			template: null,
			onFilterChange: null,
			onClearQuery: null,
			currentQueryBuilderTab: null,
			initQuery: false,
			hideButtons: false,
			preselect: null,
			searchName: '', // The user input that's used to generate a query
			suggestions: null // The suggestions from a generated query
		};
		this.$onInit = function () {
			if (self.settings) {
				// Set default values but keep the initial object reference intact
				Object.entries(self.defaultSettings).forEach(([key, value]) => {
					if (typeof self.settings[key] == 'undefined') self.settings[key] = value;
				});
				self.settings.autoSelectQueryBuilderTab = self.autoSelectQueryBuilderTab;
				self.settings.clearQuery = self.clearQuery;
				self.settings.cancelQueryEditing = self.cancelQueryEditing;
				self.settings.changeQuery = self.changeQuery;
				self.settings.setQueryBuilderOpen = self.setQueryBuilderOpen;
				self.settings.getQueryComponents = self.getQueryComponents;
				self.settings.trackQuery = self.trackQuery;
				self.settings.updateView = self.updateView;
				self.settings.applyQuery = self.applyQuery;
				self.parentScope = self.settings.scope;

				// Init query
				let initQuery = self.settings.initQuery;
				if (typeof initQuery != 'undefined' && initQuery) {
					// Load & import the initial query of the page, usually coming from the URL
					initQuery = self.parentScope.upgradeQueryVersion(initQuery);
					if (!initQuery) {
						document.body.innerHTML = 'Wrong query format.';
						document.body.style.background = 'white';
						return false;
					}
					self.parentScope.scout_query = initQueryBuilderFormat(initQuery);
					self.parentScope.active_scout_query = angular.copy(self.parentScope.scout_query);
				} else if (self.settings.page === 'project' && self.parentScope.project.scout_query) {
					// Initialize the query based on what is saved in the current project page
					self.parentScope.scout_query = angular.copy(self.parentScope.project.scout_query);
					self.parentScope.active_scout_query = angular.copy(self.parentScope.project.scout_query);
				} else {
					// Create empty query
					self.parentScope.scout_query = getDefaultQuery();
					self.parentScope.active_scout_query = angular.copy(self.parentScope.scout_query);
				}

				// Init suggestions
				for (const type in self.settings.suggestions || {}) {
					if (!self.recommendedTerms[type]) self.recommendedTerms[type] = {};
					self.settings.suggestions[type].forEach((row, rowIdx) => {
						self.recommendedTerms[type][rowIdx] = row.map((term) => {
							return {
								term: term,
								persistent: true
							};
						});
					});
				}

				self.updateView();
				self.isInitialized = true; // Set the flag to true after successful initialization
				$scope.$applyAsync();
			} else {
				self.isInitialized = false;
			}
		};

		/* Add or remove parts of the scout_query
			@param action: 'add' or 'remove'
			@param type: 'topics' or 'organizations'
			@param andIdx: index of the list (AND-dimension)
			@param term: term (string) to add or remove
			, or null/false/undefined to only add/remove an AND-concatenated list
		*/
		this.changeQuery = function (action, type, andIdx, term, options = {}) {
			if (term == '' && !(action === 'add' && type === 'semantic')) return false;
			if (term == '' && action === 'add' && type === 'semantic') action = 'remove';

			if (options.scout_query) var entity = options.scout_query.data[type];
			else var entity = self.parentScope.scout_query.data[type];
			switch (action) {
				case 'add':
					if (term) {
						// clean term
						term = cleanQueryTerm(term, type !== 'semantic');
						if (term == '') return false;

						if (type === 'semantic') {
							// add/update semantic search phrase
							if (options.scout_query) options.scout_query.data[type] = term;
							else self.parentScope.scout_query.data[type] = term;

						} else {
							// add term to a list
							if (andIdx == 'new') {
								if (entity.length > 0 && entity[entity.length - 1].length == 0) {
									// if last AND-list is empty, add the term to that list
									entity[entity.length - 1].push(term);
								} else {
									// create a new AND-list for that term
									entity.push([term]);
								}
							} else if (andIdx >= entity.length) {
								// add term to a new list
								entity.push([term]);
							} else {
								// if term already exists, it will be moved to the end
								// verbatim and non-verbatim terms may replace each other
								let checkTerms = entity[andIdx].map(function (x) {
									return x.toUpperCase().replace(/"/g, '')
								});
								if (checkTerms.includes(term.toUpperCase().replace(/"/g, ''))) {
									self.changeQuery('remove', type, andIdx, term);
									self.changeQuery('remove', type, andIdx, term.replace(/"/g, ''));
									self.changeQuery('remove', type, andIdx, '"' + term + '"');
								}
								// add term to an existing list
								entity[andIdx].push(term);
							}
						}

					} else if ((!andIdx || andIdx >= entity.length) && type !== 'semantic') {
						// add empty list
						entity.push([]);
					}
					break;

				case 'remove':
					if (type === 'semantic') {
						// remove semantic search phrase
						if (options.scout_query) options.scout_query.data[type] = '';
						else self.parentScope.scout_query.data[type] = '';

					} else {
						if (term && term != '') {
							// remove term from existing list
							entity[andIdx] = entity[andIdx].filter(function (item) {
								return item.toUpperCase() != term.toUpperCase();
							});
						} else {
							// remove complete list
							entity.splice(andIdx, 1);
						}

						// Reset recommendations
						if (!entity[andIdx] || !entity[andIdx].length) {
							self.updateRecommendations(type, andIdx, [], true);
						}
					}
					break;
			}
		};

		this.clearQuery = function (clearSections = null) {
			if (self.settings.onClearQuery) {
				self.settings.onClearQuery();
			} else {
				let emptyQuery = new ScoutQuery();
				self.parentScope.scout_query.data = emptyQuery.data;
				self.changeQuery('add', 'topics', null, null, {});
				self.changeQuery('add', 'organizations', null, null, {});
				self.autosuggestInput.semantic = '';

				self.setQueryBuilderOpen(true);
				self.settings.hideQuerySummary = true;
				$scope.$applyAsync();
			}
		};

		this.queryBuilderTabs = [
			{
				title: 'Expert',
				type: 'ADVANCED',
				iconClass: 'fa-solid fa-circle-half-stroke',
				query: null
			},
			{
				title: 'Smart',
				type: 'SMART',
				iconClass: 'fa-solid fa-magnifying-glass',
				query: null
			}
		];

		this.setQueryBuilderOpen = (newState = true) => {
			// In the Search Hub, we register the background state so that the panel can refresh view later on if needed
			if (newState && !self.settings.isFilterOpen && self.parentScope.currentPanel) {
				self.parentScope.currentPanel.currentTab?.setViewStateToBackground();
			}

			// In the Search Hub, we must reload the current panel view because the open query builder hides all panels
			if (!newState && self.settings.isFilterOpen && self.parentScope.currentPanel) {
				self.parentScope.$broadcast('changeTab', {
					panelId: self.parentScope.currentPanel.id,
					moduleName: self.parentScope.workspace2
				});
			}

			self.settings.isFilterOpen = newState;
		};

		this.cancelQueryEditing = () => {
			self.setQueryBuilderOpen(false);
			self.settings.currentQueryBuilderTab.query = self.parentScope.scout_query || null;
			self.parentScope.scout_query = angular.copy(self.parentScope.active_scout_query);
			self.settings.hideQuerySummary = self.parentScope.getSearchString() === '';
			self.autoSelectQueryBuilderTab();
		};

		this.autoSelectQueryBuilderTab = () => {
			if (self.parentScope.isSemanticQuery()) {
				self.settings.currentQueryBuilderTab = self.queryBuilderTabs.find((x) => x.type === 'SMART');
			} else {
				self.settings.currentQueryBuilderTab = self.queryBuilderTabs.find((x) => x.type === 'ADVANCED');
			}
		};

		this.selectQueryBuilderTab = (tab) => {
			if (!self.queryBuilderTabs) return false
			const prevTab = self.settings.currentQueryBuilderTab;

			if (tab) {
				self.settings.currentQueryBuilderTab = tab;
			} else {
				// Select default tab
				self.settings.currentQueryBuilderTab = self.queryBuilderTabs.find((x) => x.type === 'ADVANCED');
			}
			if (prevTab != self.settings.currentQueryBuilderTab) {
				prevTab.query = self.parentScope.scout_query;
				self.parentScope.scout_query = self.settings.currentQueryBuilderTab.query
					|| initQueryBuilderFormat(new ScoutQuery());
				self.setQueryBuilderOpen(true);
			}
		}

		this.restoreProjectQuery = function () {
			self.parentScope.scout_query = angular.copy(self.parentScope.project.scout_query);
			self.updateView();
			self.applyQuery();
		};

		this.getQueryLink = function (targetModule, preselect = false) {
			const queryParam = 'q=' + encodeURIComponent(JSON.stringify(self.parentScope.active_scout_query));
			const path = `/search${ targetModule ? `/in/${ targetModule }` : '' }`;
			const baseUrl = `${ MPG.SCOUT_BASE_URL }${ path }`;
			const project = self.parentScope.project;

			if (preselect && project) {
				if (project.parent_id) return `${ baseUrl }?folderId=${ project.parent_id }&${ queryParam }`;
				if (project.foreign) return `${ baseUrl }?groupId=${ project.owner_id }&${ queryParam }`;
			}

			return `${ baseUrl }?${ queryParam }`;
		};

		this.clickFilterMenuBtn = function () {
			self.settings.isFilterOpen = !self.settings.isFilterOpen;
		};

		this.getQueryName = function () {
			if (this.settings.searchName) return this.settings.searchName;
			return self.parentScope.getSearchStringKeywords(undefined,
				self.parentScope.project && self.parentScope.active_scout_query
					? self.parentScope.active_scout_query.data
					: null
			)[0];
		};

		// create project page(s) based on a specific query
		this.saveQuery = function () {
			if (self.parentScope.project) {
				// in a project page, save the query in the project

				// update the query which is stored in temporary project variables
				self.parentScope.project.tmp_scout_query = angular.copy(self.parentScope.active_scout_query);

				// save changes
				self.parentScope.project.elements = angular.copy(self.parentScope.project.tmpElements);
				self.parentScope.project.scout_query = angular.copy(self.parentScope.project.tmp_scout_query);
				let cleanedElements = self.parentScope.getCleanedElements(self.parentScope.project.elements);
				let projParams = {
					id: self.parentScope.project.id,
					elements: cleanedElements,
					scout_query: angular.copy(self.parentScope.project.scout_query)
				};

				function saveChanges () {
					self.parentScope.onBeforeRequest();
					scoutBackendApi.updateProject(projParams, function (response) {
						if (self.parentScope.project.last_kpi_update) delete self.parentScope.project.last_kpi_update;
						self.parentScope.onAfterRequest(response);
						if (response.status == 'error') offerTryAgain(response);
					});
				}

				saveChanges();

				function offerTryAgain (response) {
					let errDetails = $rootScope.getErrorDetails(response.message, 'saveProject');
					$rootScope.confirmDialog = {
						show: true,
						iconClass: 'fa-solid fa-exclamation-triangle',
						caption: 'Error',
						content: htmlEscape(errDetails.message),
						remark: htmlEscape(errDetails.remark),
						rightButtonLabel: 'Try again',
						rightButtonCallback: function () {
							saveChanges();
						}
					};
					$rootScope.$applyAsync();
				}

				return;
			}

			let newTitle = self.settings.title || self.getQueryName();
			let newDescription = '';
			const contentDetails = { contentType: 'EMPTY_PAGE' };

			let fields = [];
			if ($rootScope.countSelectedBookmarks() > 0 && self.settings.page == 'search') {
				fields.push({
					type: 'checkbox',
					label: 'Add ' + $rootScope.countSelectedBookmarks() + ' Bookmark'
						+ ($rootScope.countSelectedBookmarks() > 1 ? 's' : ''),
					value: true,
					style: { 'margin-bottom': '0.5em' },
				});
			}

			$rootScope.selectProjectsDialog = {
				show: true,
				iconClass: 'fa-solid fa-save',
				caption: 'Save to My Portfolio',
				content: 'Save this query within a new project page:',
				preselect: self.settings.preselect,
				multiselect: false,
				rightButtonLabel: 'Create',
				dropdownFolders: true,
				alwaysShowUnassignedProjects: true,
				alwaysShowNewProjectFields: true,
				placeFieldsAboveFolders: true,
				customTitleLabel: 'Name',
				hideDescriptionField: true,
				fields: fields,
				new: {
					selected: true,
					title: { value: newTitle },
					description: { value: newDescription }
				},

				rightButtonCallback: async function () {
					$rootScope.showMessage('Creating project...', 'pending', null);

					let addBookmarks = fields.length > 0 && fields[0].value;

					let addBookmarksToNewProject = function (newId) {
						let tasks = [];
						for (let listKey of Object.keys($rootScope.selectedBookmarks)) {
							for (let item of $rootScope.selectedBookmarks[listKey]) {
								let task = {
									id: item._meta.id,
									module_name: listKey,
									add_projects: [newId]
								};

								if ((typeof item._meta.saveBookmarkContent != 'undefined'
									&& item._meta.saveBookmarkContent)) {
									task.bookmark_json = scoutBackendApi.cleanBookmark(item);
								}
								tasks.push(task);
							}
						}
						let options = { tasks: tasks };
						let newProject = {
							id: newId,
							title: $rootScope.selectProjectsDialog.new.title.value
						};
						scoutBackendApi.editBookmarks(options, function (response) {
							if (response.status === 'success') {
								localStorage.setItem('last-bookmark-target', JSON.stringify(newProject));
								$rootScope.resetSelectedBookmarks(true);
							}
						});
					};

					var addPage = function (projParams) {
						return new Promise(function (resolve, reject) {
							scoutBackendApi.addProject(projParams, {
								log_content_type: contentDetails.contentType
							}, function (response) {
								if (response.status === 'success') {
									if (projParams.response) {
										$rootScope.projects = response.data;
									}
									let newId = response.query;
									if (addBookmarks) addBookmarksToNewProject(newId);
									resolve(newId);
								} else {
									$rootScope.showMessage('Project could not be created.', 'error');
									reject();
								}
							});
						});
					};

					let options = {
						title: $rootScope.selectProjectsDialog.new.title.value,
						description: '',
						scout_query: self.parentScope.active_scout_query
					};
					if ($rootScope.selectProjectsDialog.new.parentId) {
						options.parent_id = $rootScope.selectProjectsDialog.new.parentId;
					} else if (!$rootScope.selectProjectsDialog.new.parentId
						&& $rootScope.selectProjectsDialog.folder && $rootScope.selectProjectsDialog.folder.owner_id !== MPG.USER_ID) {
						options.owner_id = $rootScope.selectProjectsDialog.folder.owner_id;
					}

					addPage(options).then(function (newId) {
						$rootScope.showMessage('Project created.', 'success');
						$rootScope.suppressUnloadWarning = true;
						window.location.href = MPG.SCOUT_BASE_URL + '/projects/' + newId;
					}).finally(function () {
						self.parentScope.$applyAsync();
					});
				}
			};
			focusFirstModalInput();
		};

		this.applyQuery = function () {
			self.settings.onFilterChange();
			self.trackQuery();
		};

		this.getQueryComponents = function (queryData) {
			let components = [];
			Object.keys(queryData).forEach(key => {
				let value = queryData[key];
				let isNonEmptyArray = Array.isArray(value) && value.some(arr => arr.length > 0);
				let isNonEmptyString = typeof value === 'string' && value.length > 0;

				if (isNonEmptyArray || isNonEmptyString) {
					components.push(key);
				}
			});
			return components;
		}
		this.trackQuery = function () {
			let queryData = self.parentScope.active_scout_query.data;
			let querySummary = self.parentScope.getSearchString({
				add_type_name: true, query: self.parentScope.active_scout_query
			});
			let queryComponents = self.getQueryComponents(queryData);
			let queryOperators = [];

			let operators = ['AND', 'NOT', 'OR'];
			operators.forEach(operator => {
				if (querySummary.includes(operator)) {
					queryOperators.push(operator);
				}
			});

			if (queryComponents.length > 0) {
				mixpanel.track('Scout Search Applied', {
					query_components: queryComponents,
					query_summary: querySummary,
					query_operators: queryOperators,
					query_prompt: self.settings.searchName || null
				});
			}
		}

		this.isSearchAllowed = function (options = {}) {
			options = Object.assign({}, options);
			options.no_not = true;
			return self.parentScope.getSearchString(options) != '';
		};

		this.enableSearchbutton = function () {
			return (self.isSearchAllowed({ query: self.parentScope.scout_query })
				|| self.parentScope.getSearchString({ query: self.parentScope.scout_query }) == ''
				&& self.parentScope.isEditing);
		};

		this.triggerSearchOnEnter = function (type, rowId) {
			if (!self.autosuggestInput[type][rowId] && self.enableSearchbutton()) {
				self.applyQuery();
			}
		};

		this.isAndAllowed = function (data) {
			return data?.length && data.map(x => !!x.length).reduce((a, b) => a && b, true);
		};

		this.updateView = function () {
			// Show optional filter sections
			const parentQuery = self.settings.allowMultipleInstances
				? { query: self.parentScope.active_scout_query }
				: {};
			if (self.parentScope.getSearchString({ return_types: ['organizations'], ...parentQuery }) != ''
				&& self.parentScope.getSearchString({ return_types: ['semantic'], ...parentQuery }) != '') {
				self.showOrganizationsFilterInSmartSearch = true;
			}

			// Update selection of query builder tab
			self.autoSelectQueryBuilderTab();
		}

		// close the autosuggest dropdowns when clicking in the background
		$window.addEventListener('click', (e) => {
			let elem = e.target;
			let hasActiveMapegyDropdown = elem.hasActiveMapegyDropdown;
			while (elem.parentNode) {
				elem = elem.parentNode;
				if (elem.hasActiveMapegyDropdown) {
					hasActiveMapegyDropdown = true;
					break;
				}
			}
			if (!hasActiveMapegyDropdown) {
				self.resetAutosuggestData();
			}
		});


		/* Get search terms from the backend ------------------------------------------------------------------------ */

		// used to remember last successful autosuggest response
		this.lastAutosuggestData = [];
		this.lastAutosuggestQuery = null; // used to avoid race conditions
		// used to identify the dropdown
		this.lastAutosuggestType = null; // topics, organizations, not_topics, not_organizations
		this.lastAutosuggestRowId = null;

		this.resetAutosuggestData = function () {
			if (self.lastAutosuggestData.length || self.lastAutosuggestQuery) {
				self.lastAutosuggestData = [];
				self.lastAutosuggestQuery = null;
				self.lastAutosuggestType = null;
				self.lastAutosuggestRowId = null;
				$scope.$applyAsync();
			}

			if (self.lastAutosuggestPromise?.abortRequest) self.lastAutosuggestPromise.abortRequest();
		};

		this.recommendedTerms = {};
		this.showRecommendations = function (type, row_idx, term) {
			if (term.trim() == '') {
				return false;
			} else {
				self.updateRecommendations(type, row_idx, []); // reset
				if (type == 'topics' || type == 'not_topics') {
					var params = {
						query: term.trim(),
						limit: 15,
						// specify required response columns
						include: 'term,description',
						mode: 'RECOMMENDER'
					};
					return MapegyAPIService.callData('Autosuggest/Topics', params, $scope, false, false)
						.then(function (response) {
							if (response != []) self.updateRecommendations(type, row_idx, response);
							else return false;
						}).catch(function (err) {
							console.log(err);
						});
				}
			}
		};
		this.updateRecommendations = function (type, row_idx, data = null, overwritePersistent = false) {
			if (self.recommendedTerms[type]) {
				if (data) {
					if (!overwritePersistent) {
						data = (self.recommendedTerms[type][row_idx] || []).filter((x) => x.persistent).concat(data);
					}
				} else {
					data = self.recommendedTerms[type][row_idx] || [];
				}
			}
			let items = [];
			let query = self.parentScope.getSearchString(
				{ query: self.parentScope.scout_query, return_types: [type] }
			).toLowerCase();
			for (let item of data) {
				if (
					!query.includes(item.term.toLowerCase())
					&& !items.some((x) => x.term.toLowerCase === item.term.toLowerCase())
				) items.push(item);
			}
			if (!self.recommendedTerms[type]) self.recommendedTerms[type] = {};
			self.recommendedTerms[type][row_idx] = items;
			$scope.$applyAsync();
		};

		this.lastAutosuggestPromise = null;
		this.autosuggestQueryTerms = function (val, type, row_idx) {
			// get time & search
			let latestSearch = (new Date()).getTime();
			self.latestAutosuggestSearch = latestSearch;
			if (!(val.length >= 1)) return;

			// schedule search
			setTimeout(function () {
				if (latestSearch != self.latestAutosuggestSearch) return;
				if (!self.autosuggestInput[type][row_idx]) return;

				// search
				let func = () => null;
				if (type.includes('topics')) func = self.search_topics;
				else if (type.includes('organizations')) func = self.search_organizations;
				if (func) {
					if (self.lastAutosuggestPromise?.abortRequest) self.lastAutosuggestPromise.abortRequest();
					func(val, type, row_idx).then(() => {
						$scope.$applyAsync();
					});
				}
			}, 400);
		};

		this.highlightAutosuggestTitleMatch = function (arr, key, val) {
			let matchValue = val.toLowerCase();
			arr.forEach((item) => {
				let matchIdx = item[key].toLowerCase().indexOf(matchValue);
				if (matchIdx === -1) {
					item.title_html = htmlEscape(item[key]);
				} else {
					item.title_html = htmlEscape(item[key].substr(0, matchIdx))
						+ '<b>' + htmlEscape(item[key].substr(matchIdx, matchValue.length)) + '</b>'
						+ htmlEscape(item[key].substr(matchIdx + matchValue.length));
				}
			});
		};

		this.autosuggestInput = new ScoutQuery().data;
		this.selectAutosuggestItems = function (items, type, row_idx) {
			for (let [idx, item] of Object.entries(items)) {
				let term = '';
				if (type.includes('topics')) term = item.term;
				else term = item.player_name;

				self.changeQuery('add', type, row_idx, term);
				if (parseInt(idx) === 0 && type.includes('topics')) {
					self.showRecommendations(type, row_idx, term);
				}
			}

			self.autosuggestInput[type][row_idx] = '';
			self.resetAutosuggestData();
		};

		this.search_topics = function (val, type, row_idx) {
			if (val.trim() == '') {
				return Promise.resolve();
			} else {
				self.lastAutosuggestQuery = val;
				let limit = Math.min(20, Math.floor(window.innerHeight / 100));
				var params = {
					query: val,
					limit: limit,
					// specify required response columns
					include: 'term,web_links,description'
				};
				let promise = MapegyAPIService.callData('Autosuggest/Topics', params, $scope, false, false);
				self.lastAutosuggestPromise = promise;
				return promise.then(function (response) {
					if (response != []) {
						response = response.filter(function (el, index) {
							if (index < limit) {
								return el;
							} else {
								return;
							}
						});
						if (self.lastAutosuggestQuery == val) {
							self.highlightAutosuggestTitleMatch(response, 'term', val);
							self.lastAutosuggestData = response;
							self.lastAutosuggestType = type;
							self.lastAutosuggestRowId = row_idx;
						}
						return response;
					} else {
						return false;
					}
				}).catch(function (err) {
					console.log(err);
				});
			}
		};

		this.search_organizations = function (val, type, row_idx) {
			if (val.trim() == '') {
				return Promise.resolve();
			} else {
				self.lastAutosuggestQuery = val;
				let limit = Math.min(20, Math.floor(window.innerHeight / 100));
				var params = {
					query: val,
					limit: limit,
					// specify required response columns
					include: 'player_name,web_links,country_code,description'
				};
				let promise = MapegyAPIService.callData('Autosuggest/Organizations', params, $scope, false, false);
				self.lastAutosuggestPromise = promise;
				return promise.then(function (response) {
					if (response != []) {
						response = response.filter(function (el, index) {
							if (index < limit) {
								return el;
							} else {
								return;
							}
						});
						if (self.lastAutosuggestQuery == val) {
							self.highlightAutosuggestTitleMatch(response, 'player_name', val);
							self.lastAutosuggestData = response;
							self.lastAutosuggestType = type;
							self.lastAutosuggestRowId = row_idx;
						}
						return response;
					} else {
						return false;
					}
				}).catch(function (err) {
					console.log(err);
				});
			}
		};
	},
	template: `
		<div class="subheader" ng-style="$ctrl.settings.page == 'search' ?
			{'background': 'white', 'border-bottom': 'thin solid var(--mpg-color-content-line)'} : {}"
			ng-class="{
				'is-filter-open': $ctrl.settings.isFilterOpen
			}" ng-if="$ctrl.isInitialized">
			<div class="content" style="position: relative; padding-top: 0; padding-bottom: 0; max-width:none;
				overflow-x:clip">
				<div ng-if="!$ctrl.settings.loading">

					<!-- Filter header -->
					<div id="filter-header" class="m-nav-container query-builder-tabs">

						<!-- Filter tabs -->
						<div class="m-nav-tab noselect"
							ng-if="($root.showAdminTools
									|| $ctrl.parentScope.getSearchString({ return_types: ['semantic'] }) !== ''
								) && !$ctrl.settings.hideActions"
							ng-repeat="tab in $ctrl.queryBuilderTabs track by $index"
							ng-class="{ active: $ctrl.settings.currentQueryBuilderTab === tab }"
							ng-click="$ctrl.selectQueryBuilderTab(tab)">
							<div class="m-nav-tab-separator"></div><span class="tab-label">
								<i class="{{ tab.iconClass }}"
									style="margin-right:8px"></i>{{ tab.title }}
								<!-- beta badge -->
								<sup ng-if="tab.type === 'SMART'" class="m-table-tag"
									style="background:var(--mpg-color-ai); margin-bottom:-2px">BETA</sup>
							</span>
						</div>

						<div id="filter-header-right">
							<div id="filter-search-summary">

								<!-- Filter summary -->
								<span id="filter-search-summary-text"
									ng-if="!$ctrl.settings.hideQuerySummary
										&& ($ctrl.settings.page !== 'project'
											&& $ctrl.settings.page !== 'assistant'
											|| $ctrl.settings.isFilterOpen)">
									<b>Search:</b>
									&nbsp;{{
										$ctrl.parentScope.getSearchString({
											add_type_name: true, query: $ctrl.parentScope.active_scout_query
										})
									}}
								</span>

								<!-- Clickable filter summary for project pages-->
								<a href="{{ $ctrl.getQueryLink(null, true) }}"
									id="filter-search-summary-text"
									title= "Open query" target="{{ $ctrl.settings.linkTarget || '_self' }}"
									ng-if="!$ctrl.settings.hideQuerySummary
										&& ($ctrl.settings.page == 'project' || $ctrl.settings.page == 'assistant')
										&& !$ctrl.settings.isFilterOpen">
									<b>Search:</b>
									&nbsp;{{
										$ctrl.parentScope.getSearchString({
											add_type_name: true, query: $ctrl.parentScope.active_scout_query
										})
									}}
								</a>

								<!-- Clear button -->
								<span style="line-height:18px; font-size:18px; "
									ng-if="!$ctrl.settings.hideQuerySummary && !$ctrl.settings.hideActions
										&& $ctrl.settings.page == 'search' && $ctrl.parentScope.getSearchString({
											query: $ctrl.parentScope.scout_query
										}) != ''">
									<i
										class="fa-solid fa-times m-link m-link-black"
										style="vertical-align:middle; margin-left:15px;"
										ng-click="$ctrl.clearQuery()" title="Clear"></i>
								</span>
							</div>

							<span class="search-filter-buttons noselect">

								<!-- Edit button -->
								<div class="m-button-secondary m-compact"
									ng-if="$ctrl.settings.filterButtons.includes('edit')
										&& !$ctrl.settings.isFilterOpen"
									ng-click="$ctrl.settings.page == 'search'
										? $ctrl.setQueryBuilderOpen(true)
										: $ctrl.clickFilterMenuBtn()">
									<i class="fa-regular fa-pen-to-square" style="margin-right:4px;">
									</i>
									Edit
								</div>

								<!-- Restore button -->
								<div class="m-button-secondary m-compact"
									ng-if="$ctrl.settings.filterButtons.includes('restore')
									&& !$ctrl.settings.isFilterOpen && $ctrl.parentScope.getSearchString({
										add_type_name: true, query: $ctrl.parentScope.project.scout_query
									}) != $ctrl.parentScope.getSearchString({
										add_type_name: true, query: $ctrl.parentScope.active_scout_query
									}) && ($ctrl.parentScope.getSearchString({
										add_type_name: true, query: $ctrl.parentScope.project.scout_query
									}) != '' || $ctrl.parentScope.isEditing)"
									ng-click="$ctrl.restoreProjectQuery()" title="Restore the saved query">
									Restore
								</div>

								<!-- Save button -->
								<div class="m-button-main m-compact" style="border:none"
									ng-click="$ctrl.saveQuery()"
									ng-if="$ctrl.settings.filterButtons.includes('save')
										&& !$ctrl.settings.isFilterOpen
										&& ($ctrl.settings.page === 'project'
										? !$ctrl.parentScope.isEditing
											&& $ctrl.parentScope.getSearchString({
												query: $ctrl.parentScope.active_scout_query
											}) !== ''
											&& ($ctrl.parentScope.project.readonly
											|| $ctrl.parentScope.getSearchString({
												query: $ctrl.parentScope.active_scout_query
											}) !== $ctrl.parentScope.getSearchString({
												 query: $ctrl.parentScope.project.scout_query
											})
										)
										: $ctrl.parentScope.getSearchString() !== ''
									)">
									Save
								</div>

							</span>
						</div>
					</div>

					<div class="filter-header-separator" ng-if="$ctrl.settings.isFilterOpen"></div>

					<!-- Query & Filter ------------------------------------------------------------------------------->
					<div ng-show="$ctrl.settings.isFilterOpen" class="mapegyfilter">

						<!-- Headline -->
						<div class="query-builder-headline"
							ng-if="$ctrl.settings.currentQueryBuilderTab.type === 'ADVANCED'">
							Search Specific Topics and/or Organizations</div>
						<div class="query-builder-headline"
							ng-if="$ctrl.settings.currentQueryBuilderTab.type === 'SMART'">
							Explore Smart Search Beta</div>

						<div class="generic-info-block" style="margin-bottom:16px"
							ng-if="$ctrl.settings.currentQueryBuilderTab.type === 'SMART'">
							<span>
								Smart Search is gradually being rolled out to every panel.
									<a class="m-link-main" target="_blank"
									href="https://support.mapegy.com/how-tos/smart-search"
									>Learn more.</a> Help us improve by sharing your feedback—we’re listening.
							</span>
						</div>

						<div class="panel-filter-container">
							<div ng-repeat="querySection in [
								{
									type: 'semantic',
									hint: 'Search a topic',
									show: $ctrl.settings.currentQueryBuilderTab.type === 'SMART'
								}
							]"
								ng-show="querySection.show" ng-init="type = querySection.type">

								<div class="filter-row">
									<!-- Input -->
									<form autocomplete="off"
										ng-submit="$ctrl.isSearchAllowed({
											query: $ctrl.parentScope.scout_query
										})
											&& $ctrl.applyQuery();">
										<input
											type="text"
											ng-model="$ctrl.parentScope.scout_query.data.semantic"
											placeholder="{{ querySection.hint }}"
											class="large-input"
											style="width:100%"
											autocomplete="off"
										/>
									</form>
								</div>
							</div>

							<div ng-repeat="querySection in [
								{
									type: 'topics',
									hint: 'Add a topic',
									show: $ctrl.settings.currentQueryBuilderTab.type === 'ADVANCED'
								},
								{
									type: 'organizations',
									hint: 'Add an organization',
									show: $ctrl.settings.currentQueryBuilderTab.type === 'ADVANCED'
										|| ($ctrl.settings.currentQueryBuilderTab.type === 'SMART' && (
											$ctrl.parentScope.getSearchString({
												return_types:['organizations'], query: $ctrl.parentScope.scout_query
											})!=''
											|| $ctrl.showOrganizationsFilterInSmartSearch
										))
								}
							]"
								ng-show="querySection.show" ng-init="type = querySection.type">

								<!-- "AND" -->
								<span ng-repeat="(row_idx, row_data) in $ctrl.parentScope.scout_query.data[type]">

									<!-- "AND" separator -->
									<div class="divider3 filter-divider" ng-if="row_idx!=0">
										<div>
											<div style="position: relative; left: -50%;">
												<div class="filter-divider-text">And
													<i class="fa-solid fa-times"
														ng-click="$ctrl.changeQuery('remove',type,row_idx)"></i>
												</div>
											</div>
										</div>
									</div>

									<!-- "AND" row -->
									<div class="filter-row">

										<!-- Input -->
										<form autocomplete="off"
											ng-submit="
												$ctrl.changeQuery(
													'add',type,row_idx,$ctrl.autosuggestInput[type][row_idx]
													|| ''
												);
												$ctrl.showRecommendations(
													type,row_idx,$ctrl.autosuggestInput[type][row_idx]
													|| ''
												);
												$ctrl.autosuggestInput[type][row_idx]='';
												$ctrl.resetAutosuggestData();
											">
											<input
												type="text"
												ng-model="$ctrl.autosuggestInput[type][row_idx]"
												placeholder="{{ querySection.hint }}"
												class="large-input"
												autocomplete="off",
												ng-change="$ctrl.autosuggestQueryTerms(
													$ctrl.autosuggestInput[type][row_idx], type, row_idx
												)"
												ng-keydown="$event.key === 'Enter'
													&& $ctrl.triggerSearchOnEnter(type, row_idx)"
											/><span class="search-addon" ng-click="
												$ctrl.changeQuery(
													'add',type,row_idx,$ctrl.autosuggestInput[type][row_idx]
													|| ''
												);
												$ctrl.showRecommendations(
													type,row_idx,$ctrl.autosuggestInput[type][row_idx]
													|| ''
												);
												$ctrl.autosuggestInput[type][row_idx]='';
												$ctrl.resetAutosuggestData();
											"><svg><use xlink:href="#icons--search"></use></svg></span>
											<mpg-autosuggest-dropdown data="$ctrl.lastAutosuggestData" type="type"
												ng-if="$ctrl.lastAutosuggestType == type
													&& $ctrl.lastAutosuggestRowId == row_idx"
													index="row_idx"
													dropdown-on-select="$ctrl.selectAutosuggestItems"
											></mpg-autosuggest-dropdown>
										</form>

										<!-- Term list -->
										<div class="filter-termlist-container" ng-show="row_data.length > 0">
											<span ng-repeat="term in row_data" class="filter-term">{{
												term
											}}<i class="fa-solid fa-times"
												ng-click="$ctrl.changeQuery(
													'remove',type,row_idx,term
												)"></i></span>
										</div>

										<!-- Recommendations -->
										<div class="filter-recommender-container"
											ng-if="$ctrl.recommendedTerms[type]
												&& $ctrl.recommendedTerms[type][row_idx]
												&& $ctrl.recommendedTerms[type][row_idx].length > 0">
											<div class="filter-recommender-title">You might also be interested in:</div>
											<span class="filter-term"
												ng-repeat="item in $ctrl.recommendedTerms[type][row_idx]"
												ng-click="
													$ctrl.changeQuery('add',type,row_idx,item.term);
													$ctrl.updateRecommendations(type,row_idx);
												"
												title="{{item.description || 'Click to add'}}">
												<i class="fa-solid fa-plus"></i>{{
													item.term
												}}</span>
										</div>

									</div>

								</span>

								<!-- "extend filter" buttons -->
								<div class="extend-filter-button-area" ng-if="!(
									$ctrl.settings.currentQueryBuilderTab.type === 'SMART' && type === 'organizations'
									) && (
									$ctrl.isAndAllowed($ctrl.parentScope.scout_query.data[type])
									|| $ctrl.parentScope.scout_query.data['not_' + type].length == 0
									&& $ctrl.isSearchAllowed({query: $ctrl.parentScope.scout_query})
								)">
									<div class="divider3 filter-divider"
										style="display: block; border-top-style: dashed">
										<div class="extension-filter-button-container">
											<div class="m-link-main extension-filter-button"
												ng-click="$ctrl.changeQuery('add',type)"
												ng-if="$ctrl.isAndAllowed(
													$ctrl.parentScope.scout_query.data[type]
												)">
												<i class="fa-solid fa-plus"></i> AND
											</div>

											<span ng-if="$ctrl.isAndAllowed(
													$ctrl.parentScope.scout_query.data[type]
												)
												&& $ctrl.parentScope.scout_query.data['not_' + type].length == 0
												&& $ctrl.isSearchAllowed({
													query: $ctrl.parentScope.scout_query
												})"
												style="color:#e8e8e8;
												display:inline-block; margin:0 6px 0 -6px">/</span>

											<div class="m-link-main extension-filter-button"
												ng-click="$ctrl.changeQuery('add','not_' + type)"
												ng-if="$ctrl.parentScope.scout_query.data['not_' + type].length == 0
													&& $ctrl.isSearchAllowed(
														{query: $ctrl.parentScope.scout_query}
													)">
												<i class="fa-solid fa-minus"></i> NOT
											</div>
										</div>
									</div>
								</div>

								<!-- "NOT" -->
								<span ng-repeat="(row_idx, row_data)
									in $ctrl.parentScope.scout_query.data['not_' + type]">

									<!-- "NOT" separator -->
									<div class="divider3 filter-divider">
										<div>
											<div style="position: relative; left: -50%;">
												<div class="filter-divider-text">Not
													<i class="fa-solid fa-times"
														ng-click="$ctrl.changeQuery(
															'remove','not_' + type,row_idx
														)"></i>
												</div>
											</div>
										</div>
									</div>

									<!-- "NOT" row -->
									<div class="filter-row">

										<!-- Input -->
										<form autocomplete="off"
											ng-submit="
												$ctrl.changeQuery(
													'add','not_' + type,row_idx,
													$ctrl.autosuggestInput['not_' + type][row_idx]
													|| ''
												);
												$ctrl.showRecommendations(
													'not_' + type,row_idx,$ctrl.autosuggestInput['not_' + type][row_idx]
													|| ''
												);
												$ctrl.autosuggestInput['not_' + type][row_idx]='';
												$ctrl.resetAutosuggestData();
											">
											<input
												type="text"
												ng-model="$ctrl.autosuggestInput['not_' + type][row_idx]"
												placeholder="{{ querySection.hint }}"
												class="large-input"
												autocomplete="off"
												ng-change="$ctrl.autosuggestQueryTerms(
													$ctrl.autosuggestInput['not_' + type][row_idx],
													'not_' + type,
													row_idx
												)"
												ng-keydown="$event.key === 'Enter'
													&& $ctrl.triggerSearchOnEnter('not_' + type, row_idx)"
											/><span class="search-addon" ng-click="
												$ctrl.changeQuery(
													'add','not_' + type,row_idx,
													$ctrl.autosuggestInput['not_' + type][row_idx]
													|| ''
												);
												$ctrl.showRecommendations(
													'not_' + type,row_idx,
													$ctrl.autosuggestInput['not_' + type][row_idx]
													|| ''
												);
												$ctrl.autosuggestInput['not_' + type][row_idx]='';
												$ctrl.resetAutosuggestData();
											"><svg><use xlink:href="#icons--search"></use></svg></span>
											<mpg-autosuggest-dropdown data="$ctrl.lastAutosuggestData" type="'not_' + type"
												ng-if="$ctrl.lastAutosuggestType == 'not_' + type
												&& $ctrl.lastAutosuggestRowId == row_idx"
												index="row_idx"
												dropdown-on-select="$ctrl.selectAutosuggestItems"
											></mpg-autosuggest-dropdown>
										</form>

										<!-- Term list -->
										<div class="filter-termlist-container" ng-show="row_data.length > 0">
											<span ng-repeat="term in row_data" class="filter-term">{{
												term
											}}<i class="fa-solid fa-times"
													ng-click="$ctrl.changeQuery('remove','not_' + type,row_idx,term)">
												</i></span>
										</div>

										<!-- Recommendations -->
										<div class="filter-recommender-container"
											ng-if="$ctrl.recommendedTerms['not_' + type]
												&& $ctrl.recommendedTerms['not_' + type][row_idx]
												&& $ctrl.recommendedTerms['not_' + type][row_idx].length > 0">
											<div class="filter-recommender-title">You might also be interested in:</div>
											<span class="filter-term"
												ng-repeat="item in $ctrl.recommendedTerms['not_' + type][row_idx]"
												ng-click="
													$ctrl.changeQuery('add','not_' + type,row_idx,item.term);
													$ctrl.updateRecommendations('not_' + type,row_idx);
												"
												title="{{item.description || 'Click to add'}}">
												<i class="fa-solid fa-plus"></i>{{item.term}}</span>
										</div>
									</div>
								</span>
							</div>

							<!-- "show organizations" button - for SMART search -->
							<div style="flex:0; min-width:auto; white-space: nowrap; text-align:center"
								ng-show="$ctrl.settings.currentQueryBuilderTab.type === 'SMART' && $root.showAdminTools
									&& !$ctrl.settings.template
									&& $ctrl.parentScope.getSearchString(
										{return_types: ['organizations'], query: $ctrl.parentScope.scout_query}
									)==''
									&& !$ctrl.showOrganizationsFilterInSmartSearch;">
								<div class="filter-title" style="border-bottom: 0; margin-top:29px;"
									ng-click="$ctrl.showOrganizationsFilterInSmartSearch = true">
									<div style="position:relative;">
										<span class="m-link m-link-grey">
											<i class="fa-solid fa-plus" style="font-size:14px"></i> Organizations
										</span>
									</div>
								</div>
							</div>
						</div>

					<!-- Buttons -------------------------------------------------------------------------------------->

						<div class="divider3" style="margin-top:24px" ng-if="!$ctrl.settings.hideButtons"></div>

						<div id="query-builder-footer" ng-if="!$ctrl.settings.hideButtons">
							<div style="flex:1; display:flex; align-items:center; padding:8px 24px 8px 8px;
								justify-content:flex-end; font-weight:600;">
								<div class="m-link-main query-builder-cancel"
									ng-click="$ctrl.cancelQueryEditing();"
									ng-if="$ctrl.parentScope.getSearchString({
										query: $ctrl.parentScope.active_scout_query
									}) !== ''">
									<i class="fa-solid fa-arrow-left" style="margin-right:7px"></i>Back
								</div>
							</div>

							<div style="display: flex; align-items: center; padding: 8px;">
								<div class="m-button-main" ng-class="{'disabled': !$ctrl.enableSearchbutton()}"
									ng-click="$ctrl.applyQuery();">
									Search
								</div>
							</div>
						</div>
					</div>
					<!-- Query & Filter - end ------------------------------------------------------------------------->

				</div>
				<!-- Loader -->
				<div ng-if="$ctrl.settings.loading" style="text-align: center; padding: 60px 0;">
					<p>Please wait...<p>
						<i style="font-size: 50px; display: block; margin-top: 8px;">
							<i class="fa-solid fa-sync fa-spin fa-1x fa-fw"></i>
						</i>
				</div>
			</div>
		</div>
	`

});

// This is needed for tables:
const BROKEN_LINK_MARKER_HTML = ` <span class="broken-link-marker"><i class="fa-solid fa-exclamation-circle" title="`
	+ `This link might be unavailable. We’re currently working on providing a replacement.\r\n`
	+ `Note: Older links might be broken. They are displayed in order to help you understand `
	+ `results and perform historical analysis."></i></span>`;
scout.component('brokenLinkMarker', {
	bindings: {},
	controller: function ($scope, $element, $sce) {
	},
	// We could use m-tooltip="..." to show better popups here, but we rather keep it consistent.
	template: BROKEN_LINK_MARKER_HTML
});

scout.component('userIcon', {
	bindings: {
		name: '<' // if undefined, we assume it's the current user
	},
	controller: function ($scope, $element, $sce) {
		this.getShortUserName = function () {
			if (typeof this.name == 'undefined') return getShortUserName(MPG.USERNAME);
			else return getShortUserName(this.name);
		}
	},
	template: `
		<div class="mpg-user-icon">
			<div>{{ ::$ctrl.getShortUserName() || '?' }}</div>
		</div>
	`
});

scout.component('progressBar', {
	bindings: {
		actions: '=?',
		seconds: '<?', // optional; defaults to 50s
		state: '<?'    // optional: 'start', 'done', 'reset'
	},
	controller: function ($scope) {
		let self = this;
		let timeoutId = null;

		const DEFAULT_SECONDS = 50;
		const TICK_MS = 500;
		const MIN = 0.05;
		const MAX = 0.994;

		setTimeout(() => {
			self.actions = self.actions || {};
			self.actions.start = self.start;
			self.actions.done = self.done;
			self.actions.reset = self.reset;
		}, 0);

		this.componentName = 'progressBar';

		this.showProgressBar = false;
		this.settings = {
			status: null,
			transition: null,
			opacity: null
		};

		this._timeToMaxMs = function () {
			const s = Number(self.seconds);
			const seconds = Number.isFinite(s) && s > 0 ? s : DEFAULT_SECONDS;
			return seconds * 1000; // timeToMaxMs
		};

		this._computeStep = function () {
			const ticks = Math.max(1, Math.round(self._timeToMaxMs() / TICK_MS));
			return (MAX - MIN) / ticks;
		};

		this.start = function () {
			// stop previous loop (if any)
			if (timeoutId) {
				clearTimeout(timeoutId);
				timeoutId = null;
			}

			// ensure we start from the same minimum your clamp enforces
			self._step = self._computeStep();
			self.set(MIN);

			setTimeout(function () {
				self.settings.transition = 'none';
				self.settings.opacity = 1;
				self.showProgressBar = true;
				$scope.$applyAsync();
			}, 10);

			self.progress();
		};

		this.set = function (n) {
			n = self.clamp(n, MIN, 1);

			self.settings.transition = 'all 200ms linear';
			self.settings.status = n * 100;
			$scope.$applyAsync();

			self.settings.transition = 'all 200ms ease';
			self.settings.status = (n === 1 ? null : n);
			$scope.$applyAsync();

			if (n === 1) {
				self.settings.transition = 'none';
				self.settings.opacity = 1;

				setTimeout(function () {
					self.settings.transition = 'all 200ms linear';
					self.settings.opacity = 0;
					self.showProgressBar = false;
					$scope.$applyAsync();
				}, 200);
			}
		};

		this.progress = function () {
			timeoutId = setTimeout(function () {
				if (self.settings.status == null) return;

				self.increment(self._step || 0.01);
				self.progress();
			}, TICK_MS);
		};

		this.increment = function (amount) {
			let n = self.settings.status;

			if (n == null) {
				return self.start();
			} else {
				n = self.clamp(n + amount, 0, MAX);
				return self.set(n);
			}
		};

		this.clamp = function (n, min, max) {
			if (n < min) return min;
			if (n > max) return max;
			return n;
		};

		this.reset = function () {
			if (timeoutId) {
				clearTimeout(timeoutId);
				timeoutId = null;
			}
			self.settings.status = 0;
			self.settings.transition = 'all 500ms ease';
			$scope.$applyAsync();
		};

		this.done = function () {
			if (timeoutId) {
				clearTimeout(timeoutId);
				timeoutId = null;
			}
			self.set(1);
		};

		// Optional state-based API
		$scope.$watch('$ctrl.state', function (state) {
			if (state && typeof self[state] === 'function' &&
				['start', 'done', 'reset'].includes(state)) {
				self[state]();
			}
		});
	},
	template: `
       <div class="progress">
          <div class="bar"
             ng-if="$ctrl.showProgressBar"
             ng-style="{
                'opacity': $ctrl.settings.opacity,
                'transition': $ctrl.settings.transition,
                'transform': 'scaleX(' + $ctrl.settings.status + ')'
             }">
             <div class="peg"></div>
          </div>
       </div>
    `
});

// A bar chart that can display absolute, normalized, and extrapolated counts from the 'Growth' route
scout.component('mpgChart', {
	bindings: {
		wk: '<',
		data: '<',
		options: '<'
	},
	controller: function ($scope, $element, $sce, $rootScope) {
		let self = this;

		this.state = {};

		this.resetState = function () {
			self.state = {};
			$rootScope.hideMessage();
		};

		// Retain the selection state when data is reloaded.
		this.saveState = function (min, max, maxEnd) {
			self.state = {
				min: min,
				max: max, // Timestamp of the last slice
				maxEnd: maxEnd // End of the last slice (only set if the resolution is known)
			};
		};

		this.getMaxLabel = function () {
			if (!this.histogramData) return '0';
			if (this.wk.currentState && this.wk.currentState.key == 'normalized') {
				return '100 %';
			} else {
				return $rootScope.bigNumberFormatter(this.yMax_abs);
			}
		};

		this.getTimeSliceLabel = function (item) {
			let text = '';
			if (this.options && this.options.timeSliceLabel) {
				text = this.options.timeSliceLabel(item);
				if (text) text = '<div style="margin-bottom:4px; font-size:12px">' + text + '</div>';
			} else if (item.tooltip) {
				text = '<div style="margin-bottom:4px; font-size:12px">' + htmlEscape(item.tooltip) + '</div>';
			}

			if (this.wk.currentState && this.wk.currentState.key == 'normalized') {
				let percentage = item['norm_count'] * 100 / this.yMax_norm;
				percentage = percentage < 10 ? Math.round(percentage * 10) / 10 : Math.round(percentage);
				text += percentage + ' %';
			} else {
				text += $rootScope.bigNumberFormatter(item['abs_count']);
			}

			if ((this.wk.currentState && this.wk.currentState.key != 'normalized' && item.ext_count > 0)
				|| (this.wk.currentState && this.wk.currentState.key == 'normalized' && item.norm_ext_count > 0)) {
				if (this.wk.currentState.key == 'normalized') {
					let percentage = item['norm_ext_count'] * 100 / this.yMax_norm;
					percentage = percentage < 10 ? Math.round(percentage * 10) / 10 : Math.round(percentage);
					text += ' (extrapolated: ' + percentage + ' %)';
				} else {
					text += ' (extrapolated: ' + $rootScope.bigNumberFormatter(item['ext_count']) + ')';
				}
			}

			return text;
		};

		this.selectTimeRange = function (selectedBar) {
			let message = 'Click a second bar to select a time range.';
			let newStatus = this.timeRangeStatus;

			if (this.timeRangeStatus == 'start') {
				for (let bar of this.histogramData) {
					bar.isRangeStart = false;
					bar.isInRange = false;
					bar.isRangeEnd = false;
				}
				selectedBar.isRangeStart = true;
				newStatus = 'end';
				$rootScope.showMessage(message, 'pending', null);
			}

			if (this.timeRangeStatus == 'end') {
				let started = false;
				let ended = false;
				let barsInBetween = [];
				for (let bar of this.histogramData) {
					if (bar.isRangeStart) started = bar.timestamp;
					if (started && !ended) barsInBetween.push(bar);
					if (started && bar == selectedBar) {
						selectedBar.isRangeEnd = true;
						for (let b of barsInBetween) b.isInRange = true;
						ended = bar.timestamp;
						newStatus = 'start';
						$rootScope.showMessage(message, 'success', 1);
					}
				}
				if (!ended) {
					// The "end" is located to the left of "start".
					started = false;
					ended = false;
					barsInBetween = [];
					for (let i = this.histogramData.length - 1; i >= 0; i--) {
						let bar = this.histogramData[i];
						if (bar.isRangeStart) started = bar.timestamp;
						if (started && !ended) barsInBetween.push(bar);
						if (started && bar == selectedBar) {
							selectedBar.isRangeEnd = true;
							for (let b of barsInBetween) b.isInRange = true;
							ended = bar.timestamp;
							newStatus = 'start';
							$rootScope.showMessage(message, 'success', 1);
						}
					}
				}

				if (newStatus == 'start' && started && ended) {
					const from = Math.min(started, ended);
					const to = Math.max(started, ended);
					let toEnd = null;
					if (self.resolution) {
						toEnd = new Date(to);
						switch (self.resolution) {
							case 'year':
								toEnd.setUTCFullYear(toEnd.getUTCFullYear() + 1);
								break;
							case 'quarter':
								toEnd.setUTCMonth(toEnd.getUTCMonth() + 3);
								break;
							case 'month':
								toEnd.setUTCMonth(toEnd.getUTCMonth() + 1);
								break;
							case 'day':
								toEnd.setUTCDate(toEnd.getUTCDate() + 1);
								break;
						}
						toEnd = toEnd.getTime() - 1000; // remove 1s to stay in the right interval
					}

					// Custom callback
					if (this.options && this.options.afterSelectTimeRange) {
						this.options.afterSelectTimeRange(from, to, toEnd);
					}

					// Save state
					if (this.options && !this.options.isStateless) {
						self.saveState(from, to, toEnd);
					}
				}
			}

			this.timeRangeStatus = newStatus;

			// Sync select on multiple charts
			if (this.options.chartEventGroup) {
				$scope.$emit(this.options.chartEventGroup, {
					newStatus: newStatus,
					selectedBar: selectedBar
				});
			}
		};

		window.setTimeout(function () {
			// Sync select on multiple charts
			$rootScope.$on(self.options.chartEventGroup, function (evt, data) {
				self.applyTimeRange(data.newStatus, data.selectedBar);
			});
		}, 0);


		this.applyTimeRange = function (newStatus, selectedRemoteBar) {
			// Find bar
			let selectedBar = null;
			for (let bar of this.histogramData) {
				if (bar.timestamp == selectedRemoteBar.timestamp) {
					selectedBar = bar;
					break;
				}
			}
			if (!selectedBar) {
				console.log('Could not sync selected bars.');
				return;
			}

			// Update status
			this.timeRangeStatus = newStatus;
			if (newStatus == 'end') {
				for (let bar of this.histogramData) {
					bar.isRangeStart = false;
					bar.isInRange = false;
					bar.isRangeEnd = false;
				}
				selectedBar.isRangeStart = true;

			} else if (newStatus == 'start') {
				let started = false;
				let ended = false;
				let barsInBetween = [];
				for (let bar of this.histogramData) {
					if (bar.isRangeStart) started = bar.timestamp;
					if (started && !ended) barsInBetween.push(bar);
					if (started && bar == selectedBar) {
						selectedBar.isRangeEnd = true;
						for (let b of barsInBetween) b.isInRange = true;
						ended = bar.timestamp;
					}
				}
				if (!ended) {
					// The "end" is located to the left of "start".
					started = false;
					ended = false;
					barsInBetween = [];
					for (let i = this.histogramData.length - 1; i >= 0; i--) {
						let bar = this.histogramData[i];
						if (bar.isRangeStart) started = bar.timestamp;
						if (started && !ended) barsInBetween.push(bar);
						if (started && bar == selectedBar) {
							selectedBar.isRangeEnd = true;
							for (let b of barsInBetween) b.isInRange = true;
							ended = bar.timestamp;
						}
					}
				}
			}
		}

		$scope.$watch(() => {
			return self.data;
		}, (value) => {
			// Histogram axes
			self.yMax_abs = 1;
			self.yMax_norm = 1;
			self.timeline = [];

			// Selector state
			self.timeRangeStatus = 'start'; // start, end

			if (!self.data) return;
			// The "key" is needed for old data format, "stateControl" is needed for new data format.
			if (!self.options || (!self.options.key && !self.options.stateControl)) return;

			if (self.options.stateControl) {
				// The chart's state can be reset via the "stateControl" object
				self.options.stateControl.resetSelection = self.resetState;
			} else {
				self.resetState();
			}

			// Determine resolution
			self.resolution = self.data[0]?.width?.toLowerCase() || 'year';

			self.histogramData = self.data.map(function (x) {
				// Import data
				let item;
				if ('facet' in x) {
					// The new format, via "Facets"

					// The facet is expected to use the "YYYY-MM-DD" format, but we actually support more formats.
					let dateString = x.facet
						.replace(' UTC', 'Z')
						.replace(' ', 'T');
					if (!dateString.includes('T')) dateString += 'T00:00:00Z';

					item = {
						timestamp: new Date(dateString).getTime(),
						date_str: x.facet.substr(0, 10),
						abs_count: x.count,
						ext_count: x.count_extrapolated,
						norm_count: x.count_normalized,
						norm_ext_count: x.count_normalized_extrapolated
					};

					if (self.resolution === 'day') {
						item.tooltip = item.date_str.slice(0, 10);
					} else if (self.resolution === 'month') {
						item.tooltip = getMonthName(new Date(item.date_str))
					} else if (self.resolution === 'quarter') {
						let month = parseInt(item.date_str.slice(5, 7));
						if (month >= 1 && month <= 3) item.tooltip = 'Q1';
						if (month >= 4 && month <= 6) item.tooltip = 'Q2';
						if (month >= 7 && month <= 9) item.tooltip = 'Q3';
						if (month >= 10 && month <= 12) item.tooltip = 'Q4';
					}

					// Optionally load saved state
					if (self.state.min && self.state.max
						&& item.timestamp >= self.state.min
						&& (item.timestamp <= self.state.max
							|| self.state.maxEnd && item.timestamp <= self.state.maxEnd
						)) {
						item.isInRange = true;
					}
				} else {
					// The old format, via "Growth"
					item = {
						timestamp: new Date(x.date_activity.replace(' UTC', 'Z').replace(' ', 'T')).getTime(),
						date_str: x.date_activity.substr(0, 10),
						abs_count: x.kpi[self.options.key],
						ext_count: x.kpi.extrapolated[self.options.key],
						norm_count: x.kpi.normalized[self.options.key],
						norm_ext_count: x.kpi.normalized.extrapolated[self.options.key],
					};
				}

				// Find limits of y-axes
				if (item.abs_count > self.yMax_abs) self.yMax_abs = item.abs_count;
				if (item.ext_count > self.yMax_abs) self.yMax_abs = item.ext_count;
				if (item.norm_count > self.yMax_norm) self.yMax_norm = item.norm_count;
				if (item.norm_ext_count > self.yMax_norm) self.yMax_norm = item.norm_ext_count;

				return item;
			}).sort((a, b) => a.timestamp - b.timestamp);

			// Generate the timeline
			if (!self.options.hideTimeline) {
				if (self.options.timeline) {
					// Custom calculation of the timeline
					self.timeline = self.options.timeline(self.histogramData);
				} else {
					// Default calculation of the timeline
					if (self.resolution === 'day') {
						// Axis labels: month + year
						for (let item of self.histogramData) {
							let year = item.date_str.slice(0, 4);
							let label = getMonthName(new Date(item.date_str)) + ' ' + year;
							if (self.timeline.length == 0 || self.timeline[self.timeline.length - 1].label != label) {
								self.timeline.push({
									label: label,
									width: 1
								});
							} else {
								self.timeline[self.timeline.length - 1].width++;
							}
						}
					} else if (self.resolution === 'month') {
						// Axis labels: quarter + year
						for (let item of self.histogramData) {
							let year = item.date_str.slice(0, 4);
							let month = parseInt(item.date_str.slice(5, 7));
							let quarter = '?';
							if (month >= 1 && month <= 3) quarter = 'Q1';
							if (month >= 4 && month <= 6) quarter = 'Q2';
							if (month >= 7 && month <= 9) quarter = 'Q3';
							if (month >= 10 && month <= 12) quarter = 'Q4';
							let label = quarter + ' ' + year;
							if (self.timeline.length == 0 || self.timeline[self.timeline.length - 1].label != label) {
								self.timeline.push({
									label: label,
									width: 1
								});
							} else {
								self.timeline[self.timeline.length - 1].width++;
							}
						}
					} else if (self.resolution === 'year' || self.resolution === 'quarter') {
						// Axis labels: year
						for (let item of self.histogramData) {
							let year = item.date_str.slice(0, 4);
							if (self.timeline.length == 0 || self.timeline[self.timeline.length - 1].label != year) {
								self.timeline.push({
									label: year,
									width: 1
								});
							} else {
								self.timeline[self.timeline.length - 1].width++;
							}
						}
					} else {
						throw new Error('The resolution is not supported.');
					}
				}
			}
		});
	},
	template: `
		<div class="mpg-chart">
			<div class="mpg-chart-label"><div>{{ $ctrl.options.yLabel || 'Publications' }}</div></div>
			<div class="mpg-chart-max-tick"></div>
			<div class="mpg-chart-max-label">{{ $ctrl.getMaxLabel() }}</div>
			<div class="mpg-chart-reset m-link-main hide-in-exports"
				ng-if="$ctrl.options.showResetFilter && $ctrl.options.onResetFilter"
				ng-click="$ctrl.resetState(); $ctrl.options.onResetFilter()">Reset Time Filter</div>
			<div class="mpg-chart-arrow-up"></div>
			<div class="mpg-chart-arrow-right"></div>
			<div ng-repeat="item in $ctrl.histogramData" class="mpg-chart-slice"
				m-tooltip="$ctrl.getTimeSliceLabel(item)"
				ng-click="(item.abs_count || $ctrl.options.emptySlicesClickable) && $ctrl.selectTimeRange(item)"
				ng-class="{
					'mpg-chart-range-start': item.isRangeStart,
					'mpg-chart-in-range': item.isInRange,
					'mpg-chart-range-end': item.isRangeEnd,
					'mpg-chart-clickable-slice': item.abs_count || $ctrl.options.emptySlicesClickable
				}">
				<div class="mpg-chart-extrapolated-bar"
					style="height:{{ item.norm_ext_count * 100 / $ctrl.yMax_norm }}%"
					ng-show="$ctrl.wk.currentState.key == 'normalized'"></div>
				<div class="mpg-chart-bar"
					style="height:{{ item.norm_count * 100 / $ctrl.yMax_norm }}%"
					ng-show="$ctrl.wk.currentState.key == 'normalized'"></div>

				<div class="mpg-chart-extrapolated-bar"
					style="height:{{ item.ext_count * 100 / $ctrl.yMax_abs }}%"
					ng-show="$ctrl.wk.currentState.key != 'normalized'"></div>
				<div class="mpg-chart-bar"
					style="height:{{ item.abs_count * 100 / $ctrl.yMax_abs }}%"
					ng-show="$ctrl.wk.currentState.key != 'normalized'"></div>
			</div>
		</div>
		<div class="mpg-chart-timeline" style="margin-bottom:1em" ng-if="!$ctrl.options.hideTimeline">
			<div class="mpg-chart-timeline-segment" ng-repeat="segment in $ctrl.timeline"
				style="flex:{{ segment.width }}">
				{{ segment.label }}
			</div>
		</div>
	`
});

// This part of the itemLayout template is needed multiple times
ITEM_TEMPLATE_END = `
	<!-- Bookmarker -->
	<div class="mpg-field mpg-bookmark-field"
		ng-if="::($ctrl.state.itemOptions == 'bookmark' && $root.isBookmarkActionAvailable($ctrl.wk))">
		<div class="mpg-field-content">
			<bookmark-action row="item" wk="$ctrl.wk" type="'TableRow'" all-data="$ctrl.data"></bookmark-action>
		</div>
	</div>

	<!-- Custom Item Options -->
	<div class="mpg-field mpg-bookmark-field"
		ng-if="::($ctrl.state.itemOptions && $ctrl.state.itemOptions != 'bookmark') || $ctrl.state.checkboxAction">
		<div class="mpg-field-content" ng-if ="::!$ctrl.state.checkboxAction">
			<i class="{{::$ctrl.state.itemOptionsIcon || 'fa-solid fa-cog'}} m-link" style="font-size:16px"
				tabindex="0" oncontextmenu="event.stopPropagation(); return false;"
				title="{{::$ctrl.state.itemOptionsTooltip || 'Show options'}}"
				ng-click="$ctrl.state.itemOptions(item); $event.stopPropagation(); $event.preventDefault();"
				ng-keydown="$event.key == 'Enter' && $ctrl.state.itemOptions(item);"
				ng-style="{
					'pointer-events': item.loading ? 'none' : null,
					'opacity': item.loading ? '0.5' : null
				}"></i>
		</div>

		<div class="m-checkbox" ng-if="$ctrl.state.checkboxAction"
			title="{{::$ctrl.state.checkboxTooltip || 'Select project'}}"
			ng-class="{checked: item.selected}"
			tabindex="0" oncontextmenu="event.stopPropagation(); return false;"
			ng-keydown="$event.key == 'Enter' && $ctrl.state.checkboxAction(item);"
			ng-click="$ctrl.state.checkboxAction(item); $event.stopPropagation(); $event.preventDefault();">
		<div></div></div>
	</div>

	<!-- Overlays -->

	<!-- Highlighting folders during drag and drop and highlighting selected bookmarks & selected library projects -->
	<div class="mpg-tile-overlay mpg-tile-overlay--seen" ng-if="item._meta.seen"></div>
	<div class="mpg-tile-overlay mpg-tile-overlay--highlight"
		ng-if="item.selected || item._meta.selected"></div>
	<div class="mpg-tile-overlay" ng-if="item.highlightRowColor"
		ng-style="{'background': item.highlightRowColor}"></div>
	<div class="mpg-tile-overlay mpg-tile-overlay--loading" ng-if="item.loading"></div>
`;

// This part of the itemLayout template is needed twice.
ITEM_TEMPLATE = `
	<!-- Headline Fields -->
	<div ng-if="$ctrl.state.layoutMode == 'grid' || $ctrl.state.layoutMode == 'grid-column'" class="mpg-tile-headline">
		<div ng-repeat="field in $ctrl.state.fields track by field.idx"
			class="mpg-field" mpg-field-id="headline-{{ ::field.idx }}"
			ng-if="$ctrl.pageMap[$parent.$index][field.idx].showInHeadline && !field.hide"
			ng-class="field.classes" ng-style="field.dynamicStyles($ctrl.state.layoutMode, true)">
			<div ng-if="::field.name" class="mpg-field-name"
				m-tooltip="::field.tooltip" ng-bind="::field.name"></div>
			<div class="mpg-field-content" ng-if="::!field.newline">
				<div ng-if="!$ctrl.pageMap[$parent.$parent.$parent.$index][field.idx].isMissing"
					ng-bind-html="$ctrl.pageMap[$parent.$parent.$parent.$parent.$index][field.idx].html"></div>
				<div ng-if="$ctrl.pageMap[$parent.$parent.$parent.$index][field.idx].isMissing"
					m-tooltip="::$ctrl.missingFieldTooltip" m-tooltip-width="600">-</div>
			</div>
		</div>
	</div>

	<!-- Fields -->
	<div ng-repeat="field in $ctrl.state.fields track by field.idx"
		class="mpg-field" mpg-field-id="{{ ::field.idx }}"
		ng-if="($ctrl.state.layoutMode == 'list' ? $ctrl.pageMap[$parent.$index][field.idx].show
			: $ctrl.pageMap[$parent.$index][field.idx].showInFields) && !field.hide"
		ng-class="field.classes" ng-style="field.dynamicStyles($ctrl.state.layoutMode, false)">
		<div ng-if="field.name && !($ctrl.state.separateFieldLabels && $ctrl.state.layoutMode == 'list')"
			class="mpg-field-name"
			m-tooltip="::field.tooltip" ng-bind="::field.name"></div>
		<div class="mpg-field-content" ng-if="::!field.newline">
			<div ng-if="!$ctrl.pageMap[$parent.$parent.$parent.$index][field.idx].isMissing"
				ng-bind-html="$ctrl.pageMap[$parent.$parent.$parent.$parent.$index][field.idx].html"></div>
			<div ng-if="$ctrl.pageMap[$parent.$parent.$parent.$index][field.idx].isMissing"
				m-tooltip="::$ctrl.missingFieldTooltip" m-tooltip-width="600">-</div>
		</div>
	</div>
` + ITEM_TEMPLATE_END;

// This part of the itemLayout template is needed twice. - Legacy structure with $tileIdx for column layouts
COL_ITEM_TEMPLATE = `
	<!-- Headline Fields -->
	<div ng-if="$ctrl.state.layoutMode == 'grid' || $ctrl.state.layoutMode == 'grid-column'" class="mpg-tile-headline">
		<div ng-repeat="field in $ctrl.state.fields track by field.idx"
			class="mpg-field" mpg-field-id="headline-{{ ::field.idx }}"
			ng-if="$ctrl.pageMap[$tileIdx][field.idx].showInHeadline && !field.hide"
			ng-class="field.classes" ng-style="field.dynamicStyles($ctrl.state.layoutMode, true)">
			<div ng-if="::field.name" class="mpg-field-name"
				m-tooltip="::field.tooltip" ng-bind="::field.name"></div>
			<div class="mpg-field-content" ng-if="::!field.newline">
				<div ng-if="!$ctrl.pageMap[$tileIdx][field.idx].isMissing"
					ng-bind-html="$ctrl.pageMap[$tileIdx][field.idx].html"></div>
				<div ng-if="$ctrl.pageMap[$tileIdx][field.idx].isMissing"
					m-tooltip="::$ctrl.missingFieldTooltip" m-tooltip-width="600">-</div>
			</div>
		</div>
	</div>

	<!-- Fields -->
	<div ng-repeat="field in $ctrl.state.fields track by field.idx"
		class="mpg-field" mpg-field-id="{{ ::field.idx }}"
		ng-if="($ctrl.state.layoutMode == 'list' ? $ctrl.pageMap[$tileIdx][field.idx].show
			: $ctrl.pageMap[$tileIdx][field.idx].showInFields) && !field.hide"
		ng-class="field.classes" ng-style="field.dynamicStyles($ctrl.state.layoutMode, false)">
		<div ng-if="field.name && !($ctrl.state.separateFieldLabels && $ctrl.state.layoutMode == 'list')"
			class="mpg-field-name"
			m-tooltip="::field.tooltip" ng-bind="::field.name"></div>
		<div class="mpg-field-content" ng-if="::!field.newline">
			<div ng-if="!$ctrl.pageMap[$tileIdx][field.idx].isMissing"
				ng-bind-html="$ctrl.pageMap[$tileIdx][field.idx].html"></div>
			<div ng-if="$ctrl.pageMap[$tileIdx][field.idx].isMissing"
				m-tooltip="::$ctrl.missingFieldTooltip" m-tooltip-width="600">-</div>
		</div>
	</div>
` + ITEM_TEMPLATE_END;

// tile layouts and table-like layouts
scout.component('itemLayout', {
	bindings: {
		settings: '<',
		wk: '<' // needed for bookmark-action
	},
	controller: function ($scope, $element, $sce, $rootScope, MapegyAPIService) {
		let self = this;

		const animationTimeMS = 0; /* before: 200; For more details, see: .mpg-item-layout-container.mpg-is-rendering */

		// these settings can be configured
		this.defaultSettings = {
			useInfiniteScroll: false, // true: disables paging, and uses sticky menu
			itemsPerPage: 12, // Has no effect if: layoutMode == 'grid-column'; Defines bulk size for infinite scroll
			hideMissingFields: false,
			syncFieldSize: true,
			infiniteScrollFieldSyncWidthBuffer: 30, // Additional width to allow field growth caused by infinite scroll
			columnMode: false, // true: will show only one field per row and all fields will be centered
			itemTooltip: null,// itemTooltip(item) => return item property
			itemOptions: false, // 'bookmark' to make items bookmarkable; function(item) to show an "options" icon
			itemOptionsIcon: false, // optionally set another icon class for the item options button
			itemOptionsTooltip: false, // optionally set another title-tag for the item options button
			checkboxTooltip: null,
			checkboxAction: false,
			referenceSectionType: null,
			allowLayoutSwitch: true, // allow to switch between list view and grid view
			/* Layout Mode
				grid: Show tiles.
				list: Show rows.
				auto: Show 'list' if width above minListViewWidth and 'grid' if width below minListViewWidth.
				grid-column: Show tiles in multiple columns.
					allowLayoutSwitch <-- Will be false by default.
					columnConfigStore <-- Allows column configuration.
			*/
			mpgOptionsButtons: [], // generic toolbar buttons: { icon, tooltip, condition, callback, dropdown? }
			layoutMode: 'list',
			minListViewWidth: 1120, // px; used if layoutMode == 'auto'
			fields: [],
			sorting: [],
			filters: [],
			hidePagination: false,
			itemLink: false, // set a string to add a link to the whole item instead of opening details mode
			itemLinkTarget: '_self', // optional link target
			itemClickAction: false, // set function(item) to execute custom actions instead of opening details mode
			rowsClickable: true,

			/*
				Set async function(items) to execute when item is clicked or leaves viewport at the top by at least 50%.
				The returned promise is used to update the view model.
				If the function exists:
					- seen items are marked via item._meta.seen
					- scroll position is automatically adjusted to hide seen items at the top
			*/
			itemsSeenRegistrar: false,
			autoMarkSeenOnScroll: false, // Set true to mark items as seen on scroll (if itemsSeenRegistrar is set)

			/* Main search */
			showMainSearch: true,
			// allows to replace or extend the default item filter of the main search
			mainSearchFilter: null, // mainSearchFilter (item, defaultItemFilter) => [string,...]
			mainSearchTooltip: null,
			onChangeMainSearch: null, // onChangeMainSearch (searchString) => null // on input changed
			onBeforeMainSearch: null, // onBeforeMainSearch (searchString) => null // on before table update
			isInspectionShortcutVisible: null, // () => true || false
			onClickInspectionShortcut: null, // onClickInspectionShortcut (searchString) => null

			/* List view: */
			maxListViewRows: 1,
			separateFieldLabels: true, // if true, field labels will be shown in a separate row on top in list view
			centerVertically: true, // if true, fields will be centered vertically in list view
			syncFieldHeightInListView: false,
			lessSpacing: true, // remove vertical tile padding in list view

			/* Grid view: */
			minItemWidth: '265px',
			/* advancedLayout (only applied in grid view):
				false: will style tiles as in list view (simple lines in between)
				true: will style tiles more separated
				'full': will style tiles more separated + header color as in "details view"
			*/
			advancedLayout: true,

			/* Grid-column view ("boards") */
			maxAssignedItemsInBoard: 150,
			maxUnassignedItemsInBoard: 10,

			/* Allow backend-side storage of visible fields */
			visibleFieldsStore: null, // { get() => {}, set(ids) => {} }

			/* Allow backend-side storage of column configurations
				{
					get() => {},
					addColumn(column) => {},
					deleteColumn(column) => {},
					renameColumn(column) => {},
					moveColumn(column, idx) => {},
					moveItemToColumn(item, lastColumn, newColumn) => {}
				}
			*/
			columnConfigStore: null,

			/* Switch layout mode */
			customLayoutSwitchHandler: null,

			/* prevent clicking of items */
			preventItemClicking: false,

			/* Custom header buttons
				Array of button objects: [{
					icon: '',
					title: '',
					fontSize: '',
					onClick: function() { ... }
				}]
			*/
			headerButtons: null

		};
		this.state = {};

		// called before settings are imported
		this.initComponent = function () {
			this.pageData = [];
			this.pageMap = [];
			this.isFilterSectionOpen = false;

			/* Main search */
			this.mainSearch = '';
			this.isMainSearchLoading = false;
			this.latestMainSearch = null;  // time of last search
		};

		this.getSetting = function (key) {
			let setting = null;
			if (this.settings && typeof this.settings[key] != 'undefined' && this.settings[key] !== null) {
				setting = this.settings[key];
			} else {
				setting = this.defaultSettings[key];
			}
			switch (key) {
				case 'fields':
					setting = setting.map(function (field, idx) {
						let copy = Object.assign({}, field);
						copy.idx = idx;
						// materialize fields which support reactivity
						copy.hide = self.isHiddenField(field);
						copy.order = self.getFieldOrder(field);
						copy.noTopSpacing = self.getFieldValue(field, 'noTopSpacing');
						copy.noBottomSpacing = self.getFieldValue(field, 'noBottomSpacing');

						copy.classes = {
							'mpg-field-fullsize': copy.minWidth == 'full',
							'mpg-field-fit': copy.minWidth == 'fit',
							'mpg-field-noTopSpacing': copy.noTopSpacing,
							'mpg-field-noBottomSpacing': copy.noBottomSpacing,
							'mpg-field-largeTopSpacing': copy.largeTopSpacing,
							'mpg-field-largeBottomSpacing': copy.largeBottomSpacing,
							'mpg-field-newline': copy.newline,
							'mpg-field-verti-centered': copy.centerVertically && !copy.name
						};
						let type = typeof field.type == 'function' ? field.type(null) : field.type;
						if (type && type[0]) copy.classes['mpg-field-type--' + type[0]] = true;
						copy.styles = {
							'order': copy.order,
							'text-align': self.getFieldAlign(field)
						};
						copy.dynamicStyles = function (mode, isHeader = false) {
							let params = {
								mode: mode,
								isHeader: isHeader
							};
							// allow width to change depending on e.g. layout mode
							let minWidth = typeof copy.minWidth == 'function' ? copy.minWidth(params) : copy.minWidth;
							let maxWidth = typeof copy.maxWidth == 'function' ? copy.maxWidth(params) : copy.maxWidth;
							return Object.assign(copy.styles, {
								'min-width': ['full', 'fit'].includes(copy.minWidth) ? null : (minWidth || null),
								'max-width': ['full', 'fit'].includes(copy.minWidth) ? null : (maxWidth || null),
							});
						};

						return copy;
					});
					break;

				case 'sorting':
					setting = setting.map(function (sorting, idx) {
						// Allow external code to change the sorting
						sorting.applySorting = (isReverse = false) => {
							self.state.sorting[idx].reverse = isReverse;
							self.sorting = self.state.sorting[idx];
							self.onSortingChange();
						};
						return Object.assign({}, sorting);
					});
					break;

				case 'filters':
					setting = setting.map(function (filter) {
						let f = Object.assign({}, filter);
						if (self.wk.mode == 'library') {
							delete f['serverSideFilter'];
							delete f['serverSideOptions'];
						}
						// Allow external code to apply filter settings
						filter.applyFilter = (options) => self.applyFilter(f, options);
						return f;
					});
					break;

				case 'layoutMode':
					if (setting == 'auto') {
						let elem = $element[0].querySelector('.mpg-item-layout-container');
						if (elem && elem.offsetWidth >= this.getSetting('minListViewWidth')) {
							if (self.lastManuallySelectedLayoutMode) setting = self.lastManuallySelectedLayoutMode;
							else setting = 'list';
						} else {
							setting = 'grid';
						}
					} else {
						if (self.lastManuallySelectedLayoutMode) setting = self.lastManuallySelectedLayoutMode;
					}
					break;

				case 'minItemWidth':
					if ((this.state.layoutMode || this.getSetting('layoutMode')) == 'list') setting = '100%';
					break;

				case 'allowLayoutSwitch':
					if (this.settings.layoutMode == 'auto') {
						let elem = $element[0].querySelector('.mpg-item-layout-container');
						if (elem && elem.offsetWidth < this.getSetting('minListViewWidth')) {
							setting = false;
						}
					}
					if (this.settings.layoutMode == 'grid-column') setting = false;
					break;
			}
			return setting;
		};

		this.importSettings = function () {
			this.state = {};
			for (let key in self.defaultSettings) self.state[key] = self.getSetting(key);

			// set default sorting
			if (self.state.sorting) {
				self.sorting = self.state.sorting.filter(x => x.isDefault)[0] || self.state.sorting[0];
			} else {
				self.sorting = null;
			}
			// set selectable fields
			self.selectableFields = self.state.fields.filter(x => x.visibilityGroup);

			// optionally import the field visibility from an external store
			let visibleFields = null;
			if (self.settings.visibleFieldsStore && self.settings.visibleFieldsStore.get) {
				visibleFields = self.settings.visibleFieldsStore.get();
			}
			if (visibleFields !== null) {
				for (let item of self.selectableFields) {
					item.hide = !visibleFields.includes(item.visibilityGroup);
				}
			}

			// adjust hints
			this.invisibleFieldsHint = 'Some fields cannot be displayed. To see these fields, '
				+ (this.state.itemClickAction || this.state.itemLink || !this.state.rowsClickable
					? '' : 'either click on the item, ')
				+ 'switch to grid view, or hide other fields.';


			// optionally import column configurations from an external store
			if (self.settings.columnConfigStore && self.settings.columnConfigStore.get) {
				self.columns = self.settings.columnConfigStore.get();
			}
		};

		this.getFilteredData = function (excludedFilterName, includeInitialData = false) {
			// copy data
			let data = [];
			if (this.settings && this.settings.data) data = Array.from(this.settings.data);
			if (includeInitialData) data = data.concat(this.initialData);

			// filter data
			let filters = null;
			if (this.state.filters) {
				filters = this.state.filters.filter(
					x => x.match && (!excludedFilterName || x.name != excludedFilterName)
				);
				let filterFunctions = filters.map(x => x.match);
				data = data.filter(function (item) {
					for (let filter of filterFunctions) if (!filter(item)) return false;
					return true;
				});
			}

			// apply external filter
			if (this.wk.externalTableFilter) data = data.filter(item => self.wk.externalTableFilter(item));

			return {
				filters: filters,
				data: data
			}
		};

		this.loadData = function (setInitialData = true) {
			// get filtered data
			let obj = this.getFilteredData();
			this.filters = obj.filters;
			let data = obj.data;

			// apply main search
			if (this.state.showMainSearch && this.mainSearch) {
				let findString = this.mainSearch.toLowerCase();
				let defaultItemFilter = this.getDefaultItemFilter();
				// create item filter
				if (this.state.mainSearchFilter) {
					var itemFilter = function (item) {
						return self.state.mainSearchFilter(item, defaultItemFilter);
					}
				} else {
					var itemFilter = function (item) {
						return defaultItemFilter(item);
					}
				}
				// filter all items
				data = data.filter(function (item) {
					return itemFilter(item).some(x => typeof x == 'string' && x.toLowerCase().includes(findString));
				});
			}

			// sort data
			if (this.sorting && !this.sorting.serverSideSorting) {
				if (typeof self.sorting.compare == 'function') {
					// custom compare function
					var compare = self.sorting.compare;
				} else {
					// predefined compare function
					switch (self.sorting.compare) {
						case 'text':
							var compare = function (a, b, polarity) {
								if ((typeof a != 'string' || a.trim() == '') && (typeof b != 'string' || b.trim() == '')) return 0;
								if (typeof a != 'string' || a.trim() == '') return Infinity * polarity;
								if (typeof b != 'string' || b.trim() == '') return -Infinity * polarity;
								return (a || '').localeCompare(b || '');
							};
							break;
						case 'number':
							var compare = function (a, b, polarity) {
								if ((typeof a != 'number' || isNaN(a)) && (typeof b != 'number' || isNaN(b))) return 0;
								if (typeof a != 'number' || isNaN(a)) return Infinity * polarity;
								if (typeof b != 'number' || isNaN(b)) return -Infinity * polarity;
								return a - b;
							};
							break;
					}
				}

				if (this.sorting.reverse) {
					data.sort(function (a, b) {
						return compare(self.sorting.value(b), self.sorting.value(a), self.sorting.reverse ? -1 : 1);
					});
				} else {
					data.sort(function (a, b) {
						return compare(self.sorting.value(a), self.sorting.value(b), self.sorting.reverse ? -1 : 1);
					});
				}
			}

			// prepare data-fields matrix
			// must not depend on reactive field properties (like field.hide) because those can change without data reload
			let dataFields = [];
			for (let item of data) {
				let attributes = [];
				for (let field of self.state.fields) {
					let attr = {
						show: ((!this.state.hideMissingFields && !field.hideMissing) || field.newline
							|| !this.isMissingField(item, field)),
						isMissing: this.isMissingField(item, field)
					};
					if (!attr.isMissing) attr.html = this.getFieldHTML(item, field);
					attr.showInHeadline = attr.show && field.inHeadline;
					attr.showInFields = attr.show && !field.inHeadline;
					attributes.push(attr);
				}
				dataFields.push(attributes);
			}

			this.data = data;
			this.dataFields = dataFields;
			// initialData is not implemented optimally right now. There can be two problems:
			// - If an item is deleted, initial data is not updated because server-side filters could be active.
			// - If panels are initially loaded with active server-side filters, initial data is not complete.
			// As a result, filter options and ranges can be incorrect.
			if (setInitialData) this.initialData = data;

			if (this.settings.onTableDataChanged) this.settings.onTableDataChanged(data);
		};

		this.getUpdatedData = function () {
			return (self.data || []);
		};

		/* Fields -------------------------------------------------------------------------------------------------- */

		this.getFieldValue = function (field, key) {
			return typeof field[key] == 'function' ? field[key]() : field[key];
		};

		this.isMissingField = function (item, field, forExport = false, isExportURL = false) {
			// exceptions for specific types
			if (field.type && !forExport) {
				let type = typeof field.type == 'function' ? field.type(item) : field.type;
				if (type[0] == 'image' && type[1] && (type[1].fallbackIcon || type[1].fallbackIconClass)) return false;
				if (type[0] == 'number' && type[3]) return false;
				if (type[0] == 'currency' && type[2]) return false;
			}

			if (field.html && !forExport) {
				return !field.html(item);
			} else {
				let value = null;
				if (forExport && isExportURL && typeof field.exportURL != 'undefined') {
					value = typeof field.exportURL == 'function' ? field.exportURL(item) : field.exportURL;
				} else if (!isExportURL && forExport && typeof field.exportValue != 'undefined') {
					value = typeof field.exportValue == 'function' ? field.exportValue(item) : field.exportValue;
				} else if (!isExportURL && typeof field.value != 'undefined') {
					value = typeof field.value == 'function' ? field.value(item) : field.value;
				}
				return value === null || typeof value == 'undefined' || value === '' || Array.isArray(value) && !value.length;
			}
		};

		this.getFieldAlign = function (field) {
			if (field.align) return field.align;
			if (field.type) {
				let type = typeof field.type == 'function' ? field.type(null) : field.type;
				if (['score2', 'hype', 'project-status'].includes(type[0])) return 'center';
			}
			return null;
		};

		this.isHiddenField = function (field) {
			return field.hide && (typeof field.hide != 'function' || field.hide());
		};

		this.getFieldOrder = function (field) {
			let order = typeof field.order == 'function' ? field.order() : field.order;
			return Number.isInteger(order) ? order : 0;
		};

		this.getFieldHTML = function (item, field) {
			if (this.isMissingField(item, field)) return $rootScope.trustAsHtml('-');
			let html = '';
			if (field.html) {
				html = field.html(item);
			} else {
				let value = typeof field.value == 'function' ? field.value(item) : field.value;
				if (field.type) {
					let type = typeof field.type == 'function' ? field.type(item) : field.type;
					html = this.formatValue(type, value);
				} else {
					html = $rootScope.htmlEscape(value);
				}
			}
			return $rootScope.trustAsHtml(html);
		};

		this.getFieldExportValue = function (item, field, isExportURL = false) {
			if (self.isMissingField(item, field, true, isExportURL)) {
				return '-';
			} else {
				if (isExportURL && typeof field.exportURL != 'undefined') {
					var value = typeof field.exportURL == 'function' ? field.exportURL(item) : field.exportURL;
				} else if (!isExportURL && typeof field.exportValue != 'undefined') {
					var value = typeof field.exportValue == 'function' ? field.exportValue(item) : field.exportValue;
				} else if (!isExportURL && typeof field.value != 'undefined') {
					var value = typeof field.value == 'function' ? field.value(item) : field.value;
				} else {
					var value = '?';
				}
				if (typeof value == 'number') return stripTagsAndUnescapeHTML('' + value).replaceAll(';', ' ');
				else if (typeof value == 'string') return stripTagsAndUnescapeHTML(value).replaceAll(';', ' ');
				else return '?';
			}
		};

		this.formatValue = function (type, value) {
			// FIELD TYPES (names must not contain spaces)
			switch (type[0]) {
				case 'text_html':
					var isTextHTML = true;
				case 'text':
					let style = '';
					// set text size
					if (type[1] == 'small') style += 'font-size:14px;';
					if (type[1] == 'large') style += 'font-size:16px;';
					// set text align
					if (type[2]) style += 'text-align:' + htmlEscape(type[2]) + ';';
					return '<div style="' + style + '">' + ((typeof isTextHTML != 'undefined' && isTextHTML) ? value : htmlEscape(value)) + '</div>';

				case 'title':
					let titleHtml = '';
					if (value.preHTML) {
						titleHtml += '<div class="pre-title-html">' + value.preHTML + '</div>';
					}
					if (value.nameTooltip) {
						titleHtml += '<div title= "' + htmlEscape(value.nameTooltip) + '" class="title-html">';
					} else {
						titleHtml += '<div class="title-html">';
					}
					if (value.icon) titleHtml += '<div style="margin-right:16px">'
						+ this.formatValue(['image', {
							fallbackIcon: value.icon.fallbackIcon, // if svg icon
							fallbackIconSize: value.icon.fallbackIconSize || '50%',
							fallbackIconClass: value.icon.fallbackIconClass, // if fontawesome icon
							fallbackIconFontSize: value.icon.fallbackIconFontSize || '22px',
							width: '44px',
							height: '44px',
							text: value.icon.text,
							textStyle: value.icon.textStyle,
							tooltip: value.icon.tooltip,
						}], value.icon.value) + '</div>';
					titleHtml += '<div style="text-align:left;">';
					if (value.name || value.name_html) {
						titleHtml += '<div style="line-height:1.3em">';
						if (value.link) {
							// use object "hack" to allow nested links (https://kizu.dev/nested-links/)
							titleHtml += '<object type="owo/uwu">';
							titleHtml += '<a href="' + $rootScope.cleanUrl(value.link) + '" '
								+ (value.linkInternal ? '' : 'target="_blank"')
								+ ' onclick="event.stopPropagation();">';
						}
						titleHtml += '<b style="font-weight:600">';
						titleHtml += value.name ? htmlEscape(value.name) : value.name_html;
						titleHtml += '</b>';
						if (value.link) {
							titleHtml += '</a>';
							titleHtml += '</object>';
							if (!value.linkInternal) titleHtml += '<span class="external-link">'
								+ '<i class="fa-solid fa-external-link-alt"></i></span>';
							if (value.link_broken) {
								titleHtml += BROKEN_LINK_MARKER_HTML;
							}
						}
						titleHtml += '</div>';
					}
					if (value.tags) titleHtml += $rootScope.tagsFormatter(value.tags);
					titleHtml += '</div>';
					titleHtml += '</div>';
					if (value.description || value.description_html) {
						titleHtml += '<div style="font-size:12px; color:var(--mpg-color-dark-grey); '
							+ 'line-height:1.2em; padding-top:8px;"'
							+ (value.descriptionTooltip ? ('title="' + htmlEscape(value.descriptionTooltip) + '">')
								: '>')
							+ (value.description ? htmlEscape(value.description) : value.description_html) + '</div>';
					}
					if (value.query && $scope.$parent.getSearchString({ query: value.query }) != '') {
						let queryUrl = $rootScope.getSearchHubUrl();
						queryUrl += (queryUrl.includes('?') ? '&' : '?')
							+ 'q=' + encodeURIComponent(JSON.stringify(value.query));
						// use object "hack" to allow nested links (https://kizu.dev/nested-links/)
						titleHtml += '<object type="owo/uwu">';
						titleHtml += '<a class="mpg-query" title="Run in expert mode" href="' + queryUrl + '" '
							+ 'onclick="event.stopPropagation();">'
							+ '<i class="fa-solid fa-search-plus" style="margin-right:4px; vertical-align:middle"></i>'
							+ htmlEscape($scope.$parent.getSearchString({ query: value.query, add_type_name: true }))
							+ '</a>';
						titleHtml += '</object>';
					}
					return titleHtml;

				case 'tags':
					return $rootScope.tagsFormatter(value);

				case 'weblinks':
					let addLink = function (key) {
						let name = key.charAt(0).toUpperCase() + key.substr(1, key.length - 1);
						return '<div style="white-space:nowrap; margin:4px 8px;"><a class="m-link-black" href="'
							+ encodeURI($rootScope.cleanUrl(value.links[key]))
							+ '" target="_blank">' + name
							+ '</a><span class="external-link"><i class="fa-solid fa-external-link-alt"></i></span>'
							+ (value.broken && value.broken[key] ? BROKEN_LINK_MARKER_HTML : '')
							+ '</div>';
					}
					let html = '<div style="font-size:14px; display:flex; flex-wrap:wrap; justify-content:flex-end; margin:-4px -8px">';
					if (value.links['homepage']) html += addLink('homepage');
					for (let key in value.links) {
						if (key == 'homepage') continue;
						html += addLink(key);
					}
					html += '</div>';
					return html;

				case 'list':
					// type[1] (optional): html separator, default: '<br>'
					return '<div style="margin: -3px 0">'
						+ value.map(x => '<span style="display:inline-block; margin: 3px 0">'
							+ htmlEscape(x) + '</span>').join(type[1] || '<br>') + '</div>';

				case 'contextual':
					return '<div style="font-size:14px">' + $rootScope.tagsFormatter([
						{
							data: value.players, class: 'm-table-tag--filter',
							title: 'Related player that matches your query.'
						},
						{
							data: value.topics, class: 'm-table-tag--filter',
							title: 'Related topic that matches your query.'
						}
					], type[1]) + '</div>';

				case 'query':
					let queryHTML = '';
					if (value.query && $scope.$parent.getSearchString({ query: value.query }) != '') {
						let queryUrl = $rootScope.getSearchHubUrl();
						queryUrl += (queryUrl.includes('?') ? '&' : '?')
							+ 'q=' + encodeURIComponent(JSON.stringify(value.query));
						// use object "hack" to allow nested links (https://kizu.dev/nested-links/)
						queryHTML += '<object type="owo/uwu" >';
						queryHTML += '<a class="mpg-query" style="margin-top:0;" title="Run in expert mode" href="'
							+ queryUrl + '" '
							+ 'onclick="event.stopPropagation();">'
							+ '<i class="fa-solid fa-search-plus" style="margin-right:4px; vertical-align:middle"></i>'
							+ htmlEscape($scope.$parent.getSearchString({ query: value.query, add_type_name: true }))
							+ '</a>';
						queryHTML += '</object>';
					} else {
						queryHTML = '-';
					}
					return queryHTML;

				case 'number':
					// type[1] (optional): "advanced" option of bigNumberFormatter(), default: true
					// for portfolio/library:
					// type[2] (optional): related growth value
					// type[3] (optional): failed or pending status
					// type[4] (optional): value description (title tag)
					// type[5] (optional): growth value description (title tag)
					let numberFieldHtml = '';
					if (type[3]) {
						numberFieldHtml = (type[3] == 'failed')
							? "<div title='The indicator could not be updated. "
							+ "This is usually caused by a too broad query.'>"
							+ '<i class="fa-solid fa-triangle-exclamation"></i>'
							+ '</div>'
							: "<div title='Pending calculation. Please refresh the page to see updates.'>"
							+ '<i class="fa-solid fa-sync" style="color:var(--mpg-color-table-line)"></i>'
							+ '</div>';

					} else {
						let numberTitle = type[4] || '';

						let growthTitle = (typeof type[5] == 'function' ? type[5]() : type[5]) || '';

						let growthHtml = '';
						let growthNumber = type[2];
						if (typeof growthNumber != 'undefined') {
							if (growthNumber === null) {
								growthHtml = 'n/a';
							} else {
								growthHtml = Math.round(growthNumber) + ' %';
							}
						}
						if (growthHtml) {
							let color = $rootScope.getGrowthColor(growthNumber);
							growthHtml = '<div title="' + htmlEscape(growthTitle) + '" style="'
								+ 'color:var(--mpg-color-mid-grey);white-space:nowrap;line-height:1em;margin-top:6px">'
								+ '<div class="m-inline-tag" style="background:' + color + ';cursor:inherit;margin:0">'
								+ growthHtml + '</div></div>';
						}

						numberFieldHtml = '<div title="' + htmlEscape(numberTitle) + '">'
							+ htmlEscape($rootScope.bigNumberFormatter(value,
								typeof type[1] != 'undefined' ? type[1] : true
							)) + '</div>' + growthHtml;
					}

					return numberFieldHtml;

				case 'currency':
					// type[1]: unit
					// type[2] (optional): failed or pending status
					// type[3] (optional): currency title for portfolio/library
					let currencyFieldHtml = '';
					if (type[2]) {
						currencyFieldHtml = (type[2] == 'failed')
							? '<div title="The indicator could not be updated. '
							+ 'This is usually caused by a too broad query.">'
							+ '<i class="fa-solid fa-triangle-exclamation"></i>'
							+ '</div>'
							: '<div title="Pending calculation. Please refresh the page to see updates.">'
							+ '<i class="fa-solid fa-sync" style="color:var(--mpg-color-table-line)"></i>'
							+ '</div>';

					} else {
						let currencyTitle = '';
						currencyTitle = type[3] || '';
						currencyFieldHtml = '<div title="' + currencyTitle + '">'
							+ htmlEscape($rootScope.bigNumberFormatter(value))
							+ '&nbsp;<span style="font-size:0.7em">' + htmlEscape(type[1]) + '</span></div>';
					}
					return currencyFieldHtml;

				case 'plain_currency':
					// type[1]: unit
					// The value is expected to be a string, e.g. "1k - 2k" USD
					return '<div>' + htmlEscape(value) + '&nbsp;<span style="font-size:0.7em">' + htmlEscape(type[1]) + '</span></div>';

				case 'country':
					let country = getCountryOrPatentOfficeByCode(value);
					let countryName = country ? country.name : null;
					let isPatentOffice = (country && country.type === 'patent office');

					let countryFlagHtml = '<div alt="' + htmlEscape(countryName)
						+ '" title="' + htmlEscape(countryName) + '" '
						+ 'style="background-image: url(/img/flags/' + value.toUpperCase() + '.png);'
						+ 'padding-top: 0; width:32px; height:26px; margin:0 auto; display:block;'
						+ 'background-repeat:no-repeat; background-position:0 -2px; background-size:cover"/>';

					let countryCodeHtml = '<div style="text-align:center;">'
						+ htmlEscape(isPatentOffice ? countryName : value) + '</div>';

					return (country && !isPatentOffice) ? countryFlagHtml : countryCodeHtml;

				case 'score': // bar
					// type[1] can be used to normalize the value (not affecting the label)
					// type[2] allows to use a custom label-formatting function
					return '<div class="m_percentage_bar_container">'
						+ '<div class="m_percentage_bar ' + (value === 0 ? 'zero-perc-bar' : '') + '" style="width:'
						+ (value / (type[1] || 1) * 100) + '%"></div>'
						+ '<span class="m_percentage_bar_label">'
						+ (type[2] ? type[2](value) : (
								(value !== 0 && Math.round(value * 100) === 0) ? '< 1 %'
									: Math.round(value * 100) + ' %')
						) + '</span>'
						+ '</div>';

				case 'score2': // circle
					// type[1]: can be used to normalize the value (not affecting the label)
					// type[2] (optional): allows to use a custom label-formatting function
					// for portfolio/library:
					// type[3] (optional): number of projects used to calculate the value
					let r = Math.round(value / (type[1] || 1) * 26 + 2);
					let score2title = '';
					if (type[3]) {
						if (type[3] == 1) score2title = '1 project';
						else score2title = 'average of ' + htmlEscape(type[3]) + ' projects';
					}
					return ''
						+ '<div class="m_percentage_circle_container" style="margin:0 auto; width:38px; height:28px;" '
						+ 'title="' + htmlEscape(score2title) + '">'
						+ '<div class="m_percentage_circle ' + (value === 0 ? 'zero-perc-bar' : '')
						+ '" style="width:' + r + 'px;height:' + r + 'px"></div>'
						+ '<span class="m_percentage_circle_label">'
						+ (type[2] ? type[2](value) : (
								(value !== 0 && Math.round(value * 100) === 0) ? '< 1 %'
									: Math.round(value * 100) + ' %')
						) + '</div>'
						+ '';

				case 'hype':
					let hype = $rootScope.mapHypeValue(value);
					switch (hype) {
						case 1:
							return '<i class="fa-solid fa-arrow-up" aria-hidden="true" '
								+ 'style="color:var(--mpg-color-attention);text-align:center;width:100%"></i>';
						case 0.5:
							return '<i class="fa-solid fa-arrow-up" aria-hidden="true" '
								+ 'style="color:var(--mpg-color-attention); transform: rotate(45deg);'
								+ 'text-align:center;width:100%"></i>';
						case 0:
							return '<i class="fa-solid fa-arrow-up fa-rotate-90" aria-hidden="true" '
								+ 'style="color:black;text-align:center;width:100%"></i>';
						case -0.5:
							return '<i class="fa-solid fa-arrow-up" aria-hidden="true" '
								+ 'style="color:var(--mpg-color-alert); transform: rotate(135deg);'
								+ 'text-align:center;width:100%"></i>';
						case -1:
							return '<i class="fa-solid fa-arrow-down" aria-hidden="true" '
								+ 'style="color:var(--mpg-color-alert);text-align:center;width:100%"></i>';
						default:
							return '';
					}

				case 'project-status':
					let iconHTML = '';
					let label = '';
					if (value <= WTA_STATUS.WATCH_MAX) {
						iconHTML = '<i class="fa-regular fa-eye" style="font-size:30px"></i>';
						label = 'WATCH';
					} else if (value > WTA_STATUS.THINK_MAX) {
						iconHTML = '<i class="fa-solid fa-walking" style="font-size:30px"></i>';
						label = 'ACT';
					} else if (!isNaN(value)) {
						iconHTML = '<i class="fa-solid fa-brain" style="font-size:30px"></i>';
						label = 'THINK';
					}

					return '<div class="m_percentage_circle_container" style="width:unset; height:30px" title="">'
						+ '<div class="m_percentage_circle"' +
						'style="width:unset;height:30px;background:transparent;box-shadow:none;color:var(--mpg-color-main);display:flex;justify-content:center;align-items:center;"' +
						'>' + iconHTML + '</div>'
						+ '<span class="m_percentage_circle_label" style="letter-spacing:0.5px">' + label + '</span>'
						+ '</div>';

				case 'image':
					let props = type[1] || {};
					let iconClass;
					let iconClassText;
					let iconClassTextStyle;
					let iconClassFontSize;
					let iconClassTooltip;
					if (value && typeof value === 'object') {
						// Use iconClass when a specific icon needed for this value other than the fallbackIconClass.
						if (value.iconClass) iconClass = value.iconClass;
						if (value.iconClassText) iconClassText = value.iconClassText;
						if (value.iconClassTextStyle) iconClassTextStyle = value.iconClassTextStyle;
						if (value.iconClassFontSize) iconClassFontSize = value.iconClassFontSize;
						if (value.iconClassTooltip) iconClassTooltip = value.iconClassTooltip;

						value = value.url;
					}
					/* props:
						{
							width: a fixed px value or % relative to minWidth of field,
							height: a fixed px value or % relative to props.width,
							mode: (all modes preserve the aspect ratio and affect images but not svg icons)
								 DEFAULT      --> image will never be larger than its resolution or the available space
								'coverHeight' --> resize image to cover the entire height (via zooming & cropping)
								'coverWidth'  --> resize image to cover the entire width (via zooming & cropping)
							zoomEffect: mouseover zoom effect
							fallbackIcon: svg icon name,
							fallbackIconSize: svg icon size in % relative to image size
							fallbackIconClass: e.g. fontawesome icon class (alternative to fallbackIcon),
							fallbackIconFontSize: size in px for font-based icons (if fallbackIconClass is used)
							allowEmpty: the fallback icon will only be used if the image fails to load, not as default
							text: text that will be shown as centered overlay on the image/icon
							textStyle: CSS string, e.g. marginTop to position the text overlay vertically,
							tooltip: the text for the "title" tag of the item
						}
					*/
					if (value) {
						switch (props.mode) {
							case 'coverHeight':
								var imageStyle = 'height:100%; position:absolute;';
								break;
							case 'coverWidth':
								var imageStyle = 'width:100%;';
								break;
							default:
								var imageStyle = 'max-height:100%; max-width:100%;';
						}
						var image = '<img style="pointer-events:none;' + imageStyle + '" src="'
							+ encodeURI($rootScope.cleanUrl(value, true)) + '" '
							+ 'onerror="this.style.display=\'none\'; '
							+ 'this.parentNode.classList.add(\'show-default-preview-icon\')">';
					}
					if (props.fallbackIcon) {
						var fallback = '<svg class="default-preview-icon" viewBox="0 0 1 1" '
							+ 'style="width:' + (props.fallbackIconSize || '100%') + ';height:'
							+ (props.fallbackIconSize || '100%') + ';">'
							+ '<use xlink:href="#' + (props.fallbackIcon ? 'icons--' + props.fallbackIcon : '') + '"></use>'
							+ '</svg>';
					} else if (props.fallbackIconClass) {
						var fallback = '<i class="default-preview-icon '
							+ (iconClass || props.fallbackIconClass || '') + '" '
							+ 'style="font-size:' + (iconClassFontSize || props.fallbackIconFontSize || '22px') + ';">'
							+ '</i>';
					}

					let classes = ['mpg-field--image'];
					if (props.zoomEffect) classes.push('mpg-img-zoom-effect');

					return '<div style="width:' + (props.width || '64px') + '" class="' + classes.join(' ')
						+ '" title="' + htmlEscape(props.tooltip || iconClassTooltip) + '">'
						+ '<div style="padding-bottom:'
						+ (!value && props.allowEmpty ? '0' : (props.height || '100%')) + ';"> '
						+ '<div '
						+ 'class="' + (value || props.allowEmpty ? '' : 'show-default-preview-icon') + '">'
						+ (value ? image : '')
						+ ((props.fallbackIcon || props.fallbackIconClass) ? fallback : '')
						+ '</div>'
						+ ((props.text || iconClassText) ? ('<div class="mpg-icon-text-overlay"><div style="'
							+ (props.textStyle || iconClassTextStyle || '')
							+ '">' + htmlEscape(props.text || iconClassText) + '</div></div>') : '')
						+ '</div>'
						+ '</div>';

				default:
					return htmlEscape(value);
			}
		};

		this.missingFieldTooltip = '<b>No information available</b>'
			+ "<div style='margin:12px 0 8px 0'>This could be because:</div><ul style='margin-bottom:0'>"
			+ "<li>The information does not exist in our database, or it does not apply.</li>"
			+ "<li>There is not enough data to determine a value with reasonable certainty.</li>";

		this.selectVisibleFields = function () {
			let items = {};
			this.selectableFields.filter(
				x => typeof x.visibilityGroup == 'string'
					&& (!x.onlyLayoutMode || x.onlyLayoutMode == self.settings.layoutMode)).forEach(function (item, idx) {
				if (!Object.keys(items).includes(item.visibilityGroup)) {
					items[item.visibilityGroup] = {
						id: item.visibilityGroup,
						title: item.visibilityGroup,
						selected: !item.hide
					};
				} else {
					// show group as "selected" only if all fields are visible
					items[item.visibilityGroup].selected &= !item.hide;
				}
			});
			items = Object.values(items);


			let fields = [];
			if (self.settings.visibleFieldsStore && self.settings.visibleFieldsStore.get() !== null) {
				fields.push({
					type: 'action',
					label: 'Reset',
					hideIcon: true,
					action: async () => {
						/*
							Update backend-side store
							In this case, trigger the visibility change externally via field[x].hide = () => { ... }
						*/
						await self.settings.visibleFieldsStore.set(null).catch((err) => {
							console.error(err);
						});
					},
					hint: (self.settings.layoutMode === 'list' ? 'KPIs that you don’t use are hidden by default. ' : '')
						+ 'If you edit your visible fields, your selection will be saved. '
						+ 'Click here to restore the default behavior.'
				});
			}

			$rootScope.selectDialog = {
				show: true,
				iconClass: 'fa-solid fa-tasks',
				caption: 'Fields',
				content: self.tooManyFields ? ('<i class="fa fa-exclamation-triangle" style="color:var(--mpg-color-main); margin-right:4px"></i> ' + this.invisibleFieldsHint) : '',
				rightButtonLabel: 'OK',
				multiselect: true,
				allowNoSelection: true,
				returnAllItems: true,
				items: items,
				fields: fields,

				rightButtonCallback: async function () {
					// load new state
					let results = {};
					let saveIds = [];
					for (let item of $rootScope.selectDialog.items) {
						results[item.id] = !item.selected;
						if (item.selected) saveIds.push(item.id);
					}

					// check if the selection changed
					let selectionChanged = false;
					let prevState = null;
					if (self.settings.visibleFieldsStore && self.settings.visibleFieldsStore.get) {
						prevState = self.settings.visibleFieldsStore.get();
					}
					if (prevState === null || saveIds.length !== prevState.length) {
						selectionChanged = true;
					} else {
						for (let key of prevState) {
							if (!saveIds.includes(key)) selectionChanged = true;
						}
						for (let key of saveIds) {
							if (!prevState.includes(key)) selectionChanged = true;
						}
					}

					if (selectionChanged) {
						if (self.settings.visibleFieldsStore && self.settings.visibleFieldsStore.set) {
							/*
								Update backend-side store
								In this case, trigger the visibility change externally via field[x].hide = () => { ... }
							*/
							await self.settings.visibleFieldsStore.set(saveIds).catch((err) => {
								console.error(err);
							});
						} else {
							// Default button behavior
							await self.render(false, () => {
								// update item
								for (let item of self.selectableFields) {
									item.hide = results[item.visibilityGroup];
								}
							});
						}

						mixpanel.track('Table - Visible Fields Changed', {
							visible_fields: (self.selectableFields)
								.filter(field => !field.hide)
								.map(field => field.name)
						});
					}
				}
			};
		};

		/* Paging -------------------------------------------------------------------------------------------------- */

		this.currentPage = 0; // The visible page. For inf. scroll, the last mounted page
		this.currentStartPage = 0; // For inf. scroll, the first mounted page
		this.pages = 0;
		this.getPages = function () {
			if (!this.settings || !this.data) return 0;
			if (this.state.layoutMode === 'grid-column') {
				return this.data.length ? 1 : 0;
			} else {
				return Math.ceil(this.data.length / this.state.itemsPerPage);
			}
		};

		this.pageData = [];
		this.pageMap = [];
		this.columns = [];
		this.loadPageData = function () {
			if (!this.settings || !this.data) return [];
			if (this.state.layoutMode === 'grid-column') {
				// We will assign items to columns
				const pageData = this.data;
				const pageMap = this.dataFields;
				const transformedPageMap = {};

				// Copy columns without item IDs
				const columns = this.columns.map(x => Object.assign({}, x));
				for (const column of columns) {
					if (column.isDefault) column.hasMoreItems = false; // reset
					// Remove object references
					column.items = [];
				}

				// Map project IDs to column indexes
				let mapping = new Map();
				for (let colIdx = 0; colIdx < this.columns.length; colIdx++) {
					for (const item of this.columns[colIdx].items || []) mapping.set(item.id, colIdx);
				}

				// Fill items into the columns
				const defaultColIdx = columns.findIndex(x => x.isDefault);
				for (let itemIdx = 0; itemIdx < pageData.length; itemIdx++) {
					const item = pageData[itemIdx];
					let colIdx = mapping.get(item.id);
					if (typeof colIdx == 'undefined') colIdx = defaultColIdx;
					const column = columns[colIdx];
					if (column.isDefault) {
						// We show only a limited number of unassigned items
						if (column.items.length > this.state.maxUnassignedItemsInBoard) {
							column.hasMoreItems = true;
						} else {
							transformedPageMap[colIdx + '_' + column.items.length] = pageMap[itemIdx];
							column.items.push(item);
						}
					} else {
						transformedPageMap[colIdx + '_' + column.items.length] = pageMap[itemIdx];
						column.items.push(item);
					}
				}

				this.pageData = columns; // return items in column format
				this.pageMap = transformedPageMap;
			} else {
				let itemsPerPage = this.state.itemsPerPage;

				// return items as list
				this.pageData = this.data.slice(
					this.currentPage * itemsPerPage, (this.currentPage + 1) * itemsPerPage
				);
				this.pageMap = this.dataFields.slice(
					this.currentPage * itemsPerPage, (this.currentPage + 1) * itemsPerPage
				);
			}
		};

		this.setCurrentPage = async function (page = 0, updateType = '', render = true) {
			let importSettings = updateType == 'importSettings' && !self.wk.latestUpdateMode;
			// reset state
			if (importSettings) this.initComponent();
			// leave the "details mode" if the selected item disappeared
			if (!this.settings.data || !this.currentItem || this.settings.data.indexOf(this.currentItem) === -1) {
				this.currentItem = null;
				this.currentItemIdx = null;
			}

			// Digest view updates
			$scope.$applyAsync();
			await new Promise(r => setTimeout(r));

			// Start rendering
			if (render) await self.startRendering();

			// Scroll to top when changing pages
			if (updateType === 'paging') self.scrollTo();

			// (Re-)import settings & data
			if (importSettings) self.importSettings();
			const isStandardMode = ['importSettings', 'loadData', 'loadDataFull'].includes(updateType);
			if (isStandardMode) self.loadData(importSettings || updateType == 'loadDataFull');
			self.pages = self.getPages();

			// Skip fully seen pages at the beginning
			if (page === 0 && this.state.itemsSeenRegistrar && isStandardMode) {
				let firstUnseenIdx = this.data.findIndex((x) => !x._meta?.seen);
				if (firstUnseenIdx === -1 && this.data.length) firstUnseenIdx = this.data.length - 1;
				const skipPages = Math.floor(firstUnseenIdx / this.state.itemsPerPage);
				if (skipPages > 0) page = skipPages;
			}

			// Set current page
			self.currentPage = Math.min(page, self.pages);
			self.currentStartPage = self.currentPage;

			// Avoid changing the scroll position
			let layoutWrapper;
			if (self.state.useInfiniteScroll) {
				layoutWrapper = $element[0].querySelector('.mpg-item-layout-wrapper');
				layoutWrapper.style.overflowAnchor = 'none';
			}

			// Update page data and digest view updates
			self.loadPageData();
			$scope.$applyAsync();
			await new Promise(r => setTimeout(r));

			// Allow scroll anchoring again
			if (self.state.useInfiniteScroll) layoutWrapper.style.overflowAnchor = null;

			// Adjust field sizes
			if (self.state.syncFieldSize) await self.syncFieldSize();
			else self.resetFieldSize();

			// Digest view updates
			$scope.$applyAsync();
			await new Promise(r => setTimeout(r));

			// Finish rendering
			if (render) await self.finishRendering(isStandardMode ? 'autofocus-page' : 'page');
		};

		this.getPageInfo = function () {
			if (this.state.layoutMode === 'grid-column') {
				return '';
			} else {
				return (this.currentPage * this.state.itemsPerPage + 1) + ' - '
					+ Math.min((this.currentPage + 1) * this.state.itemsPerPage, this.data.length)
					+ ' of ' + this.data.length;
			}
		};

		this.scrollTo = function (margin = undefined, elem = null, onlyUp = false) {
			if (typeof margin == 'undefined') margin = 10;
			if (!elem) elem = $element[0].querySelector('.mpg-item-layout-container');
			let elementPosition = elem.getBoundingClientRect().top;
			let elementHeight = elem.getBoundingClientRect().height;
			let windowScroll = document.documentElement.scrollTop;
			let windowHeight = document.documentElement.offsetHeight;
			if (elementPosition < margin || ( // Element starts above viewport
				elementHeight + 2 * margin > windowHeight && ( // Or element is bigger than viewport
					!onlyUp || elementPosition < margin // Optional: element must start above viewport
				)
			)) {
				// Scroll to top of element
				window.scrollTo(0, Math.max(0, Math.ceil(windowScroll + elementPosition - margin)));
			} else if (elementPosition + elementHeight + margin > windowHeight
				&& elementHeight + 2 * margin <= windowHeight) {
				// If element is below (and fits into) viewport, make full element visible at bottom of viewport
				window.scrollTo(0, Math.max(0, Math.ceil(windowScroll + elementPosition - windowHeight + elementHeight + margin)));
			}
		};

		/* Infinite scroll ----------------------------------------------------------------------------------------- */

		// Multiple of window.innerHeight for which we keep hidden DOM nodes in infinite scroll
		const PRELOAD_FACTOR = 2;
		const UNLOAD_FACTOR = 2.5;

		// Controls grouping of page skipping over time
		let SKIP_DEBOUNCE_MS = 150;
		let debounceIdentifier = null;

		// Controls delayed execution of blocked (due to locks) scroll events
		let DELAYED_SCROLL_TRIGGER_MS = 150;
		let delayedScrollEventTrigger = null;

		let lastScrollTop = document.documentElement.scrollTop; // Allows to track scroll direction
		const infScrollMenuTopMargin = 10; // The spacing that's added above the menu in sticky mode
		this.isMenuSticky = false; // Tracks the menu mode
		let isScrollListenerLocked = false; // Avoids overlapping scroll event executions
		let focusElement = null; // Remember the first visible element for refocus after resize

		const makeMenuSticky = (container, menu) => {
			// The maximum spacing between the sticky menu and the first item
			const bottomMargin = this.state.layoutMode === 'grid' ? 10 : 0;

			// Transform to sticky menu
			container.style.paddingTop = (menu.getBoundingClientRect().height + bottomMargin) + 'px';
			container.classList.add('mpg-item-layout-sticky-menu');
			this.isMenuSticky = true;
			$scope.$applyAsync();
			setTimeout(() => {
				// Adjust for height changes caused by width changes
				container.style.paddingTop = menu.getBoundingClientRect().height - infScrollMenuTopMargin
					+ bottomMargin + 'px';
			});
		};

		const makeMenuInline = (container, menu) => {
			// The maximum spacing between the sticky menu and the first item
			const bottomMargin = this.state.layoutMode === 'grid' ? 10 : 0;

			// Transform to inline menu
			const heightDiff = menu.getBoundingClientRect().height - parseInt(container.style.paddingTop)
				- infScrollMenuTopMargin + bottomMargin;
			container.classList.remove('mpg-item-layout-sticky-menu');
			container.style.paddingTop = null;
			// Adjust for height changes caused by interactions in sticky mode (like opened filter)
			if (heightDiff) window.scrollBy(0, heightDiff);
			this.isMenuSticky = false;
			$scope.$applyAsync();
		};

		// Controls view adjustments for infinite scroll, called by scroll events and by normal rendering
		const infiniteScrollListener = async (isCalledByRender = false) => {
			const container = $element[0].querySelector('.mpg-item-layout-container');
			const isRendering = () => self.isRendering || container.classList.contains('mpg-is-hidden');

			// Make sure that the last scroll event is not lost
			if ((isRendering() || isScrollListenerLocked) && !isCalledByRender) {
				if (delayedScrollEventTrigger) clearTimeout(delayedScrollEventTrigger);
				delayedScrollEventTrigger = setTimeout(() => {
					delayedScrollEventTrigger = null;
					infiniteScrollListener();
				}, DELAYED_SCROLL_TRIGGER_MS);
				return;
			}
			clearTimeout(delayedScrollEventTrigger);
			if (!isCalledByRender) isScrollListenerLocked = true;

			// Get relevant elements and prepare other variables
			const layoutWrapper = container.querySelector('.mpg-item-layout-wrapper');
			const layout = layoutWrapper.querySelector('.mpg-item-layout:not(.mpg-item-layout-header)');
			const menu = container.querySelector('.mpg-item-layout-menu');
			const wrapper = container.querySelector('.mpg-item-layout-wrapper');
			const isSticky = this.isMenuSticky;
			let localDebounceCallback = null;

			// The maximum spacing between the sticky menu and the first item
			const bottomMargin = this.state.layoutMode === 'grid' ? 10 : 0;

			// Switch between sticky and normal menu
			if (!isSticky && container.getBoundingClientRect().top <= infScrollMenuTopMargin) {
				// Transform to sticky menu
				makeMenuSticky(container, menu);
			} else if (
				isSticky && wrapper.getBoundingClientRect().top > menu.getBoundingClientRect().height + bottomMargin
			) {
				// Transform to inline menu
				makeMenuInline(container, menu);
			}

			let scrollTop = document.documentElement.scrollTop;

			// Make sure that enough items above and below the view position are loaded
			if ((scrollTop > lastScrollTop || isCalledByRender) && self.currentPage + 1 < self.pages) {
				// Scrolling down
				let mounted, unmounted;
				let maxRepeat = 1000;
				let skipPages = false;
				let scrollContentMeta = null;
				do {
					maxRepeat--;

					// Skip sequential page rendering if user scrolled to fast/far
					await new Promise(resolve => setTimeout(resolve));
					scrollContentMeta = this.getInfScrollContentMeta(layout, layoutWrapper);
					if (scrollContentMeta.bottom < 0) {
						skipPages = true;
						break;
					}

					// Sequentially mount/unmount a page
					mounted = await this.mountNextInfiniteScrollItems(wrapper);
					unmounted = await this.unmountPrevInfiniteScrollItems(wrapper);
				} while ((mounted || unmounted) && maxRepeat > 0 && (!isRendering() || isCalledByRender));

				// Jump to a page based on scroll position
				if (skipPages && !isCalledByRender) {
					const currentDummySpacing = parseFloat(layoutWrapper.style.paddingBottom || 0);
					const currentPosition = currentDummySpacing + scrollContentMeta.bottom;
					const remainingPages = self.pages - self.currentPage - 1;
					const projectedRemainingPage = Math.round(currentPosition * remainingPages / (currentDummySpacing || 1));
					let projectedPage = self.pages - projectedRemainingPage;
					projectedPage = Math.min(projectedPage, self.pages - 1);
					projectedPage = Math.max(projectedPage, 0);

					// Debounce page skipping to avoid interruption of scrolling
					localDebounceCallback = async () => {
						await self.setCurrentPage(projectedPage);
					};
				}
			}
			if ((scrollTop < lastScrollTop || isCalledByRender) && !localDebounceCallback) {
				// Scrolling up
				let mounted, unmounted;
				let maxRepeat = 1000;
				let skipPages = false;
				let scrollContentMeta = null;
				do {
					maxRepeat--;

					// Skip sequential page rendering if user scrolled to fast/far
					await new Promise(resolve => setTimeout(resolve));
					scrollContentMeta = this.getInfScrollContentMeta(layout, layoutWrapper);
					if (scrollContentMeta.top > window.innerHeight) {
						skipPages = true;
						break;
					}

					// Sequentially mount/unmount a page
					mounted = await this.mountPrevInfiniteScrollItems(wrapper);
					unmounted = await this.unmountNextInfiniteScrollItems(wrapper);
				} while ((mounted || unmounted) && maxRepeat > 0 && (!isRendering() || isCalledByRender));

				// Jump to a page based on scroll position
				if (skipPages && !isCalledByRender) {
					const currentDummySpacing = parseFloat(layout.style.paddingTop || 0);
					const currentPosition = currentDummySpacing - scrollContentMeta.top;
					let projectedPage = Math.round(currentPosition * self.currentStartPage / (currentDummySpacing || 1));
					projectedPage = Math.min(projectedPage, self.pages - 1);
					projectedPage = Math.max(projectedPage, 0);

					// Debounce page skipping to avoid interruption of scrolling
					localDebounceCallback = async () => {
						await self.setCurrentPage(projectedPage);
					};
				}
			}

			lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
			if (!isCalledByRender) isScrollListenerLocked = false;

			// Execute debounced callback
			if (localDebounceCallback) {
				debounceIdentifier = localDebounceCallback;
				await new Promise(resolve => setTimeout(resolve, SKIP_DEBOUNCE_MS));
				if (debounceIdentifier === localDebounceCallback) {
					if (isRendering() || isScrollListenerLocked) {
						// If locks are active, clear the task and schedule another scroll event
						debounceIdentifier = null;
						setTimeout(infiniteScrollListener);
					} else {
						// Execute now
						isScrollListenerLocked = true;
						await localDebounceCallback();
						debounceIdentifier = null;
						isScrollListenerLocked = false;
					}
				}
			}

			// Prepare: Remember the first visible element for refocus after resize
			let elems = Array.from(layout.querySelectorAll('.mpg-tile:not([mpg-tile-id="labels"])'));
			const margin = parseFloat($element[0].querySelector('.mpg-item-layout-container')?.style?.paddingTop || 0);
			const idx = elems.findIndex((elem) => elem.getBoundingClientRect().top > margin);
			let newFocusElem = idx !== -1 ? elems[idx] : null;

			// Mark items as seen when they leave the viewport by at least 50%
			if (self.state.itemsSeenRegistrar && self.state.autoMarkSeenOnScroll && !isRendering() && elems.length) {
				// Find last item that left the viewport
				let lastPossibleElemIdx;
				if (newFocusElem) lastPossibleElemIdx = idx === 0 ? 0 : (idx - 1);
				else lastPossibleElemIdx = elems.length - 1;
				const lastSeenElem = elems.slice(0, lastPossibleElemIdx + 1).findLast((x) => {
					return x.offsetHeight / 2 + x.getBoundingClientRect().top <= margin
				});

				// Mark items as seen
				if (lastSeenElem) {
					const lastSeenItemIdx = self.currentStartPage * self.state.itemsPerPage
						+ parseInt(lastSeenElem.getAttribute('mpg-tile-id'));
					const seenItems = self.data.slice(0, lastSeenItemIdx + 1).filter((x) => !x._meta.seen);
					if (seenItems.length) self.registerItemsSeen(seenItems);
				}
			}

			// Remember the first visible element for refocus after resize
			if (newFocusElem && focusElement
				&& newFocusElem.getBoundingClientRect().top === focusElement.getBoundingClientRect().top) {
				// Keep focus on old element if it's in the same row as the new focus element
				newFocusElem = focusElement;
			}
			focusElement = newFocusElem;
		};

		this.isLastPageAllSeen = () => {
			return this.currentPage == this.pages - 1 && !this.pageData.find((x) => !x._meta?.seen);
		};

		this.updateStickyMenuOffset = () => {
			if (!this.isMenuSticky) return;

			// The maximum spacing between the sticky menu and the first item
			const bottomMargin = this.state.layoutMode === 'grid' ? 10 : 0;

			const container = $element[0].querySelector('.mpg-item-layout-container');
			const menu = container.querySelector('.mpg-item-layout-menu');
			const prevPaddingTop = parseFloat(container.style.paddingTop || 0);
			const newPaddingTop = menu.getBoundingClientRect().height - infScrollMenuTopMargin + bottomMargin;
			container.style.paddingTop = newPaddingTop + 'px';
			return newPaddingTop;
		};

		// Check, based on scroll position, if previous items must be loaded into DOM, and add them if needed
		this.mountPrevInfiniteScrollItems = async (layoutWrapper) => {
			const layout = layoutWrapper.querySelector('.mpg-item-layout:not(.mpg-item-layout-header)');

			// Insert content of another page at the top if the first item ends less than ... above the viewport
			const fillNeeded = layout.getBoundingClientRect().top + parseFloat(layout.style.paddingTop || 0)
				> -window.innerHeight * PRELOAD_FACTOR;
			if (fillNeeded && this.currentStartPage - 1 >= 0) {
				this.currentStartPage--;

				const itemsPerRow = window.getComputedStyle(layout).gridTemplateColumns.split(' ').length;
				const startIndex = (this.currentStartPage) * this.state.itemsPerPage;
				const endIndex = (this.currentStartPage + 1) * this.state.itemsPerPage;
				const newPageData = this.data.slice(startIndex, endIndex);
				const newPageMap = this.dataFields.slice(startIndex, endIndex);
				const addedCount = newPageData.length;

				// Disable scroll anchoring
				layoutWrapper.style.overflowAnchor = 'none';

				// Add items from previous page to the end, to let Angular.js create DOM nodes outside the viewport
				this.pageData.push(...newPageData);
				this.pageMap.push(...newPageMap);

				// Digest view updates
				$scope.$applyAsync();
				await new Promise(resolve => setTimeout(resolve));

				// Get the added elements and the item before which we want to add them
				let elems = Array.from(layout.querySelectorAll('.mpg-tile:not([mpg-tile-id="labels"])'));
				let oldFirstElem = elems[0];
				elems = elems.slice(elems.length - self.state.itemsPerPage);

				// Move the items from the end to the front
				this.pageData.unshift(...this.pageData.splice(this.pageData.length - addedCount, addedCount));
				this.pageMap.unshift(...this.pageMap.splice(this.pageMap.length - addedCount, addedCount));

				/*
					Now, we have DOM nodes with the correct mpg-tile-id at the beginning.
					But we still need to render the content of the items.
					So we move the added items again to the end of the page, but via CSS "style.order",
						at the end of the current digest, before paint.
					We render them there because rendering can change the height across multiple digests.
				*/
				$scope.$evalAsync(function () {
					const gridItemShift = (oldFirstElem.style.gridColumnStart || 1) - 1;
					for (const elem of elems) elem.style.order = 2;
					elems[0].style.gridColumnStart
						= ((gridItemShift - self.state.itemsPerPage) % itemsPerRow + itemsPerRow) % itemsPerRow + 1;
				});

				// Digest view updates
				$scope.$applyAsync();
				await new Promise(resolve => setTimeout(resolve));

				// Render the new items
				await this.renderDiff();
				await new Promise(resolve => setTimeout(resolve));

				// Move rendered items back to their correct position and reduce dummy spacings accordingly
				for (const elem of elems) elem.style.order = null;
				const currentDummySpacing = parseFloat(layout.style.paddingTop || 0);
				const spacingDiff = elems[0].getBoundingClientRect().top - oldFirstElem.getBoundingClientRect().top;
				let newSpacing = spacingDiff + currentDummySpacing;
				let scrollBy = null;
				if (newSpacing < 0) {
					// If the page got narrower in grid view, the spacing is smaller than needed
					scrollBy = -newSpacing; // Scroll down to compensate unremovable spacing
					newSpacing = 0;
				}
				if (this.currentStartPage === 0 && newSpacing > 0) {
					// If the page got wider in grid view, the spacing is bigger than needed
					window.scrollBy(0, -newSpacing); // Scroll up to compensate additionally removed spacing
					newSpacing = 0;
				}
				layout.style.paddingTop = newSpacing + 'px';
				oldFirstElem.style.gridColumnStart = null;

				// Hide correct right/bottom table borders in standard layout
				self.updateTableLines();

				// Make tiles visible
				elems.forEach((x) => x.classList.add('is-tile-rendered'));

				// Avoiding the height update allows us (below) to call scrollBy() with nearly no flickering
				if (!scrollBy) {
					// Unfix items container height
					layout.style.height = 'auto';

					// Digest view updates
					await new Promise(resolve => setTimeout(resolve));
				}

				// Fix new items container height to avoid height change on resize
				layout.style.maxHeight = Math.ceil(layout.scrollHeight) + 'px';
				layout.style.height = Math.ceil(layout.scrollHeight) + 'px';

				// Correct the scroll position after the content height was updated
				if (scrollBy) window.scrollBy(0, scrollBy);

				// Reactivate scroll anchoring
				layoutWrapper.style.overflowAnchor = null;

				return true;
			}
		};

		// Check, based on scroll position, if next items must be loaded into DOM, and add them if needed
		this.mountNextInfiniteScrollItems = async (layoutWrapper) => {
			const layout = layoutWrapper.querySelector('.mpg-item-layout:not(.mpg-item-layout-header)');

			// Append content of another page at the bottom if the last item ends less than ... below the viewport
			const fillNeeded = layout.getBoundingClientRect().top + layout.scrollHeight
				< window.innerHeight * (PRELOAD_FACTOR + 1);
			if (fillNeeded && this.currentPage + 1 < this.pages) {
				this.currentPage++;

				// Add items from next page
				const startIndex = (this.currentPage) * this.state.itemsPerPage;
				const endIndex = (this.currentPage + 1) * this.state.itemsPerPage;
				this.pageData.push(...this.data.slice(startIndex, endIndex));
				this.pageMap.push(...this.dataFields.slice(startIndex, endIndex));

				// Digest view updates
				$scope.$applyAsync();
				await new Promise(resolve => setTimeout(resolve));
				await new Promise(resolve => requestAnimationFrame(resolve));
				await new Promise(resolve => requestAnimationFrame(resolve));

				// Render the new items
				await this.renderDiff();
				await new Promise(resolve => setTimeout(resolve));

				// Get items from last page and the item before it
				let elems = Array.from(layout.querySelectorAll('.mpg-tile:not([mpg-tile-id="labels"])'));
				elems = elems.slice((self.currentPage - self.currentStartPage) * self.state.itemsPerPage - 1);
				const prevLastElem = elems.shift();
				const newLastElem = elems[elems.length - 1];

				// Make tiles visible
				elems.forEach((x) => x.classList.add('is-tile-rendered'));

				// Calculate adjustment of dummy spacing
				const currentDummySpacing = parseFloat(layoutWrapper.style.paddingBottom || 0);
				const spacingDiff = prevLastElem.getBoundingClientRect().bottom
					- newLastElem.getBoundingClientRect().bottom;
				let newSpacing = spacingDiff + currentDummySpacing;
				if (newSpacing < 0) newSpacing = 0;
				if (this.currentPage + 1 === this.pages && newSpacing > 0) {
					// If the page got wider in grid view, the spacing is bigger than needed
					newSpacing = 0;
				}

				// Unfix items container height
				layout.style.height = 'auto';

				// Digest view updates
				await new Promise(resolve => setTimeout(resolve));

				// Fix new items container height to avoid height change on resize
				layout.style.maxHeight = Math.ceil(layout.scrollHeight) + 'px';
				layout.style.height = Math.ceil(layout.scrollHeight) + 'px';

				// Update dummy spacing
				layoutWrapper.style.paddingBottom = newSpacing + 'px';

				return true;
			}
		};

		// Check, based on scroll position, if previous items are outside the preload area, and replace them by a space
		this.unmountPrevInfiniteScrollItems = async (layoutWrapper) => {
			let layout = layoutWrapper.querySelector('.mpg-item-layout:not(.mpg-item-layout-header)');

			// Get items from first page and the item after it
			let elems = Array.from(layout.querySelectorAll('.mpg-tile:not([mpg-tile-id="labels"])'));
			elems = elems.slice(0, self.state.itemsPerPage + 1);
			if (elems.length < 2) return;
			const nearestElem = elems[elems.length - 2]; // Nearest element that could be removed
			const newFirstElem = elems.pop();

			// Remove content of a page if its nearest item is outside the preload area
			const unmountNeeded = self.pageData.length > self.state.itemsPerPage
				&& nearestElem.getBoundingClientRect().bottom < -window.innerHeight * UNLOAD_FACTOR;
			if (unmountNeeded) {
				this.currentStartPage++;

				const spacingDiff = newFirstElem.getBoundingClientRect().top - elems[0].getBoundingClientRect().top;
				const currentDummySpacing = parseFloat(layout.style.paddingTop || 0);
				const itemsPerRow = window.getComputedStyle(layout).gridTemplateColumns.split(' ').length;
				const gridItemShift = (elems[0].style.gridColumnStart || 1) - 1;

				// Remove items
				this.pageData.splice(0, this.state.itemsPerPage);
				this.pageMap.splice(0, this.state.itemsPerPage);

				// Replace items by spacing - Runs at the very end of the current digest, before paint
				layoutWrapper.style.overflowAnchor = 'none';
				$scope.$evalAsync(function () {
					layout.style.paddingTop = (spacingDiff + currentDummySpacing) + 'px';
					newFirstElem.style.gridColumnStart = (gridItemShift + self.state.itemsPerPage) % itemsPerRow + 1;
				});

				// Digest view updates
				$scope.$applyAsync();
				await new Promise(resolve => setTimeout(resolve));

				// Unfix items container height
				layout.style.height = 'auto';

				// Digest view updates
				await new Promise(resolve => requestAnimationFrame(resolve));
				await new Promise(resolve => setTimeout(resolve));

				// Fix new items container height to avoid height change on resize
				layout.style.maxHeight = Math.ceil(layout.scrollHeight) + 'px';
				layout.style.height = Math.ceil(layout.scrollHeight) + 'px';

				// Reactivate scroll anchoring
				layoutWrapper.style.overflowAnchor = null;

				return true;
			}
		};

		// Check, based on scroll position, if next items are outside the preload area, and replace them by a space
		this.unmountNextInfiniteScrollItems = async (layoutWrapper) => {
			let layout = layoutWrapper.querySelector('.mpg-item-layout:not(.mpg-item-layout-header)');

			// Get items from last page and the item before it
			let elems = Array.from(layout.querySelectorAll('.mpg-tile:not([mpg-tile-id="labels"])'));
			elems = elems.slice((self.currentPage - self.currentStartPage) * self.state.itemsPerPage - 1);
			if (elems.length < 2) return;
			const newLastElem = elems.shift();
			const farthestElem = elems[elems.length - 1];

			// Remove content of a page if its nearest item is outside the preload area
			const unmountNeeded = self.pageData.length > self.state.itemsPerPage
				&& newLastElem.getBoundingClientRect().bottom > window.innerHeight * (UNLOAD_FACTOR + 1);
			if (unmountNeeded) {
				this.currentPage--;

				// Calculate adjustment of dummy spacing
				const spacingDiff = farthestElem.getBoundingClientRect().bottom - newLastElem.getBoundingClientRect().bottom;
				const currentDummySpacing = parseFloat(layoutWrapper.style.paddingBottom || 0);

				// Remove items
				this.pageData.splice((this.currentPage - self.currentStartPage + 1) * this.state.itemsPerPage);
				this.pageMap.splice((this.currentPage - self.currentStartPage + 1) * this.state.itemsPerPage);

				// Replace items by spacing - Runs at the very end of the current digest, before paint
				$scope.$evalAsync(function () {
					layoutWrapper.style.paddingBottom = (spacingDiff + currentDummySpacing) + 'px';
				});

				// Digest view updates
				$scope.$applyAsync();
				await new Promise(resolve => setTimeout(resolve));

				// Unfix items container height
				layout.style.height = 'auto';

				// Digest view updates
				await new Promise(resolve => setTimeout(resolve));

				// Fix new items container height to avoid height change on resize
				layout.style.maxHeight = Math.ceil(layout.scrollHeight) + 'px';
				layout.style.height = Math.ceil(layout.scrollHeight) + 'px';

				return true;
			}
		};

		this.isInfiniteScrollEventRegistered = false;
		this.registerInfiniteScrollEventHandler = () => {
			if (this.isInfiniteScrollEventRegistered) return false;
			this.isInfiniteScrollEventRegistered = true;
			window.addEventListener('scroll', (e) => {
				infiniteScrollListener();
			}, { passive: true });
		};

		// Renders newly added items without affecting container properties
		this.renderDiff = async function () {
			if (self.state.syncFieldSize) await self.syncFieldSize('diff');
			await self.finishRendering('diff');
		};

		this.getInfScrollContentMeta = (layout, layoutWrapper) => {
			// Ge first and last rendered elements
			const firstElem = layout.querySelector('.mpg-tile:not([mpg-tile-id="labels"])');
			let lastElem = layout.lastElementChild;
			while (lastElem && !lastElem.matches('.mpg-tile:not([mpg-tile-id="labels"])')) {
				lastElem = lastElem.previousElementSibling;
			}

			// Compute average page height
			const visibleItems = self.pageData.length || 0;
			let contentHeight = 0, top = 0, bottom = 0;
			if (firstElem && lastElem) {
				top = firstElem.getBoundingClientRect().top;
				bottom = lastElem.getBoundingClientRect().bottom;
				contentHeight = bottom - top;
			}

			const spacingTop = parseFloat(layout.style.paddingTop || 0);
			const spacingBottom = parseFloat(layoutWrapper.style.paddingBottom || 0);
			const fullHeight = spacingTop + spacingBottom + contentHeight;

			return {
				contentHeight: contentHeight, // Content area excluding dummy spacing
				avgPageHeight: contentHeight / visibleItems * self.state.itemsPerPage,
				top: top, // Distance of content area's top to top of viewport
				bottom: bottom, // Distance of content area's bottom to top of viewport
				spacingTop: spacingTop,
				spacingBottom: spacingBottom,
				fullHeight: fullHeight // Content area including dummy spacing
			};
		}

		this.resetInfiniteScrollView = async () => {
			await new Promise(resolve => requestAnimationFrame(resolve));
			const startPage = self.currentStartPage || 0;
			const endPage = self.currentPage || startPage || 0;
			const container = $element[0].querySelector('.mpg-item-layout-container');
			const layoutWrapper = container.querySelector('.mpg-item-layout-wrapper');
			const layout = layoutWrapper.querySelector('.mpg-item-layout:not(.mpg-item-layout-header)');
			const elems = layout.querySelectorAll('.mpg-tile:not([mpg-tile-id="labels"])');
			const firstElem = elems[0];
			const itemsPerRow = window.getComputedStyle(layout).gridTemplateColumns.split(' ').length;
			const avgPageHeight = this.getInfScrollContentMeta(layout, layoutWrapper).avgPageHeight;
			const startDiff = startPage * avgPageHeight;
			const endDiff = (self.pages - endPage - 1) * avgPageHeight;

			// Set dummy spacings based on estimates
			layout.style.paddingTop = startPage === 0 ? null : (startDiff + 'px');
			layoutWrapper.style.paddingBottom = endPage + 1 === self.pages ? null : (endDiff + 'px');

			if (firstElem) {
				// Set tile indention
				firstElem.style.gridColumnStart = self.state.layoutMode == 'list' ? null
					: ((startPage * self.state.itemsPerPage) % itemsPerRow + 1);

				// Reset indention of other tiles
				elems.forEach((elem) => {
					if (elem !== firstElem) elem.style.gridColumnStart = null;
				});
			}
			lastScrollTop = document.documentElement.scrollTop;
			return elems;
		}

		this.scrollToTop = () => {
			window.scrollTo(0, 0);
		};

		/* Reactivity ---------------------------------------------------------------------------------------------- */

		// Call from application side after data has changed.
		// resetInitialData = true ensures that filter options will be updated.
		// When calling this function after applying server-side filters, resetInitialData must be set to false.
		this.reloadData = function (resetPage = false, resetInitialData = true) {
			return new Promise(async function (resolve, reject) {
				await self.setCurrentPage(resetPage ? 0 : self.currentPage,
					resetInitialData ? 'loadDataFull' : 'loadData');
				resolve();
			});
		};

		// init settings
		$scope.$watch(() => {
			return self.settings;
		}, async function (settings) {
			if (!self.settings) return;
			self.initiating = true;
			self.moduleScope = angular.element('#' + self.wk.id).scope();
			self.settings.reloadData = self.reloadData;
			self.settings.getCSVData = self.getCSVData;
			self.settings.applyFilter = self.applyFilter;
			self.settings.editFilter = (filter) => self.editFilter(filter);
			self.settings.openFilterSection = () => {
				self.isFilterSectionOpen = true;
			};
			self.settings.getMainSearch = () => self.mainSearch;
			self.settings.getUpdatedData = () => self.getUpdatedData();
			self.settings.itemDragStart = (evt, id, item) => self.itemDragStart(evt, id, item);
			self.settings.itemDrag = (evt) => self.itemDrag(evt);
			self.settings.itemDragEnd = (evt) => self.itemDragEnd(evt);
			self.settings.getLastDraggedItem = () => self.getLastDraggedItem();
			if (self.settings.useInfiniteScroll) self.registerInfiniteScrollEventHandler();
			//self.settings.getState = (key) => self.state[key] || self.getSetting(key);
			await self.setCurrentPage(0, 'importSettings');
			if (self.settings.onReady) self.settings.onReady();
			window.setTimeout(function () {
				self.initiating = false;
				$scope.$applyAsync();
			}, 0);
		});

		// field-related reactivity - this will not reset the page, but it will reset selected visible fields
		$scope.$watch(() => {
			if (!self.settings || !self.settings.fields) return undefined;
			let visible = self.settings.fields.map(x => self.isHiddenField(x) ? 'n' : 'y').join('');
			let order = self.settings.fields.map(x => self.getFieldOrder(x)).join('-');
			let spacingTop = self.settings.fields.map(x => self.getFieldValue(x, 'noTopSpacing') ? 'n' : 'y').join('');
			let spacingBottom = self.settings.fields.map(x => self.getFieldValue(x, 'noBottomSpacing') ? 'n' : 'y').join('');
			let layoutMode = self.settings.layoutMode;
			// return a unique key for the state of the fields
			return visible + '_' + order + '_' + spacingTop + '_' + spacingBottom + '_' + layoutMode;
		}, async function (now, before) {
			if (!self.settings || now == before || typeof before == 'undefined') return;

			await self.render(true, function () {
				// (re-)import field settings
				self.state.fields = self.getSetting('fields');

				// set selectable fields
				self.selectableFields = self.state.fields.filter(x => x.visibilityGroup);

				// track layout mode changes
				if (self.state.layoutMode !== self.settings.layoutMode) {
					mixpanel.track('Table - Layout Mode Changed', { layout_mode: self.settings.layoutMode });
				}
			});
		});

		// handle rendering and resizing in background
		this.reRenderingRequired = false;
		this.prevRenderingDonePromise = null;
		$scope.$watch(() => {
			return self.wk.isInBackground;
		}, function (inBackground, previously) {
			// check if re-rendering is required
			if (inBackground === true && (self.isRendering === true || self.reRenderingRequired == 2)) {
				self.reRenderingRequired = 1;
			}
			// we need to render again
			if (inBackground === false && self.reRenderingRequired === 1) {
				self.reRenderingRequired = 2;
				// wait until previous rendering is done
				let prevRenderingPromise = new Promise(function (resolve, reject) {
					if (!self.isRendering) {
						return resolve();
					} else {
						let unwatch = $scope.$watch(() => {
							return self.isRendering;
						}, function (isRendering) {
							if (isRendering === false) {
								unwatch();
								if (self.reRenderingRequired == 2 && prevRenderingPromise == self.prevRenderingPromise) {
									resolve();
								} else {
									reject();
								}
							}
						});
					}
				});
				self.prevRenderingPromise = prevRenderingPromise;
				prevRenderingPromise.then(function () {
					self.render(true);
					setTimeout(() => {
						if (self.reRenderingRequired == 2 && prevRenderingPromise == self.prevRenderingPromise) {
							self.reRenderingRequired = false;
						}
					});
				}).catch(function () {
				});
			}
		});

		// Render the current view again (e.g. after resize)
		this.render = async (hideFast = false, callback = null) => {
			let container = $element[0].querySelector('.mpg-item-layout-container');
			if (hideFast) container.classList.add('mpg-is-hidden');

			// Start rendering
			await self.startRendering();

			// Update view
			if (callback) $scope.$applyAsync();
			await new Promise(resolve => setTimeout(resolve));

			// Execute custom updates
			if (callback) await callback();

			// Re-import relevant properties
			self.state.layoutMode = self.getSetting('layoutMode');
			self.state.syncFieldSize = self.getSetting('syncFieldSize');
			self.state.minItemWidth = self.state.layoutMode == 'list' ? '100%' : self.getSetting('minItemWidth');
			self.state.allowLayoutSwitch = self.getSetting('allowLayoutSwitch');
			if (self.state.useInfiniteScroll) {
				// Reset indention of tiles
				const container = $element[0].querySelector('.mpg-item-layout-container');
				const layoutWrapper = container.querySelector('.mpg-item-layout-wrapper');
				const layout = layoutWrapper.querySelector('.mpg-item-layout:not(.mpg-item-layout-header)');
				const elems = layout.querySelectorAll('.mpg-tile:not([mpg-tile-id="labels"])');
				elems.forEach((elem) => elem.style.gridColumnStart = null);
			}

			// Update view
			$scope.$applyAsync();
			await new Promise(resolve => setTimeout(resolve));

			// Finish rendering
			if (self.state.syncFieldSize) await self.syncFieldSize();
			await self.finishRendering();
			if (hideFast) container.classList.remove('mpg-is-hidden');
		};

		/*
			Observe container resize

			"lastWidth" will be used to trigger Angular's $watch function. If ResizeObserver is not available,
			Angular will only notice resize events that are caused by clicks or $applyAsync,
			i.e. animations (e.g. collapsing sidebar in my projects) will only fire at the end.
		*/
		this.lastWidth = null;
		this.lastWidthChangeWasInit = false;
		$rootScope.$watch(() => {
			return self.lastWidth;
		}, async (now, before) => {
			if (now == before || !now || !before && self.initiating !== false
				|| self.reRenderingRequired || self.isRendering || self.lastWidthChangeWasInit) return;
			self.render(true);
		});

		// ResizeObserver (if supported) can observe all size changes.
		this.lastObserverWidth = null;
		let resizeTimeout;
		if (ResizeObserver) {
			new ResizeObserver(function (entries) {
				let lastWidthChangeWasInit = true;
				let width = entries[0].contentRect.width;
				let lastObserverWidth = self.lastObserverWidth;
				self.lastObserverWidth = width;
				if (lastObserverWidth == width || !width) return;
				// hide table as early as possible
				let container = $element[0].querySelector('.mpg-item-layout-container');
				if (self.lastWidth != width && self.initiating === false) {
					container.classList.add('mpg-is-hidden');
					lastWidthChangeWasInit = false;
				} else if (self.lastWidth == width && self.initiating === false) {
					// revert "hide" if change was triggered and reverted before lastWidth was applied
					container.classList.remove('mpg-is-hidden');
				}
				// only fire once (if multiple resize events occur due to an animation)
				clearTimeout(resizeTimeout);
				resizeTimeout = window.setTimeout(function () {
					if (self.lastObserverWidth == width && self.lastWidth != width) {
						self.lastWidthChangeWasInit = lastWidthChangeWasInit;
						self.lastWidth = width;
						$scope.$applyAsync();
					}
				}, 200);
			}).observe($element[0].querySelector('.mpg-item-layout:not(.mpg-item-layout-header)'));

		} else {
			// fallback
			$rootScope.$watch(() => {
				return $element[0].querySelector('.mpg-item-layout-container').getBoundingClientRect().width;
			}, function (now, before) {
				if (now == before || !now || now == self.lastWidth) return;
				self.lastWidth = now;
				$scope.$applyAsync();
			});

			this.isReadyToRender = function () {
				let elem = $element[0].querySelector('.mpg-item-layout-container');
				return !!elem && !!elem.offsetWidth;
			};

			// If ResizeObserver is not available, window resize needs to trigger Angular's $watch function.
			$rootScope.$on('resize', async function () {
				if (!self.isRendering && !self.reRenderingRequired && self.isReadyToRender()) {
					$scope.$applyAsync();
				}
			});
		}

		this.lastManuallySelectedLayoutMode = null;
		this.switchLayoutMode = async (newMode = null) => {
			let changedMode = (self.state.layoutMode == 'list' ? 'grid' : 'list');
			if (self.settings.customLayoutSwitchHandler) {
				// In this case, trigger the layout mode change externally via layoutSettings.layoutMode
				self.settings.customLayoutSwitchHandler(changedMode);
			} else {
				// Default button behavior
				await this.render(false, function () {
					self.state.layoutMode = newMode || changedMode;
					self.lastManuallySelectedLayoutMode = self.state.layoutMode;
				});
			}
			mixpanel.track('Table - Layout Mode Changed', { layout_mode: self.state.layoutMode });
		};

		this.onSortingChange = function () {
			if (self.sorting && self.sorting.serverSideSorting) {
				self.moduleScope.updateModuleData(
					self.wk,
					{ order: self.sorting.serverSideSorting },
					'serverSideSorting'
				);
			} else {
				self.setCurrentPage(0, 'loadData');
			}
			mixpanel.track('Table - Sorting Changed', { sorting_name: self.sorting ? self.sorting.name : null });
		};

		this.clickFilterMenu = async () => {
			this.isFilterSectionOpen = !this.isFilterSectionOpen;
			await new Promise(resolve => requestAnimationFrame(resolve));
			self.updateStickyMenuOffset();
		};

		/* Styling ------------------------------------------------------------------------------------------------- */

		this.startRendering = async () => {
			self.isRendering = true;

			// Update view and wait for fade out
			$scope.$applyAsync();
			await new Promise(r => setTimeout(r, animationTimeMS));

			// wait until the container is rendered properly
			await waitForView(() => $element[0].querySelector('.mpg-item-layout-container').offsetWidth);

			// fix container height
			let layout = $element[0].querySelector('.mpg-item-layout:not(.mpg-item-layout-header)');
			let height = Math.ceil(layout.getBoundingClientRect().height);
			layout.style.height = height + 'px';
			layout.style.maxHeight = null;

			// reset bookmarking checkbox size
			let bookmarkFields = $element[0].querySelectorAll('.mpg-item-layout .mpg-bookmark-field');
			for (let elem of bookmarkFields) elem.style.minWidth = null;

			// reset bottom margin of headline
			let headlines = $element[0].querySelectorAll('.mpg-item-layout .mpg-tile .mpg-tile-headline');
			for (let headline of headlines) headline.style.marginBottom = null;

			// show newline fields that were hidden in list mode
			let elems = $element[0].querySelectorAll('.mpg-field-newline');
			for (let elem of elems) elem.style.display = null;
		};

		// determine how many rows are used to display all fields
		// only applicable if field sizes are synchronized and missing fields are visible
		this.getFieldElementDetails = function () {
			// optimize position of bookmarking checkboxes
			const minOffsetLeft = 8; // paddingLeft of .mpg-tile
			let tiles = $element[0].querySelectorAll('.mpg-item-layout .mpg-tile');
			let visibleFields = {};
			let rows = 0;
			for (let tile of tiles) {
				rows = 0;
				tile.querySelectorAll(':scope > .mpg-field').forEach(function (field, idx) {
					if (!field.classList.contains('mpg-bookmark-field') && field.style.display != 'none') {
						if (!visibleFields[idx]) visibleFields[idx] = [];
						visibleFields[idx].push(field);
					}
					if (field.offsetLeft <= minOffsetLeft && field.offsetWidth) rows++;
				});
			}
			return {
				visibleFields: Object.values(visibleFields),
				rows: rows // number of rows, considering all fields, including bookmarker
			};
		};

		// Hide right/bottom table borders in standard layout
		this.updateTableLines = (elems) => {
			if (!elems) elems = $element[0].querySelectorAll(
				'.mpg-item-layout-container:not(.mpg-item-layout-advanced) .mpg-tile'
			);
			let maxTop = 0, maxLeft = 0;

			// Find largest top and left distances
			for (let elem of elems) {
				if (elem.offsetTop > maxTop
					&& !elem.classList.contains('separate-field-labels') // Doesn't work via :not(...) above
				) {
					maxTop = elem.offsetTop;
				}
				if (elem.offsetLeft > maxLeft) maxLeft = elem.offsetLeft;
			}

			// Update table line visibilities
			for (let elem of elems) {
				if (elem.offsetTop == maxTop && !elem.classList.contains('separate-field-labels')) {
					elem.classList.add('mpg-hide-before');
				} else elem.classList.remove('mpg-hide-before');
				if (elem.offsetLeft == maxLeft) elem.classList.add('mpg-hide-after');
				else elem.classList.remove('mpg-hide-after');
			}
		};

		/*
			renderMode:
				'page' - the function is called by setCurrentPage(), so we want to scroll to the first item of the page
				'autofocus-page' - like 'page' but allows automatic scrolling to first unseen item
				'diff' - inform the function that it's called by renderDiff() for infinite scroll
		*/
		this.finishRendering = function (renderMode = null) {
			return new Promise(async function (resolve, reject) {
				// Select HTML elements of all rendered items and column labels
				let elems = $element[0].querySelectorAll(
					'.mpg-item-layout-container:not(.mpg-item-layout-advanced) .mpg-tile'
				);

				// Hide right/bottom table borders in standard layout
				self.updateTableLines(elems);

				/*
					Ensure that the list view doesn't show too many fields.
					Only applicable if field sizes are synchronized and missing fields are visible.
				*/
				self.tooManyFields = false;
				if (self.state.maxListViewRows && self.state.layoutMode == 'list' && self.state.syncFieldSize
					&& !self.state.hideMissingFields) {
					let fieldElementDetails;
					do {
						fieldElementDetails = self.getFieldElementDetails();
						if (fieldElementDetails.rows > self.state.maxListViewRows) {
							let lastId = fieldElementDetails.visibleFields.length - 1;
							let elems = fieldElementDetails.visibleFields[lastId];
							for (let elem of elems) elem.style.display = 'none';
							self.tooManyFields = true;
						}
					} while (fieldElementDetails.rows > self.state.maxListViewRows);

					// For differential rendering, ensure that we don't show more fields than in other items
					if (renderMode === 'diff') {
						let visibleFields = 0;
						for (const elems of self.getFieldElementDetails().visibleFields) {
							if (elems.length > visibleFields) visibleFields = elems.length;
							if (elems.length < visibleFields) {
								// Only some of the fields are visible - Hide all of them
								elems.forEach((elem) => elem.style.display = 'none');
							}
						}
					}
				}

				// Optimize position of bookmarking checkboxes
				const minOffsetLeft = 8; // paddingLeft of .mpg-tile
				let tiles = $element[0].querySelectorAll('.mpg-item-layout .mpg-tile');
				for (let tile of tiles) {
					let bookmarkField = tile.querySelector('.mpg-field.mpg-bookmark-field');
					let headline = tile.querySelector('.mpg-tile-headline');
					let rows = 0;
					let fields = tile.querySelectorAll(':scope > .mpg-field');
					let hasFields = false;
					for (let field of fields) {
						if (field.offsetLeft == minOffsetLeft) rows++;
						if (field.style.display != 'none' && !field.classList.contains('mpg-field-newline')) {
							hasFields = true;
						}
					}
					if (rows > 1 || self.state.columnMode || self.state.layoutMode == 'grid'
						|| self.state.layoutMode == 'grid-column') {
						// multiple rows: position checkbox at the bottom
						if (bookmarkField) bookmarkField.style.margin = 'auto 0 0 0';
					} else {
						// single row: center checkbox vertically
						if (bookmarkField) bookmarkField.style.margin = 'auto 0';
					}
					if (bookmarkField) {
						if (bookmarkField.offsetLeft == minOffsetLeft && !self.state.columnMode) {
							// checkbox has its own row: align right
							bookmarkField.style.minWidth = '100%';
						} else {
							// checkbox shares a row with other fields
							bookmarkField.style.minWidth = null;
						}
					} else {
						// remove bottom margin of headline if no fields are visible
						if (headline && !hasFields) headline.style.marginBottom = '-8px';
					}
				}

				if (renderMode === 'diff') {
					resolve();
				} else {
					window.setTimeout(async () => {
						let delayedScrollY = null; // Can be set to scroll AFTER container height update
						const layoutWrapper = $element[0].querySelector('.mpg-item-layout-wrapper');
						const layout = layoutWrapper.querySelector('.mpg-item-layout:not(.mpg-item-layout-header)');
						let firstElem;

						if (self.state.useInfiniteScroll) {
							// Update dummy spacings
							const itemElems = await self.resetInfiniteScrollView();
							firstElem = itemElems[0];

							// Autofocus first unseen item if itemsSeenRegistrar exists
							if (renderMode == 'autofocus-page' && self.state.itemsSeenRegistrar) {
								const firstUnseenIdx = self.pageData.findIndex((x) => !x._meta?.seen);
								firstElem = itemElems[firstUnseenIdx];

								// Ensure that menu is sticky, to avoid shifts after scrollTo()
								if (!self.isMenuSticky) {
									const container = $element[0].querySelector('.mpg-item-layout-container');
									const menu = container.querySelector('.mpg-item-layout-menu');
									makeMenuSticky(container, menu);
								}
							}

							/*
								Correct the content shift caused by the sticky menu e.g. after filter menu size change.
								Check if menu is sticky and retrieve content offset.
							*/
							const contentOffset = self.updateStickyMenuOffset();

							const scrollToElem = (elem) => {
								let elementPosition = elem.getBoundingClientRect().top;
								let windowScroll = document.documentElement.scrollTop;
								if (typeof contentOffset !== 'undefined') {
									const margin = contentOffset + infScrollMenuTopMargin;
									const maxScrollY = document.documentElement.scrollHeight - window.innerHeight;
									const wantScrollY = Math.max(0,
										Math.ceil(windowScroll + elementPosition - margin)
									);
									const possibleScrollY = Math.min(maxScrollY, wantScrollY);
									window.scrollTo(0, possibleScrollY);
									if (possibleScrollY < wantScrollY) delayedScrollY = wantScrollY;
								}
							};

							// Position content in viewport
							if (renderMode === 'page' || renderMode === 'autofocus-page') {
								if (firstElem) scrollToElem(firstElem);

								// Make tiles visible
								const tiles = Array.from(
									layout.querySelectorAll('.mpg-tile:not([mpg-tile-id="labels"])')
								);
								tiles.forEach((x) => x.classList.add('is-tile-rendered'));

							} else if (focusElement) {
								// Focus the same elements as before if the content didn't change
								scrollToElem(focusElement);
							}
						}

						// Update container height
						$element[0].querySelector(
							'.mpg-item-layout:not(.mpg-item-layout-header)'
						).style.height = 'auto';

						// Avoid height change on resize
						let height = Math.ceil(layout.getBoundingClientRect().height);
						if (height) {
							layout.style.maxHeight = height + 'px';
							layout.style.height = height + 'px';
						}

						if (self.state.useInfiniteScroll) {
							await new Promise(r => setTimeout(r));

							// Make sure that we scroll down as far as possible to the correct position
							if (delayedScrollY) window.scrollTo(0, delayedScrollY);

							// If all items are seen, show the "all read" view
							if (!firstElem && self.state.itemsSeenRegistrar && renderMode === 'autofocus-page') {
								const elem = $element[0].querySelector('.mpg-item-layout-container .mpg-allread');
								if (elem) elem.scrollIntoView();
							}

							// Make sure that we have enough items on the page when using infinite scroll
							await infiniteScrollListener(true).catch((err) => {
								console.error(err);
							});
						}

						self.isRendering = false;
						$scope.$applyAsync();

						resolve();
					}, 0);
				}
			});
		};

		/*
			syncMode:
				'diff' - sync uninitialized elements with existing elements (for infinite scroll)
		*/
		this.syncFieldSize = async function (syncMode = null) {
			return new Promise(function (resolve, reject) {
				let wUpdateElems = $element[0].querySelectorAll('.mpg-field:not(.mpg-bookmark-field):not(.mpg-field-newline)');
				let hUpdateElems = $element[0].querySelectorAll('.mpg-field:not(.mpg-bookmark-field):not(.mpg-label-field):not(.mpg-field-newline)');
				let wRefElems = wUpdateElems;
				let hRefElems = hUpdateElems;

				if (syncMode === 'diff') {
					// Use the already synchronized elements as a reference
					wRefElems = Array.from(wUpdateElems).filter(x => x.style.width);
					hRefElems = Array.from(hUpdateElems).filter(x => x.style.height);

					// Update only elements that haven't been updated yet
					wUpdateElems = Array.from(wUpdateElems).filter(x => !x.style.width);
					hUpdateElems = Array.from(hUpdateElems).filter(x => !x.style.height);
				}

				self.resetFieldSize(wUpdateElems);

				window.setTimeout(() => {
					// Sync width -----------------------------------------------------------

					// Find largest fields
					let width = {};
					for (let elem of wRefElems) {
						let id = elem.getAttribute('mpg-field-id');
						const elemWidth = syncMode === 'diff'
							? parseInt(elem.style.width) // Reuse previously determined size
							: elem.getBoundingClientRect().width; // Measure size
						if (typeof width[id] == 'undefined' || width[id] < elemWidth) {
							if (self.state.useInfiniteScroll && syncMode !== 'diff') {
								width[id] = elemWidth + self.state.infiniteScrollFieldSyncWidthBuffer;
							} else {
								width[id] = elemWidth;
							}
						}
					}

					// Apply new size
					for (let elem of wUpdateElems) {
						let size = width[elem.getAttribute('mpg-field-id')];
						if (size) elem.style.width = Math.ceil(size) + 'px';
						else console.log('Cannot sync. field size: Width is ' + size + '.');
					}

					window.setTimeout(() => {
						if (self.state.layoutMode != 'list' || self.state.syncFieldHeightInListView) {
							// Sync height --------------------------------------------------

							// Find largest fields
							let height = {};
							for (let elem of hRefElems) {
								let id = elem.getAttribute('mpg-field-id');
								const elemHeight = syncMode === 'diff'
									? parseInt(elem.style.height) // Reuse previously determined size
									: elem.getBoundingClientRect().height; // Measure size
								if (typeof height[id] == 'undefined' || height[id] < elemHeight) {
									height[id] = elemHeight;
								}
							}

							// Apply new size
							for (let elem of hUpdateElems) {
								let size = height[elem.getAttribute('mpg-field-id')];
								if (size) elem.style.height = Math.ceil(size) + 'px';
								else console.log('Cannot sync. field size: Height is ' + size + '.');
							}
						}
						resolve();
					}, 0);
				}, 0);
			});
		};

		this.resetFieldSize = function (initialElements = null) {
			let elems = initialElements || $element[0].querySelectorAll('.mpg-field:not(.mpg-bookmark-field):not(.mpg-field-newline)');
			for (let elem of elems) {
				elem.style.width = 'auto';
				elem.style.height = 'auto';
				elem.style.display = null; // show fields that were hidden in list mode
			}
		};

		/* Details view / References section ----------------------------------------------------------------------- */

		this.currentItem = null;
		this.currentItemIdx = null;
		this.openItem = function (item, idx) {
			if (!this.state.rowsClickable || this.state.itemLink) return false;
			this.registerItemsSeen([item]);
			if (this.state.itemClickAction) {
				// custom click action
				this.state.itemClickAction(item);
			} else {
				// open details mode
				self.scrollTo(18);
				this.currentItemIdx = idx;
				this.currentItem = item;
				item.expanded = true;
				window.setTimeout(function () {
					if (self.state.referenceSectionType) self.moduleScope.loadReferencesHTML(item, self.state.referenceSectionType, self.wk.id);
					self.moduleScope.$applyAsync();
				}, 0);
			}
		};
		this.pendingSeenItemRegistrations = [];
		this.registerItemsSeen = async (items) => {
			if (!this.state.itemsSeenRegistrar) return;

			// Filter out duplicate clicks on the same item
			items = items.filter(item => !item._meta.seen);
			if (!items.length) return;

			// Deduplicate pending requests
			for (const pendingSeenItemSet of this.pendingSeenItemRegistrations) {
				items = items.filter(item => !pendingSeenItemSet.has(item));
				if (!items.length) return;
			}
			const itemSet = new Set(items);
			this.pendingSeenItemRegistrations.push(itemSet);

			// Execute custom callback to persist the change
			await this.state.itemsSeenRegistrar(items).then(() => {
				items.forEach((item) => item._meta.seen = true);
				$scope.$applyAsync();
			}).catch(() => {
				// Nothing to do - Handle error feedback in itemsSeenRegistrar()
			}).then(() => {
				this.pendingSeenItemRegistrations.splice(this.pendingSeenItemRegistrations.indexOf(itemSet), 1);
			});
		};
		this.navigating = false;
		this.navigateThroughItems = async function (item, idx, action) {
			let pageChanged = false;
			const isPrevAction = action === 'prev';
			const isNextAction = action === 'next';
			const isFirstItem = idx === -1;
			const isLastItem = idx === self.pageData.length;
			self.navigating = true;
			if ((isPrevAction && isFirstItem && self.currentPage !== 0)
				|| (isNextAction && isLastItem && self.currentPage !== self.pages - 1)) {
				pageChanged = true;
				const newPage = isPrevAction ? self.currentPage - 1 : self.currentPage + 1;
				await this.setCurrentPage(newPage, '', false);
				idx = isPrevAction ? self.pageData.length - 1 : 0;
				item = this.pageData[idx];
			}
			this.currentItemIdx = idx;
			this.currentItem = item;
			item.expanded = true;
			window.setTimeout(async function () {
				if (self.state.referenceSectionType) self.moduleScope.loadReferencesHTML(item, self.state.referenceSectionType, self.wk.id);
				self.moduleScope.$applyAsync();
				self.navigating = false;
				if (pageChanged) self.resetFieldSize();
			}, 0);
		};
		this.disableNavigation = function (item, action) {
			let index = self.data.findIndex(element => element === item);
			return (action == 'prev') ? index - 1 < 0 : index + 1 == self.data.length;
		};

		this.closeDetailsView = function () {
			let item = this.currentItem;
			let id = this.currentItemIdx;
			this.currentItem = null;
			this.currentItemIdx = null;
			setTimeout(self.scrollTo());
			item.loading = true;
			this.render(true).then(function () {
				// scroll to previous item and shortly highlight it
				let tile = $element[0].querySelector('.mpg-tile[mpg-tile-id="' + id + '"]');
				let overlay = $element[0].querySelector('.mpg-tile[mpg-tile-id="' + id + '"] > .mpg-tile-overlay--loading');
				if (tile && overlay) {
					setTimeout(() => {
						self.scrollTo(self.state.advancedLayout ? 8 : 0, tile);
						overlay.style.transition = 'opacity 0.6s ease-in';
						setTimeout(() => {
							overlay.style.opacity = '0';
							setTimeout(() => {
								item.loading = false;
								$scope.$applyAsync();
								setTimeout(() => {
									overlay.style.transition = null;
									overlay.style.opacity = null;
								});
							}, 600);
						});
					});
				}
			});
		};

		/* Filtering ----------------------------------------------------------------------------------------------- */

		this.getFilterOptions = function (filter) {
			// get values
			let items = this.getFilteredData(filter.name, true).data;
			let values = [];

			let addOption = function (x, value) {
				let isSelected = false;
				if (filter.match) {
					isSelected = filter.reverse ? !filter.match(value, true) : filter.match(value, true);
				}
				values.push({
					id: value,
					title: filter.label ? filter.label(x, value) : value,
					selected: isSelected
				});
			};

			for (let x of items) {
				let value = filter.value(x);
				if (Array.isArray(value)) {
					for (let v of value) addOption(x, v);
				} else {
					addOption(x, value);
				}
			}
			;

			// remove missing values
			values = values.filter(function (x) {
				return x.id !== null && typeof x.id != 'undefined' && x.id !== '' &&
					x.title !== null && typeof x.title != 'undefined' && x.title !== '';
			});

			// add currently selected values (which might be missing because of other server-side filters)
			if (filter.selected && ['select', 'multiselect'].includes(filter.type[0])) values = values.concat(filter.selected);

			// get unique values
			let uniqueValues = {};
			for (let x of values) {
				let key = '' + x.id;
				if (!(key in uniqueValues)) uniqueValues[key] = x;
			}
			// sort values
			uniqueValues = Object.values(uniqueValues);
			uniqueValues.sort(function (a, b) {
				if (typeof a.title == 'number') return a.title - b.title;
				else return (a.title || '').localeCompare(b.title || '');
			});
			return uniqueValues;
		};

		this.getServerSideFilterParams = function (excludedFilter = null) {
			let params = (this.state.filters || []).filter(
				(x) => x.selected && x.serverSideFilter && x != excludedFilter
			).map(function (x) {
				switch (x.type[0]) {
					case 'select':
					case 'multiselect':
						return x.serverSideFilter(x.selectedIds || []);
					case 'range':
					case 'date_range':
						return x.serverSideFilter(x.selected.min, x.selected.max);
				}
			});
			return Object.assign({}, ...params);
		};

		this.resetFilter = function (filter) {
			let oldServerSideFilters = JSON.stringify(self.getServerSideFilterParams());

			// reset filter
			delete filter.selected;
			delete filter.selectedLabels;
			delete filter.selectedIds;
			delete filter.match;

			// reset dependent filters
			let queue = [filter];
			while (queue.length) {
				let deactivatedFilter = queue.shift();
				for (let item of self.state.filters) {
					if (item.dependencies && item.dependencies.includes(deactivatedFilter.name)) {
						if (item.selected) {
							delete filter.selected;
							delete filter.selectedLabels;
							delete filter.selectedIds;
							delete filter.match;
							queue.push(item.name);
						}
					}
				}
			}

			const result = self.updateModuleAfterFilterChange(oldServerSideFilters);
			return result;
		};

		this.updateModuleAfterFilterChange = function (oldServerSideFilters) {
			if (!oldServerSideFilters) throw new Error('oldServerSideFilters parameter missing');

			let newServerSideFilters = self.getServerSideFilterParams();
			if (oldServerSideFilters != JSON.stringify(newServerSideFilters)) {
				// reload data
				return self.moduleScope.updateModuleData(self.wk, newServerSideFilters, 'serverSideFiltering');
			} else {
				// update page
				self.setCurrentPage(0, 'loadData');
			}
		};

		this.editFilter = async function (filter) {
			let options = this.getFilterOptions(filter);
			let oldServerSideFilters = JSON.stringify(self.getServerSideFilterParams());

			switch (filter.type[0]) {
				case 'select':
				case 'multiselect':
					$rootScope.selectDialog = {
						show: true,
						description: filter.description,
						loading: filter.serverSideOptions ? true : false,
						iconClass: 'fa-solid fa-filter',
						caption: 'Filter: ' + filter.name,
						rightButtonLabel: 'OK',
						presetSection: (filter.countryFilter)
							? { include_patent_office: !!(filter.includeRegionalPatentOffices) }
							: false,
						multiselect: filter.type[0] == 'multiselect',
						clearAllEnabled: filter.type[0] == 'multiselect',
						allowNoSelection: true,
						items: filter.serverSideOptions ? [] : options,
						rightButtonCallback: function () {
							self.applyFilter(filter, { items: $rootScope.selectDialog.items });
						}
					};
					if (filter.serverSideOptions) {
						// We expect that server-side filters work equally for the "Facets" and the table's "updateData" endpoints.
						// The table's "updateData" function can use:
						//   - special filters that are not needed here (like result limit)
						//   - basic filters that are applied in all cases (like entity type)
						//   - filters that come from other components (see externalTableFilter)
						// Those external filter params must be set in wk.latestFilters, using a scope that is different from ours:
						let externalParams = Object.entries(self.wk.latestFilters)
							.filter(x => x[0] != 'serverSideFiltering' && x[0] != 'serverSideSorting')
							.reduce((acc, cur) => Object.assign(acc, cur[1]), {});
						// Additionally, this component can apply its own filters.
						// We need to apply all server-side filters that are not from the currently selected filter:
						let internalParams = self.getServerSideFilterParams(filter);

						let facetParams = Object.assign({}, externalParams, internalParams, {
							limit: 500
						});

						// only load facets if parameters changed
						let knownFilterState = JSON.stringify(facetParams);
						if (filter.lastKnownFilterState != knownFilterState) {
							filter.lastKnownFilterState = knownFilterState;
							await MapegyAPIService.callData('Facets/' + filter.serverSideOptions.facet,
								facetParams, {}, false, false).then(function (response) {
								if (filter.serverSideOptions.include) {
									response = response.filter((x) => {
										return filter.serverSideOptions.include.includes(x.facet);
									});
								}
								filter.facets = response;
							}).catch(function (err) {
								console.log(err);
								filter.facets = null;
								$rootScope.selectDialog.show = false;
								$rootScope.showMessage('Error: Could not load filter options.', 'error');
								$scope.$applyAsync();
							});
						}

						// merge facets with client-side filter options
						let newOptions = {};
						for (let responseItem of (filter.facets || [])) {
							newOptions[responseItem.facet] = {
								id: responseItem.facet,
								title: filter.serverSideOptions.label ?
									filter.serverSideOptions.label(responseItem.facet) : responseItem.facet,
								percent: responseItem.percent,
								selected: filter.match ? filter.match(responseItem.facet, true) : false
							};
							if (filter.serverSideOptions.facet == 'Documents/Country') {
								let country = getCountryOrPatentOfficeByCode(newOptions[responseItem.facet].title);
								if (country) {
									newOptions[responseItem.facet].title = country.name;
									if (country.type) newOptions[responseItem.facet].type = country.type;
								}
							}
						}
						for (let option of options) {
							if (!newOptions[option.id]) newOptions[option.id] = option;
						}
						newOptions = Object.values(newOptions);
						setTimeout(() => $rootScope.selectDialog.showData(newOptions));
					}
					break;

				case 'range':
					let values = options.map(x => x.id);
					let unit = filter.type[3] || null;
					let scale = filter.type[4] || 1;
					let selectedMin = filter.selected && filter.selected.min !== null ? Math.floor(scale * filter.selected.min) : null;
					let selectedMax = filter.selected && filter.selected.max !== null ? Math.ceil(scale * filter.selected.max) : null;
					let useFallbackMin = false;
					let useFallbackMax = false;
					// step size is 1

					// min limit
					if (typeof filter.type[1] == 'number') {
						var min = Math.floor(scale * filter.type[1]);
					} else if (values.length) {
						var min = Math.floor(scale * Math.min(...values));
					} else {
						useFallbackMin = true;
						var min = Number.MIN_SAFE_INTEGER;
					}

					// max limit
					if (typeof filter.type[2] == 'number') {
						var max = Math.ceil(scale * filter.type[2]);
					} else if (values.length) {
						var max = Math.ceil(scale * Math.max(...values));
					} else {
						useFallbackMax = true;
						var max = Number.MAX_SAFE_INTEGER;
					}

					if (min <= 0 && 0 <= max) {
						var fallback = 0;
					} else {
						var fallback = Math.round(min + max);
					}

					// include previous values
					if (selectedMin !== null) {
						if (selectedMin < min) min = selectedMin;
						if (selectedMin > max) max = selectedMin;
					}
					if (selectedMax !== null) {
						if (selectedMax < min) min = selectedMax;
						if (selectedMax > max) max = selectedMax;
					}

					$rootScope.confirmDialog = {
						show: true,
						iconClass: 'fa-solid fa-filter',
						caption: 'Filter: ' + filter.name,
						rightButtonLabel: 'OK',
						fields: [
							{
								type: 'number',
								label: 'Minimum' + (unit ? (' (' + unit + ')') : ''),
								enabled: selectedMin !== null,
								value: selectedMin !== null ? selectedMin : (useFallbackMin ? fallback : min),
								min: min,
								max: max
							}, {
								type: 'number',
								label: 'Maximum' + (unit ? (' (' + unit + ')') : ''),
								enabled: selectedMax !== null,
								value: selectedMax !== null ? selectedMax : (useFallbackMax ? fallback : max),
								min: min,
								max: max
							}
						],
						rightButtonCallback: function () {
							let min = $rootScope.confirmDialog.fields[0];
							let max = $rootScope.confirmDialog.fields[1];

							self.applyFilter(filter, {
								min: min.enabled ? (min.value / scale) : null,
								max: max.enabled ? (max.value / scale) : null
							});
						}
					};
					break;

				case 'date_range': {
					let values = options.map(x => x.id);
					let selectedMin = filter.selected && filter.selected.min !== null ? Math.floor(filter.selected.min) : null;
					let selectedMax = filter.selected && filter.selected.max !== null ? Math.ceil(filter.selected.max) : null;
					let useFallbackMin = false;
					let useFallbackMax = false;
					// step size is 1

					// min limit
					if (typeof filter.type[1] == 'number') {
						var min = Math.floor(filter.type[1]);
					} else if (values.length) {
						var min = Math.floor(Math.min(...values));
					} else {
						useFallbackMin = true;
						var min = new Date().getTime();
					}

					// max limit
					if (typeof filter.type[2] == 'number') {
						var max = Math.ceil(filter.type[2]);
					} else if (values.length) {
						var max = Math.ceil(Math.max(...values));
					} else {
						useFallbackMax = true;
						var max = new Date().getTime();
					}

					// include previous values
					if (selectedMin !== null) {
						if (selectedMin < min) min = selectedMin;
						if (selectedMin > max) max = selectedMin;
					}
					if (selectedMax !== null) {
						if (selectedMax < min) min = selectedMax;
						if (selectedMax > max) max = selectedMax;
					}

					// Transform timestamps to dates and ensure that values get displayed in UTC instead of local time
					if (min) min = shiftTimezone(new Date(min));
					if (max) max = shiftTimezone(new Date(max));
					if (selectedMin) selectedMin = shiftTimezone(new Date(selectedMin));
					if (selectedMax) selectedMax = shiftTimezone(new Date(selectedMax));

					$rootScope.confirmDialog = {
						show: true,
						iconClass: 'fa-solid fa-filter',
						caption: 'Filter: ' + filter.name,
						rightButtonLabel: 'OK',
						fields: [
							{
								type: 'date',
								label: 'Minimum',
								showToggle: true,
								enabled: selectedMin !== null,
								value: selectedMin !== null ? selectedMin : (useFallbackMin ? fallback : min),
								minDate: min && !useFallbackMin
									? unshiftTimezone(min).toISOString().substring(0, 10) : null,
								maxDate: max && !useFallbackMax
									? unshiftTimezone(max).toISOString().substring(0, 10) : null
							}, {
								type: 'date',
								label: 'Maximum',
								showToggle: true,
								enabled: selectedMax !== null,
								value: selectedMax !== null ? selectedMax : (useFallbackMax ? fallback : max),
								minDate: min && !useFallbackMin
									? unshiftTimezone(min).toISOString().substring(0, 10) : null,
								maxDate: max && !useFallbackMax
									? unshiftTimezone(max).toISOString().substring(0, 10) : null
							}
						],
						rightButtonCallback: function () {
							let min = $rootScope.confirmDialog.fields[0];
							let max = $rootScope.confirmDialog.fields[1];
							let minValue = min.enabled && min.value || null;
							let maxValue = max.enabled && max.value || null;

							// Transform displayed values back to correct dates
							if (minValue) minValue = unshiftTimezone(minValue);
							if (maxValue) maxValue = unshiftTimezone(maxValue);

							if (minValue) minValue.setUTCHours(0, 0, 0, 0);
							if (maxValue) maxValue.setUTCHours(23, 59, 59, 0);

							self.applyFilter(filter, {
								min: minValue ? minValue.getTime() : null,
								max: maxValue ? maxValue.getTime() : null
							});
						}
					};
				}
					break;
			}
		};

		this.isFilterAvailable = function (filter) {
			if (filter.selected) return true;
			let dependencies = Array.from(filter.dependencies || []);
			if (this.filters) {
				for (let f of this.filters) {
					if (dependencies.includes(f.name)) {
						dependencies = dependencies.filter(x => x != f.name);
					}
				}
			}
			return !dependencies.length;
		};

		this.applyFilter = (filter, options) => {
			let oldServerSideFilters = JSON.stringify(self.getServerSideFilterParams());
			let isFilterRecentlyAdded = !filter.selected;  // Check if the filter is added not edited.

			switch (filter.type[0]) {
				case 'select':
				case 'multiselect':
					/*
					options = {
						items: [...] // Format: see getFilterOptions()
					}
					*/
					const items = options.items;

					if (items.length) {
						// set filter
						filter.selected = Array.from(items);
						filter.selectedLabels = filter.selected.map(x => x.title);
						filter.selectedIds = filter.selected.map(x => x.id);
						if (filter.reverse === true) {
							// reverse matching
							filter.match = function (x, isValue = false) {
								let v = isValue ? x : filter.value(x);
								if (Array.isArray(v)) {
									return !filter.selectedIds.filter(val => v.includes(val)).length;
								} else {
									return !filter.selectedIds.includes(v);
								}
							};
						} else {
							// normal matching
							filter.match = function (x, isValue = false) {
								let v = isValue ? x : filter.value(x);
								if (Array.isArray(v)) {
									return filter.selectedIds.filter(val => v.includes(val)).length;
								} else {
									return filter.selectedIds.includes(v);
								}
							};
						}
						const result = self.updateModuleAfterFilterChange(oldServerSideFilters);

						if (isFilterRecentlyAdded) mixpanel.track('Table - Filter Added', { filter_name: filter.name });
						return result;
					} else {
						// reset filter
						return self.resetFilter(filter);
					}
					break;

				case 'range':
				case 'date_range':
					/*
					options = {
						min: ...,
						max: ...
					}
					*/
					let min = options.min;
					let max = options.max;
					const minIsMissing = Number.isNaN(min) || min === null || typeof min === 'undefined';
					const maxIsMissing = Number.isNaN(max) || max === null || typeof max === 'undefined';

					if (!minIsMissing || !maxIsMissing) {
						// set filter
						filter.selected = {
							min: Number.isNaN(min) ? null : min,
							max: Number.isNaN(max) ? null : max
						};
						filter.match = function (x, isValue = false) {
							let v = isValue ? x : filter.value(x);
							// v may be a range
							if (Array.isArray(v) && v.length == 2) {
								if (typeof v[0] != 'number' || isNaN(v[0])) return false;
								if (typeof v[1] != 'number' || isNaN(v[1])) return false;
								if (filter.selected.min !== null && filter.selected.max !== null
									&& filter.selected.min > filter.selected.max) {
									return false;
								}
								return (filter.selected.min === null || filter.selected.min <= v[1])
									&& (filter.selected.max === null || filter.selected.max >= v[0]);
							}
							// v may be a number
							if (typeof v != 'number' || isNaN(v)) return false;
							return (filter.selected.min === null || filter.selected.min <= v)
								&& (filter.selected.max === null || filter.selected.max >= v);
						};

						self.updateModuleAfterFilterChange(oldServerSideFilters);
						if (isFilterRecentlyAdded) mixpanel.track('Table - Filter Added', { filter_name: filter.name });
					} else {
						// reset filter
						self.resetFilter(filter);
					}
					break;
			}
		};

		/* Main search -------------------------------------------------------------------------------------------- */

		this.applyMainSearch = async function (clear = false) {
			if (clear) {
				this.mainSearch = '';

				// Allow to invalidate previous calls to onBeforeMainSearch()
				if (self.state.onChangeMainSearch) await self.state.onChangeMainSearch(self.mainSearch);

				// Allow to hook into the main search mechanism
				let continueSearch = true;
				if (self.state.onBeforeMainSearch) await self.state.onBeforeMainSearch(self.mainSearch).catch(() => {
					continueSearch = false;
				});

				if (continueSearch) self.setCurrentPage(0, 'loadData');
			} else {
				this.isMainSearchLoading = true;
				let latestSearch = (new Date()).getTime();
				this.latestMainSearch = latestSearch;

				// Allow to invalidate previous calls to onBeforeMainSearch()
				if (self.state.onChangeMainSearch) await self.state.onChangeMainSearch(self.mainSearch);

				window.setTimeout(async function () {
					if (latestSearch != self.latestMainSearch) return;
					self.isMainSearchLoading = false;

					// Allow to hook into the main search mechanism
					let continueSearch = true;
					if (self.state.onBeforeMainSearch) await self.state.onBeforeMainSearch(self.mainSearch).catch(() => {
						continueSearch = false;
					});

					if (continueSearch) self.setCurrentPage(0, 'loadData');
				}, 500);
			}
		};

		// returns an array of strings that shall be searched by default via the main search
		// the default filter assumes that a single field of type "title" exists
		// the filter list can be replaced or extended via the mainSearchFilter() setting
		this.getDefaultItemFilter = function () {
			// find the title field
			let titleField = this.state.fields.find(function (field) {
				let type = typeof field.type == 'function' ? field.type(null) : field.type;
				if (type && type[0] == 'title') return true;
			});
			// create the default item filter
			if (titleField && titleField.value) {
				return function (item) {
					let value = titleField.value(item);
					let search = [];
					if (value.name) search.push(value.name);
					else if (value.name_html) search.push(stripTagsAndUnescapeHTML(value.name_html));
					if (value.description) search.push(value.description);
					else if (value.description_html) search.push(stripTagsAndUnescapeHTML(value.description_html));
					if (value.query) {
						search = search.concat($scope.$parent.getSearchStringKeywords(undefined, value.query.data));
					}
					return search;
				};
			} else {
				return (item) => [];
			}
		};

		/* Export ------------------------------------------------------------------------------------------------- */

		// Returns data for CSV/etc. export functions as array of objects.
		// The first element contains the field names.
		this.getCSVData = function () {
			let data = [{}];

			// Add field names
			self.state.fields.forEach(function (field, idx) {
				if (field.noExport || field.newline) return;
				if (field.exportData) {
					// The new export mechanism allows an arbitrary number of export properties per field.
					Object.keys(field.exportData).forEach((key, subIdx) => {
						data[0][idx + '_' + subIdx] = key || field.name || '?';
					});
				} else {
					// The old export mechanism can export a single property and a URL per field.
					// It also exports field name and value by default if no export settings are defined.
					data[0][idx + '_'] = field.exportName || field.name || '?';
					if (field.exportURL) {
						data[0][idx + '_url'] = data[0][idx + '_'] + ' URL';
					}
				}
			});

			// Add items
			for (let item of self.data) {
				let obj = {};
				self.state.fields.forEach(function (field, idx) {
					if (field.noExport || field.newline) return;
					if (field.exportData) {
						// The new export mechanism allows an arbitrary number of export properties per field.
						Object.values(field.exportData).forEach((valOrFunc, subIdx) => {
							let value = typeof valOrFunc == 'function' ? valOrFunc(item) : valOrFunc;
							if (value === null || typeof value == 'undefined' || value === '') {
								// Is missing value
								obj[idx + '_' + subIdx] = '-';
							} else {
								switch (typeof value) {
									// Format value
									case 'number':
										value = '' + value;
									case 'string':
										value = stripTagsAndUnescapeHTML(value).replaceAll(';', ' ');
										break;

									// Unsupported type
									default:
										value = '?';
								}
								obj[idx + '_' + subIdx] = value;
							}
						});
					} else {
						// The old export mechanism can export a single property and a URL per field.
						// It also exports field name and value by default if no export settings are defined.
						obj[idx + '_'] = self.getFieldExportValue(item, field);
						if (field.exportURL) {
							obj[idx + '_url'] = self.getFieldExportValue(item, field, true);
						}
					}
				});
				data.push(obj);
			}
			return data;
		};

		/* Drag & Drop -------------------------------------------------------------------------------------------- */

		this.draggable = {
			dragStart: (evt, customType) => {
				// only allow plain data, URI data and custom data
				let plainData = evt.originalEvent.dataTransfer.getData('text/plain');
				let uriData = evt.originalEvent.dataTransfer.getData('text/uri-list');
				evt.originalEvent.dataTransfer.clearData();
				if (plainData) evt.originalEvent.dataTransfer.setData('text/plain', plainData);
				if (uriData) evt.originalEvent.dataTransfer.setData('text/uri-list', uriData);
				if (customType) evt.originalEvent.dataTransfer.setData('mapegy/' + customType, 'true');

				// remove drag-image (set transparent 1x1 gif)
				let img = document.createElement("img");
				img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
				evt.originalEvent.dataTransfer.setDragImage(img, 0, 0);

				// update position of drag & drop animation
				this.draggable.drag(evt);

				// show drag & drop animation
				document.getElementById('dnd-animation').classList.add('show-dnd-animation');
			},
			drag: (evt) => {
				// update position of drag & drop animation
				let dnd = document.getElementById('dnd-animation');
				if (evt.clientX && evt.clientY) {
					dnd.style.left = evt.clientX + 'px';
					dnd.style.top = evt.clientY + 'px';
					if (dnd.classList.contains('hide-dnd-animation')) {
						dnd.classList.remove('hide-dnd-animation');
					}
				} else {
					if (!dnd.classList.contains('hide-dnd-animation')) {
						dnd.classList.add('hide-dnd-animation');
					}
				}
			},
			dragEnd: (evt) => {
				// hide drag & drop animation
				document.getElementById('dnd-animation').classList.remove('show-dnd-animation');
			}
		};

		this.lastDraggedItem = null; // { columnIdx: ..., item: ... };
		this.lastDraggedColumnIdx = null;
		this.itemDragStart = function (evt, columnIdx, item) {
			this.lastDraggedItem = { columnIdx: columnIdx, item: item };
			this.draggable.dragStart(evt, 'item');
		}
		this.columnDragStart = function (evt, columnIdx, item) {
			if (this.columns[columnIdx].isDefault) {
				evt.preventDefault();
				return false;
			}
			this.lastDraggedColumnIdx = columnIdx;
			this.draggable.dragStart(evt, 'column');
		}

		this.itemDrag = function (evt) {
			this.draggable.drag(evt);
		};
		this.columnDrag = function (evt) {
			this.draggable.drag(evt);
		};

		this.itemDragEnd = function (evt) {
			this.draggable.dragEnd(evt);
			this.lastDraggedItem = null;
			this.lastDragTargetColumnIdx = null;
		};
		this.columnDragEnd = function (evt) {
			this.draggable.dragEnd(evt);
			this.lastDraggedColumnIdx = null;
			this.lastDragTargetBeforeColumnIdx = null;
		};

		this.reachedBoardLimit = function (columnIdx) {
			if (this.columns[this.lastDraggedItem.columnIdx].isDefault && !this.columns[columnIdx].isDefault) {
				let itemsInBoard = this.columns.reduce((acc, obj) => obj.isDefault ? acc : acc + obj.items.length, 0);
				if (itemsInBoard >= this.state.maxAssignedItemsInBoard) {
					$rootScope.showMessage('You reached the limit of ' + this.state.maxAssignedItemsInBoard
						+ ' items per board.', 'error');
					return true;
				}
			}
		};

		this.lastDragTargetColumnIdx = null;
		this.lastDragTargetBeforeColumnIdx = null;
		this.dragOverColumn = function (evt, columnIdx) {
			if (!evt.originalEvent.dataTransfer.types.includes('mapegy/item')) return false;
			if (this.lastDraggedItem && columnIdx === this.lastDraggedItem.columnIdx) return false;
			if (this.reachedBoardLimit(columnIdx)) return false;
			if (this.lastDragTargetColumnIdx !== columnIdx) {
				this.lastDragTargetColumnIdx = columnIdx;
			}

			evt.preventDefault();
		}
		this.dragOverBeforeColumn = function (evt, columnIdx) {
			evt.stopPropagation();
			if (!evt.originalEvent.dataTransfer.types.includes('mapegy/column')) return false;

			// column can't be dropped next to itself
			if (columnIdx === this.lastDraggedColumnIdx) return false;
			if (columnIdx === this.lastDraggedColumnIdx + 1) return false;

			// column can't be dropped behind the default column (which contains the unassigned items)
			const defaultIdx = this.columns.findIndex(x => x.isDefault);
			if (this.lastDraggedColumnIdx > defaultIdx && columnIdx <= defaultIdx) return false;
			if (this.lastDraggedColumnIdx < defaultIdx && columnIdx > defaultIdx) return false;

			// set target column
			if (this.lastDragTargetBeforeColumnIdx !== columnIdx) {
				this.lastDragTargetBeforeColumnIdx = columnIdx;
			}
			evt.preventDefault();
		}

		this.dragLeaveColumn = function (evt) {
			this.lastDragTargetColumnIdx = null;
			evt.preventDefault();
		}
		this.dragLeaveBeforeColumn = function (evt) {
			this.lastDragTargetBeforeColumnIdx = null;
			evt.preventDefault();
		}

		this.dropIntoColumn = async function (evt, columnIdx) {
			if (!evt.originalEvent.dataTransfer.getData('mapegy/item')) return false;
			const lastColumn = this.columns[this.lastDraggedItem.columnIdx];
			const newColumn = this.columns[columnIdx];
			if (lastColumn == newColumn) return;
			const draggedItem = this.lastDraggedItem.item;
			if (this.reachedBoardLimit(columnIdx)) return false;

			// update backend-side store
			await self.settings.columnConfigStore.moveItemToColumn(draggedItem, lastColumn, newColumn)
				.catch((fullReset = false) => {
					return fullReset;
				}).then((fullReset = false) => {
					// reload column configuration
					self.columns = self.settings.columnConfigStore.get();
					if (fullReset) self.reloadData(true, true);
					else self.reloadData(false, false);
				});

			evt.preventDefault();
		}

		this.dropBeforeColumn = async function (evt, columnIdx) {
			if (!evt.originalEvent.dataTransfer.getData('mapegy/column')) return false;
			const movedColumn = this.columns[this.lastDraggedColumnIdx];
			if (this.lastDraggedColumnIdx < columnIdx) columnIdx--;

			// update backend-side store
			await self.settings.columnConfigStore.moveColumn(movedColumn, columnIdx).catch(() => {
				// nothing to do
			}).then(() => {
				// reload column configuration
				self.columns = self.settings.columnConfigStore.get();
				self.reloadData(false, false);
			});

			document.activeElement.blur();
			evt.preventDefault();
		}

		this.getLastDraggedItem = function () {
			return this.lastDraggedItem;
		}

		this.addColumn = function () {
			$rootScope.confirmDialog = {
				show: true,
				iconClass: 'fa-solid fa-plus',
				caption: 'Add Column',
				rightButtonLabel: 'Add',
				fields: [{
					type: 'text',
					label: 'Name',
					mandatory: true
				}],
				rightButtonCallback: function () {
					const newColumn = { name: $rootScope.confirmDialog.fields[0].value, items: [] };

					// update backend-side store
					self.settings.columnConfigStore.addColumn(newColumn).catch(() => {
						// nothing to do
					}).then(() => {
						// reload column configuration
						if (self.settings.onBeforeColumnCountChanged) {
							self.settings.onBeforeColumnCountChanged(self.columns.length + 1);
						}
						self.columns = self.settings.columnConfigStore.get();
						self.expandedColumnIdx = null;
						self.reloadData(false, false);
					});
				}
			};
		};

		this.expandedColumnIdx = null;
		this.clickColumn = function (colIdx) {
			/* "Expand" function has been deactivated
			this.expandedColumnIdx = this.expandedColumnIdx === colIdx ? null : colIdx;
			this.render(true);
			*/

			self.editColumn(null, colIdx);
		};

		this.editColumn = function (evt, colIdx) {
			if (evt) evt.stopPropagation();
			const oldName = self.columns[colIdx].name;
			$rootScope.confirmDialog = {
				show: true,
				iconClass: 'fa-solid fa-pen',
				caption: 'Edit Column',
				rightButtonLabel: 'Save',
				fields: [
					{
						type: 'text',
						label: 'Name',
						value: oldName,
						mandatory: true
					},
					{
						type: 'action',
						label: 'Delete',
						hint: 'The contained items will become unassigned items.',
						action: () => {
							// update backend-side store
							self.settings.columnConfigStore.deleteColumn(self.columns[colIdx]).catch(() => {
								// nothing to do
							}).then(() => {
								// reload column configuration
								if (self.settings.onBeforeColumnCountChanged) {
									self.settings.onBeforeColumnCountChanged(self.columns.length - 1);
								}
								self.columns = self.settings.columnConfigStore.get();
								self.expandedColumnIdx = null;
								self.reloadData(false, false);
							});
						}
					}
				],
				rightButtonCallback: function () {
					const newName = $rootScope.confirmDialog.fields[0].value;
					if (self.columns[colIdx].name === newName) return;
					self.columns[colIdx].name = newName;

					// update backend-side store
					self.settings.columnConfigStore.renameColumn(self.columns[colIdx]).catch(() => {
						self.columns[colIdx].name = oldName;
					}).then(() => {
						// reload column configuration
						self.columns = self.settings.columnConfigStore.get();
						self.reloadData(false, false);
					});
				}
			};
		};


	},
	template: `
		<div class="mpg-item-layout-container" ng-class="{
			'mpg-is-init': $ctrl.initiating,
			'mpg-is-rendering': $ctrl.isRendering || $ctrl.reRenderingRequired || $ctrl.navigating,
			'mpg-is-grid-view': $ctrl.state.layoutMode == 'grid' || $ctrl.state.layoutMode == 'grid-column',
			'mpg-is-column-view': $ctrl.state.layoutMode == 'grid-column',
			'mpg-item-layout-advanced': $ctrl.state.advancedLayout
				&& ($ctrl.state.layoutMode == 'grid' || $ctrl.state.layoutMode == 'grid-column'),
			'mpg-item-layout-horiz-centered': $ctrl.state.columnMode,
			'mpg-item-layout-verti-centered': $ctrl.state.centerVertically,
			'mpg-item-layout-less-spacing': $ctrl.state.lessSpacing && $ctrl.state.layoutMode == 'list',
			'mpg-item-layout-infinite-scroll': $ctrl.state.useInfiniteScroll
		}">
			<div class="mpg-item-layout-menu">
				<!-- Options -->
				<div class="mpg-item-layout-options" ng-show="!$ctrl.currentItem" class="noselect">
					<div style="flex:1; display:flex; flex-wrap:wrap; margin-right:-10px;">
						<div style="flex:1; display:flex;">
							<!-- Filtering -->
							<div class="mpg-options-button m-link m-link-grey noselect"
								style="margin:0 16px 10px 0; white-space:nowrap"
								ng-if="$ctrl.state.filters && $ctrl.state.filters.length"
								title="{{ $ctrl.isFilterSectionOpen ? 'Hide' : 'Show' }} filters"
								ng-click="$ctrl.clickFilterMenu()"
								ng-style="{ 'color': $ctrl.isFilterSectionOpen ? 'var(--mpg-color-main)' : null }">
								Filter
								<span style="font-size:14px" ng-if="$ctrl.filters && $ctrl.filters.length">
									&nbsp;({{ $ctrl.filters.length }})
								</span>
							</div>

							<!-- Visibility of fields -->
							<div ng-if="$ctrl.selectableFields && $ctrl.selectableFields.length"
								class="mpg-options-button m-link m-link-grey noselect"
								title="Select visible fields" ng-click="$ctrl.selectVisibleFields()"
								style="margin:0 16px 10px 0; white-space:nowrap">
								<!--<i style="margin-right:4px; font-size:13px"
									class="fa-solid fa-lock" title=""
									ng-if="$ctrl.settings.visibleFieldsStore.get() !== null"
									m-tooltip="'The configuration has been saved.'"></i>-->
								Fields
								<i style="margin-left:3px; margin-bottom:8px; color:var(--mpg-color-main2); font-size:14px"
									class="fa-solid fa-exclamation" title=""
									ng-if="$ctrl.state.layoutMode == 'list' && $ctrl.tooManyFields"
									m-tooltip="$ctrl.invisibleFieldsHint"></i>
							</div>

							<!-- Sorting -->
							<div ng-if="$ctrl.sorting" style="margin:0 10px 10px 0; white-space:nowrap">
								<select ng-model="$ctrl.sorting" class="mini-select" style="width:auto;"
									ng-style="{
										'border-radius': $ctrl.sorting.serverSideSorting ? '6px' : '6px 0 0 6px'
									}"
									ng-change="$ctrl.onSortingChange()"
									ng-disabled="$ctrl.isRendering || $ctrl.reRenderingRequired">
									<option ng-repeat="sorting in $ctrl.state.sorting" ng-value="sorting">{{ sorting.name }}</option>
								</select
								><div class="mpg-sort-direction m-link" title="Reverse sorting"
									ng-if="!$ctrl.sorting.serverSideSorting"
									ng-click="$ctrl.sorting.reverse = !$ctrl.sorting.reverse; $ctrl.setCurrentPage(0, 'loadData')">
									<i class="fa-solid fa-sort-up"
										style="position:absolute; left:0; width:100%; margin-bottom:1px;"
										ng-class="{'mpg-sort-direction-active': !$ctrl.sorting.reverse }"></i>
									<i class="fa-solid fa-sort-down" style="position:absolute;
										left:0; width:100%; margin-top:1px;"
										ng-class="{'mpg-sort-direction-active': $ctrl.sorting.reverse }"></i>
								</div>
							</div>
						</div>

						<div style="display:flex; flex:99999;">
							<!-- Main Search -->
							<div style="flex:1;">
								<div ng-if="$ctrl.state.showMainSearch" style="margin:0 10px 10px 0; position:relative">
									<div style="position:absolute; right:8px; top:0; display:flex; align-items:center;
										height:100%; font-size:14px">
										<i class="fa-solid fa-sync fa-spin fa-fw" ng-show="$ctrl.isMainSearchLoading"
											style="color:var(--mpg-color-main); pointer-events:none;"></i>
										<i class="fa-solid fa-times m-link m-link-grey" style="margin-right:3px"
											title="Clear"
											ng-show="!$ctrl.isMainSearchLoading && $ctrl.mainSearch"
											ng-click="$ctrl.applyMainSearch(true);"></i>
									</div>
									<input ng-model="$ctrl.mainSearch" type="text" class="mini-text-input"
										placeholder="{{ $ctrl.state.mainSearchTooltip || 'Search' }}"
										ng-change="$ctrl.applyMainSearch()" title=""
										style="border-radius:6px; min-width:160px; padding-right:28px;">
								</div>
							</div>

							<!-- Layout mode (list vs. grid) -->
							<div class="mpg-options-button"
								ng-if="$ctrl.state.allowLayoutSwitch" style="margin-right:10px">
								<i class="fa-solid fa-th-list m-link m-link-grey"
									ng-show="$ctrl.state.layoutMode == 'list'"
									title="Switch to grid view"
									ng-click="$ctrl.switchLayoutMode()"></i>
								<i class="fa-solid fa-th m-link m-link-grey"
									ng-show="$ctrl.state.layoutMode != 'list'"
									title="Switch to list view"
									ng-click="$ctrl.switchLayoutMode()"></i>
							</div>

							<!-- mpgOptionsButtons -->
							<div class="mpg-options-button" style="margin-right:10px"
								ng-repeat="btn in $ctrl.state.mpgOptionsButtons"
								ng-if="!btn.condition || btn.condition()">
								<i ng-class="btn.icon + ' ' + (btn.class || 'm-link m-link-grey')" tabindex="0"
									ng-attr-title="{{ btn.tooltip }}" ng-if="!btn.dropdown && !btn.svgIcon"
									ng-click="btn.callback()" ng-keydown="$event.key == 'Enter' && btn.callback()"></i>
								<svg ng-if="!btn.dropdown && btn.svgIcon" tabindex="0"
									ng-class="btn.class"
									ng-click="btn.callback()" ng-keydown="$event.key == 'Enter' && btn.callback()"
									style="width:16px; height:16px; outline:none;"
									><title>{{ btn.tooltip }}</title
										><use ng-attr-href="{{'#' + btn.svgIcon}}"></use></svg>
								<!-- Optional dropdown for buttons -->
								<span ng-if="btn.dropdown">
									<i ng-class="btn.icon + ' panel-btn-toggle ' + (btn.class || 'm-link m-link-grey')"
										tabindex="0" ng-attr-title="{{ btn.tooltip }}"></i>
									<div class="panel-btn-dropdown" style="top:100%; width:auto;">
										<div class="m-link" tabindex="0" onclick="this.blur()"
											style="font-size:14px; padding:8px 10px;"
											ng-repeat="item in btn.dropdown" ng-click="item.callback()">
											{{ item.label }}
										</div>
									</div>
								</span>
							</div>

							<!-- Scroll to top, for infinite scroll -->
							<div class="mpg-options-button"
								ng-if="$ctrl.isMenuSticky" style="margin-right:10px">
								<i class="fa-solid fa-angle-double-up m-link m-link-grey"
									title="Scroll up"
									ng-click="$ctrl.scrollToTop()"></i>
							</div>

							<div class="mpg-options-button m-link m-link-grey" style="margin-right:10px"
								ng-if="$ctrl.state.layoutMode == 'grid-column'"
								tabindex="0"
								ng-click="$ctrl.addColumn()"
								ng-keydown="$event.key == 'Enter' && $ctrl.addColumn()"
							><i class="fa-solid fa-plus" style="font-size:21px; margin-right:6px;" title="Add column"></i>
							<span style="font-weight:600; font-size:19px">Column</span>
							</div>
						</div>
						<!-- Custom header buttons -->
						<div style="display: flex; flex: 1;">
						<div ng-repeat="button in $ctrl.state.headerButtons"
							style="font-size:18px; padding-right:10px; white-space:nowrap"
							class="mpg-options-button m-link m-link-grey"
							ng-attr-title="{{ button.title }}"
							ng-click="button.onClick()">
							<i ng-class="button.icon"></i>
						</div>
						</div>
					</div>

					<!-- Filter section -->
					<div class="mpg-result-filters" ng-if="$ctrl.state.filters && $ctrl.isFilterSectionOpen">
						<!-- Filter -->
						<div ng-repeat="filter in $ctrl.state.filters track by $index"
							ng-class="{
								'mpg-active-filter': filter.selected,
								'mpg-deep-filter': filter.serverSideFilter,
								'mpg-disabled-filter': !$ctrl.isFilterAvailable(filter) || filter.isExternallyControlled(),
								'mpg-range-filter': filter.type[0] == 'range' || filter.type[0] == 'date_range',
								'm-link': !filter.isExternallyControlled()
							}"
							ng-show="(!filter.isExternallyControlled() || filter.selected)
								&& (!filter.condition || filter.condition())"
							m-tooltip="(
								filter.isExternallyControlled() === true
									? 'Please use the above chart to change this filter.'
									: ($ctrl.isFilterAvailable(filter)
											? 'Click here to edit the filter.'
											: ('Dependencies: <b>' + filter.dependencies.join(', ') + '</b>'))
										+ '<br><br>' + (filter.serverSideFilter
											? 'This filter will load a new result set.'
											: 'This will filter the currently loaded results.')
									)"
							ng-click="$ctrl.isFilterAvailable(filter) && !filter.isExternallyControlled()
								&& $ctrl.editFilter(filter)">

							<!-- Range begin -->
							<div class="mpg-result-filter-meta" style="margin-right:8px"
								ng-if="filter.type[0] == 'range' && filter.selected && filter.selected.min !== null">
								{{ $root.Math.floor(filter.selected.min * (filter.type[4] || 1))
										+ (filter.type[3] ? (' ' + filter.type[3]) : '') }}
								<i class="fa-solid fa-less-than-equal" style="font-size:11px; margin-left:6px"></i>
							</div>
							<div class="mpg-result-filter-meta" style="margin-right:8px"
								ng-if="filter.type[0] == 'date_range' && filter.selected && filter.selected.min !== null">
								{{ $root.toDate(filter.selected.min).toISOString().substr(0, 10) }}
								<i class="fa-solid fa-less-than-equal" style="font-size:11px; margin-left:6px"></i>
							</div>

							<!-- Filter name -->
							<div class="mpg-result-filter-name"
								ng-if="filter.type[0] == 'range' || filter.type[0] == 'date_range' || !filter.selected"
								>{{ filter.name }}</div>
							<div class="mpg-result-filter-name" style="display:flex;"
								ng-if="filter.type[0] != 'range' && filter.type[0] != 'date_range' && filter.selected">
								{{ filter.name }}
								<!-- Reset select/multiselect filter -->
								<div style="flex:1; text-align:right" ng-show="!filter.isExternallyControlled()">
									<i class="fa-solid fa-times m-link"
										ng-click="$ctrl.resetFilter(filter); $event.stopPropagation();"
										m-tooltip="'Reset filter'" ng-mouseover="$event.stopPropagation();"></i>
								</div>
							</div>

							<!-- Range end -->
							<div class="mpg-result-filter-meta" style="margin-left:8px"
								ng-if="filter.type[0] == 'range' && filter.selected && filter.selected.max !== null">
									<i class="fa-solid fa-less-than-equal" style="font-size:11px; margin-right:6px"></i>
									{{ $root.Math.ceil(filter.selected.max * (filter.type[4] || 1))
											+ (filter.type[3] ? (' ' + filter.type[3]) : '') }}
							</div>
							<div class="mpg-result-filter-meta" style="margin-left:8px"
								ng-if="filter.type[0] == 'date_range' && filter.selected && filter.selected.max !== null">
									<i class="fa-solid fa-less-than-equal" style="font-size:11px; margin-right:6px"></i>
									{{ $root.toDate(filter.selected.max).toISOString().substr(0, 10) }}
							</div>

							<!-- Filter meta -->
							<div class="mpg-result-filter-meta" ng-if="filter.selectedLabels">
								{{ filter.selectedLabels.join(', ') }}
							</div>

							<!-- Reset range -->
							<div style="flex:1; text-align:right"
								ng-if="(filter.type[0] == 'range' || filter.type[0] == 'date_range') && filter.selected"
								ng-show="!filter.isExternallyControlled()">
								<i class="fa-solid fa-times m-link"
									ng-click="$ctrl.resetFilter(filter); $event.stopPropagation();"
									m-tooltip="'Reset filter'" ng-mouseover="$event.stopPropagation();"></i>
							</div>
						</div>
					</div>
				</div>


				<!-- Table header -->
				<div class="mpg-item-layout mpg-item-layout-header"
					ng-show="!$ctrl.currentItem || $ctrl.isRendering || $ctrl.reRenderingRequired"
				>
					<!-- Optional: labels above the items -->
					<div class="mpg-tile separate-field-labels" mpg-tile-id="labels"
						ng-if="$ctrl.pageData && $ctrl.pageData.length
							&& $ctrl.state.separateFieldLabels && $ctrl.state.layoutMode == 'list'">
						<div ng-repeat="field in $ctrl.state.fields track by field.idx"
							class="mpg-field mpg-label-field" mpg-field-id="{{ ::field.idx }}"
							ng-if="$ctrl.pageMap[0][field.idx].show && !field.hide"
							ng-class="field.classes" ng-style="field.dynamicStyles($ctrl.state.layoutMode, false)">
							<div ng-if="::field.name" class="mpg-field-name"
								m-tooltip="::field.tooltip" ng-bind="::field.name"></div>
						</div>

						<!-- Bookmarker title field -->
						<div class="mpg-field mpg-bookmark-field mpg-label-field"
							ng-if="::($ctrl.state.itemOptions == 'bookmark' && $root.isBookmarkActionAvailable($ctrl.wk))"
							style="width:34px;">
							<div class="mpg-field-name"
								style="width:100%; text-align:center;"
								m-tooltip="$ctrl.wk.mode === 'library'
								? 'Select one or more items to copy, move, or delete.'
								: 'Select one or more items to bookmark to projects.'">
								<i class="fa-solid fa-bookmark"></i>
							</div>
						</div>

							<!-- Custom checkbox field -->
						<div class="mpg-field mpg-bookmark-field mpg-label-field"
							ng-if="::$ctrl.state.checkboxAction"
							style=" width:34px; visibility:hidden; pointer-events:none">
						</div>

						<!-- Custom Item Options dummy -->
						<div class="mpg-field mpg-bookmark-field mpg-label-field"
							ng-if="::$ctrl.state.itemOptions && $ctrl.state.itemOptions != 'bookmark'"
							style="visibility:hidden; pointer-events:none">
							<div class="mpg-field-content">
								<i class="{{::$ctrl.state.itemOptionsIcon || 'fa-solid fa-cog'}} m-link"
									style="font-size:16px"></i>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Item layout ----------------------------------------------------------------------------------------->
			<div class="mpg-item-layout-wrapper">
				<div class="mpg-item-layout"
					ng-style="{
						'grid-template-columns': 'repeat(auto-fill, minmax(' + $ctrl.state.minItemWidth + ', 1fr))'
					}"
					ng-show="!$ctrl.currentItem || $ctrl.isRendering || $ctrl.reRenderingRequired"
					ng-class="{
						'mpg-item-layout-advanced2': $ctrl.state.advancedLayout == 'full',
						'mpg-rows-not-clickable': !$ctrl.state.rowsClickable
					}">

					<!-- Default items -->
					<div ng-if="::!$ctrl.state.itemLink && $ctrl.state.layoutMode != 'grid-column'"
						ng-repeat="item in $ctrl.pageData"
						m-tooltip="$ctrl.state.itemTooltip ? $ctrl.state.itemTooltip(item) : ''"
						class="mpg-tile mpg-clickable" mpg-tile-id="{{ $index }}"
						ng-click="$ctrl.openItem(item, $parent.$index)"
						ng-class="{'mpg-item-seen': item._meta.seen}"
						ng-style="{'pointer-events': $ctrl.state.preventItemClicking ? 'none' : null}"
						style="user-select:none" ng-dragstart="$ctrl.itemDragStart($event, $colIdx, item)"
						ng-drag="$ctrl.itemDrag($event)" ng-dragend="$ctrl.itemDragEnd($event)"
						>` + ITEM_TEMPLATE + `
					</div>

					<!-- Link items -->
					<a ng-if="::$ctrl.state.itemLink && $ctrl.state.layoutMode != 'grid-column'"
						ng-repeat="item in $ctrl.pageData"
						class="mpg-tile mpg-clickable" mpg-tile-id="{{ $index }}"
						href="{{ $ctrl.state.itemLink(item) }}"
						target="{{ $ctrl.state.itemLinkTarget || '_self' }}"
						ng-click="$ctrl.registerItemsSeen([item])"
						ng-class="{'mpg-item-seen': item._meta.seen}"
						draggable="true" ng-dragstart="$ctrl.itemDragStart($event, $colIdx, item)"
						ng-drag="$ctrl.itemDrag($event)" ng-dragend="$ctrl.itemDragEnd($event)"
						>` + ITEM_TEMPLATE + `
					</a>

					<!-- Column -->
					<div class="mpg-item-layout-column"
						ng-if="$ctrl.state.layoutMode == 'grid-column'"
						ng-repeat="column in $ctrl.pageData"
						ng-init="$colIdx = $index"
						ng-style="{
							'grid-template-columns': 'repeat(auto-fill, minmax(' + $ctrl.state.minItemWidth + ', 1fr))'
						}"
						ng-class="{
							'mpg-item-layout-drop-focus': $ctrl.lastDragTargetColumnIdx === $colIdx,
							'mpg-item-layout-drop-focus-before': $ctrl.lastDragTargetBeforeColumnIdx === $colIdx,
							'mpg-item-layout-drop-focus-after': $ctrl.lastDragTargetBeforeColumnIdx === $colIdx+1,
							'mpg-item-layout-col-expanded': $ctrl.expandedColumnIdx === $colIdx,
							'mpg-item-layout-col-collapsed':
								$ctrl.expandedColumnIdx !== null && $ctrl.expandedColumnIdx !== $colIdx,
							'mpg-item-layout-col-is-default': column.isDefault
						}"
						ng-dragover="$ctrl.dragOverColumn($event, $colIdx)"
					>
						<!-- Column header -->
						<div class="mpg-item-layout-column-header m-link m-link-grey"
							tabindex="{{ column.isDefault ? '-1' : '0' }}"
							ng-if="$ctrl.data.length || $ctrl.isRendering || $ctrl.reRenderingRequired"
							draggable="true"
							ng-dragstart="$ctrl.columnDragStart($event, $colIdx)"
							ng-drag="$ctrl.columnDrag($event)"
							ng-dragend="$ctrl.columnDragEnd($event)"
							ng-click="!column.isDefault && $ctrl.clickColumn($colIdx)"
							ng-keydown="$event.key == 'Enter' && !column.isDefault && $ctrl.clickColumn($colIdx)"
							m-tooltip="!column.isDefault ? 'Click to edit. Drag to rearrange.' : null"
						><span class="mpg-item-layout-column-header-name">{{ column.name }}</span>
							<i class="fa-solid fa-pen mpg-item-layout-column-header-edit-icon"></i>
							<!-- "Expand" function has been deactivated
							<i class="fa-regular fa-arrow-alt-circle-left"
								ng-if="$ctrl.expandedColumnIdx === $colIdx"
								tabindex="0"
								title="Collapse column"
								style="position:absolute; left:12px; font-size:24px; top:10px"
							></i>
							<div class="m-button-main m-extra-small"
								ng-if="$ctrl.expandedColumnIdx === $colIdx && !column.isDefault"
								tabindex="0"
								title="Edit column"
								style="position:absolute; right:12px; font-weight:normal; top:10px"
								ng-click="$ctrl.editColumn($event, $colIdx)"
								ng-keydown="$ctrl.editColumn($event, $colIdx)"
							>Edit
							</div>
							-->
						</div>

						<!-- Default items -->
						<div ng-if="::!$ctrl.state.itemLink" ng-repeat="item in column.items track by $index"
							ng-init="$tileIdx = $colIdx + '_' + $index" class="mpg-tile mpg-clickable"
							mpg-tile-id="{{ ::$tileIdx }}"
							ng-click="$ctrl.openItem(item, $tileIdx)"
							draggable="true" ng-dragstart="$ctrl.itemDragStart($event, $colIdx, item)"
							ng-drag="$ctrl.itemDrag($event)" ng-dragend="$ctrl.itemDragEnd($event)"
							>` + COL_ITEM_TEMPLATE + `
						</div>

						<!-- Link items -->
						<a ng-if="::$ctrl.state.itemLink" ng-repeat="item in column.items track by $index"
							ng-init="$tileIdx = $colIdx + '_' + $index" class="mpg-tile mpg-clickable"
							mpg-tile-id="{{ ::$tileIdx }}"
							href="{{ $ctrl.state.itemLink(item) }}"
							target="{{ $ctrl.state.itemLinkTarget || '_self' }}"
							draggable="true" ng-dragstart="$ctrl.itemDragStart($event, $colIdx, item)"
							ng-drag="$ctrl.itemDrag($event)" ng-dragend="$ctrl.itemDragEnd($event)"
							>` + COL_ITEM_TEMPLATE + `
						</a>

						<div class="mpg-item-layout-column-has-more" ng-show="column.hasMoreItems"
							>...</div>

						<!-- Column dropzone overlay -->
						<div class="mpg-item-layout-drop-overlay"
							ng-drop="$ctrl.dropIntoColumn($event, $colIdx)"
							ng-dragleave="$ctrl.dragLeaveColumn($event)"
						></div>

						<!-- Between-columns dropzone overlay -->
						<div class="mpg-item-layout-drop-overlay-before"
							ng-drop="$ctrl.dropBeforeColumn($event, $colIdx)"
							ng-dragleave="$ctrl.dragLeaveBeforeColumn($event)"
							ng-dragover="$ctrl.dragOverBeforeColumn($event, $colIdx)"
						></div>
						<div class="mpg-item-layout-drop-overlay-after"
							ng-if="$colIdx === $ctrl.pageData.length - 1"
							ng-drop="$ctrl.dropBeforeColumn($event, $colIdx+1)"
							ng-dragleave="$ctrl.dragLeaveBeforeColumn($event)"
							ng-dragover="$ctrl.dragOverBeforeColumn($event, $colIdx+1)"
						></div>
					</div>

					<!-- "No results" message -->
					<div ng-if="$ctrl.data && !$ctrl.data.length && !$ctrl.isRendering && !$ctrl.reRenderingRequired"
						style="width: 100%; position: absolute; left: 0; top: 0; height: 100%; flex-direction: column;
						display: flex; justify-content: center; align-items: center;">
						<div style="font-weight:600;">
							No results match the current filters.
						</div>
						<div style="margin-top:8px" ng-if="$ctrl.mainSearch && $ctrl.state.isInspectionShortcutVisible
							&& $ctrl.state.isInspectionShortcutVisible()">
							<div class="m-button-main m-extra-small"
								ng-click="$ctrl.settings.onClickInspectionShortcut($ctrl.mainSearch)">Inspect: <b>{{
								$root.limitString($ctrl.mainSearch, 40)
							}}</b></div>
						</div>
					</div>

					<!-- Overlays -->
					<div class="mpg-busy-layer" ng-if="$ctrl.isRendering || $ctrl.reRenderingRequired">
						<div style="position:relative">
							<i class="fa-solid fa-sync fa-spin fa-2x fa-fw"></i>
						</div>
					</div>
				</div>
			</div>

			<!-- Pagination -->
			<div class="mpg-pagination"
				ng-if="$ctrl.pages && !$ctrl.state.hidePagination && $ctrl.state.layoutMode !== 'grid-column'
					&& !$ctrl.state.useInfiniteScroll"
				ng-show="!$ctrl.currentItem">
				<div ng-click="$ctrl.setCurrentPage($ctrl.currentPage - 1, 'paging')"
					style="font-size:32px" ng-class="{'mpg-disabled': $ctrl.currentPage <= 0}" class="m-link"
					title="Previous page">
					<i class="fa-solid fa-chevron-left"></i>
				</div>

				<div ng-click="$ctrl.setCurrentPage(0, 'paging')" style="font-size:16px;"
					title="First page" ng-class="{'mpg-disabled': $ctrl.currentPage <= 1}" class="m-link">
					<i class="fa-solid fa-angle-double-left"></i>
				</div>

				<div class="mpg-page-number" style="flex:1; text-align:center">{{ $ctrl.getPageInfo() }}</div>

				<!-- dummy -->
				<div style="font-size:16px; visibility:hidden; pointer-events:none" class="m-link">
					<i class="fa-solid fa-angle-double-right"></i>
				</div>

				<div ng-click="$ctrl.setCurrentPage($ctrl.currentPage + 1, 'paging')"
					style="font-size:32px" ng-class="{'mpg-disabled': $ctrl.currentPage + 1 >= $ctrl.pages}"
					class="m-link" title="Next page">
					<i class="fa-solid fa-chevron-right"></i>
				</div>
			</div>

			<!-- "All read" view -->
			<div ng-if="$ctrl.state.useInfiniteScroll && $ctrl.state.itemsSeenRegistrar" class="mpg-allread"
				ng-class="{'mpg-allread-visible': $ctrl.isLastPageAllSeen()}">
				<i class="fa-solid fa-check" style="font-size:90px"></i>
				<div>ALL READ</div>
			</div>

			<!-- Item details view ----------------------------------------------------------------------------------->
			<div class="mpg-details-section mpg-item-layout-advanced2"
				ng-if="$ctrl.currentItem && !$ctrl.isRendering && !$ctrl.reRenderingRequired">
				<!-- Back button -->
				<i class="fa-solid fa-arrow-alt-circle-left mpg-details-back"
					ng-click="$ctrl.closeDetailsView()"
					title="Back to page"></i>

				<!-- Navigation buttons -->
				<div class="table-items-navigation">
					<i class="fa-solid fa-circle-chevron-left" title="Show previous item"
						ng-class="{'disabled': $ctrl.disableNavigation($ctrl.currentItem, 'prev')}"
						ng-click="$ctrl.navigateThroughItems(
							$ctrl.pageData[$ctrl.currentItemIdx - 1], $ctrl.currentItemIdx - 1, 'prev'
						)">
					</i>
					<i class="fa-solid fa-circle-chevron-right" title="Show next item"
						ng-class="{'disabled':  $ctrl.disableNavigation($ctrl.currentItem, 'next')}"
						ng-click="$ctrl.navigateThroughItems(
							$ctrl.pageData[$ctrl.currentItemIdx + 1], $ctrl.currentItemIdx + 1, 'next'
						)">
					</i>
				</div>

				<!-- Headline Fields -->
				<div class="mpg-tile-headline">
					<div ng-repeat="field in $ctrl.state.fields track by field.idx"
						class="mpg-field" mpg-field-id="headline-{{ ::field.idx }}"
						ng-if="$ctrl.pageMap[$ctrl.currentItemIdx][field.idx].show && field.inHeadline"
						ng-class="field.classes" ng-style="field.dynamicStyles('details', true)">
						<div ng-if="::field.name" class="mpg-field-name"
							m-tooltip="::field.tooltip" ng-bind="::field.name"></div>
						<div class="mpg-field-content" ng-if="::!field.newline">
							<div ng-if="!$ctrl.pageMap[$ctrl.currentItemIdx][field.idx].isMissing"
								ng-bind-html="$ctrl.pageMap[$ctrl.currentItemIdx][field.idx].html"></div>
							<div ng-if="$ctrl.pageMap[$ctrl.currentItemIdx][field.idx].isMissing"
								m-tooltip="::$ctrl.missingFieldTooltip" m-tooltip-width="600">-</div>
						</div>
					</div>
				</div>

				<!-- Fields -->
				<div class="mpg-details-fields">
					<div ng-repeat="field in $ctrl.state.fields track by field.idx"
						class="mpg-field" mpg-field-id="{{ ::field.idx }}"
						ng-if="$ctrl.pageMap[$ctrl.currentItemIdx][field.idx].show && !field.inHeadline"
						ng-class="field.classes" ng-style="field.dynamicStyles('details')">
						<div ng-if="::field.name" class="mpg-field-name"
							m-tooltip="::field.tooltip" ng-bind="::field.name"></div>
						<div class="mpg-field-content" ng-if="::!field.newline">
							<div ng-if="!$ctrl.pageMap[$ctrl.currentItemIdx][field.idx].isMissing"
								ng-bind-html="$ctrl.pageMap[$ctrl.currentItemIdx][field.idx].html"></div>
							<div ng-if="$ctrl.pageMap[$ctrl.currentItemIdx][field.idx].isMissing"
								m-tooltip="::$ctrl.missingFieldTooltip" m-tooltip-width="600">-</div>
						</div>
					</div>
				</div>

				<!-- References -->
				<div style="width:100%; margin-top:8px;" ng-if="$ctrl.state.referenceSectionType">
					<reference-section data="$ctrl.currentItem.refsData" wk="$ctrl.wk"
						type="{{ $ctrl.state.referenceSectionType }}"></reference-section>

					<!-- "Load more" button -->
					<div ng-style="{
						'visibility': ($ctrl.currentItem.reachedRefsLimit && !$ctrl.currentItem.reachedMaxRefsLimit && !$ctrl.currentItem.loadingRefs) ? null : 'hidden'
					}"
						class="m-link-default load-more-button" ng-click="$ctrl.currentItem.refsLoaded = false; $ctrl.currentItem.refsLimit = $ctrl.currentItem.refsLimit * 2;
						$ctrl.moduleScope.loadReferencesHTML($ctrl.currentItem, $ctrl.state.referenceSectionType, $ctrl.wk.id);">Load more</div>
				</div>

				<!-- Bookmarker -->
				<div ng-if="::($ctrl.state.itemOptions == 'bookmark' && $root.isBookmarkActionAvailable($ctrl.wk))"
					style="right:0; bottom:0; display:flex; justify-content:flex-end;"
					ng-style="{
						'padding': $ctrl.state.referenceSectionType ? '16px' : null,
						'position': $ctrl.state.referenceSectionType ? 'absolute' : null,
						'min-width': $ctrl.state.referenceSectionType ? null : '100%'
					}">
					<bookmark-action row="$ctrl.currentItem" wk="$ctrl.wk"
						type="'TableRow'" all-data="$ctrl.data"></bookmark-action>
				</div>

				<!-- Custom Item Options dummy -->
				<div ng-if="::$ctrl.state.itemOptions && $ctrl.state.itemOptions != 'bookmark'"
					style="right:0; bottom:0; display:flex; justify-content:flex-end;"
					ng-style="{
						'padding': $ctrl.state.referenceSectionType ? '16px' : null,
						'position': $ctrl.state.referenceSectionType ? 'absolute' : null,
						'min-width': $ctrl.state.referenceSectionType ? null : '100%'
					}">
					<i class="{{::$ctrl.state.itemOptionsIcon || 'fa-solid fa-cog'}}
						m-link" style="font-size:16px" title="{{::$ctrl.state.itemOptionsTooltip || 'Show options'}}"
						ng-click="$ctrl.state.itemOptions($ctrl.currentItem); $event.stopPropagation();
							$event.preventDefault();"
						ng-style="{
							'pointer-events': $ctrl.currentItem.loading ? 'none' : null,
							'opacity': $ctrl.currentItem.loading ? '0.5' : null
						}"></i>
				</div>

				<!-- Overlays -->
				<div class="mpg-tile-overlay mpg-tile-overlay--seen" ng-if="$ctrl.currentItem._meta.seen"></div>
				<div class="mpg-tile-overlay mpg-tile-overlay--highlight"
					ng-if="$ctrl.currentItem._meta.selected"></div>
				<div class="mpg-tile-overlay" ng-if="$ctrl.currentItem.highlightRowColor"
					ng-style="{'background': $ctrl.currentItem.highlightRowColor}"></div>
				<div class="mpg-tile-overlay mpg-tile-overlay--loading" ng-if="$ctrl.currentItem.loading"></div>
			</div>

			<!-- Back button -->
			<div ng-if="$ctrl.currentItem" class="mpg-details-back-footer">
				<div ng-click="$ctrl.closeDetailsView()" class="m-link" title="Back to page">
					<i class="fa-solid fa-arrow-circle-left"></i> back
				</div>
			</div>
		</div>
	`
});

scout.component('confirmDialog', {
	bindings: {
		data: '='
	},
	controller: function ($scope, $element, $sce) {
		this.validate = function (showFeedback = true) {
			if (showFeedback) this.data.error = false;
			let hasError = false;

			if (this.data.fields !== undefined) {
				var that = this;
				this.data.fields.forEach(function (field, idx) {
					if (field.mandatory && (!field.condition || field.condition())) {
						function error () {
							hasError = true;
							if (showFeedback) {
								that.data.error = true;
								field.error = true;
							}
							return false;
						}

						switch (field.type) {
							case 'file':
								if (!field.value || !field.value.files) return error();
								break;
							case 'number':
								if (!field.value && field.value != 0) return error();
								break;
							case 'radio':
								if (!field.value) return error();
								if (
									typeof field.value == 'object'
									&& field.value.choices
									&& !field.value.value
								) return error();
								break;
							case 'checkboxGroup':
								if (field.choices && !field.choices.some(x => x.value)) return error();
								break;
							default:
								if (!field.value) return error();
						}
					}
				});
			}

			return !hasError;
		};
		this.cancel = function () {
			if (this.data.leftButtonCallback) this.data.leftButtonCallback();
			this.close();
		};
		this.close = function () {
			if (this.data.closeCallback) this.data.closeCallback();
			this.data.show = false;
		};
		this.submit = function () {
			if (this.data.closeRight || this.validate()) {
				if (this.data.rightButtonCallback) this.data.rightButtonCallback();
				if (!this.data.preventCloseOnSubmit) this.close();
			}
		};
		this.trustAsHtml = function (html) {
			return $sce.trustAsHtml(html);
		};

		this.getLeftButtonLabel = function () {
			return typeof this.data.leftButtonLabel == 'function'
				? this.data.leftButtonLabel(this.data) : this.data.leftButtonLabel;
		};

		this.getRightButtonLabel = function () {
			return typeof this.data.rightButtonLabel == 'function'
				? this.data.rightButtonLabel(this.data) : this.data.rightButtonLabel;
		};

		this.clickBackground = function (e) {
			if (e && e.currentTarget == e.target && this.data.closeOnBackgroundClick
				&& !(this.data.hideCloseWhenLoading && this.data.loading)) {
				this.cancel();
			}
		};

		this.onNumberChange = function (input) {
			if (!input.allowMissingNumber && input.value === null) {
				input.value = Math.min(Math.max(0, this.min || -Infinity), this.max || Infinity);
			}
		};

		this.getPlaceholder = function (input) {
			return typeof input.placeholder == 'function' ? input.placeholder() : input.placeholder || null;
		};

		this.stripTags = function (html = '') {
			return stripTagsAndUnescapeHTML(html);
		};

		this.callUploadAutomation = async (input) => {
			input._isUploadAutomationBusy = true;
			$scope.$applyAsync();
			await input.automationCallback().catch(() => {
				// Nothing to do here - Catch errors inside automationCallback()!
			});
			input._isUploadAutomationBusy = false;
			$scope.$applyAsync();
		};

		this.callUploadAutomationPromptConfig = async (input) => {
			input.automationPromptConfigCallback(
				() => this.callUploadAutomation(input)
			);
		};

		this.state = false;
		this.init = function () {
			if (this.data && this.data.show && !this.state) {
				// constructor ----------------------------------------------------------------------------------------
				mixpanel.track('Dialog Opened', { dialog_name: this.data.dialogName || this.data.caption || '' });
				disableBodyScrollbar();

				if (this.data.fields) {
					this.customSelectGroups = [];
					for (let field of this.data.fields) {
						// pre-compute groups for custom-select fields (avoid function in ng-repeat)
						if (field.type === 'custom-select' && field.choices) {
							const groupKey = field.choicesGroupKey;
							if (groupKey) {
								const groups = {};
								const order = [];
								field.choices.forEach(function (choice) {
									const group = choice[groupKey] || '';
									if (!groups[group]) {
										groups[group] = [];
										order.push(group);
									}
									groups[group].push(choice);
								});
								this.customSelectGroups.push(order.map(i => ({ label: i, choices: groups[i] })));
							} else {
								this.customSelectGroups.push([{ label: '', choices: field.choices }]);
							}
						} else {
							this.customSelectGroups.push(null);
						}

						// fix angular bug: field.value not initialized correctly
						if (field.type == 'radio' && field.value && field.choices) {
							let idx = field.choices.indexOf(field.value);
							window.setTimeout(function () {
								field.value = field.choices[idx];
							}, 0);
						}
					}
				}

				this.state = true;
				return true;
			} else if (this.data && !this.data.show && this.state) {
				// destructor ----------------------------------------------------------------------------------------
				enableBodyScrollbar();

				this.state = false;
				return false;
			} else if (this.data && this.data.show == this.state) return this.state;
		};
	},
	template: `
		<div class="mpg-modal {{ $ctrl.data.dialogClass || '' }}" style="display: flex" ng-if="$ctrl.init()"
			ng-mousedown="$ctrl.clickBackground($event)">
			<div class="mpg-modal-content mpg-modal-flex-height"
				ng-style="{'max-width': ($ctrl.data.maxWidth || '500px')}">
				<span style="flex:1">
					<i class="fa-solid fa-times mpg-close" aria-hidden="true"
						ng-click="$ctrl.cancel()" ng-if="!($ctrl.data.hideCloseWhenLoading && $ctrl.data.loading)"></i>

					<div class="mpg-modal-title">
						<i class="{{$ctrl.data.iconClass}}" aria-hidden="true" style="margin-right: 8px;"
							ng-if="$ctrl.data.iconClass"></i>
						<svg aria-hidden="true" ng-if="$ctrl.data.svgIcon"
							style="margin-right:8px; width:16px; height:16px; vertical-align:bottom;"
							><use ng-attr-href="{{'#' + $ctrl.data.svgIcon}}"></use></svg>
						{{ $ctrl.data.caption }}
					</div>

					<!-- logs -->
					<div ng-if="$ctrl.data.logs">
						<p ng-repeat="log in $ctrl.data.logs track by $index" ng-bind-html="$ctrl.trustAsHtml(log)"
							style="line-height: 1.4em"></p>
					</div>

					<!-- loader -->
					<div ng-if="$ctrl.data.loading" style="text-align:center;margin:60px 0 40px 0">
						<i class="fa-solid fa-sync fa-spin fa-3x fa-fw"></i>
					</div>

					<form ng-submit="$ctrl.submit();" ng-if="!$ctrl.data.loading">
						<!-- description -->
						<p ng-bind-html="$ctrl.trustAsHtml($ctrl.data.content)"
							ng-if="$ctrl.data.content && (!$ctrl.data.hideContent || !$ctrl.data.hideContent())"
							style="line-height: 1.4em"></p>

						<!-- inputs -->
						<div ng-repeat="input in $ctrl.data.fields"
							ng-if="(input.label || input.type =='output') && (!input.condition || input.condition())"
							ng-style="input.style">
							<div class="label" ng-switch="input.type" ng-if="input.type != 'checkbox'"
								ng-style="{
									'display': input.hide ? 'none' : null,
									'padding-left': input.indent ? '25px' : null
								}">
								<span ng-if="input.label && input.type != 'action'"
									ng-style="{
									'font-weight': input.indent ? 'normal' : null
								}">{{input.label}}{{(input.mandatory) ? '*' : ''}}</span>

								<!-- hints -->
								<a ng-if="input.type != 'action' && input.hint && input.hintLink" href="{{ input.hintLink }}" target="_blank">
									<i class="fa-solid fa-question-circle m-link m-link-black"
										m-tooltip="input.hint" style="margin-left:4px;"></i>
								</a>
								<i class="fa-solid fa-question-circle m-link m-link-black"
									ng-if="input.type != 'action' && input.hint && !input.hintLink"
									m-tooltip="input.hint"
									style="margin-left:4px; cursor:default;"></i>

								<i class="fa-solid fa-paste m-link m-link-black"
									ng-if="input.type != 'action' && input.valueHint && input.valueHint != input.value"
									m-tooltip="'Click to insert your last used value.'"
									style="margin-left:4px; cursor:pointer;"
									ng-click="input.value = input.valueHint">
								</i>

								<div ng-switch-when="radio" style="margin-top: 8px;">
									<label ng-repeat="choice in input.choices" style="font-weight:normal;">
										<input ng-value="choice" ng-model="input.value" type="radio" ng-class="{'has-error': input.error}">
											{{ input.choicesLabelKey ? choice[input.choicesLabelKey] : choice }}{{ choice.choices ? ':' : '' }}<br>
											<select ng-if="choice.choices" ng-model="choice.value" class="level2-select"
												ng-class="{'level2-select-focus': choice == input.value}" ng-change="input.value = choice">
												<option disabled value="">{{ choice.choices.length ? 'Please choose...' : 'Not available.' }}</option>
												<option ng-repeat="choice2 in choice.choices" ng-value="choice2" title="{{ choice2.description || '' }}">
													{{ choice.choicesLabelKey ? choice2[choice.choicesLabelKey] : choice2 }}
												</option>
											</select>
									</label>
								</div>
								<div ng-switch-when="select">
									<select ng-model="input.value" ng-class="{'has-error': input.error}">
										<option disabled value="">{{ input.choices.length ? 'Please choose...' : 'Not available.' }}</option>
										<option ng-repeat="choice in input.choices" ng-value="choice"
											ng-if="!choice.condition || choice.condition()">
											{{ input.choicesLabelKey ? choice[input.choicesLabelKey] : choice }}
										</option>
									</select>
								</div>
								<div ng-switch-when="custom-select"
									style="display:flex; align-items:center; position:relative;">
									<label class="input-label" style="width: 100%; margin: 0;">
										<select style="width: 100%;" ng-model="input.value"
											ng-class="{'has-error': input.error}">
										<optgroup ng-repeat="group in $ctrl.customSelectGroups[$index]"
											label="{{ group.label }}">
												<option ng-repeat="choice in group.choices track by $index"
													ng-value="choice"
													title="{{ $ctrl.stripTags(choice.description) }}">
													{{ input.choicesLabelKey ? choice[input.choicesLabelKey] : choice }}
												</option>
											</optgroup>
										</select>

										<!-- Custom visible placeholder to simulate selected <option> text -->
										<div class="custom-select-overlay-container" ng-if="input.value">
												{{ input.value[input.choicesGroupKey] }}
												<i class="fas fa-chevron-right"
													style="font-size: 14px; margin: 0 4px;"></i>
												{{ input.choicesLabelKey
													? input.value[input.choicesLabelKey]
													: input.value }}
										</div>
									</label>
								</div>
								<input ng-switch-when="text" ng-model="input.value" type="text"
									ng-pattern="input.pattern" ng-class="{'has-error': input.error}">
								<div ng-switch-when="file" style="display:flex; align-items:center; margin-top:10px">
									<label class="m-button-main m-small"
										ng-style="{
											'visibility': input._isUploadAutomationBusy ? 'hidden' : null,
											'pointer-events': input._isUploadAutomationBusy ? 'none' : null
										}"
										style="white-space:nowrap; font-weight:normal; width:auto; margin:0"
										>Select File
										<input ng-file-model="input.value" accept="{{input.fileAccept}}"
											id="dialog-file-input"
											ng-click="input.onOpenUploadDialog && input.onOpenUploadDialog()"
											type="file" ng-class="{'has-error': input.error}" style="display:none">
									</label>
									<div style="flex:1"></div>

									<!-- Automation Menu -->
									<div class="mpg-modal-action-menu">
										<!-- Automation Submenu -->
										<span class="mpg-modal-action-submenu">
											<i ng-if="input.automationCallback && input.automationPromptConfigCallback
												&& !input._isUploadAutomationBusy"
												style="margin-left:12px; font-size:18px; margin-top:2px"
												title="{{ input.automationPromptConfigTooltip }}"
												class="fa-solid fa-terminal m-link-ai"
												ng-click="$ctrl.callUploadAutomationPromptConfig(input);
													$event.preventDefault();"></i>
										</span>

										<!-- Automation Main Action -->
										<svg class="m-link-ai"
											ng-if="input.automationCallback && !input._isUploadAutomationBusy"
											ng-click="$ctrl.callUploadAutomation(input); $event.preventDefault();"
											style="margin-left:12px; width:20px; height:20px;"
										><title>{{ input.automationTooltip }}</title
											><use xlink:href="#icons--assistant-custom"></use></svg>
										<div ng-if="input.automationCallback && input._isUploadAutomationBusy"
											style="margin-left:12px; font-size:18px;">
											<i class="fa-solid fa-sync fa-spin fa-fw"></i>
										</div>
									</div>
								</div>
								<textarea ng-switch-when="textarea" ng-model="input.value"
									ng-class="{'has-error': input.error}"
									maxlength="{{ input.maxLength || null }}"
									style="max-width:100%; min-width:100%;
										min-height:{{ input.minHeight || '80' }}px !important"></textarea>
								<input ng-switch-when="date" ng-model="input.enabled" type="checkbox"
									style="vertical-align:bottom; margin-left:8px;"
									ng-if="!input.mandatory && input.showToggle">
								<input ng-switch-when="date" type="date" ng-model="input.value"
									min="{{input.minDate}}" max="{{input.maxDate}}" style="margin-top:12px"
									ng-class="{'has-error': input.error}"
									ng-if="input.enabled || input.mandatory || !input.showToggle">

								<input ng-switch-when="number" ng-model="input.enabled" type="checkbox"
									style="vertical-align:bottom; margin-left:8px;"
									ng-if="!input.mandatory && !input.allowMissingNumber">
								<input ng-switch-when="number" type="number" ng-model="input.value"
									min="{{input.min}}"  max="{{input.max}}" step="{{input.step || 1}}"
									style="margin-top:12px" ng-class="{'has-error': input.error}"
									placeholder="{{ $ctrl.getPlaceholder(input) }}"
									ng-change="$ctrl.onNumberChange(input)"
									onchange="if (this.value === '' || this.value === null) return;
										this.value = Math.max((
											this.step == parseInt(this.step) ? parseInt(this.value) || 0 : this.value
										),this.min || -Infinity);
										this.value = Math.min((
											this.step == parseInt(this.step) ? parseInt(this.value) || 0 : this.value
										),this.max || Infinity)"
									 ng-if="input.enabled || input.mandatory || input.allowMissingNumber">
								<div ng-switch-when="range" style="display: flex; margin-top:12px; gap:8px;">
									<span style="font-weight:normal;">
										{{ input.rangeLabel(input.min) || '0%'}}
									</span>
									<input type="range" min="{{ input.min || 0 }}" max="{{ input.max || 1 }}" step="any"
										ng-model="input.value"
										m-tooltip="input.rangeLabel(input.value)"
										style="flex: 1; cursor:pointer;">
									<span style="font-weight:normal;">
										{{ input.rangeLabel(input.max) || '100%'}}
									</span>
								</div>

								<!-- actions -->
								<div ng-switch-when="action" ng-if="input.action && !input.link" class="m-link-main"
									ng-click="input.keepOpenOnAction ? null : $ctrl.close(); input.action();"
									style="display:inline-block; font-size:18px; font-weight:600"
									m-tooltip="input.actionTooltip"
									ng-style="input.nestedDialogsReturnButton
										? {'color': 'black','font-size': '20px'}
										: {}">
									<i class="{{ input.iconClass || 'fa-solid fa-arrow-right'}}"
										ng-class="{'nested-dialog-return-button': input.nestedDialogsReturnButton}"
										style="margin-right:12px;"></i>{{ input.label }}
								</div>
								<a ng-switch-when="action" ng-if="input.link && !input.action" class="m-link-main"
									href="{{ input.link }}"
									style="display:inline-block; font-size:18px; font-weight:600">
									<i class="{{ input.iconClass || 'fa-solid fa-arrow-right'}}"
										style="margin-right:12px;"></i>{{ input.label }}
								</a>

								<div ng-switch-when="output" ng-bind-html="$ctrl.trustAsHtml(input.output())"
									style="{{ input.label ? 'margin-top:12px;' : '' }} font-weight:normal; line-height:1.5em; font-size:14px;
									{{ input.noStyle ? '' : 'color:var(--mpg-color-main); border:thin solid var(--mpg-color-main); padding: 4px 12px;'}}"></div>

								<i class="fa-solid fa-power-off m-link m-link-black"
									ng-if="input.type == 'action' && input.deactivateAction"
									title="{{ input.deactivateActionTitle || '' }}"
									style="margin-left:12px; cursor:pointer;" ng-click="$ctrl.close();
									input.deactivateAction();">
								</i>

								<i class="{{ input.deleteIconClass || 'fa-regular fa-trash-alt'}} m-link m-link-black"
									ng-if="input.type == 'action' && input.deleteAction
										&& (!input.deleteShowCondition || input.deleteShowCondition())"
									title="{{ input.deleteActionTitle || '' }}"
									style="margin-left:12px; cursor:pointer;"
									ng-click="input.keepOpenOnDeleteAction ? null : $ctrl.close(); input.deleteAction();">
								</i>

								<!-- hints -->
								<a ng-if="input.type == 'action' && input.hint && input.hintLink" href="{{ input.hintLink }}" target="_blank">
									<i class="fa-solid fa-question-circle m-link m-link-black" m-tooltip="input.hint" style="margin-left:4px;"></i>
								</a>
								<i class="fa-solid fa-question-circle m-link m-link-black"
									ng-if="input.type == 'action' && input.hint && !input.hintLink"
									m-tooltip="input.hint"
									style="margin-left:4px; cursor:default;"></i>

								<span ng-if="input.error && input.type!='radio' && !input.hideValidityCheck"
									ng-class="{'has-error-msg': input.error}">This field is mandatory.</span>
								<span ng-if="input.error && input.type=='radio' && !input.hideValidityCheck"
									ng-class="{'has-error-msg': input.error}">Please make a choice.</span>
							</div>
							<div ng-if="input.type == 'checkboxGroup'">
								<div ng-repeat="choice in input.choices" style="margin-bottom:16px;">
									<label style="display: flex; align-items: center; gap: 5px; cursor:pointer;">
										<input type="checkbox" ng-model="choice.value"
											ng-change="input.onChange && input.onChange()"
											ng-class="{'has-error': input.error}" style="vertical-align:bottom">
										<span style="font-weight:normal">{{ choice.label }}</span>
									</label>
								</div>
							</div>
							<div ng-if="input.type == 'checkbox'"
								ng-style="{ 'padding-left': input.indent ? '25px' : null }">
								<label style="display:inline-block; width:auto" class="noselect">
									<input ng-model="input.value" type="checkbox" ng-class="{'has-error': input.error}"
										ng-change="input.onChange && input.onChange()"
										style="vertical-align:bottom">
									<span style="font-weight:normal">{{input.label}}{{(input.mandatory) ? '*' : ''}}</span>
								</label>

								<!-- hints -->
								<a ng-if="input.hint && input.hintLink" href="{{ input.hintLink }}" target="_blank">
									<i class="fa-solid fa-question-circle m-link m-link-black" m-tooltip="input.hint" style="margin-left:4px;"></i>
								</a>
								<i class="fa-solid fa-question-circle m-link m-link-black"
									ng-if="input.hint && !input.hintLink" m-tooltip="input.hint"
									style="margin-left:4px; cursor:default;"></i>

								<span ng-if="input.error && input.type!='radio'" ng-class="{'has-error-msg': input.error}"
									style="margin-left:8px;">This field is mandatory.</span>
							</div>
						</div>

						<!-- remark -->
						<p style="line-height: 1.4em;" ng-if="$ctrl.data.remark">
							<small ng-bind-html="$ctrl.trustAsHtml($ctrl.data.remark)"></small>
						</p>

						<!-- confirmation buttons -->
						<p style="margin-top: 1.4em; margin-bottom: 0px; display: flex" ng-if="!$ctrl.data.hideButtons">
							<button type="button" class="m-button m-small" style="width: calc(50% - 2px);margin-right:4px;
								visibility:{{$ctrl.data.closeRight ? 'hidden' : 'visible'}};" ng-click="$ctrl.cancel()">
								{{ $ctrl.getLeftButtonLabel() || 'Cancel' }}
							</button><button class="m-button-main m-small" id="mpg-confirm-dialog-btn" type="button"
							ng-disabled="!$ctrl.validate(false)
								|| $ctrl.data.disableRightButton && $ctrl.data.disableRightButton()"
								style="width: calc(50% - 2px)" ng-click="$ctrl.submit();">
								{{ $ctrl.getRightButtonLabel() || 'OK' }}
							</button>
						</p>
					</form>
				</span>
				<div ng-if="$ctrl.data.footerHTML" ng-bind-html="$ctrl.trustAsHtml($ctrl.data.footerHTML)"
					class="mpg-modal-footer"></div>
			</div>
		</div>
	`
});

// allow to use 'ng-file-model'
scout.directive("ngFileModel", [function () {
	return {
		scope: {
			ngFileModel: "="
		},
		link: function (scope, element, attributes) {
			element.bind("change", function (changeEvent) {
				if (!changeEvent.target.files[0]) return false;
				scope.$apply(function () {
					scope.ngFileModel = {
						files: changeEvent.target.files
					};
				});
			});
		}
	}
}]);

scout.component('selectDialog', {
	bindings: {
		data: '='
	},
	controller: function ($scope, $element, $sce, $rootScope) {
		let self = this;
		this.validate = function () {
			let error = false;

			function isItemSelected () {
				if (self.treeData.length) {
					let tree = $('#modal-jstree').jstree(true);
					if (tree) {
						let allNodes = tree.get_json('#', { 'flat': true });
						for (let n of allNodes) {
							if (n.state.selected) return true;
						}
					}
				}
				return false;
			}

			function hasUniquePresetName (value) {
				if (self.data.originalPresetName && value == self.data.originalPresetName) return true;
				else return !Object.keys(MPG.CUSTOM_COUNTRIES_PRESETS || {}).includes(value);
			};

			if (this.data.mandatoryExtraInput
				&& (!this.data.mandatoryExtraInputValue || !hasUniquePresetName(this.data.mandatoryExtraInputValue))) {
				error = true;
			}

			if (!this.data.allowNoSelection && !isItemSelected()) error = true;
			return !error;
		};
		this.close = function () {
			this.data.show = false;
		};
		this.cancel = function () {
			if (this.data.leftButtonCallback) {
				this.data.leftButtonCallback();
			}
			this.close();
		};
		this.submit = function () {
			if (this.validate()) {
				// apply selection
				if (this.treeData.length) {
					let tree = $('#modal-jstree').jstree(true);
					if (tree) {
						let allNodes = tree.get_json('#', { 'flat': true });
						for (let i of this.data.items) i.selected = false;
						for (let n of allNodes) {
							if (n.state.selected) {
								let id = tree.get_node(n.id).original.item_data.id;
								for (let i of this.data.items) {
									if (i.id == id) {
										i.selected = true;
										break;
									}
								}
							}
						}
					}
				}

				// select items
				if (!this.data.returnAllItems) this.data.items = this.data.items.filter(x => x.selected);
				if (!this.data.multiselect && !this.data.allowNoSelection) this.data.items = this.data.items[0];

				this.data.rightButtonCallback();
				this.close();
			}
		};
		this.trustAsHtml = function (html) {
			return $sce.trustAsHtml(html);
		};

		this.applySearch = function () {
			this.isSearchLoading = true;
			$scope.$applyAsync();
			let latestSearch = (new Date()).getTime();
			this.latestSearch = latestSearch;
			window.setTimeout(function () {
				if (latestSearch != self.latestSearch) return;
				let tree = $('#modal-jstree').jstree(true);
				let allNodes = tree.get_json('#', { 'flat': true });

				if (self.search == '') {
					// reset
					for (let node of allNodes) {
						tree.show_node(node, true);
					}
				} else {
					// show matching nodes
					for (let node of allNodes) {
						if (tree.get_node(node).original.search_text.includes(self.search.toLowerCase())) {
							tree.show_node(node, true);
						} else {
							tree.hide_node(node, true);
						}
					}
				}
				tree.redraw(true);
				self.isSearchLoading = false;
				$scope.$applyAsync();
			}, 500);
		};

		this.constructTree = function () {
			let treeData = [];
			for (let i of self.data.items) {
				let title = stripTagsAndUnescapeHTML(i.title);
				let itemText = title;

				// Add icon for patent offices
				if (i.type === 'patent office') {
					itemText = '<i style="font-size:15px; margin:0 5px;" class="fa-solid fa-building-columns"></i>'
						+ itemText;
				}

				// show percentage
				if ('percent' in i) {
					let percLabel = '' + Math.round(i.percent);
					if (percLabel == '0') percLabel = '< 1';
					itemText = '<div class="m_percentage_bar_container list-percent-bar" style="margin:0 9px 0 4px;">'
						+ '<div class="m_percentage_bar" style="width:' + i.percent + '%"></div>'
						+ '<span class="m_percentage_bar_label">' + percLabel + ' %</span>'
						+ '</div>' + itemText;
				}

				// prepare tree item
				treeData.push({
					text: itemText,
					state: {
						selected: i.selected
					},
					item_data: i,
					search_text: title.toLowerCase(),
					...(i.percent ? { percent: Math.round(i.percent) } : {})
				});
			}
			self.treeData = treeData;

			window.setTimeout(function () {
				// create tree
				$("#modal-jstree").jstree('destroy');
				$('#modal-jstree').jstree({
					core: {
						data: treeData,
						multiple: self.data.multiselect ? true : false,
						check_callback: true, // Required for modifications
					},
					types: {
						default: {
							icon: false
						}
					},
					checkbox: {
						three_state: false
					},
					plugins: ["types", "checkbox", "dnd"]
				}).on("select_node.jstree deselect_node.jstree", function () {
					if (self.data.presetSection) self.updateSelectedPresetsState();
				}).on('changed.jstree', function (e, data) {
					$scope.$applyAsync();
				}).on('ready.jstree', function () {
					if (self.data.presetSection && self.data.items.some(item => item.selected)) {
						self.updateSelectedPresetsState();
					}
				});
				$scope.$applyAsync();
			});
		};

		this.sortTreeAfterInsertion = function (tree) {
			let nodes = tree.get_node('#').children
				.map(id => tree.get_node(id))
				.sort((a, b) => {
					const aPercent = a.original.percent;
					const bPercent = b.original.percent;

					// Both have percent → descending, equal keeps original order
					if (aPercent !== undefined && bPercent !== undefined) {
						return bPercent - aPercent;
					}

					// Only one has percent → it comes first
					if (aPercent !== undefined) return -1;
					if (bPercent !== undefined) return 1;

					// Neither has percent → sort alphabetically by search_text
					const textA = (a.original.search_text || '').toLowerCase();
					const textB = (b.original.search_text || '').toLowerCase();
					return textA.localeCompare(textB);
				});

			nodes.forEach((node, index) => {
				tree.move_node(node, '#', index);
			});
		}

		// Presets -----------------------------------------------------------------------------------------------------
		this.countryPresets = null;
		this.maxPresetsDisplayed = 11;
		this.displayedCountryPresets = null;
		this.presetsExpanded = false;

		// Initialize county presets
		this.initializeCountryPresets = function () {
			let includePatentOffices = self.data.presetSection.include_patent_office;

			// Regional patents offices only added in the patents panel
			let patentOfficeCodes = includePatentOffices ? null : new Set(Object.keys(regionalPatentOffices));
			let customPresets = {};
			let userPresets =
				(typeof MPG.CUSTOM_COUNTRIES_PRESETS !== 'undefined' && MPG.CUSTOM_COUNTRIES_PRESETS) || {};
			for (let [preset, codes] of Object.entries(userPresets)) {
				if (patentOfficeCodes) customPresets[preset] = codes.filter(code => !patentOfficeCodes.has(code));
				else customPresets[preset] = codes;
			}

			// Get sorted default presets, filter out keys that already exist in customPresets.
			let defaultPresets = $rootScope.getDefaultPresets(includePatentOffices);
			let filteredDefaultPresets = Object.fromEntries(
				Object.entries(defaultPresets).filter(([preset]) => !(preset in customPresets))
			);

			// Sort customPresets keys alphabetically
			let sortedCustomPresets = Object.fromEntries(
				Object.entries(customPresets).sort(([a], [b]) => a.localeCompare(b))
			);
			let mergedPresets = {
				...sortedCustomPresets,
				...filteredDefaultPresets
			};
			self.countryPresets = Object.entries(mergedPresets).map(([presetName, codes]) => ({ presetName, codes }));

			self.presetsExpanded = false;
			self.displayedCountryPresets = self.getDisplayedPresets();
		};
		this.expandCountryPresets = () => {
			self.presetsExpanded = true;
			self.displayedCountryPresets = self.countryPresets;
		}
		this.collapseCountryPresets = () => {
			self.presetsExpanded = false;
			self.displayedCountryPresets = self.getDisplayedPresets();
		}
		this.canCollapse = function () {
			if (!self.presetsExpanded) return false;
			const selectedKeys = new Set(Object.keys(self.data.selectedPresets || {}));
			return self.countryPresets
				.slice(self.maxPresetsDisplayed)
				.some(p => !selectedKeys.has(p.presetName));
		};

		this.getDisplayedPresets = function () {
			if (!self.countryPresets) return [];

			let base = self.countryPresets.slice(0, self.maxPresetsDisplayed);

			if (!self.data.selectedPresets) return base;

			let selectedKeys = new Set(Object.keys(self.data.selectedPresets));
			let selected = self.countryPresets.filter(p => selectedKeys.has(p.presetName));

			let combined = [...base];
			selected.forEach(preset => {
				if (!combined.some(c => c.presetName === preset.presetName)) {
					combined.push(preset);
				}
			});

			return combined;
		};

		this.togglePresets = function (ids, select) {
			let tree = $('#modal-jstree').jstree(true);
			let allNodes = tree.get_json('#', { flat: true });
			let existingIds = new Set(allNodes.map(n => tree.get_node(n.id).original.item_data.id));
			let nodesAdded = false;

			if (!self.data.selectedPresets) self.data.selectedPresets = {};

			for (const id of ids) {
				if (existingIds.has(id)) {
					// If already in tree, find the node and select/deselect it
					const existingNode = allNodes.find(n => tree.get_node(n.id).original.item_data.id === id);
					tree.open_node(existingNode, false, false);
					if (existingNode && !tree.is_disabled(existingNode)) {
						if (select) tree.select_node(existingNode, true, true);
						else tree.deselect_node(existingNode);
					}
				} else {
					// Otherwise, create a new node and select it
					let country = getCountryOrPatentOfficeByCode(id);
					let countryTitle = stripTagsAndUnescapeHTML(country.name || id);
					let itemText = countryTitle;
					if (country.type === 'patent office') {
						itemText = '<i style="font-size:15px; margin:0 5px;" class="fa-solid fa-building-columns"></i>'
							+ itemText;
					}
					const newNode = {
						text: itemText,
						state: {
							selected: false
						},
						item_data: { id: id },
						search_text: countryTitle.toLowerCase()
					};
					// Create the node and then select it if needed
					tree.create_node('#', newNode, 'last', function (node) {
						tree.open_node(node);
						if (!tree.is_disabled(node) && select) tree.select_node(node, true, true);
					});
					self.data.items.push({
						id: id,
						selected: true,
						title: htmlEscape(countryTitle),
						...(country.type ? { type: country.type } : {})
					})
					nodesAdded = true;
				}
			}

			// Sort all nodes after all insertions
			if (nodesAdded) self.sortTreeAfterInsertion(tree);
		}

		this.updateSelectedPresetsState = function () {
			const tree = $('#modal-jstree').jstree(true);
			const selectedIds = new Set(tree.get_selected().map(id => tree.get_node(id).original.item_data.id));

			const presets = self.countryPresets;
			if (!self.data.selectedPresets) self.data.selectedPresets = {};
			for (let { presetName, codes } of presets) {
				const allSelected = codes.every(code => selectedIds.has(code));
				if (allSelected) self.data.selectedPresets[presetName] = true;
				else delete self.data.selectedPresets[presetName];
			}

			if (self.data.selectedPresets && !self.presetsExpanded) {
				self.displayedCountryPresets = self.getDisplayedPresets();
			}

			$scope.$applyAsync();
		};

		// -------------------------------------------------------------------------------------------------------------

		this.selectAll = function () {
			let tree = $('#modal-jstree').jstree(true);
			let allNodes = tree.get_json('#', { 'flat': true });
			for (let node of allNodes) {
				tree.open_node(node, false, false);
				if (!tree.is_disabled(node)) tree.select_node(node, true, true);
			}
			tree.redraw(true);
		};

		this.clearAll = function () {
			let tree = $('#modal-jstree').jstree(true);
			let allNodes = tree.get_json('#', { 'flat': true });
			for (let node of allNodes) {
				if (tree.is_open(node)) {
					tree.close_node(node, false, false);
				}
				if (!tree.is_disabled(node)) {
					tree.deselect_node(node);
				}
			}
			tree.redraw(true);
		};

		this.state = false;
		this.init = function () {
			if (this.data && this.data.show && !this.state) {
				// constructor ----------------------------------------------------------------------------------------
				mixpanel.track('Dialog Opened', { dialog_name: this.data.dialogName || this.data.caption || '' });

				if (!this.data.new) this.data.new = {};
				this.state = true;
				this.search = '';
				this.isSearchLoading = false;
				disableBodyScrollbar();
				if (this.data.presetSection) this.initializeCountryPresets();
				if (this.data.items && this.data.items.length) this.constructTree();
				// allow to update the view - use when loading data asynchronously
				this.data.showData = (items) => {
					self.data.loading = false;
					$scope.$applyAsync();
					setTimeout(() => {
						self.data.items = items;
						self.constructTree();
					});
				}
				return true;
			} else if (this.data && !this.data.show && this.state) {
				// destructor ----------------------------------------------------------------------------------------
				enableBodyScrollbar();

				this.state = false;
				return false;
			} else if (this.data && this.data.show == this.state) return this.state;
		};
	},
	template: `
		<div class="mpg-modal {{ $ctrl.data.modalClass }}" style="display: flex" ng-if="$ctrl.init()">
			<div class="mpg-modal-content">
				<i class="fa-solid fa-times mpg-close" aria-hidden="true" ng-click="$ctrl.cancel()"></i>
				<span>
					<div class="mpg-modal-title">
						<i class="{{$ctrl.data.iconClass || 'fa-solid fa-tasks'}}" style="margin-right: 8px;"></i>
						{{ $ctrl.data.caption }}
					</div>

					<!-- description -->
					<div ng-if="$ctrl.data.description">
						<p style="line-height: 1.4em">{{ $ctrl.data.description }}</p>
					</div>

					<!-- loader -->
					<div ng-if="$ctrl.data.loading" style="text-align:center;margin:60px 0 40px 0">
						<i class="fa-solid fa-sync fa-spin fa-3x fa-fw"></i>
					</div>

					<form ng-submit="" ng-if="!$ctrl.data.loading">
						<p ng-bind-html="$ctrl.trustAsHtml($ctrl.data.content)" ng-if="$ctrl.data.content"
							style="margin-bottom:16px; line-height: 1.4em"></p>

						<span ng-if="$ctrl.data.mandatoryExtraInput" style="font-weight:bold;">
							{{ $ctrl.data.mandatoryExtraInput }}*
						</span>
						<div ng-if="$ctrl.data.mandatoryExtraInput"
							style="display:flex; align-items:center; margin-bottom:8px;">
							<!-- extra input -->
							<div style="position:relative; flex:1;">
								<input type="text" ng-model="$ctrl.data.mandatoryExtraInputValue"
									ng-class="{'has-error': input.error}">
							</div>
						</div>

						<span ng-if="$ctrl.data.addSearchLabel" style="font-weight:bold;">
							{{ $ctrl.data.addSearchLabel }}*
						</span>
						<div style="display:flex; align-items:center">
							<!-- search -->
							<div style="position: relative; flex:1" ng-if="$ctrl.treeData.length">
								<i style="position:absolute; right:9px; top:23px; color: var(--mpg-color-main)" ng-if="$ctrl.isSearchLoading">
									<i class="fa-solid fa-sync fa-spin fa-1x fa-fw"></i>
								</i>
								<input type="text" placeholder="Search..." ng-model="$ctrl.search" ng-change="$ctrl.applySearch()">
							</div>

							<!-- clear all -->
							<div class="m-link" ng-if="$ctrl.data.clearAllEnabled"
								style="margin-left:8px; margin-top:4px; white-space:nowrap; font-size:13px;"
								ng-click="$ctrl.clearAll()">Clear all</div>

							<!-- select all -->
							<div class="m-link" ng-if="$ctrl.data.allowSelectAll"
								style="margin-left:8px; margin-top:4px; white-space:nowrap; font-size:13px;" ng-click="$ctrl.selectAll()">Select all</div>
						</div>

						<!-- item tree -->
						<div style="max-height: 270px; overflow-y: auto; padding: 0;" ng-show="$ctrl.treeData.length">
							<div id="modal-jstree" style="width:calc(100% - 5px);"></div>
						</div>
						<!-- "empty" message -->
						<div ng-if="!$ctrl.treeData.length" style="font-style:italic;color:var(--mpg-color-mid-grey);margin-bottom:12px;margin-left:34px;">
							<div>{{ $ctrl.data.customNoDataMessage ? $ctrl.data.customNoDataMessage : 'No data available.' }}</div>
						</div>

						<!-- spacer -->
						<div style="height:0.6em"></div>

						<div ng-if="$ctrl.treeData.length && $ctrl.data.presetSection"
							class="countries-presets-container" style= "margin-bottom:10px;">
							<span style="font-weight:bold;">Preset:</span>
							<span ng-repeat="presetObj in $ctrl.displayedCountryPresets"
								class="m-button-secondary m-extra-small"
								m-tooltip="$root.getPresetTooltip(presetObj.codes)"
								ng-click="$ctrl.data.selectedPresets[presetObj.presetName]
									= !$ctrl.data.selectedPresets[presetObj.presetName];
									$ctrl.togglePresets(
										presetObj.codes, $ctrl.data.selectedPresets[presetObj.presetName]
									);"
								ng-class="{'selected': $ctrl.data.selectedPresets[presetObj.presetName]}">
								{{ presetObj.presetName }}
							</span>

							<!-- Show more -->
							<span ng-if="$ctrl.countryPresets.length > $ctrl.displayedCountryPresets.length"
								class="m-button-secondary m-extra-small"
								ng-click="$ctrl.expandCountryPresets()" style="cursor: pointer;"
								ng-keydown="$event.key == 'Enter' && $ctrl.expandCountryPresets()" tabindex="0">
								...
							</span>

							<!-- Show less -->
							<span ng-if="$ctrl.canCollapse()"
								class="m-link show-less-button" ng-click="$ctrl.collapseCountryPresets()" tabindex="0"
								ng-keydown="$event.key == 'Enter' && $ctrl.collapseCountryPresets()">
								<i class="fa-solid fa-arrow-left-long"></i>
								Show Less
							</span>

							<a style="padding-left:5px;" href="account#presets" target="_blank">
								<i class="fa-solid fa-pen"></i>
							</a>
						</div>

						<!-- actions -->
						<div ng-repeat="input in $ctrl.data.fields" ng-if="!input.condition || input.condition()">
							<label ng-switch="input.type">
								<!-- actions -->
								<div ng-switch-when="action" ng-if="input.action && !input.link" class="m-link-main"
									ng-click="input.keepOpenOnAction ? null : $ctrl.close(); input.action();"
									style="display:inline-block; font-size:18px; font-weight:600">
									<i class="{{ input.iconClass || 'fa-solid fa-arrow-right'}}"
										ng-if="!input.hideIcon"
										style="margin-right:12px;"></i>{{ input.label }}
								</div>
								<a ng-switch-when="action" ng-if="input.link && !input.action" class="m-link-main"
									href="{{ input.link }}"
									style="display:inline-block; font-size:18px; font-weight:600">
									<i class="{{ input.iconClass || 'fa-solid fa-arrow-right'}}"
										ng-if="!input.hideIcon"
										style="margin-right:12px;"></i>{{ input.label }}
								</a>

								<!-- hints -->
								<a ng-if="input.type == 'action' && input.hint && input.hintLink"
									href="{{ input.hintLink }}" target="_blank">
									<i class="fa-solid fa-question-circle m-link
										m-link-black" m-tooltip="input.hint" style="margin-left:4px;">
									</i>
								</a>
								<i class="fa-solid fa-question-circle m-link m-link-black" m-tooltip="input.hint"
									ng-if="input.type == 'action' && input.hint && !input.hintLink"
									style="margin-left:4px; cursor:default;"></i>
							</label>
						</div>

						<p style="margin-top: 0.8em; margin-bottom: 0px;">
							<button type="button" class="m-button m-small" style="width: calc(50% - 2px);margin-right:4px;"
								ng-click="$ctrl.cancel()">
								Cancel
							</button><button class="m-button-main m-small" id="mpg-confirm-dialog-btn" type="button"
								style="width: calc(50% - 2px)" ng-click="$ctrl.submit();" ng-disabled="!$ctrl.validate()">
								{{ $ctrl.data.rightButtonLabel || 'OK' }}
							</button>
						</p>
					</form>
				</span>
			</div>
		</div>
	`
});

scout.component('selectProjectsDialog', {
	bindings: {
		data: '='
	},
	controller: function ($scope, $element, $sce, $rootScope) {
		let self = this;

		// Keep the folder row highlight synchronized with its checked or indeterminate checkbox state.
		function syncRefinementFolderSelection (tree, folder) {
			folder = tree.get_node(folder);
			if (!folder || folder.original.page_meta.item_type !== 'FOLDER') return;
			if (tree.is_checked(folder) || tree.is_undetermined(folder)) {
				tree.select_node(folder, true, true);
			} else {
				tree.deselect_node(folder, true);
			}
		}

		this.validate = function () {
			let error = false;

			if (this.data.new && this.data.new.selected && !this.data.hideNewProjectOption) {
				if (this.data.new.title === undefined ||
					!this.data.new.title.value) {
					error = true;
					this.data.new.title = {
						error: true
					};
					return false;
				}
			}

			// Scrolling to preselected node while dragging and dropping projects.
			if (self.data.preselect) {
				$('#modal-jstree').on('ready.jstree', function () {
					let tree = $('#modal-jstree').jstree(true);
					if (tree) {
						let allNodes = tree.get_json('#', { 'flat': true });
						let preselectedNode = allNodes.find(
							node => tree.get_node(node.id).original.page_meta.id === self.data.preselect
						);
						if (preselectedNode) {
							// Scroll to preselected node
							document.getElementById(preselectedNode.id).scrollIntoView();
						}
					}
				});
			}

			function isProjectSelected () {
				if (self.treeData && self.treeData.length) {
					let tree = $('#modal-jstree').jstree(true);
					if (tree) {
						var allNodes = tree.get_json('#', { 'flat': true });
						for (let n of allNodes) {
							let node = tree.get_node(n.id);
							if (self.data.refineProjectSelection) {
								if (node.original.page_meta.item_type == 'FOLDER'
									&& (tree.is_checked(node) || tree.is_undetermined(node))) return true;
							} else if (n.state.selected && (node.original.page_meta.item_type != 'FOLDER'
								|| self.data.dialogSubtype == 'SELECT_FOLDER')) {
								return true;
							}
						}
					}
				}
				if (self.data.dropdownFolders && !self.configureMode) {
					if (self.data.hideNewProjectOption) return true;
					else self.data.new.selected = true;
				}
				if (self.data.new.selected && !self.data.hideNewProjectOption) return true;
				if (self.data.offerCurrentPage || self.data.offerLastBookmarkTarget || self.data.offerSourcePage) {
					return true;
				}
				return false;
			}

			if (!isProjectSelected()) error = true;
			return !error;
		};
		this.close = function () {
			this.data.show = false;
		};
		this.cancel = function () {
			if (this.data.leftButtonCallback) {
				this.data.leftButtonCallback();
			}
			this.close();
		};
		this.submit = function () {
			if (self.data.selectedPage) {
				self.data.offerCurrentPage = self.data.selectedPage === 'currentPage';
				self.data.offerLastBookmarkTarget = self.data.selectedPage === 'lastBookmarkTarget';
				self.data.offerSourcePage = self.data.selectedPage === 'sourcePage';
			}
			if (this.validate()) {

				// apply project selection
				if (this.treeData.length && (!self.data.dropdownFolders || self.configureMode)) {
					let tree = $('#modal-jstree').jstree(true);
					let allNodes = tree.get_json('#', { 'flat': true });
					for (let p of this.data.projects) p.selected = false;
					let projectsById = new Map(this.data.projects.map(project => [String(project.id), project]));
					for (let n of allNodes) {
						let nodeData = tree.get_node(n.id);
						let isSelected = n.state.selected;
						if (self.data.refineProjectSelection) {
							isSelected = nodeData.original.page_meta.item_type === 'FOLDER'
								&& (tree.is_checked(nodeData) || tree.is_undetermined(nodeData));
						}
						if (isSelected) {
							let id = nodeData.original.page_meta.id;
							let project = projectsById.get(String(id));
							if (project) project.selected = true;
						}
					}

					// In project-refinement mode, collect deselected project IDs for blacklisting.
					if (self.data.refineProjectSelection) {
						// Preserve blacklist entries outside currently included folders.
						let deselectedProjectIds = new Set(self.data.blacklistedProjects || []);
						for (let n of allNodes) {
							let nodeData = tree.get_node(n.id);
							if (!nodeData || !nodeData.original) continue;
							let meta = nodeData.original.page_meta;
							if (!meta || !meta._isProject) continue;
							// Only blacklist projects whose direct parent folder IS selected
							let parentId = tree.get_parent(n.id);
							let parentNode = tree.get_node(parentId);
							let parentIsSelected = parentNode
								&& (tree.is_checked(parentNode) || tree.is_undetermined(parentNode));
							if (parentIsSelected) {
								if (tree.is_checked(nodeData)) deselectedProjectIds.delete(meta.id);
								else deselectedProjectIds.add(meta.id);
							}
						}
						self.data.deselectedProjectIds = Array.from(deselectedProjectIds);
					}
				}

				// select projects
				if (self.data.offerCurrentPage) {
					if (this.data.focusedProject) {
						let project = angular.copy(this.data.focusedProject);
						project.selected = true;
						this.data.projects = [project];
					} else {
						this.data.projects = [{ id: self.data.focusedProjectId, selected: true }];
					}
				} else if (self.data.offerSourcePage) {
					// source pages for each alert project can be fetched from its _meta, no need to pass projects
					this.data.projects = [{}];
				} else if (self.data.offerLastBookmarkTarget) {
					this.data.projects = [{
						title: self.data.lastBookmarkTarget.title,
						id: self.data.lastBookmarkTarget.id, selected: true
					}];
				} else {
					this.data.projects = this.data.projects.filter(p => p.selected);
					if (this.data.dropdownFolders && !this.configureMode && this.data.hideNewProjectOption) {
						self.data.projects = [self.currentFolder];
					}
				}
				for (let p of this.data.projects) {
					if (p.parent_id?.startsWith('unassigned_folder')) p.parent_id = null;
					if (p.id?.startsWith('unassigned_folder')) p.id = null;
				}
				if (!this.data.multiselect) this.data.projects = this.data.projects[0];

				// add folder or project id to new project
				if (this.configureMode && this.data.projects && this.data.projects.id) {
					this.data.new.parentId = this.data.projects.id;
				} else if (this.currentFolder) {
					this.data.new.parentId = this.currentFolder.id?.startsWith('unassigned_folder')
						? null
						: this.currentFolder.id;
				}

				// return current folder
				this.data.folder = this.currentFolder;
				this.data.rightButtonCallback();
				this.close();
			}
		};
		this.trustAsHtml = function (html) {
			return $sce.trustAsHtml(html);
		};

		this.applySearch = function () {
			this.isSearchLoading = true;
			$scope.$applyAsync();
			let latestSearch = (new Date()).getTime();
			this.latestSearch = latestSearch;
			window.setTimeout(function () {
				if (latestSearch != self.latestSearch) return;
				let tree = $('#modal-jstree').jstree(true);
				let allNodes = tree.get_json('#', { 'flat': true });

				if (self.search == '') {
					// reset
					for (let node of allNodes) {
						tree.show_node(node, true);
						if (node.state.preOpened) tree.open_node(node, false, false);
						else tree.close_node(node, false);
					}
					// open parent nodes of selected nodes
					for (let node of allNodes) {
						let isSelected = tree.is_selected(node);
						if (self.data.refineProjectSelection) {
							let meta = tree.get_node(node).original.page_meta;
							isSelected = meta.item_type === 'FOLDER'
								? tree.is_checked(node) || tree.is_undetermined(node)
								: tree.is_checked(node);
						}
						if (isSelected) {
							let thisNode = node;
							while (thisNode != '#') {
								thisNode = tree.get_parent(thisNode);
								tree.open_node(thisNode, false, false);
							}
						}
					}
				} else {
					// show matching nodes
					for (let node of allNodes) {
						if (node.text.toLowerCase().includes(self.search.toLowerCase())) {
							tree.show_node(node, true);
						} else {
							tree.hide_node(node, true);
						}
					}
					// show and open parent nodes of matching nodes
					for (let node of allNodes) {
						if (!tree.is_hidden(node)) {
							let thisNode = node;
							while (thisNode != '#') {
								thisNode = tree.get_parent(thisNode);
								tree.show_node(thisNode, true);
								tree.open_node(thisNode, false, false);
							}
						}
					}
				}
				tree.redraw(true);
				self.isSearchLoading = false;
				$scope.$applyAsync();
			}, 500);
		};

		this.selectAll = function () {
			let tree = $('#modal-jstree').jstree(true);
			let allNodes = tree.get_json('#', { 'flat': true });
			if (self.data.refineProjectSelection) {
				tree.check_all();
				for (let node of allNodes) {
					let treeNode = tree.get_node(node.id);
					if (treeNode.original.page_meta.item_type !== 'FOLDER') continue;
					syncRefinementFolderSelection(tree, treeNode);
				}
				return;
			}
			for (let node of allNodes) {
				tree.open_node(node, false, false);
				if (!tree.is_disabled(node)) tree.select_node(node, true, true);
			}
			tree.redraw(true);
		};

		this.clearAll = function () {
			let tree = $('#modal-jstree').jstree(true);
			let allNodes = tree.get_json('#', { 'flat': true });
			if (self.data.refineProjectSelection) {
				tree.uncheck_all();
				for (let node of allNodes) {
					let treeNode = tree.get_node(node.id);
					if (treeNode.original.page_meta.item_type !== 'FOLDER') continue;
					syncRefinementFolderSelection(tree, treeNode);
				}
				tree.close_all(false);
				return;
			}
			for (let node of allNodes) {
				if (tree.is_open(node)) {
					tree.close_node(node, false, false);
				}
				if (!tree.is_disabled(node)) {
					tree.deselect_node(node);
				}
			}
			tree.redraw(true);
		};

		this.getPages = function (parent, callback) {
			let UnassignedFolder = parent && (parent.id).startsWith('unassigned_folder');
			scoutBackendApi.getProjects({
				parentId: UnassignedFolder ? null : parent.id,
				allChildPages: true,
				getSimpleResponse: true,
				...(UnassignedFolder && { onlyOwnerId: parent.owner_id })

			}, function (response) {
				if (response.status != 'success') {
					$rootScope.showMessage(response.message, response.status);
					return;
				}
				let pages = [];
				for (let p of Object.values(response.data)) {
					if (parent.id.startsWith('unassigned_folder') && !p.parent_id) p.parent_id = parent.id;
					if (p.item_type != 'FOLDER') pages.push(p);
				}
				pages = $rootScope.sortProjects(pages, false, parent.id);
				for (let p of self.folders) {
					if (p.id == parent.id) {
						p.pages = pages;
						self.currentFolder = p;
					}
				}
				callback(pages);
			});
		};

		this.generateFolderGroups = function (folders, treeStructure = false) {
			let folderGroups = {};

			for (const folder of folders) {
				let group = null;
				let ownerId = folder.owner_id || MPG.USER_ID;
				if (!(folder.owner_id in folderGroups)) {
					group = MPG.MPG_GROUPS.find((x) => x.id === folder.owner_id);
					folderGroups[ownerId] = {
						name: group ? group.full_name : MPG.USERNAME,
						folders: []
					};
				} else {
					group = { full_name: folderGroups[ownerId].name };
				}
				folder.owner = group?.full_name || MPG.USERNAME;
				if (folder.owner_id !== MPG.USER_ID) folder.foreign = true;
				if (folder.id.startsWith('unassigned_folder')) {
					folder.title = treeStructure ? 'Uncategorized Projects' : 'None';
				}
				folderGroups[ownerId].folders.push(folder);
			}
			;
			return folderGroups;
		}

		this.getFolders = function (callback) {
			scoutBackendApi.getProjects({
				onlyRoots: true,
				getSimpleResponse: true
			}, function (response) {
				if (response.status != 'success') {
					$rootScope.showMessage(response.message, response.status);
					return;
				}

				let unassignedProjects = [];
				for (let p of Object.values(response.data)) {
					// filter by owner
					if (self.data.filterByOwner && p.owner_id != self.data.filterByOwner) continue;

					// import folders
					if (p.item_type == 'FOLDER') {
						self.folders.push(p);
					} else {
						unassignedProjects.push(p);
					}
				}
				if (unassignedProjects.length > 0 || self.data.alwaysShowUnassignedProjects) {
					for (let group of MPG.MPG_GROUPS) {
						if (!self.data.filterByOwner || self.data.filterByOwner == group.id) {
							self.folders.push({
								title: 'Uncategorized Projects',
								item_type: 'FOLDER',
								id: 'unassigned_folder_' + group.id,
								parent_id: null,
								owner_id: group.id
							});
						}
					}
					if (!self.data.filterByOwner) {
						self.folders.push({
							title: 'Uncategorized Projects',
							item_type: 'FOLDER',
							parent_id: null,
							id: 'unassigned_folder',
							owner_id: MPG.USER_ID
						});
					}
				}
				self.folders = $rootScope.sortProjects(self.folders, self.data.sortPinnedFolders || false);
				self.currentFolder = null;
				callback(self.folders);
			});
		};

		this.constructTree = function (rootId = null, projectView = false) {
			this.openedIds = [];
			// Show folders grouped by owners
			let GroupFoldersView = self.data.showGroupFolders && !projectView;
			// get ids of opened nodes (all parents of focusedProjectId)
			if (self.data.focusedProjectId) self.expandParentsOf(self.data.focusedProjectId);

			// in DISTRIBUTE_QUERY mode, disabled pages shall be visible (parents expanded)
			if (self.data.dialogSubtype == 'DISTRIBUTE_QUERY') {
				for (let id of self.data.disabledProjectIds) {
					self.expandParentsOf(id);
				}
			}

			function isOpenNode (p) {
				return self.openedIds.includes(p.id) ||
					(self.data.dialogSubtype == 'DISTRIBUTE_QUERY' && p.id == self.data.focusedProjectRootId);
			}

			let refineProjectSelection = self.data.refineProjectSelection === true;
			let blacklistedProjectIds = new Set((self.data.blacklistedProjects || []).map(String));
			let folderProjectsByKey = new Map();
			if (refineProjectSelection) {
				for (let project of self.data.folderProjects || []) {
					let key = project.parent_id
						? 'folder:' + project.parent_id
						: 'owner:' + project.owner_id;
					if (!folderProjectsByKey.has(key)) folderProjectsByKey.set(key, []);
					folderProjectsByKey.get(key).push(project);
				}
			}

			/*
				Radar and Matrix already have the project metadata. Adding those lightweight
				project nodes up front lets jsTree calculate the correct tri-state before a
				folder is expanded, instead of correcting it after a lazy request.
			*/
			function getPreloadedProjectNodes (folder) {
				let isUnassignedFolder = folder.id && folder.id.startsWith('unassigned_folder');
				let key = isUnassignedFolder ? 'owner:' + folder.owner_id : 'folder:' + folder.id;
				let projects = $rootScope.sortProjects(folderProjectsByKey.get(key) || [], false,
					isUnassignedFolder ? null : folder.id);
				return projects.map(function (project) {
					let isBlacklisted = blacklistedProjectIds.has(String(project.id));
					return {
						text: htmlEscape(project.title || MPG.DEFAULT_PROJECT_NAME),
						state: { checked: folder.selected && !isBlacklisted },
						page_meta: {
							id: project.id,
							title: project.title,
							parent_id: project.parent_id,
							owner_id: project.owner_id,
							item_type: project.item_type,
							_isProject: true
						},
						li_attr: { class: 'project-item-in-folder' }
					};
				});
			}

			var treeData = [];
			var queue = [];
			if (GroupFoldersView) {
				let folderGroups = self.generateFolderGroups(self.data.projects, true);
				for (const [groupId, group] of Object.entries(folderGroups)) {
					let groupNode = {
						text: htmlEscape(group.name),
						state: { opened: true, selected: false },
						page_meta: { name: group.name, id: groupId, type: 'group' },
						a_attr: { href: MPG.SCOUT_BASE_URL + '/group/' + groupId },
						children: [],
						li_attr: { class: groupId == MPG.USER_ID ? 'user-item' : 'user-group-item' }
					};
					for (let folder of group.folders) {
						let preloadedProjects = refineProjectSelection ? getPreloadedProjectNodes(folder) : [];
						let checkedProjects = preloadedProjects.filter(project => project.state.checked).length;
						let allProjectsChecked = checkedProjects === preloadedProjects.length;
						let someProjectsChecked = checkedProjects > 0 && !allProjectsChecked;
						let folderHasSelection = folder.selected
							&& (preloadedProjects.length === 0 || checkedProjects > 0);
						var folderElement = {
							text: htmlEscape(folder.title),
							state: {
								opened: isOpenNode(folder),
								preOpened: isOpenNode(folder),
								selected: refineProjectSelection ? folderHasSelection : folder.selected,
								checked: refineProjectSelection && folderHasSelection
									&& (preloadedProjects.length === 0 || allProjectsChecked),
								undetermined: refineProjectSelection && folderHasSelection && someProjectsChecked,
								disabled: self.data.disabledProjectIds
								&& self.data.disabledProjectIds.includes(folder.id) ? true : false
							},
							page_meta: folder,
							children: refineProjectSelection ? preloadedProjects : [],
							li_attr: { class: 'folder-item' }
						}
						folderElement.page_meta.item_type = 'FOLDER';
						if (folder.id && folder.id == self.data.focusedProjectId) {
							folderElement.li_attr.class += ' focused-project';
						}
						if (folder.id && folder.id == self.data.focusedProjectRootId) {
							folderElement.li_attr.class += ' focused-project-root';
						}
						groupNode.children.push(folderElement);
					}
					treeData.push(groupNode);
				}


			} else {
				const isDisabled = (project, parentNode) => {
					if (self.data.disabledProjectIds) {
						if (self.data.disabledProjectIds.includes(project.id)) return true;
						if (self.data.inheritPageDisabledState && parentNode.state?.disabled) return true;
					}
					return false;
				};
				var expandParent = { page_meta: { id: rootId } };
				do {
					for (let p of self.data.projects) {
						if (self.data.preselect && p.id === self.data.preselect && !self.data.dropdownFolders) {
							p.selected = true;
						}
						if (p.parent_id == expandParent.page_meta.id) {
							var insertElement = {
								text: htmlEscape(p.title || MPG.DEFAULT_PROJECT_NAME),
								state: {
									opened: isOpenNode(p),
									preOpened: isOpenNode(p),
									selected: p.selected,
									disabled: isDisabled(p, expandParent)
								},
								page_meta: p,
								children: []
							};
							insertElement.li_attr = { class: '' };
							if (p.item_type == 'FOLDER' && self.data.dialogSubtype != 'SELECT_FOLDER') insertElement.li_attr.class = 'folder-item';
							if (p.id == self.data.focusedProjectId) insertElement.li_attr.class = 'focused-project';
							if (p.id == self.data.focusedProjectRootId) insertElement.li_attr.class += ' focused-project-root';
							if (expandParent.page_meta.id == rootId) treeData.push(insertElement);
							else expandParent.children.push(insertElement);
							queue.push(insertElement);
						}
					}
					expandParent = queue.shift();
				} while (expandParent);
			}
			self.treeData = treeData;

			if (!treeData.length && !self.data.hideNewProjectOption) {
				self.data.new.selected = true;
			} else {
				self.data.new.selected = false;
			}

			window.setTimeout(function () {
				// create tree
				$("#modal-jstree").jstree('destroy');
				$('#modal-jstree').off('.select-folder-checkbox');
				// Add class for project-refinement mode so CSS can show its checkboxes.
				if (refineProjectSelection) {
					$('#modal-jstree').addClass('refine-project-selection-mode');
				} else {
					$('#modal-jstree').removeClass('refine-project-selection-mode');
				}

				if (refineProjectSelection) {
					let lastClickedRefinementNodeId = null;
					/*
						Make folder and project labels toggle their checkboxes.
						The disclosure triangle remains responsible only for opening and closing the folder.
					*/
					$('#modal-jstree').on('click.select-folder-checkbox',
						'.folder-item > .jstree-anchor, .project-item-in-folder > .jstree-anchor', function (e) {
							e.preventDefault();
							e.stopImmediatePropagation();
							let tree = $('#modal-jstree').jstree(true);
							let node = tree.get_node(this);
							let meta = node.original.page_meta;
							let nodesToToggle = [node.id];
							let lastClickedNode = tree.get_node(lastClickedRefinementNodeId);
							// Mirror jsTree's sibling-only Shift range for the untied checkbox state.
							if (e.shiftKey && lastClickedNode && lastClickedNode.parent === node.parent) {
								let siblings = tree.get_node(node.parent).children;
								let start = siblings.indexOf(lastClickedNode.id);
								let end = siblings.indexOf(node.id);
								nodesToToggle = siblings.slice(Math.min(start, end), Math.max(start, end) + 1);
							}

							if (meta.item_type === 'FOLDER') {
								let shouldCheck = !(tree.is_checked(node) || tree.is_undetermined(node));
								for (let folderId of nodesToToggle) {
									let folder = tree.get_node(folderId);
									if (shouldCheck) {
										tree.check_node(folder);
									} else {
										/*
											An indeterminate folder is not considered checked by jsTree, so
											uncheck its selected projects explicitly before clearing the folder.
										*/
										tree.uncheck_node(folder.children_d);
										tree.uncheck_node(folder);
									}
									syncRefinementFolderSelection(tree, folder);
								}
							} else {
								let parent = tree.get_node(tree.get_parent(node));
								let shouldCheck = !tree.is_checked(node);
								tree[shouldCheck ? 'check_node' : 'uncheck_node'](nodesToToggle);
								syncRefinementFolderSelection(tree, parent);
							}
							lastClickedRefinementNodeId = node.id;
							$(this).focus();
							$scope.$applyAsync();
						});
				}

				$('#modal-jstree').jstree({
					core: {
						data: treeData,
						multiple: self.data.multiselect ? true : false,
						check_callback: true,
						dblclick_toggle: !refineProjectSelection
					},
					types: {
						default: {
							icon: false
						}
					},
					checkbox: {
						three_state: refineProjectSelection,
						tie_selection: !refineProjectSelection,
						whole_node: !refineProjectSelection
					},
					plugins: ["types", "checkbox"]
				}).on("select_node.jstree", function (e, data) {
					if (data.node.original.page_meta.type == 'group') {
						// for user/group node expand or collapse children nodes only
						$("#modal-jstree").jstree('deselect_node', data.node);
						$("#modal-jstree").jstree('toggle_node', data.node);
					} else if (data.node.original.page_meta.item_type == 'FOLDER'
						&& self.data.dialogSubtype != 'SELECT_FOLDER') {
						// show cached pages
						if (data.node.original.page_meta.pages) {
							self.data.projects = data.node.original.page_meta.pages;
							self.currentFolder = data.node.original.page_meta;
							self.search = '';
							$scope.$applyAsync();
							self.constructTree(data.node.original.page_meta.id, true);
						} else {
							// load pages
							self.data.loading = true;
							self.getPages(data.node.original.page_meta, function (pages) {
								self.data.projects = pages;
								self.data.loading = false;
								self.search = '';
								$scope.$applyAsync();
								self.constructTree(data.node.original.page_meta.id, true);
							});
						}
					}
				}).on('changed.jstree', function (e, data) {
					$scope.$applyAsync();
				});

			}, 0);
		};

		this.expandParentsOf = function (id) {
			var currentParent = id;
			do {
				var idBefore = currentParent;
				for (let p of self.data.projects) {
					if (p.id == currentParent) {
						currentParent = p.parent_id;
						if (p.parent_id && p.parent_id != id) self.openedIds.push(p.parent_id);
						break;
					}
				}
			} while (currentParent && currentParent != id && idBefore != currentParent);
		};

		this.configureCurrentFolder = function () {
			// Load folder projects
			self.data.loading = true;
			self.getPages(self.currentFolder, function (pages) {
				self.data.projects = pages;
				self.data.loading = false;
				self.search = '';
				$scope.$applyAsync();
				self.constructTree(self.currentFolder.id);
				self.configureMode = true;
			});
		}
		this.getLimitedFolderAndOwner = function (maxTotalLength = 30) {
			let limitedOwner = self.currentFolder.owner.length > 30
				? $rootScope.limitString(self.currentFolder.owner, maxTotalLength)
				: self.currentFolder.owner;
			/*
				if currentFolder.owner is over 30 characters , we increase the word limit by 10
				to show the currentFolder.title
			*/
			const remainingLength = (maxTotalLength - limitedOwner.length || 10);
			const limitedTitle = $rootScope.limitString(self.currentFolder.title, remainingLength);
			return {
				owner: limitedOwner,
				title: limitedTitle
			};
		}

		this.state = false;
		this.init = function () {
			if (this.data && this.data.show && !this.state) {
				// constructor ----------------------------------------------------------------------------------------
				mixpanel.track('Dialog Opened', { dialog_name: this.data.dialogName || this.data.caption || '' });

				if (!this.data.new) this.data.new = {};
				this.state = true;
				this.search = '';
				this.data.loading = true;
				this.configureMode = false;
				this.isSearchLoading = false;
				disableBodyScrollbar();
				this.folders = [];
				this.currentFolder = null;
				if (this.data.offerCurrentPage) this.data.selectedPage = 'currentPage';
				else if (this.data.offerSourcePage) this.data.selectedPage = 'sourcePage';
				else if (this.data.offerLastBookmarkTarget) this.data.selectedPage = 'lastBookmarkTarget';
				else this.data.selectedPage = null; // state of selector can't be boolean

				if (this.data.pageId) {
					// Only show pages of a specific project
					scoutBackendApi.getProjects({
						pageId: this.data.pageId
					}, function (response) {
						if (response.status != 'success') {
							$rootScope.showMessage(response.message, response.status);
							return;
						}
						let pages = $rootScope.sortProjects(Object.values(response.data));
						// find root id
						let root = pages[0];
						while (Object.keys(response.data).includes(root.parent_id)) root = response.data[root.parent_id];
						self.data.projects = pages;
						self.data.loading = false;
						$scope.$applyAsync();
						self.data.focusedProjectRootId = root.id;
						self.constructTree(root.parent_id);
					});
				} else if (self.data.folders) {
					// Show folders that are given as parameter
					self.folders = $rootScope.sortProjects(self.data.folders, self.data.sortPinnedFolders || false);
					self.currentFolder = null;
					self.data.projects = self.folders;
					self.data.loading = false;
					$scope.$applyAsync();
					self.constructTree();
				} else if (self.data.projects) {
					// Show projects that are given as parameter
					self.currentFolder = null;
					self.data.loading = false;
					$scope.$applyAsync();
					self.constructTree();
				} else {
					// Show folders from My Portfolio
					this.getFolders(function (folders) {
						self.data.projects = folders;
						if (self.data.dropdownFolders && !self.data.preselect) {
							self.currentFolder = self.data.projects[0];
							self.currentFolder.title = 'None';
						} else if (self.data.dropdownFolders && self.data.preselect) {
							self.currentFolder = (self.data.projects).find(x => x.id === self.data.preselect);
						}
						self.data.folderGroups = self.generateFolderGroups(self.data.projects);

						self.data.loading = false;
						$scope.$applyAsync();
						self.constructTree();
					});
				}

				return true;
			} else if (this.data && !this.data.show && this.state) {
				// destructor ----------------------------------------------------------------------------------------
				enableBodyScrollbar();

				this.state = false;
				return false;
			} else if (this.data && this.data.show == this.state) return this.state;
		};
	},
	template: `
		<div class="mpg-modal {{ $ctrl.data.modalClass }}" style="display: flex" ng-if="$ctrl.init()">
			<div class="mpg-modal-content">
				<i class="fa-solid fa-times mpg-close" aria-hidden="true" ng-click="$ctrl.cancel()"></i>
				<span>
					<div class="mpg-modal-title">
						<i class="{{$ctrl.data.iconClass || 'fa-solid fa-tasks'}}" style="margin-right: 8px;"></i>
						{{ $ctrl.data.caption }}
					</div>

					<!-- loader -->
					<div ng-if="$ctrl.data.loading" style="text-align:center;margin:60px 0 40px 0">
						<i class="fa-solid fa-sync fa-spin fa-3x fa-fw"></i>
					</div>

					<form ng-submit="" ng-if="!$ctrl.data.loading">
						<p ng-bind-html="$ctrl.trustAsHtml($ctrl.data.content)"
							ng-if="$ctrl.data.content && (!$ctrl.data.dropdownFolders || $ctrl.configureMode)"
							style="margin-bottom:16px; line-height: 1.4em"></p>

						<!-- new project (top) -->
						<div style="padding:8px 20px;margin:8px -20px 16px -20px;"
							ng-if="!$ctrl.configureMode && !$ctrl.data.hideNewProjectOption
								&& !($ctrl.data.offerCurrentPage || $ctrl.data.offerLastBookmarkTarget
									|| $ctrl.data.offerSourcePage)
								&& (!$ctrl.data.dropdownFolders || $ctrl.data.alwaysShowNewProjectFields)
								&& $ctrl.data.placeFieldsAboveFolders">
							<label style="margin:0;padding-top:0;padding-bottom:3px;letter-spacing:0.031em"
								ng-if="!$ctrl.data.alwaysShowNewProjectFields">
								<input type="checkbox" ng-model="$ctrl.data.new.selected" style="margin-left: 39px;">
								New Project
							</label>
							<div ng-if="$ctrl.data.new.selected">
								<label>
									{{ $ctrl.data.customTitleLabel || 'Title*' }}
									<input ng-model="$ctrl.data.new.title.value"
										type="text" ng-class="{'has-error': $ctrl.data.new.title.error}">
									<span ng-if="$ctrl.data.new.title.error"
										ng-class="{'has-error-msg': $ctrl.data.new.title.error}">
										This field is mandatory.
									</span>
								</label>
								<label ng-if="!$ctrl.data.hideDescriptionField">
									Description
									<input type="text" ng-model="$ctrl.data.new.description.value">
								</label>

								<!-- actions (top) -->
								<div ng-repeat="input in $ctrl.data.fields"
									ng-if="!input.condition || input.condition()">
									<label ng-switch="input.type">
										<!-- actions -->
										<div ng-switch-when="action" ng-if="input.action && !input.link"
											class="m-link-main"
											ng-click="input.keepOpenOnAction ? null : $ctrl.close(); input.action();"
											style="display:inline-block; font-size:18px; font-weight:600">
											<i class="{{ input.iconClass || 'fa-solid fa-arrow-right'}}"
												ng-if="!input.hideIcon"
												style="margin-right:12px;"></i>{{ input.label }}
										</div>
										<a ng-switch-when="action" ng-if="input.link && !input.action"
											class="m-link-main"
											href="{{ input.link }}"
											style="display:inline-block; font-size:18px; font-weight:600">
											<i class="{{ input.iconClass || 'fa-solid fa-arrow-right'}}"
												ng-if="!input.hideIcon"
												style="margin-right:12px;"></i>{{ input.label }}
										</a>

										<!-- hints -->
										<a ng-if="input.type == 'action' && input.hint && input.hintLink"
											href="{{ input.hintLink }}" target="_blank">
											<i class="fa-solid fa-question-circle m-link
												m-link-black" m-tooltip="input.hint" style="margin-left:4px;">
											</i>
										</a>
										<i class="fa-solid fa-question-circle m-link m-link-black"
											m-tooltip="input.hint"
											ng-if="input.type == 'action' && input.hint && !input.hintLink"
											style="margin-left:4px; cursor:default;"></i>

										<div ng-switch-when="checkbox" style="font-weight:normal;">
											<input type="checkbox" ng-model="input.value" ng-style="input.style">
											{{ input.label }}
										</div>
									</label>
								</div>
							</div>
						</div>

						<div style="display:flex; align-items:center; position:relative;"
							ng-if="!($ctrl.data.offerCurrentPage || $ctrl.data.offerLastBookmarkTarget
								|| $ctrl.data.offerSourcePage) && $ctrl.data.dropdownFolders && !$ctrl.configureMode">
							<label class="input-label">
								<div style="display:flex; align-items:center; justify-content:space-between;
										margin-bottom:4px;">
									<span> Folder </span>
									<span class="m-link-main" ng-if="$ctrl.currentFolder"
										ng-click="$ctrl.configureCurrentFolder()"
										style="font-size:13px; font-weight:600; white-space:nowrap;">
										<i class="fa-solid fa-arrow-right" style="margin-right:5px;"></i>
										Create Subpage
									</span>
								</div>
								<select style="width: 100%;" ng-model="$ctrl.currentFolder"
									ng-class="{'has-error': input.error}">
									<optgroup label="{{ group.name }}" ng-repeat="group in $ctrl.data.folderGroups">
										<option ng-repeat="folder in group.folders track by $index" ng-value="folder">
											{{ $root.limitString(folder.title, 30) }}
										</option>
									</optgroup>
								</select>

								<!-- Custom visible placeholder to simulate selected <option> text -->
								<div class="custom-select-overlay-container">
										{{ $ctrl.getLimitedFolderAndOwner().owner }}
										<i class="fas fa-chevron-right" style="font-size: 14px; margin: 0 4px;"></i>
										{{ $ctrl.getLimitedFolderAndOwner().title }}
								</div>
							</label>
						</div>

						<div style="display:flex; align-items:center"
							ng-if="!($ctrl.data.offerCurrentPage || $ctrl.data.offerLastBookmarkTarget
								|| $ctrl.data.offerSourcePage)">
							<!-- search -->
							<div style="position: relative; flex:1"
								ng-if="$ctrl.treeData.length && (!$ctrl.data.dropdownFolders || $ctrl.configureMode)">
								<i style="position:absolute; right:9px; top:23px; color: var(--mpg-color-main)" ng-if="$ctrl.isSearchLoading">
									<i class="fa-solid fa-sync fa-spin fa-1x fa-fw"></i>
								</i>
								<input type="text" placeholder="Search..." ng-model="$ctrl.search" ng-change="$ctrl.applySearch()">
							</div>


							<!-- clear all -->
							<div class="m-link" ng-if="$ctrl.data.clearAllEnabled"
								style="margin-left:8px; margin-top:4px; white-space:nowrap; font-size:13px;"
								ng-click="$ctrl.clearAll()">Clear all</div>

							<!-- select all -->
							<div class="m-link" ng-if="$ctrl.data.dialogSubtype == 'DISTRIBUTE_QUERY'"
								style="margin-left:8px; margin-top:4px; white-space:nowrap; font-size:13px;" ng-click="$ctrl.selectAll()">Select all</div>
						</div>

						<!-- "current page" selector -->
						<fieldset ng-if="$ctrl.data.offerCurrentPage || $ctrl.data.offerLastBookmarkTarget
							|| $ctrl.data.offerSourcePage">
							<label style="font-weight:normal" ng-if="$ctrl.data.offerCurrentPage">
								<input type="radio" ng-model="$ctrl.data.selectedPage" value="currentPage">
								Add to <b>current page</b>
							</label>
							<label ng-if="$ctrl.data.offerSourcePage" style="font-weight:normal">
								<input type="radio" ng-model="$ctrl.data.selectedPage" value="sourcePage">
								Add to alert source
							</label>
							<label ng-if="$ctrl.data.offerLastBookmarkTarget" style="font-weight:normal">
								<input type="radio" ng-model="$ctrl.data.selectedPage" value="lastBookmarkTarget">
								Add to <b>{{ $ctrl.data.lastBookmarkTarget.title }}</b>
							</label>
							<label style="font-weight:normal">
								<input type="radio" ng-model="$ctrl.data.selectedPage" value="anotherPage"
									ng-change="$ctrl.data.offerCurrentPage = false;
										$ctrl.data.offerLastBookmarkTarget = false;
										$ctrl.data.offerSourcePage = false;">
								Choose another page
							</label>
						</fieldset>

						<div style="margin:8px 0; display:flex; align-items:center;"
							ng-if="!$ctrl.data.pageId
								&& !($ctrl.data.offerCurrentPage || $ctrl.data.offerLastBookmarkTarget
									|| $ctrl.data.offerSourcePage)
								&& (!$ctrl.currentFolder || !$ctrl.data.dropdownFolders || $ctrl.configureMode)">
							<!-- back button -->
							<span ng-if="$ctrl.currentFolder && (!$ctrl.data.dropdownFolders || $ctrl.configureMode)"
								class="m-link" title="Back"
								ng-click="$ctrl.configureMode = false; $ctrl.data.projects = $ctrl.folders;
								$ctrl.currentFolder = $ctrl.data.dropdownFolders && $ctrl.currentFolder || null;
								$ctrl.search = ''; $ctrl.$applyAsync(); $ctrl.constructTree();">
								<i class="fa-solid fa-arrow-alt-circle-left"
									style="font-size:24px; margin-right:10px"></i>
							</span>
							<!-- folder name -->
							<span ng-if="!$ctrl.currentFolder"
								style="font-weight:bold; letter-spacing:0.5px; font-size:18px; flex:1">
								{{ $ctrl.data.customFoldersTitle ? $ctrl.data.customFoldersTitle : 'All Folders' }}
							</span>
							<span ng-if="$ctrl.currentFolder && (!$ctrl.data.dropdownFolders || $ctrl.configureMode)"
								style="font-weight:bold; letter-spacing:0.5px; font-size:18px; flex:1; line-height:1.2em">
								{{ $ctrl.currentFolder.title == 'None'
								 	? 'Uncategorized Projects'
									: $ctrl.currentFolder.title
								}}
							</span>
						</div>

						<!-- item tree -->
						<div style="max-height: 270px; overflow-y: auto; padding: 0;"
							ng-if="$ctrl.treeData.length && (!$ctrl.data.dropdownFolders || $ctrl.configureMode)"
							ng-show="!($ctrl.data.offerCurrentPage || $ctrl.data.offerLastBookmarkTarget
								|| $ctrl.data.offerSourcePage)">
							<div id="modal-jstree" style="width:calc(100% - 5px);"></div>
						</div>

						<!-- "empty" message -->
						<div ng-if="!$ctrl.treeData.length" style="font-style:italic;color:var(--mpg-color-mid-grey);margin-bottom:12px;margin-left:34px;">
							<div ng-if="!$ctrl.currentFolder">{{ $ctrl.data.customNoProjectsMessage ? $ctrl.data.customNoProjectsMessage : 'You have no projects yet.' }}</div>
							<div ng-if="$ctrl.currentFolder">This folder is empty.</div>
						</div>

						<!-- new project -->
						<div style="background:#f6f6f6;padding:8px 20px;margin:8px -20px 0 -20px;"
							ng-if="!$ctrl.data.hideNewProjectOption
								&& !($ctrl.data.offerCurrentPage || $ctrl.data.offerLastBookmarkTarget
									|| $ctrl.data.offerSourcePage)
								&& (!$ctrl.data.dropdownFolders || $ctrl.data.alwaysShowNewProjectFields)
								&& !$ctrl.data.placeFieldsAboveFolders">
							<label style="margin:0;padding-top:0;padding-bottom:3px;letter-spacing:0.031em"
								ng-if="!$ctrl.data.alwaysShowNewProjectFields">
								<input type="checkbox" ng-model="$ctrl.data.new.selected" style="margin-left: 39px;">
								New Project
							</label>
							<div ng-if="$ctrl.data.new.selected">
								<label>
									{{ $ctrl.data.customTitleLabel || 'Title*' }}
									<input ng-model="$ctrl.data.new.title.value" type="text" ng-class="{'has-error': $ctrl.data.new.title.error}">
									<span ng-if="$ctrl.data.new.title.error" ng-class="{'has-error-msg': $ctrl.data.new.title.error}">This field is mandatory.</span>
								</label>
								<label ng-if="!$ctrl.data.hideDescriptionField">
									Description
									<input type="text" ng-model="$ctrl.data.new.description.value">
								</label>
							</div>
						</div>

						<!-- actions -->
						<div ng-repeat="input in $ctrl.data.fields"
							ng-if="!$ctrl.data.placeFieldsAboveFolders && (!input.condition || input.condition())">
							<label ng-switch="input.type">
								<!-- actions -->
								<div ng-switch-when="action" ng-if="input.action && !input.link" class="m-link-main"
									ng-click="input.keepOpenOnAction ? null : $ctrl.close(); input.action();"
									style="display:inline-block; font-size:18px; font-weight:600">
									<i class="{{ input.iconClass || 'fa-solid fa-arrow-right'}}"
										ng-if="!input.hideIcon"
										style="margin-right:12px;"></i>{{ input.label }}
								</div>
								<a ng-switch-when="action" ng-if="input.link && !input.action" class="m-link-main"
									href="{{ input.link }}"
									style="display:inline-block; font-size:18px; font-weight:600">
									<i class="{{ input.iconClass || 'fa-solid fa-arrow-right'}}"
										ng-if="!input.hideIcon"
										style="margin-right:12px;"></i>{{ input.label }}
								</a>

								<!-- hints -->
								<a ng-if="input.type == 'action' && input.hint && input.hintLink"
									href="{{ input.hintLink }}" target="_blank">
									<i class="fa-solid fa-question-circle m-link
										m-link-black" m-tooltip="input.hint" style="margin-left:4px;">
									</i>
								</a>
								<i class="fa-solid fa-question-circle m-link m-link-black" m-tooltip="input.hint"
									ng-if="input.type == 'action' && input.hint && !input.hintLink"
									style="margin-left:4px; cursor:default;"></i>
							</label>
						</div>

						<p style="margin-top: 1.4em; margin-bottom: 0px;">
							<button type="button" class="m-button m-small" style="width: calc(50% - 2px);margin-right:4px;"
								ng-click="$ctrl.cancel()">
								Cancel
							</button><button class="m-button-main m-small" id="mpg-confirm-dialog-btn" type="button"
								style="width: calc(50% - 2px)" ng-click="$ctrl.submit();" ng-disabled="!$ctrl.validate()">
								{{ $ctrl.data.rightButtonLabel || 'OK' }}
							</button>
						</p>
					</form>
				</span>
			</div>
		</div>
	`
});

scout.component('manageShareableLinksDialog', {
	bindings: {
		data: '='
	},
	controller: function ($scope, $element, $sce, $rootScope) {
		this.cancel = function () {
			if (this.data.leftButtonCallback) {
				this.data.leftButtonCallback();
			}
			this.close();
		};
		this.close = function () {
			this.data.show = false;
		};
		this.trustAsHtml = function (html) {
			return $sce.trustAsHtml(html);
		};
		this.copyToClipboard = function (txt) {
			navigator.clipboard.writeText(txt).then(function () {
				$rootScope.showMessage('Copied to clipboard.', 'success');
			}, function (err) {
				$rootScope.showMessage('ERROR: Copy command failed.', 'error');
			});
		};
		this.getEmbedCode = function (link) {
			return '<iframe src="' + this.getUrl(link) + '&embed=true" '
				+ 'style="border:none;width:100%;min-height:800px;height:100vh">'
				+ '</iframe>';
		};
		this.links = null;
		this.getExpirationInfo = function (link) {
			if (!link.expired) return '∞';
			else return Math.ceil((link.expired - (new Date())) / 1000 / 60 / 60 / 24) + '/' + Math.ceil((link.expired - link.created) / 1000 / 60 / 60 / 24);
		};

		this.importAccessKeys = function (response) {
			for (let item of response.data) {
				item.created = datetimeToDate(universalToLocalDatetime(item.created)).getTime();
				item.expired = item.expired ? datetimeToDate(universalToLocalDatetime(item.expired)).getTime() : null;
			}
			this.links = response.data;
			$scope.$applyAsync();
		};

		this.addLink = function () {
			let self = this;
			self.loading = true;

			function handleResponse (response = null, showMessage = true) {
				self.loading = false;
				if (showMessage && response) $rootScope.showMessage(response.message, response.status);
				if (response && response.status == 'success') {
					self.importAccessKeys(response);
					if (self.data.type == 'PROJECT') {
						mixpanel.track('Project Interaction', { interaction_name: 'Shareable Link Added' });
					}
				}
			}

			if (this.data.type == 'PROJECT') {
				let params = {
					project_id: self.data.projectId,
					days: self.data.selectedInterval == '∞' ? -1 : self.data.selectedInterval
				};
				if (self.data.useExtraPassword) params.extra_password = self.data.extraPassword;
				scoutBackendApi.addProjectAccessKey(params, handleResponse);
			} else if (this.data.type == 'RADAR') {
				let params = {
					days: self.data.selectedInterval == '∞' ? -1 : self.data.selectedInterval,
					title: self.title || self.data.defaultTitle,
					folders: self.data.folders,
					dim1: self.data.dim1,
					dim2: self.data.dim2,
					blacklisted_projects: self.data.blacklistedProjects || null
				};
				if (self.data.useExtraPassword) params.extra_password = self.data.extraPassword;
				scoutBackendApi.addRadarAccessKey(params, handleResponse);
			} else if (this.data.type == 'MATRIX') {
				let params = {
					days: self.data.selectedInterval == '∞' ? -1 : self.data.selectedInterval,
					title: self.title || self.data.defaultTitle,
					saved_x_folders: self.data.savedXFolders,
					saved_y_folders: self.data.savedYFolders,
					indicator: self.data.indicator,
					normalization: self.data.normalization,
					indicator_name: self.data.indicatorName,
					normalization_name: self.data.normalizationName,
					blacklisted_projects_x: self.data.blacklistedProjectsX || null,
					blacklisted_projects_y: self.data.blacklistedProjectsY || null,
					matrix_order: self.data.matrixOrder || null
				};
				if (self.data.useExtraPassword) params.extra_password = self.data.extraPassword;

				scoutBackendApi.call('add_matrix_access_key', params)
					.catch((response) => response)
					.then(handleResponse);

			} else if (this.data.type == 'ALERTS') {
				self.data.addLinkCallback(handleResponse);
			}
		};

		this.deleteLink = function (link) {
			let self = this;
			self.loading = true;

			function handleResponse (response) {
				self.loading = false;
				$rootScope.showMessage(response.message, response.status);
				if (response.status == 'success') self.importAccessKeys(response);
			}

			if (this.data.type == 'PROJECT') {
				scoutBackendApi.deleteProjectAccessKey({
					id: link.id,
					project_id: self.data.projectId
				}, handleResponse);
			} else if (this.data.type == 'RADAR') {
				scoutBackendApi.deleteRadarAccessKey({
					id: link.id
				}, handleResponse);
			} else if (this.data.type == 'MATRIX') {
				scoutBackendApi.call('delete_matrix_access_key', { id: link.id })
					.catch((response) => response)
					.then(handleResponse);
			} else if (this.data.type == 'ALERTS') {
				scoutBackendApi.call('delete_rss_feed', {
					id: link.id
				}).catch((response) => response).then(handleResponse);
			}
		};

		this.getUrl = function (link) {
			// Encode dots so sharing apps do not treat a trailing dot as sentence punctuation.
			return this.data.rootUrl + '?key=' + encodeURIComponent(link.id).replace(/\./g, '%2E');
		};

		this.getMailtoLink = function (link) {
			if (!this.data || !this.data.mailtoSubject || !this.data.mailtoBody) return false;
			let url = this.getUrl(link);
			let title = link.meta && link.meta.title;
			let subject = (typeof this.data.mailtoSubject == 'function') ? this.data.mailtoSubject(title)
				: this.data.mailtoSubject;
			let body = (typeof this.data.mailtoBody == 'function') ? this.data.mailtoBody(url, title)
				: this.data.mailtoBody;
			return 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
		};

		this.initMailtoLink = function (link) {
			let self = this;
			window.setTimeout(function () {
				document.getElementById('sharing-link-' + link.id).innerHTML = '<a class="m-link m-link-black" href="'
					+ self.getMailtoLink(link) + '"><i class="fa-solid fa-envelope" '
					+ 'onclick="mixpanel.track(\'Project Interaction\', { '
					+ 'interaction_name: \'Shareable Link Email Button Clicked\' })"></i></a>';
			}, 0);
		};

		this.getFolderNames = function (folderIds) {
			let names = [];
			for (let folder of this.data.allFolders) {
				if (this.data.type == 'RADAR') {
					/*
						-null in folderIds means all uncategorzied folders selected (Legacy format)
						-selected uncategorized folders in radar settings are currently saved by their owner_id
					*/
					if ((folderIds.includes(folder.id) && folder.id)
						|| (folderIds.includes(folder.owner_id) && !folder.id)
						|| (folderIds.includes(null) && !folder.id)) {
						names.push(folder.title);
					}
				} else if (folderIds.includes(folder.id)) names.push(folder.title);
			}
			return names;
		};

		// DEPRECATED - Use $ctrl.data.linkName() instead
		this.getLinkName = function (link) {
			const name = ['RADAR', 'MATRIX'].includes(this.data.type) ? link.meta.title
				: dateToDatetime(new Date(link.created)).substring(0, 10);
			return this.data.linkNameTransformation ? this.data.linkNameTransformation(name) : name;
		};

		this.state = false;
		this.init = function () {
			if (this.data && this.data.show && !this.state) {
				// constructor ----------------------------------------------------------------------------------------
				mixpanel.track('Dialog Opened', { dialog_name: this.data.dialogName || this.data.caption || '' });

				this.data.useExtraPassword = false;
				this.data.extraPassword = '';

				disableBodyScrollbar();

				if (this.data.type == 'MATRIX') {
					this.data.defaultNormalization = $scope.$parent.defaultNormalization.name;
					this.data.defaultIndicator = $scope.$parent.defaultIndicator.name;
				}

				if (this.links === null) {
					let self = this;
					self.loading = true;

					if (this.data.type == 'PROJECT') {
						scoutBackendApi.getProjectAccessKeys({
							project_id: self.data.projectId
						}, function (response) {
							self.loading = false;
							if (response.status == 'success') self.importAccessKeys(response);
							else $rootScope.showMessage(response.message, response.status);
						});
					} else if (this.data.type == 'RADAR') {
						scoutBackendApi.getRadarAccessKeys(function (response) {
							self.loading = false;
							if (response.status == 'success') self.importAccessKeys(response);
							else $rootScope.showMessage(response.message, response.status);
						});
					} else if (this.data.type == 'MATRIX') {
						scoutBackendApi.call('get_matrix_access_keys').then((response) => {
							self.loading = false;
							if (response.status == 'success') self.importAccessKeys(response);
							else $rootScope.showMessage(response.message, response.status);
						});
					} else if (this.data.type == 'ALERTS') {
						scoutBackendApi.call('get_rss_feeds', {}).then((response) => {
							self.loading = false;
							self.importAccessKeys(response);
						}).catch((response) => {
							self.loading = false;
							$rootScope.showMessage(response.message, response.status);
						});
					}
				} else if (this.data.type == 'ALERTS' && this.data.response) {
					// Allow to update the links from outside the component
					this.importAccessKeys(this.data.response);
				}

				this.state = true;
				return true;
			} else if (this.data && !this.data.show && this.state) {
				// destructor ----------------------------------------------------------------------------------------
				enableBodyScrollbar();

				this.state = false;
				return false;
			} else if (this.data && this.data.show == this.state) return this.state;
		};
	},
	template: `
		<div class="mpg-modal" style="display: flex;" ng-if="$ctrl.init()">
			<div class="mpg-modal-content" style="overflow:hidden;">
				<i class="fa-solid fa-times mpg-close" aria-hidden="true" ng-click="$ctrl.cancel()"></i>
				<span>
					<div class="mpg-modal-title">
						<i class="{{$ctrl.data.iconClass}}" aria-hidden="true" style="margin-right: 8px;"
							ng-if="$ctrl.data.iconClass"></i>
						{{ $ctrl.data.caption }}
					</div>
					<div ng-show="$ctrl.loading" style="text-align:center">
						<p>Please wait...<p>
						<i style="font-size: 50px; display: block; margin-top: 8px;">
							<i class="fa-solid fa-sync fa-spin fa-1x fa-fw"></i>
						</i>
					</div>
					<form ng-show="!$ctrl.loading">
						<!-- description -->
						<p ng-bind-html="$ctrl.trustAsHtml($ctrl.data.content)" ng-if="$ctrl.data.content"
							style="line-height: 1.4em"></p>

						<!-- remark -->
						<p style="line-height: 1.4em;" ng-if="$ctrl.data.remark">
							<small ng-bind-html="$ctrl.trustAsHtml($ctrl.data.remark)"></small>
						</p>

						<!-- Active links -->
						<style>
							.shareable-links-table { width: 100%; margin-bottom: 16px; }
							.shareable-links-table tr td { padding: 0 0 8px 0; }
							.shareable-links-table tr th { padding: 0 0 16px 0; }
							.shareable-links-table input { margin: 0 !important; text-align:right; }
						</style>
						<table class="shareable-links-table" ng-show="$ctrl.links.length">
							<tr ng-if="$ctrl.data.type !== 'ALERTS'">
								<th style="padding-right:16px; text-align:left;">{{
									$ctrl.data.type === 'ALERTS' ? 'Feed URL' : 'Shareable Link'
								}}</th>
								<th style="padding-right:16px; white-space:nowrap;"
									ng-if="$ctrl.data.type !== 'ALERTS'">Days Left</th>
								<th ng-if="$ctrl.data.type === 'ALERTS'"></th>
								<th></th>
								<th></th>
								<th></th>
								<th></th>
							</tr>
							<tr ng-repeat-start="link in $ctrl.links">
								<td style="padding-right:16px;">
									<a href="{{ $ctrl.getUrl(link) }}" target="_blank"
										style="word-break:break-word; font-size:14px;"
										m-tooltip="
											($ctrl.data.type === 'RADAR' ?
											'<table style=\\'width:100%;\\'>
											<tr>
												<td style=\\'padding-right:1em; padding-bottom:8px;
													vertical-align:top;\\'>Distance (default):</td>
												<td style=\\'font-weight:600; vertical-align:top;\\'>
													' + $root.getKpiName(link.meta.dim1) + '
												</td>
											</tr>
											<tr>
												<td style=\\'padding-right:1em; padding-bottom:8px;
													vertical-align:top;\\'>Size (default):</td>
												<td style=\\'font-weight:600; vertical-align:top;\\'>
													' + (link.meta.dim2 == 'NONE' ? 'NONE'
														: $root.getKpiName(link.meta.dim2)) + '
												</td>
											</tr>
											<tr>
												<td style=\\'padding-right:1em; vertical-align:top;\\'>Folders:</td>
												<td style=\\'vertical-align:top;\\'>
													' + (link.meta.folders ? $root.htmlEscape(
														$ctrl.getFolderNames(link.meta.folders).join(', ')
													) : 'ALL') + '
												</td>
											</tr>
											</table>'
											: $ctrl.data.type === 'MATRIX' ?
											'<table style=\\'width:100%;\\'>'
												+ '<tr>'
													+ '<td style=\\'padding-right:1em; padding-bottom:8px;'
														+ ' white-space:nowrap; vertical-align:top;\\'>'
														+ 'Indicator (default):'
													+ '</td>'
													+ '<td style=\\'font-weight:600; vertical-align:top;\\'>'
														+ (link.meta.indicator_name || link.meta.indicator
															|| $ctrl.data.defaultIndicator) + '</td>'
												+ '</tr>'
												+ '<tr>'
													+ '<td style=\\'padding-right:1em; padding-bottom:8px;'
														+ ' white-space:nowrap; vertical-align:top;\\'>'
														+ 'Normalization (default):'
													+ '</td>'
													+ '<td style=\\'font-weight:600; vertical-align:top;\\'>'
														+ (link.meta.normalization_name || link.meta.normalization
															|| $ctrl.data.defaultNormalization)
														+ '</td>'
												+ '</tr>'
												+ '<tr>'
													+ '<td style=\\'padding-right:1em; padding-bottom:8px;'
														+ ' white-space:nowrap; vertical-align:top;\\'>'
														+ 'X-Axis Folders:'
													+ '</td>'
													+ '<td style=\\'vertical-align:top; white-space:normal;'
														+ ' word-break:break-word;\\'>'
														+ $ctrl.getFolderNames(link.meta.saved_x_folders).join(', ')
														+ '</td>'
												+ '</tr>'
												+ '<tr>'
													+ '<td style=\\'padding-right:1em; white-space:nowrap;'
														+ ' vertical-align:top;\\'>Y-Axis Folders:</td>'
													+ '<td style=\\'vertical-align:top; white-space:normal;'
														+ ' word-break:break-word;\\'>'
														+ $ctrl.getFolderNames(link.meta.saved_y_folders).join(', ')
														+ '</td>'
												+ '</tr>'
											+ '</table>'
											: ''
											)

											+ (($ctrl.data.type === 'RADAR' ||  $ctrl.data.type === 'MATRIX')
												&& link.has_extra_pass
											? '<div style=\\'height:12px\\'></div>' : '')

											+ (link.has_extra_pass ?
											'<i style=\\'margin-right:4px;\\'
												class=\\'fa-solid fa-lock\\'></i> Password-protected</td>' : ''
											)">
										<i style="margin-right:4px" class="fa-solid fa-lock" ng-if="link.has_extra_pass"
											></i>
										{{ $ctrl.data.linkName ? $ctrl.data.linkName(link) : $ctrl.getLinkName(link) }}
									</a>
								</td>
								<td style="text-align:center;padding-right:16px;"
									ng-if="$ctrl.data.type !== 'ALERTS'">{{
									$ctrl.getExpirationInfo(link);
								}}</td>
								<td ng-if="$ctrl.data.type === 'ALERTS'">
									<div style="margin-right:16px">
										<i class="fa-solid fa-cog m-link m-link-black"
											title="Configure"
											ng-click="$ctrl.data.linkConfigurationCallback(link)"></i>
									</div>
								</td>
								<td>
									<div style="margin-right:16px">
										<i class="fa-solid fa-copy m-link m-link-black"
											title="Copy link"
											ng-click="$ctrl.copyToClipboard($ctrl.getUrl(link))"></i>
									</div>
								</td>
								<td>
									<div style="margin-right:16px" class="fa-solid fa-code m-link m-link-black"
										ng-if="$ctrl.data.type === 'RADAR' || $ctrl.data.type === 'MATRIX'"
										ng-click="
											!link.showEmbedLink && $ctrl.copyToClipboard($ctrl.getEmbedCode(link));
											link.showEmbedLink = !link.showEmbedLink;"
										title="{{ link.showEmbedLink ? 'Click to hide the embed code.'
											: 'Click to copy the embed code.' }}">
									</div>
								</td>
								<td>
									<div style="margin-right:16px" ng-if="$ctrl.getMailtoLink(link)"
										ng-init="$ctrl.initMailtoLink(link)" id="sharing-link-{{ link.id }}"
										title="{{ 'Share via email. (This button only works if you\\'ve configured a '
											+ 'default email client on your device.' }})">
									</div>
								</td>
								<td>
									<i class="fa-solid fa-trash-alt m-link m-link-black"
									ng-click="$ctrl.deleteLink(link)" title="Delete"></i>
								</td>
							</tr>
							<tr ng-repeat-end="" ng-if="link.showEmbedLink">
								<td colspan="7">
									<textarea
										style="font-size:10px; height:60px; resize:none; line-height:1.4em !important;
											margin-top:0;"
										readonly="readonly">{{ $ctrl.getEmbedCode(link) }}</textarea>
								</td>
							</tr>
						</table>

						<!-- actions section -->
						<div style="background:#f6f6f6;padding:20px;margin:0 -20px;"
							ng-if="$ctrl.data.type !== 'ALERTS'">
							<!-- Title -->
							<div ng-if="$ctrl.data.type === 'RADAR' || $ctrl.data.type === 'MATRIX'"
								style="display:flex; align-items:center; margin-bottom:16px">
								<b>Title:</b>
								<input type="text" ng-model="$ctrl.title" style="flex:1; margin:0 0 0 8px;"
								placeholder="{{ $ctrl.data.defaultTitle }}">
							</div>

							<!-- New link -->
							<b style="visibility:hidden; margin-right:8px;"
								ng-if="$ctrl.data.type === 'RADAR' || $ctrl.data.type === 'MATRIX'">Title:</b>
							Link expires in
							<select style="margin: 0 8px 0 8px; width:auto; min-height:auto; padding: 6px"
								ng-model="$ctrl.data.selectedInterval">
								<option ng-repeat="choice in $ctrl.data.intervals"
									ng-value="choice"> {{ choice }} </option>
							</select> days.

							<!-- Optional extra password -->
							<div style="font-weight:normal; display:flex; align-items:center; margin-top:8px;
								min-height:38px" title="This allows you to add an additional layer of security.
								Otherwise the content can be accessed by everyone who knows the URL.">
								<b style="visibility:hidden; margin-right:8px;"
									ng-if="$ctrl.data.type === 'RADAR' || $ctrl.data.type === 'MATRIX'">Title:</b>
								<label style="font-weight:normal; white-space:nowrap; margin:0 12px 2px 3px; flex:1;
									font-size:14px;">
									<input type="checkbox" ng-model="$ctrl.data.useExtraPassword"
										style="vertical-align:bottom">
									Extra password{{$ctrl.data.useExtraPassword ? ':' : ''}}
								</label>
								<input type="password" ng-if="$ctrl.data.useExtraPassword"
									placeholder="min. 10 characters" style="flex:999;margin:0"
									ng-model="$ctrl.data.extraPassword">
							</div>
						</div>

						<!-- confirmation buttons -->
						<p style="padding:{{ $ctrl.data.type === 'ALERTS' ? '20px' : '0' }} 20px 20px 20px;
							margin:0 -20px -20px -20px; display:flex;
							background:#f6f6f6;">
							<button type="button" class="m-button m-button-white m-small"
								style="width: calc(50% - 2px);margin-right:4px;" ng-click="$ctrl.cancel()">
								Close
							</button><button class="m-button-main m-small" id="mpg-confirm-dialog-btn" type="button"
								style="width: calc(50% - 2px)" ng-click="$ctrl.addLink();"
								ng-class="{
									'disabled': $ctrl.data.useExtraPassword && $ctrl.data.extraPassword.length < 10
								}">{{ $ctrl.data.type === 'ALERTS' ? 'Create RSS Feed' : 'Create Link' }}
							</button>
						</p>
					</form>
				</span>
			</div>
		</div>
	`
});

// Generic select dropdown component -------------------------------------------------------------------
// A reusable dropdown triggered by focus/click. Supports search, header action buttons,
// pin/unpin, drag-and-drop, and keyboard navigation.
scout.component('mpgSelectDropdown', {
	bindings: {
		settings: '<',
	},
	controller: ['$scope', '$element', function ($scope, $element) {
		var self = this;
		this.searchActive = false;
		this.searchQuery = '';
		this.dragOpen = false;

		this.$onInit = function () {
			if (self.settings) {
				self.settings.resetSearch = function () {
					self.searchQuery = '';
					self.searchActive = false;
				};
			}
		};

		this.getFilteredItems = function () {
			if (!self.settings.items) return [];
			if (!self.searchQuery) return self.settings.items;
			let q = self.searchQuery.toLowerCase();
			return self.settings.items.filter(function (item) {
				let label = self.settings.itemLabel ? self.settings.itemLabel(item) : '';
				return label.toLowerCase().indexOf(q) !== -1;
			});
		};

		this.isItemSelected = function (item) {
			if (self.settings.itemIsSelected) return self.settings.itemIsSelected(item);
			return false;
		};

		this.select = function (item, $event) {
			const shouldClose = !self.settings.onSelect
				|| self.settings.onSelect(item, $event, self.getFilteredItems()) !== false;
			if (!shouldClose) return;

			self.searchQuery = '';
			self.searchActive = false;
			// Blur active element to close dropdown
			if (document.activeElement && $element[0].contains(document.activeElement)) document.activeElement.blur();
		};

		this.activateSearch = function ($event) {
			if ($event) $event.stopPropagation();
			let wrapper = $element[0].querySelector('.mpg-select-dropdown');
			if (wrapper) wrapper.focus();
			self.searchActive = true;
			$scope.$applyAsync();
			setTimeout(function () {
				let input = $element[0].querySelector('.mpg-select-dropdown-search input');
				if (input) input.focus();
			}, 0);
		};

		this.clearSearch = function ($event) {
			if ($event) {
				$event.stopPropagation();
				$event.preventDefault();
			}
			if (self.searchQuery) {
				self.searchQuery = '';
			} else {
				self.searchActive = false;
				let wrapper = $element[0].querySelector('.mpg-select-dropdown');
				if (wrapper) wrapper.focus();
			}
			$scope.$applyAsync();
			if (self.searchActive) {
				setTimeout(function () {
					let input = $element[0].querySelector('.mpg-select-dropdown-search input');
					if (input) input.focus();
				}, 0);
			}
		};

		this.handleKeydown = function ($event, item) {
			if ($event.key === 'Enter') {
				$event.preventDefault();
				self.select(item, $event);
			}
		};

		this.handleTriggerKeydown = function ($event) {
			if ($event.key === 'Escape') $event.target.blur();
		};

		this.handleTriggerMouseDown = function ($event) {
			// If clicking the trigger while the dropdown is already open (focused), close it.
			if (document.activeElement && $element[0].contains(document.activeElement)) {
				document.activeElement.blur();
				$event.preventDefault();
			}
		};

		this.togglePin = function (item, $event) {
			$event.stopPropagation();
			$event.preventDefault();
			if (self.settings.itemIsPinned && self.settings.itemIsPinned(item)) {
				if (self.settings.onUnpin) self.settings.onUnpin(item);
			} else {
				if (self.settings.onPin) self.settings.onPin(item);
			}
			$element[0].querySelector('.mpg-select-dropdown').focus();
		};

		this.headerBtnClick = function (btn, $event) {
			$event.stopPropagation();
			$event.preventDefault();
			if (btn.isSearch) {
				self.activateSearch($event);
			} else if (btn.onClick) {
				btn.onClick();
				let el = $element[0].querySelector('.mpg-select-dropdown');
				if (el) el.blur();
			}
		};

		// Drag-and-drop------------------------------------------------------------------------------------------------
		this.draggedOverTrigger = false;
		this.handleTriggerDragOver = function ($event) {
			$event.preventDefault();
			self.draggedOverTrigger = true;
			// Trigger is not allowed target
			$event.originalEvent.dataTransfer.dropEffect = 'none';
			if (!self.dragOpen) {
				self.dragOpen = true;
				self.handleOpen();
				$scope.$applyAsync();
			}
		};
		this.handleTriggerDragLeave = function () {
			self.draggedOverTrigger = false;
		};
		this.handlePanelDragLeave = function ($event) {
			// Safari sets relatedTarget to null — skip the close, dragend safety net handles cleanup
			if (!$event.relatedTarget) return;
			let el = $element[0].querySelector('.mpg-select-dropdown-panel');
			if (el && !el.contains($event.relatedTarget)) {
				self.dragOpen = false;
				$scope.$applyAsync();
			}
		};
		this.lastDragValid = false;
		this.getDragItemFromEvent = function ($event) {
			let target = $event.target;
			let itemEl = target && target.closest ? target.closest('.mpg-select-dropdown-item') : null;

			if (!itemEl || !$element[0].contains(itemEl)) return null;

			let index = parseInt(itemEl.getAttribute('data-drag-index'), 10);
			if (isNaN(index)) return null;

			return self.getFilteredItems()[index] || null;
		};

		this.handleListDragOver = function ($event) {
			let item = self.getDragItemFromEvent($event);
			let allowed = !!item;

			if (item && self.settings.onItemDragOver) {
				allowed = self.settings.onItemDragOver(item, $event) !== false;
			}

			$event.stopPropagation();
			$event.preventDefault();

			if ($event.originalEvent && $event.originalEvent.dataTransfer) {
				$event.originalEvent.dataTransfer.dropEffect = allowed ? 'move' : 'none';
			}

			if (!allowed) {
				self.lastDragValid = false;
				if (self.draggedOverItem === item) self.draggedOverItem = null;
				return;
			}

			self.lastDragValid = true;
			if (self.draggedOverItem !== item) self.draggedOverItem = item;

			if (document.activeElement) document.activeElement.blur();
		};
		this.handleItemDragLeave = function (item) {
			if (self.draggedOverItem === item) {
				self.draggedOverItem = null;
				self.lastDragValid = false;
			}
		};
		this.handleItemDrop = function (item, $event) {
			$event.preventDefault();
			self.draggedOverItem = null;
			self.lastDragValid = false;
			self.draggedOverTrigger = false;
			self.dragOpen = false;
			if (self.settings.onItemDrop) self.settings.onItemDrop(item, $event);
		};
		this.handleItemDragStart = function (item, $event) {
			if (self.settings.onItemDragStart) self.settings.onItemDragStart(item, $event);
		};
		this.handleItemDrag = function (item, $event) {
			if (self.settings.onItemDrag) self.settings.onItemDrag(item, $event);
		};
		this.handleItemDragEnd = function (item, $event) {
			if (self.settings.onItemDragEnd) self.settings.onItemDragEnd(item, $event);
		};

		// Helper getters for template ---------------------------------------------------------------------------------
		this.getIcon = function () {
			return typeof self.settings.icon === 'function' ? self.settings.icon() : self.settings.icon;
		};

		this.getLabel = function () {
			return typeof self.settings.label === 'function' ? self.settings.label() : self.settings.label;
		};
		this.getTriggerTooltip = function () {
			if (self.settings.triggerTooltip) {
				return typeof self.settings.triggerTooltip === 'function'
					? self.settings.triggerTooltip()
					: self.settings.triggerTooltip;
			}
			return self.getLabel();
		};
		this.getItemTooltip = function (item) {
			return self.settings.itemTooltip ? self.settings.itemTooltip(item) : self.getItemLabel(item);
		};
		this.getTriggerClass = function () {
			return self.settings.triggerClass || '';
		};
		this.getHeaderButtons = function () {
			return self.settings.headerButtons;
		};
		this.getSearchPlaceholder = function () {
			return self.settings.searchPlaceholder || 'Search...';
		};
		this.getItemLabel = function (item) {
			return self.settings.itemLabel ? self.settings.itemLabel(item) : '';
		};
		this.getItemIsSpecial = function (item) {
			return self.settings.itemIsSpecial ? self.settings.itemIsSpecial(item) : false;
		};
		this.getItemIsPinned = function (item) {
			return self.settings.itemIsPinned ? self.settings.itemIsPinned(item) : false;
		};
		this.getItemCanPin = function (item) {
			return self.settings.itemCanPin ? self.settings.itemCanPin(item) : true;
		};
		this.getItemDraggable = function (item) {
			return self.settings.itemDraggable ? self.settings.itemDraggable(item) : false;
		};

		this.lastLeftPosition = null;
		this.updateDropdownListWidth = function () {
			let rect = $element[0].getBoundingClientRect();
			if (self.lastLeftPosition !== rect.left) {
				self.lastLeftPosition = rect.left;
				$element[0].style.setProperty('--dropdown-left', rect.left + 'px');
			}
		};
		this.handleOpen = function () {
			self.updateDropdownListWidth();
			if (self.settings.onOpen) self.settings.onOpen();
		};

		// Safety net: close drag-opened dropdown when any drag operation ends
		let onDragEnd = function () {
			if (self.dragOpen) {
				self.dragOpen = false;
				self.draggedOverTrigger = false;
				self.draggedOverItem = null;
				$scope.$applyAsync();
			}
		};
		document.addEventListener('dragend', onDragEnd);

		$scope.$on('$destroy', function () {
			document.removeEventListener('dragend', onDragEnd);
		});
	}],
	template: `
		<div class="mpg-select-dropdown noselect" tabindex="0"
			ng-class="{'mpg-select-dropdown--drag-open': $ctrl.dragOpen}"
			ng-keydown="$ctrl.handleTriggerKeydown($event)"
			ng-focus="$ctrl.handleOpen()">

			<!-- Trigger button -->
			<div class="mpg-select-dropdown-trigger m-button-secondary m-compact"
				style="position:relative; border:thin solid;"
				ng-class="$ctrl.getTriggerClass()"
				title="{{ $ctrl.getTriggerTooltip() }}"
				ng-mousedown="$ctrl.handleTriggerMouseDown($event)"
				ng-dragover="$ctrl.handleTriggerDragOver($event)"
				ng-dragleave="$ctrl.handleTriggerDragLeave()">
				<div class="mpg-tile-overlay mpg-tile-overlay--highlight"
					ng-if="$ctrl.draggedOverTrigger"></div>
				<i ng-class="$ctrl.getIcon()" ng-if="$ctrl.getIcon()"
					style="margin-right:5px;"></i>
				<span class="mpg-select-dropdown-trigger-label">{{ $ctrl.getLabel() }}</span>
				<i class="fa-solid fa-chevron-down"
					style="margin-left:6px; font-size:10px;"></i>
			</div>

			<!-- Dropdown panel -->
			<div class="mpg-select-dropdown-panel"
				ng-dragleave="$ctrl.handlePanelDragLeave($event)">

				<!-- Header (only if headerButtons provided and search is not active) -->
				<div class="mpg-select-dropdown-header"
					ng-if="$ctrl.getHeaderButtons().length && !$ctrl.searchActive">
					<div tabindex="0" class="mpg-select-dropdown-header-btn"
						ng-repeat="btn in $ctrl.getHeaderButtons()"
						ng-if="!btn.condition || btn.condition()"
						ng-click="$ctrl.headerBtnClick(btn, $event)"
						ng-keydown="$event.key === 'Enter' && $ctrl.headerBtnClick(btn, $event)"
						title="{{ btn.tooltip }}">
						<i ng-class="btn.icon"></i>
					</div>
				</div>

				<!-- Search bar (replaces header when active) -->
				<div class="mpg-select-dropdown-search" ng-if="$ctrl.searchActive">
					<input type="text"
						ng-model="$ctrl.searchQuery"
						placeholder="{{ $ctrl.getSearchPlaceholder() }}"
						ng-keydown="$event.key === 'Escape' && $ctrl.clearSearch($event)">
					<i class="fa-solid fa-times mpg-select-dropdown-search-clear"
						ng-mousedown="$ctrl.clearSearch($event)"></i>
				</div>

				<!-- Item list -->
				<div class="mpg-select-dropdown-list"
					ng-dragenter="$ctrl.handleListDragOver($event)"
					ng-dragover="$ctrl.handleListDragOver($event)">
					<div class="mpg-select-dropdown-item"
						ng-repeat="item in $ctrl.getFilteredItems()"
						data-drag-index="{{ $index }}"
						tabindex="0"
						ng-click="$ctrl.select(item, $event)"
						ng-keydown="$ctrl.handleKeydown($event, item)"
						ng-class="{'mpg-select-dropdown-item--selected': $ctrl.isItemSelected(item)}"
						ng-attr-draggable="{{ $ctrl.getItemDraggable(item) ? 'true' : undefined }}"
						ng-dragstart="$ctrl.handleItemDragStart(item, $event)"
						ng-drag="$ctrl.handleItemDrag(item, $event)"
						ng-dragend="$ctrl.handleItemDragEnd(item, $event)"
						title="{{ $ctrl.getItemTooltip(item) }}">
						<div class="mpg-select-dropdown-item-label-wrapper">
							<span class="mpg-select-dropdown-item-label">
								{{ $ctrl.getItemLabel(item) }}
							</span>
							<span ng-if="$ctrl.getItemIsSpecial(item)" style="flex-shrink: 0;">*</span>
						</div>
						<i class="fa-thumbtack mpg-select-dropdown-pin"
							ng-if="(($ctrl.settings.onPin || $ctrl.settings.onUnpin)
								&& $ctrl.settings.itemCanPin(item))"
							ng-class="{
								'fa-solid': $ctrl.getItemIsPinned(item),
								'fa-light': !$ctrl.getItemIsPinned(item),
								'mpg-select-dropdown-pin--pinned': $ctrl.getItemIsPinned(item)
							}"
							ng-mousedown="$event.preventDefault()"
							ng-click="$ctrl.togglePin(item, $event)"
							title="{{ $ctrl.getItemIsPinned(item) ? 'Unpin folder' : 'Pin folder' }}"></i>
						<div class="mpg-tile-overlay mpg-tile-overlay--highlight"
							ng-if="$ctrl.draggedOverItem === item"
							ng-drop="$ctrl.handleItemDrop(item, $event)"
							ng-dragleave="$ctrl.handleItemDragLeave(item)"
							style="pointer-events: all;"></div>
					</div>
				</div>
			</div>
		</div>
	`
});

function enableDropdownKeyNavigation (rootElement) {
	const key = event.key;
	const elems = [
		rootElement.querySelector(':scope > input'),
		...Array.from(rootElement.querySelectorAll('.m-dropdown-row'))
	];
	const activeElem = document.activeElement;
	let idx = elems.indexOf(activeElem);
	if (idx == -1) idx = 0;

	let selectResult = function (idx = 0) {
		if (!elems.length) return;
		elems[(idx + elems.length) % elems.length].focus();
		event.stopPropagation();
		event.preventDefault();
	};

	switch (event.key) {
		case "ArrowUp":
			selectResult(idx - 1);
			break;
		case "ArrowDown":
			selectResult(idx + 1);
			break;
		case "Enter":
			if (idx !== 0) elems[idx].click();
			break;
	}
}

// Autosuggest dropdown for the query builder.
// Its parent element must contain a single <input> element.
scout.component('mpgAutosuggestDropdown', {
	bindings: {
		data: '<',
		type: '<',
		index: '<',
		dropdownOnSelect: '<'
	},
	controller: function ($scope, $element, $sce) {
		// Set up key events
		let inputElement = $element[0].parentNode;
		let enableKeyEvents = () => {
			enableDropdownKeyNavigation(inputElement);
		};
		inputElement.hasActiveMapegyDropdown = true;
		inputElement.addEventListener('keydown', enableKeyEvents);
		$scope.$on('$destroy', function () {
			inputElement.removeEventListener('keydown', enableKeyEvents);
			delete inputElement.hasActiveMapegyDropdown;
		});

		this.getMultiselectItems = () => {
			return (this.data || []).filter(x => x.checked);
		};
	},
	template: `
		<div class="m-dropdown"
			ng-class="{
				'multiselect-active': $ctrl.getMultiselectItems().length
			}">
			<div ng-show="$ctrl.getMultiselectItems().length"
				class="m-dropdown-multi-add-btn"
				ng-click="$ctrl.dropdownOnSelect($ctrl.getMultiselectItems(), $ctrl.type, $ctrl.index)"
			>Click here to add all selected items ({{
				$ctrl.getMultiselectItems().length
			}})</div>
			<div tabindex="0" class="m-dropdown-row" ng-repeat="item in $ctrl.data"
				ng-click="$ctrl.dropdownOnSelect([item], $ctrl.type, $ctrl.index)"
				onmousemove="this.focus()">
				<!-- checkbox for multiselect -->
				<div title="Check to add multiple items" class="m-dropdown-checkbox">
					<div class="m-checkbox" ng-class="{checked: item.checked}"
						ng-click="
							item.checked ? item.checked = false : item.checked = true;
							$event.stopPropagation();
						"><div></div></div>
				</div>

				<!-- logo -->
				<div class="preview-icon-container" ng-class="{
					'show-default-preview-icon': !item.web_links || !item.web_links.images
						|| !item.web_links.images.length
				}">
					<img ng-if="item.web_links && item.web_links.images
						&& item.web_links.images.length"
						ng-src="{{
							$root.cleanUrl(item.web_links.images[0], true)
						}}"
						onerror="
							this.style.display='none';
							this.parentNode.classList.add('show-default-preview-icon');
						">
					<svg class="default-preview-icon" viewBox="0 0 1 1"
						><use ng-if="$ctrl.type.includes('topics')" xlink:href="#icons--topic"></use
						><use ng-if="$ctrl.type.includes('organizations')" xlink:href="#icons--organization"></use
						></svg>
				</div>

				<div style="flex:1">
					<!-- name -->
					<div>
						<span style="flex:1" ng-bind_html="$root.trustAsHtml(item.title_html)"></span
						><span ng-if="$ctrl.type.includes('organizations')"
							style="font-size:12px">, {{ item.country_code }}</span>
					</div>
					<!-- description -->
					<div class="m-dropdown-result-descr" ng-if="item.description">
						<small ng-if="item.description.length < 120">
							{{ item.description }}
						</small>
						<small ng-if="item.description.length >= 120" title="{{ item.description }}">
							{{ item.description.substr(0, 120) + '&hellip;' }}
						</small>
					</div>
				</div>
			</div>
		</div>
	`
});

